import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Upload: any;
};

/** Autogenerated return type of AcquireBadge. */
export type AcquireBadgePayload = {
  __typename?: 'AcquireBadgePayload';
  badge: Badge;
};

export type Ad = {
  __typename?: 'Ad';
  adClickCount: Scalars['Int'];
  adClickUrl: Scalars['String'];
  adContent: AdContent;
  adContents: Array<AdContent>;
  adDescription: Scalars['String'];
  adExposureCount: Scalars['Int'];
  adFinishTime?: Maybe<Scalars['String']>;
  adLocales: Array<Scalars['String']>;
  adStartTime?: Maybe<Scalars['String']>;
  adStatus: AdStatusEnum;
  adSupportedPlatform: Scalars['String'];
  adTitle: Scalars['String'];
  adType: AdTypeEnum;
  doNotShowUntil: Scalars['Int'];
  id: Scalars['ID'];
};

export type AdContent = {
  __typename?: 'AdContent';
  ad: Ad;
  backgroundColor?: Maybe<Scalars['String']>;
  clickUrl?: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
  contentUrl: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export enum AdPlatformEnum {
  /** App */
  App = 'APP',
  /** Mobile Web */
  MobileWeb = 'MOBILE_WEB',
  /** PC Web */
  PcWeb = 'PC_WEB'
}

export enum AdStatusEnum {
  /** Draft */
  Draft = 'DRAFT',
  /** Pending */
  Pending = 'PENDING',
  /** Running */
  Running = 'RUNNING',
  /** STOP */
  Stop = 'STOP'
}

export enum AdTypeEnum {
  /** Chat Banner 1 Type */
  ChatBanner_1 = 'CHAT_BANNER_1',
  /** CPS */
  Cps = 'CPS',
  /** Home Banner 1 Type */
  HomeBanner_1 = 'HOME_BANNER_1',
  /** Popup Type */
  Popup = 'POPUP',
  /** Portfolio Banner 1 Type */
  PortfolioBanner_1 = 'PORTFOLIO_BANNER_1'
}

/** Autogenerated return type of AddArticleComment. */
export type AddArticleCommentPayload = {
  __typename?: 'AddArticleCommentPayload';
  comment: ArticleComment;
};

/** Autogenerated return type of AddArticle. */
export type AddArticlePayload = {
  __typename?: 'AddArticlePayload';
  article: Article;
};

/** Autogenerated return type of AddAssetItemsToUserFavorite. */
export type AddAssetItemsToUserFavoritePayload = {
  __typename?: 'AddAssetItemsToUserFavoritePayload';
  items: Array<SearchFollowItem>;
};

/** Autogenerated return type of AddBackTestingProjectResult. */
export type AddBackTestingProjectResultPayload = {
  __typename?: 'AddBackTestingProjectResultPayload';
  backTestingProjectResult?: Maybe<BackTestingProject>;
};

/** Autogenerated return type of AddBookmarkToArticle. */
export type AddBookmarkToArticlePayload = {
  __typename?: 'AddBookmarkToArticlePayload';
  article: Article;
};

/** Autogenerated return type of AddBuyForeignDecimalStockOrder. */
export type AddBuyForeignDecimalStockOrderPayload = {
  __typename?: 'AddBuyForeignDecimalStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of AddBuyForeignStockOrder. */
export type AddBuyForeignStockOrderPayload = {
  __typename?: 'AddBuyForeignStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of AddBuyKrDecimalStockOrder. */
export type AddBuyKrDecimalStockOrderPayload = {
  __typename?: 'AddBuyKrDecimalStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of AddBuyKrStockOrder. */
export type AddBuyKrStockOrderPayload = {
  __typename?: 'AddBuyKrStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of AddCommentToFavoriteItemCategory. */
export type AddCommentToFavoriteItemCategoryPayload = {
  __typename?: 'AddCommentToFavoriteItemCategoryPayload';
  category?: Maybe<FavoriteItemCategory>;
};

/** Autogenerated return type of AddCommunityReport. */
export type AddCommunityReportPayload = {
  __typename?: 'AddCommunityReportPayload';
  communityReport: CommunityReportObject;
};

/** Autogenerated return type of AddCryptoCurrencyAssetsToPortfolio. */
export type AddCryptoCurrencyAssetsToPortfolioPayload = {
  __typename?: 'AddCryptoCurrencyAssetsToPortfolioPayload';
  errors: Array<Scalars['String']>;
  portfolio: UserPortfolio;
};

/** Autogenerated return type of AddCryptoExchangeApiKeyToUser. */
export type AddCryptoExchangeApiKeyToUserPayload = {
  __typename?: 'AddCryptoExchangeApiKeyToUserPayload';
  cryptoExchangeApiKey: CryptoExchangeApiKey;
};

/** Autogenerated return type of AddCurrencyAssetsToPortfolio. */
export type AddCurrencyAssetsToPortfolioPayload = {
  __typename?: 'AddCurrencyAssetsToPortfolioPayload';
  errors: Array<Scalars['String']>;
  portfolio: UserPortfolio;
};

/** Autogenerated return type of AddCustomPortfolioTopic. */
export type AddCustomPortfolioTopicPayload = {
  __typename?: 'AddCustomPortfolioTopicPayload';
  portfolioTopic: PortfolioTopic;
};

/** Autogenerated return type of AddDividendHistories. */
export type AddDividendHistoriesPayload = {
  __typename?: 'AddDividendHistoriesPayload';
  dividendHistories: Array<DividendHistory>;
  errors: Array<Scalars['String']>;
};

/** Autogenerated return type of AddEtcAssetsToPortfolio. */
export type AddEtcAssetsToPortfolioPayload = {
  __typename?: 'AddEtcAssetsToPortfolioPayload';
  errors: Array<Scalars['String']>;
  portfolio: UserPortfolio;
};

/** Autogenerated return type of AddFavoriteItemCategory. */
export type AddFavoriteItemCategoryPayload = {
  __typename?: 'AddFavoriteItemCategoryPayload';
  category?: Maybe<FavoriteItemCategory>;
};

/** Autogenerated return type of AddInvestingKeywordToMe. */
export type AddInvestingKeywordToMePayload = {
  __typename?: 'AddInvestingKeywordToMePayload';
  myInvestingKeywords: Array<InvestingKeyword>;
};

/** Autogenerated return type of AddItemsToFavoriteItemCategory. */
export type AddItemsToFavoriteItemCategoryPayload = {
  __typename?: 'AddItemsToFavoriteItemCategoryPayload';
  category: FavoriteItemCategory;
};

/** Autogenerated return type of AddKbSecUserAccount. */
export type AddKbSecUserAccountPayload = {
  __typename?: 'AddKbSecUserAccountPayload';
  kbSecUserAccount?: Maybe<KbSecUserAccount>;
};

/** Autogenerated return type of AddLectureContentAttendanceHistory. */
export type AddLectureContentAttendanceHistoryPayload = {
  __typename?: 'AddLectureContentAttendanceHistoryPayload';
  lectureContentAttendanceHistory: LectureContentAttendanceHistory;
};

/** Autogenerated return type of AddLectureContentOpenNotification. */
export type AddLectureContentOpenNotificationPayload = {
  __typename?: 'AddLectureContentOpenNotificationPayload';
  lectureContentOpenNotification: LectureContentOpenNotification;
};

/** Autogenerated return type of AddLectureContentReview. */
export type AddLectureContentReviewPayload = {
  __typename?: 'AddLectureContentReviewPayload';
  lectureContentReview: LectureContentReview;
};

/** Autogenerated return type of AddLikeToArticle. */
export type AddLikeToArticlePayload = {
  __typename?: 'AddLikeToArticlePayload';
  article?: Maybe<Article>;
};

/** Autogenerated return type of AddLikeToLectureContentReview. */
export type AddLikeToLectureContentReviewPayload = {
  __typename?: 'AddLikeToLectureContentReviewPayload';
  lectureContentReview: LectureContentReview;
};

/** Autogenerated return type of AddLogToInvestingDiary. */
export type AddLogToInvestingDiaryPayload = {
  __typename?: 'AddLogToInvestingDiaryPayload';
  investingDiaryLog?: Maybe<InvestingDiaryLog>;
};

/** Autogenerated return type of AddMyFinPongPlusPortfoliosFromApp. */
export type AddMyFinPongPlusPortfoliosFromAppPayload = {
  __typename?: 'AddMyFinPongPlusPortfoliosFromAppPayload';
  portfolios: Array<UserPortfolio>;
};

/** Autogenerated return type of AddOrderItemsToUser. */
export type AddOrderItemsToUserPayload = {
  __typename?: 'AddOrderItemsToUserPayload';
  order: ProductOrder;
};

/** Autogenerated return type of AddPortfolioAssets. */
export type AddPortfolioAssetsPayload = {
  __typename?: 'AddPortfolioAssetsPayload';
  errors: Array<Scalars['String']>;
  portfolio: UserPortfolio;
};

/** Autogenerated return type of AddReplyToArticleComment. */
export type AddReplyToArticleCommentPayload = {
  __typename?: 'AddReplyToArticleCommentPayload';
  reply: ArticleCommentReply;
};

/** Autogenerated return type of AddReplyToLectureContentReview. */
export type AddReplyToLectureContentReviewPayload = {
  __typename?: 'AddReplyToLectureContentReviewPayload';
  lectureContentReviewReply: LectureContentReviewReply;
};

/** Autogenerated return type of AddReserveBuyForeignStockOrder. */
export type AddReserveBuyForeignStockOrderPayload = {
  __typename?: 'AddReserveBuyForeignStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of AddReserveBuyKrStockOrder. */
export type AddReserveBuyKrStockOrderPayload = {
  __typename?: 'AddReserveBuyKrStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of AddReserveSellForeignStockOrder. */
export type AddReserveSellForeignStockOrderPayload = {
  __typename?: 'AddReserveSellForeignStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of AddReserveSellKrStockOrder. */
export type AddReserveSellKrStockOrderPayload = {
  __typename?: 'AddReserveSellKrStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of AddReviewRequestedStatus. */
export type AddReviewRequestedStatusPayload = {
  __typename?: 'AddReviewRequestedStatusPayload';
  reviewRequestedStatus: ReviewRequestedStatus;
};

/** Autogenerated return type of AddSellForeignDecimalStockOrder. */
export type AddSellForeignDecimalStockOrderPayload = {
  __typename?: 'AddSellForeignDecimalStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of AddSellForeignStockOrder. */
export type AddSellForeignStockOrderPayload = {
  __typename?: 'AddSellForeignStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of AddSellKrDecimalStockOrder. */
export type AddSellKrDecimalStockOrderPayload = {
  __typename?: 'AddSellKrDecimalStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of AddSellKrStockOrder. */
export type AddSellKrStockOrderPayload = {
  __typename?: 'AddSellKrStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of AddStarToFavoriteItemCategory. */
export type AddStarToFavoriteItemCategoryPayload = {
  __typename?: 'AddStarToFavoriteItemCategoryPayload';
  category?: Maybe<FavoriteItemCategory>;
};

/** Autogenerated return type of AddStockOrderHistory. */
export type AddStockOrderHistoryPayload = {
  __typename?: 'AddStockOrderHistoryPayload';
  stockOrderHistory: KbSecStockOrderHistory;
};

/** Autogenerated return type of AddWishToLectureContent. */
export type AddWishToLectureContentPayload = {
  __typename?: 'AddWishToLectureContentPayload';
  userWishedLectureContent: UserWishedLectureContent;
};

/** Autogenerated return type of AgreeKbSecAccountTerms. */
export type AgreeKbSecAccountTermsPayload = {
  __typename?: 'AgreeKbSecAccountTermsPayload';
  kbSecAgreement: KbSecAgreement;
};

export type Agreement = {
  __typename?: 'Agreement';
  contentEn?: Maybe<Scalars['String']>;
  contentKo?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  titleEn?: Maybe<Scalars['String']>;
  titleKo?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type AllAgreements = {
  __typename?: 'AllAgreements';
  marketingList?: Maybe<Array<Agreement>>;
  privacyList?: Maybe<Array<Agreement>>;
  termsList?: Maybe<Array<Agreement>>;
};

export type ApiUser = {
  __typename?: 'ApiUser';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  nickname?: Maybe<Scalars['String']>;
};

export type AppAuth = {
  __typename?: 'AppAuth';
  hasVerified: Scalars['Boolean'];
};

/** Autogenerated return type of ApplyProfessionalInvestor. */
export type ApplyProfessionalInvestorPayload = {
  __typename?: 'ApplyProfessionalInvestorPayload';
  professionalInvestorApplicant: ProfessionalInvestorApplicant;
};

export type Article = {
  __typename?: 'Article';
  assetTagIds?: Maybe<Array<Scalars['ID']>>;
  assetTags?: Maybe<Array<AssetTag>>;
  bookmarkedUserIds?: Maybe<Array<Scalars['ID']>>;
  comments?: Maybe<Array<ArticleComment>>;
  commentsCount?: Maybe<Scalars['Int']>;
  communityUser: CommunityUser;
  content: Array<ArticleContent>;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<DeletedBy>;
  dynamicLinkUrl?: Maybe<Scalars['String']>;
  exposureCount: Scalars['Int'];
  feedTopic?: Maybe<FeedTopic>;
  id: Scalars['ID'];
  isBookmarked: Scalars['Boolean'];
  isLiked: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  language: Scalars['String'];
  likes?: Maybe<Array<ArticleLike>>;
  likesCount?: Maybe<Scalars['Int']>;
  portfolioTopicIds?: Maybe<Array<Scalars['ID']>>;
  portfolioTopics?: Maybe<Array<PortfolioTopic>>;
  publishedAt?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<ArticleTag>>;
  temporarySavedAt?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
  viewCount: Scalars['Int'];
};

export type ArticleComment = {
  __typename?: 'ArticleComment';
  articleId?: Maybe<Scalars['ID']>;
  communityUser: CommunityUser;
  content: Array<ArticleCommentContent>;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<DeletedBy>;
  id: Scalars['ID'];
  parentCommentId?: Maybe<Scalars['ID']>;
  replies?: Maybe<Array<ArticleCommentReply>>;
  repliesCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};

export type ArticleCommentContent = ArticleContentText;

export type ArticleCommentContentInput = {
  textContents?: InputMaybe<Array<ArticleContentTextInput>>;
};

export type ArticleCommentReply = {
  __typename?: 'ArticleCommentReply';
  communityUser: CommunityUser;
  content: Array<ArticleCommentContent>;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<DeletedBy>;
  id: Scalars['ID'];
  parentCommentId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};

export type ArticleContent = ArticleContentAsset | ArticleContentBackTestingProject | ArticleContentImage | ArticleContentOgTag | ArticleContentPortfolio | ArticleContentText;

export type ArticleContentAsset = {
  __typename?: 'ArticleContentAsset';
  categoryType: Scalars['String'];
  content: ArticleContentAssetContent;
  sortId: Scalars['Int'];
  uuid?: Maybe<Scalars['ID']>;
};

export type ArticleContentAssetContent = {
  __typename?: 'ArticleContentAssetContent';
  asset: SearchCompany;
};

export type ArticleContentBackTestingProject = {
  __typename?: 'ArticleContentBackTestingProject';
  categoryType: Scalars['String'];
  content: BackTestingProject;
  sortId: Scalars['Int'];
  uuid?: Maybe<Scalars['ID']>;
};

export type ArticleContentImage = {
  __typename?: 'ArticleContentImage';
  categoryType: Scalars['String'];
  content: ArticleContentImageContent;
  sortId: Scalars['Int'];
  uuid?: Maybe<Scalars['ID']>;
};

export type ArticleContentImageContent = {
  __typename?: 'ArticleContentImageContent';
  imageUrl: Scalars['String'];
};

export type ArticleContentImageInput = {
  imageFile?: InputMaybe<Scalars['Upload']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  sortId: Scalars['ID'];
};

export type ArticleContentInput = {
  cryptoContents?: InputMaybe<Array<BackTestingCryptoInput>>;
  imageContents?: InputMaybe<Array<ArticleContentImageInput>>;
  ogTagContents?: InputMaybe<Array<ArticleContentOgTagInput>>;
  portfolioContents?: InputMaybe<Array<ArticleContentPortfolioContentInput>>;
  stockContents?: InputMaybe<Array<BackTestingStockInput>>;
  textContents?: InputMaybe<Array<ArticleContentTextInput>>;
};

export type ArticleContentOgTag = {
  __typename?: 'ArticleContentOgTag';
  categoryType: Scalars['String'];
  content: ArticleContentOgTagContent;
  sortId: Scalars['Int'];
  uuid?: Maybe<Scalars['ID']>;
};

export type ArticleContentOgTagContent = {
  __typename?: 'ArticleContentOgTagContent';
  ogDescription?: Maybe<Scalars['String']>;
  ogImageUrl?: Maybe<Scalars['String']>;
  ogTitle?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ArticleContentOgTagInput = {
  ogDescription?: InputMaybe<Scalars['String']>;
  ogImageUrl?: InputMaybe<Scalars['String']>;
  ogTitle?: InputMaybe<Scalars['String']>;
  sortId: Scalars['ID'];
  url?: InputMaybe<Scalars['String']>;
};

export type ArticleContentPortfolio = {
  __typename?: 'ArticleContentPortfolio';
  categoryType: Scalars['String'];
  content: ArticleContentPortfolioContent;
  sortId: Scalars['Int'];
  uuid?: Maybe<Scalars['ID']>;
};

export type ArticleContentPortfolioContent = {
  __typename?: 'ArticleContentPortfolioContent';
  baseCurrencySymbol?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  evaluationAmount?: Maybe<Scalars['Float']>;
  fundoraPortfolioSequence?: Maybe<Scalars['String']>;
  hasPortfolioAccessEnabled?: Maybe<Scalars['Boolean']>;
  imageUrl: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  portfolioLink?: Maybe<Scalars['String']>;
  purchaseAmount?: Maybe<Scalars['Float']>;
  revenueVerifiedAt?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugs?: Maybe<Array<Scalars['String']>>;
};

export type ArticleContentPortfolioContentInput = {
  baseCurrencySymbol?: InputMaybe<Scalars['String']>;
  hasPortfolioAccessEnabled?: InputMaybe<Scalars['Boolean']>;
  imageData?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  portfolioLink: Scalars['String'];
  slug: Scalars['String'];
  slugs?: InputMaybe<Array<Scalars['String']>>;
  sortId?: InputMaybe<Scalars['ID']>;
};

export type ArticleContentSubTextComponent = ArticleContentTextSubTextComponentCrypto | ArticleContentTextSubTextComponentStock | ArticleContentTextSubTextComponentText | ArticleContentTextSubTextComponentUser;

export type ArticleContentText = {
  __typename?: 'ArticleContentText';
  categoryType: Scalars['String'];
  content: ArticleContentTextContent;
  sortId: Scalars['Int'];
  uuid?: Maybe<Scalars['ID']>;
};

export type ArticleContentTextContent = {
  __typename?: 'ArticleContentTextContent';
  subTextComponents: Array<ArticleContentSubTextComponent>;
};

export type ArticleContentTextInput = {
  cryptoComponents?: InputMaybe<Array<ArticleContentTextSubComponentCryptoInput>>;
  sortId: Scalars['ID'];
  stockComponents?: InputMaybe<Array<ArticleContentTextSubComponentStockInput>>;
  textComponents?: InputMaybe<Array<ArticleContentTextSubComponentTextInput>>;
  userComponents?: InputMaybe<Array<ArticleContentTextSubComponentUserInput>>;
};

export type ArticleContentTextSubComponentCryptoInput = {
  cryptoCurrencyId: Scalars['ID'];
  sortId: Scalars['ID'];
};

export type ArticleContentTextSubComponentStockInput = {
  companyId: Scalars['ID'];
  sortId: Scalars['ID'];
};

export type ArticleContentTextSubComponentTextInput = {
  sortId: Scalars['ID'];
  text: Scalars['String'];
};

export type ArticleContentTextSubComponentUserInput = {
  sortId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type ArticleContentTextSubTextComponentCrypto = {
  __typename?: 'ArticleContentTextSubTextComponentCrypto';
  assetTagId: Scalars['ID'];
  base?: Maybe<Scalars['String']>;
  componentType: Scalars['String'];
  counter?: Maybe<Scalars['String']>;
  cryptoCurrencyId: Scalars['ID'];
  name: LanguageString;
  sortId: Scalars['Int'];
  symbol: Scalars['String'];
  uuid?: Maybe<Scalars['ID']>;
};

export type ArticleContentTextSubTextComponentStock = {
  __typename?: 'ArticleContentTextSubTextComponentStock';
  assetTagId: Scalars['ID'];
  companyId: Scalars['ID'];
  componentType: Scalars['String'];
  country: Scalars['String'];
  name: LanguageString;
  sortId: Scalars['Int'];
  ticker: Scalars['String'];
  uuid?: Maybe<Scalars['ID']>;
};

export type ArticleContentTextSubTextComponentText = {
  __typename?: 'ArticleContentTextSubTextComponentText';
  componentType: Scalars['String'];
  sortId: Scalars['Int'];
  text: Scalars['String'];
  uuid?: Maybe<Scalars['ID']>;
};

export type ArticleContentTextSubTextComponentUser = {
  __typename?: 'ArticleContentTextSubTextComponentUser';
  componentType: Scalars['String'];
  nickname: Scalars['String'];
  sortId: Scalars['Int'];
  userId: Scalars['ID'];
  uuid?: Maybe<Scalars['ID']>;
};

export type ArticleLike = {
  __typename?: 'ArticleLike';
  id: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
};

export type ArticlePortfolioTopic = {
  __typename?: 'ArticlePortfolioTopic';
  id: Scalars['ID'];
  isCustomTopic?: Maybe<Scalars['Boolean']>;
  name: LanguageString;
  portfolioTopicId?: Maybe<Scalars['ID']>;
  tagName: Scalars['String'];
  taggedCount: Scalars['Int'];
};

export type ArticleStockTag = {
  __typename?: 'ArticleStockTag';
  country?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<LanguageString>;
  stockTagId: Scalars['ID'];
  taggedCount?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
};

export type ArticleTag = ArticlePortfolioTopic | ArticleStockTag;

export enum AssetCategory {
  /** Company Asset */
  Company = 'COMPANY',
  /** Crypto Currency Asset */
  CryptoCurrency = 'CRYPTO_CURRENCY',
  /** Currency Asset */
  Currency = 'CURRENCY',
  /** Etc Asset */
  Etc = 'ETC',
  /** Etc Company Asset */
  EtcCompany = 'ETC_COMPANY'
}

export type AssetTag = {
  __typename?: 'AssetTag';
  categoryType: Scalars['String'];
  companyId?: Maybe<Scalars['ID']>;
  cryptoCurrencyId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  relativeSearchKeywords?: Maybe<Array<Scalars['String']>>;
  symbol: Scalars['String'];
};

export type AssetTagTitle = {
  __typename?: 'AssetTagTitle';
  categoryType: Scalars['String'];
  companyId?: Maybe<Scalars['ID']>;
  counterCurrency: CounterCurrency;
  country?: Maybe<Scalars['String']>;
  cryptoCurrencyId?: Maybe<Scalars['ID']>;
  exchange?: Maybe<Scalars['String']>;
  followItemId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isFollowing: Scalars['Boolean'];
  name: Scalars['String'];
  price?: Maybe<Scalars['String']>;
  priceChangePercent?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  userFollowingId?: Maybe<Scalars['ID']>;
};

export enum AuthClient {
  /** Android client */
  Android = 'ANDROID',
  /** IOS client */
  Ios = 'IOS',
  /** Web client */
  Web = 'WEB'
}

export enum AuthMethod {
  /** Apple signin method */
  Apple = 'APPLE',
  /** Facebook signin method */
  Facebook = 'FACEBOOK',
  /** Google signin method */
  Google = 'GOOGLE',
  /** Kakao signin method */
  Kakao = 'KAKAO'
}

export type AuthToken = {
  __typename?: 'AuthToken';
  authMethod: Scalars['String'];
  deviceRegistrationToken?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  isNewUser?: Maybe<Scalars['Boolean']>;
  nickname?: Maybe<Scalars['String']>;
  token: Scalars['String'];
};

export type BackTestingAiResult = {
  __typename?: 'BackTestingAiResult';
  cases?: Maybe<Array<BackTestingResultCase>>;
  times?: Maybe<Array<Scalars['Int']>>;
};

export type BackTestingAsset = BackTestingCrypto | BackTestingStock;

export type BackTestingCase = BackTestingCrypto | BackTestingPortfolio | BackTestingStock;

export type BackTestingCrypto = {
  __typename?: 'BackTestingCrypto';
  base: Scalars['String'];
  counter: Scalars['String'];
  name?: Maybe<LanguageString>;
  sortId?: Maybe<Scalars['ID']>;
  weight?: Maybe<Scalars['Float']>;
};

export type BackTestingCryptoInput = {
  base: Scalars['String'];
  counter: Scalars['String'];
  sortId?: InputMaybe<Scalars['ID']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type BackTestingPortfolio = {
  __typename?: 'BackTestingPortfolio';
  assets?: Maybe<Array<BackTestingAsset>>;
  name: Scalars['String'];
  sortId?: Maybe<Scalars['ID']>;
};

export type BackTestingPortfolioInput = {
  cryptoAssets?: InputMaybe<Array<BackTestingCryptoInput>>;
  name: Scalars['String'];
  sortId?: InputMaybe<Scalars['ID']>;
  stockAssets?: InputMaybe<Array<BackTestingStockInput>>;
};

export type BackTestingProject = {
  __typename?: 'BackTestingProject';
  aiResult?: Maybe<BackTestingAiResult>;
  cases: Array<BackTestingCase>;
  cashFlowAmount?: Maybe<Scalars['Float']>;
  cashFlowType: PeriodEnum;
  createdAt: Scalars['String'];
  currencySymbol: Scalars['String'];
  endPeriod: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  initialAmount: Scalars['Float'];
  rebalancingType: PeriodEnum;
  result: BackTestingResult;
  slug: Scalars['String'];
  slugSharedAt?: Maybe<Scalars['String']>;
  startPeriod: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
  userId?: Maybe<Scalars['ID']>;
};

export type BackTestingProjectInput = {
  cashFlowAmount?: InputMaybe<Scalars['Float']>;
  cashFlowType?: InputMaybe<PeriodEnum>;
  cryptoCases?: InputMaybe<Array<BackTestingCryptoInput>>;
  currencySymbol: Scalars['String'];
  endPeriod: Scalars['String'];
  imageData?: InputMaybe<Scalars['String']>;
  initialAmount: Scalars['Float'];
  portfolioCases?: InputMaybe<Array<BackTestingPortfolioInput>>;
  rebalancingType?: InputMaybe<PeriodEnum>;
  result: BackTestingResultInput;
  startPeriod: Scalars['String'];
  stockCases?: InputMaybe<Array<BackTestingStockInput>>;
  title: Scalars['String'];
};

export type BackTestingResult = {
  __typename?: 'BackTestingResult';
  cases: Array<BackTestingResultCase>;
  times: Array<Scalars['Int']>;
};

export type BackTestingResultCase = {
  __typename?: 'BackTestingResultCase';
  balancesByTime: Array<Scalars['Float']>;
  bestYear: Scalars['Int'];
  bestYearReturnRate?: Maybe<Scalars['Float']>;
  cagr: Scalars['Float'];
  maxDrawdown: Scalars['Float'];
  sortId?: Maybe<Scalars['ID']>;
  worstYear: Scalars['Int'];
  worstYearReturnRate: Scalars['Float'];
};

export type BackTestingResultCaseInput = {
  balancesByTime: Array<Scalars['Float']>;
  bestYear: Scalars['Int'];
  bestYearReturnRate?: InputMaybe<Scalars['Float']>;
  cagr: Scalars['Float'];
  maxDrawdown: Scalars['Float'];
  sortId?: InputMaybe<Scalars['ID']>;
  worstYear?: InputMaybe<Scalars['Int']>;
  worstYearReturnRate?: InputMaybe<Scalars['Float']>;
};

export type BackTestingResultInput = {
  cases?: InputMaybe<Array<BackTestingResultCaseInput>>;
  times: Array<Scalars['Int']>;
};

export type BackTestingStock = {
  __typename?: 'BackTestingStock';
  country: Scalars['String'];
  name?: Maybe<LanguageString>;
  sortId?: Maybe<Scalars['ID']>;
  ticker: Scalars['String'];
  weight?: Maybe<Scalars['Float']>;
};

export type BackTestingStockInput = {
  country: Scalars['String'];
  sortId?: InputMaybe<Scalars['ID']>;
  ticker: Scalars['String'];
  weight?: InputMaybe<Scalars['Float']>;
};

export type Badge = {
  __typename?: 'Badge';
  acquireCondition?: Maybe<BadgeAcquireCondition>;
  category: BadgeCategory;
  deeplinkUrl?: Maybe<Scalars['String']>;
  descriptions: LanguageString;
  dimmedImageUrl: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  isAcquireConditionAchieved: Scalars['Boolean'];
  isAcquired: Scalars['Boolean'];
  isRepresentativeBadge: Scalars['Boolean'];
  level: BadgeLevel;
  names: LanguageString;
  supportedLanguages: Array<Scalars['String']>;
  verificationUrl?: Maybe<Scalars['String']>;
};

export type BadgeAcquireCondition = {
  __typename?: 'BadgeAcquireCondition';
  achievementStatusMessages: LanguageString;
  id: Scalars['ID'];
  requiredValue: Scalars['Int'];
  type: Scalars['String'];
};

export type BadgeCategory = {
  __typename?: 'BadgeCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
  names?: Maybe<LanguageString>;
};

export type BadgeLevel = {
  __typename?: 'BadgeLevel';
  id: Scalars['ID'];
  name: Scalars['String'];
  names?: Maybe<LanguageString>;
};

/** Autogenerated return type of BlockUser. */
export type BlockUserPayload = {
  __typename?: 'BlockUserPayload';
  user: User;
};

export type CategorizedCompany = {
  __typename?: 'CategorizedCompany';
  companies?: Maybe<Array<Company>>;
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: LanguageString;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  language: Scalars['String'];
  latestMessage?: Maybe<ChatRoomMessage>;
  linkUrl: Scalars['String'];
  numberOfActiveUsers: Scalars['Int'];
  numberOfMessages: Scalars['Int'];
  numberOfUsers: Scalars['Int'];
  password?: Maybe<Scalars['String']>;
  portfolioSequence?: Maybe<Scalars['ID']>;
  roomImageUrl: Scalars['String'];
  roomName: Scalars['String'];
  roomType: Scalars['String'];
  slug: Scalars['String'];
  ticker?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type ChatRoomMessage = {
  __typename?: 'ChatRoomMessage';
  content: Array<ChatRoomMessageContent>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type ChatRoomMessageContent = {
  __typename?: 'ChatRoomMessageContent';
  base?: Maybe<Scalars['String']>;
  baseSymbol?: Maybe<Scalars['String']>;
  change?: Maybe<Scalars['String']>;
  counter?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  dividendPerShare?: Maybe<Scalars['String']>;
  dividendRatio?: Maybe<Scalars['String']>;
  estimate?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  monthlyDividend?: Maybe<Array<Scalars['Float']>>;
  multiplies?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  portfolioId?: Maybe<Scalars['String']>;
  portfolioName?: Maybe<Scalars['String']>;
  portfolioSlug?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  priceChangePercent?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ChatRoomNotification = {
  __typename?: 'ChatRoomNotification';
  firestoreDocumentId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  notificationOffUserIds: Array<Scalars['ID']>;
  notificationOnUserIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of ClickAdContent. */
export type ClickAdContentPayload = {
  __typename?: 'ClickAdContentPayload';
  adContent: AdContent;
};

/** Autogenerated return type of ClickAd. */
export type ClickAdPayload = {
  __typename?: 'ClickAdPayload';
  ad: Ad;
};

/** Autogenerated return type of ClickCpsAd. */
export type ClickCpsAdPayload = {
  __typename?: 'ClickCpsAdPayload';
  cpsAd: CpsAd;
};

/** Autogenerated return type of ClickInvestingInsight. */
export type ClickInvestingInsightPayload = {
  __typename?: 'ClickInvestingInsightPayload';
  investingInsight: InvestingInsight;
};

export type CloudFrontSignedCookie = {
  __typename?: 'CloudFrontSignedCookie';
  cloudFrontKeyPairId: Scalars['String'];
  cloudFrontPolicy: Scalars['String'];
  cloudFrontSignature: Scalars['String'];
  domain: Scalars['String'];
  expires?: Maybe<Scalars['String']>;
  path: Scalars['String'];
};

export type CodefCert = {
  __typename?: 'CodefCert';
  encodedCertAccessToken: Scalars['String'];
  encryptionKey: Scalars['String'];
};

export type CodefCertificationMethodInput = {
  certPassword: Scalars['String'];
  derFile: Scalars['String'];
  keyFile: Scalars['String'];
};

export type CommunityNotification = {
  __typename?: 'CommunityNotification';
  content: CommunityNotificationContent;
  createdAt: Scalars['String'];
  hasConfirmed?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  notificationCategoryLogoImageUrl?: Maybe<Scalars['String']>;
  notificationCategoryName?: Maybe<Scalars['String']>;
  notificationCategoryType: Scalars['String'];
  receiverUserId: Scalars['ID'];
  sender: CommunityNotificationUser;
};

export type CommunityNotificationContent = {
  __typename?: 'CommunityNotificationContent';
  deeplinkUrl?: Maybe<Scalars['String']>;
  notificationMessage?: Maybe<Scalars['String']>;
  notificationMessageTemplate?: Maybe<Scalars['String']>;
  receiverArticleCommentId?: Maybe<Scalars['ID']>;
  receiverArticleId?: Maybe<Scalars['ID']>;
  senderArticleCommentId?: Maybe<Scalars['ID']>;
};

export type CommunityNotificationStatus = {
  __typename?: 'CommunityNotificationStatus';
  communityNotifications: Array<CommunityNotification>;
  hasUnconfirmedNotification: Scalars['Boolean'];
};

export type CommunityNotificationUser = {
  __typename?: 'CommunityNotificationUser';
  nickname?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export enum CommunityReportContentEnum {
  /** Article Comment Report */
  ArticleCommentReport = 'ARTICLE_COMMENT_REPORT',
  /** Article Report */
  ArticleReport = 'ARTICLE_REPORT',
  /** User Report */
  UserReport = 'USER_REPORT'
}

export type CommunityReportInput = {
  etcReasonDetail?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
  reportContentId: Scalars['ID'];
  reportType: CommunityReportContentEnum;
};

export type CommunityReportObject = {
  __typename?: 'CommunityReportObject';
  createdAt: Scalars['String'];
  etcReasonDetail?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  reportContentId: Scalars['ID'];
  reportType: Scalars['String'];
  reporterId: Scalars['ID'];
};

export type CommunityUser = {
  __typename?: 'CommunityUser';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isLectureContentAuthor?: Maybe<Scalars['Boolean']>;
  lectureContents?: Maybe<Array<LectureContent>>;
  nickname?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  representativeBadge?: Maybe<Badge>;
  userId?: Maybe<Scalars['ID']>;
  userType?: Maybe<Scalars['String']>;
};

/**
 *   [Company]
 *   flow: Query -> Company
 * fields: ticker, name, exchange, sub_exchange, stock_price(obj), currency(obj), company_name, company_names,
 *   spec ref: https://www.notion.so/therichteam/Company-4c1b7896f77c4a73882f59fcd7e92a34
 *
 */
export type Company = {
  __typename?: 'Company';
  assetTagId?: Maybe<Scalars['ID']>;
  /** deprecated -> currency */
  base?: Maybe<Scalars['String']>;
  /** deprecated -> currency */
  baseSymbol?: Maybe<Scalars['String']>;
  chartSymbol?: Maybe<Scalars['String']>;
  companyName: LanguageString;
  companyNames?: Maybe<Array<CompanyName>>;
  companyPrice?: Maybe<CompanyPrice>;
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  dividendFrequency?: Maybe<Scalars['String']>;
  dividendRatioPercent?: Maybe<Scalars['Float']>;
  exDividendMonths?: Maybe<Array<Scalars['Int']>>;
  /** ex) KRX */
  exchange?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  isExist?: Maybe<Scalars['Boolean']>;
  lastYearRegularDividendAmount?: Maybe<Scalars['Float']>;
  latestRegularDividendAmount?: Maybe<Scalars['Float']>;
  listDate?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  needTtm?: Maybe<Scalars['Boolean']>;
  paymentMonths?: Maybe<Array<Scalars['Int']>>;
  /** deprecated -> stockPrice */
  price?: Maybe<Scalars['String']>;
  /** deprecated -> stockPrice */
  priceChangePercent?: Maybe<Scalars['String']>;
  /** deprecated -> stockPrice */
  priceUpdatedAt?: Maybe<Scalars['String']>;
  samsungStockCode?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  securityGroup?: Maybe<Scalars['String']>;
  stockPrice?: Maybe<StockPrice>;
  /** ex) KOSPI */
  subExchange?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
};

export type CompanyDetail = {
  __typename?: 'CompanyDetail';
  assetTagId?: Maybe<Scalars['ID']>;
  chartSymbol?: Maybe<Scalars['String']>;
  companyName: LanguageString;
  companyPrice?: Maybe<CompanyPrice>;
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  dividendFrequency?: Maybe<Scalars['String']>;
  etfDetail?: Maybe<EtfDetail>;
  exDividendMonths?: Maybe<Array<Scalars['Int']>>;
  /** ex) KRX */
  exchange?: Maybe<Scalars['String']>;
  favoriteItemUsersCount?: Maybe<Scalars['Int']>;
  followItemId?: Maybe<Scalars['ID']>;
  followersCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  isExist?: Maybe<Scalars['Boolean']>;
  isFollowing?: Maybe<Scalars['Boolean']>;
  lastYearRegularDividendAmount?: Maybe<Scalars['Float']>;
  latestRegularDividendAmount?: Maybe<Scalars['Float']>;
  listDate?: Maybe<Scalars['String']>;
  logoImageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  needTtm?: Maybe<Scalars['Boolean']>;
  paymentMonths?: Maybe<Array<Scalars['Int']>>;
  /** deprecated -> stockPrice */
  price?: Maybe<Scalars['String']>;
  /** deprecated -> stockPrice */
  priceChangePercent?: Maybe<Scalars['String']>;
  /** deprecated -> stockPrice */
  priceUpdatedAt?: Maybe<Scalars['String']>;
  samsungStockCode?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  securityGroup?: Maybe<Scalars['String']>;
  /** ex) KOSPI */
  subExchange?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
};

export type CompanyInput = {
  country?: InputMaybe<Scalars['String']>;
  exchange?: InputMaybe<Scalars['String']>;
  ticker: Scalars['String'];
};

export type CompanyName = {
  __typename?: 'CompanyName';
  id: Scalars['ID'];
  language: Scalars['String'];
  name: Scalars['String'];
};

export type CompanyPrice = {
  __typename?: 'CompanyPrice';
  companyId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  isMarketHoliday?: Maybe<Scalars['Boolean']>;
  isReserveOrderAvailable?: Maybe<Scalars['Boolean']>;
  marketType?: Maybe<MarketTypeEnum>;
  previousClose?: Maybe<Scalars['String']>;
  previousClosePriceChange?: Maybe<Scalars['String']>;
  previousClosePriceChangePercent?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  priceChange?: Maybe<Scalars['String']>;
  priceChangePercent?: Maybe<Scalars['String']>;
  priceUpdateType?: Maybe<Scalars['String']>;
  priceUpdatedAt?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
};

export type CompanySector = {
  __typename?: 'CompanySector';
  companySectorName: LanguageString;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CompareToServerCi = {
  __typename?: 'CompareToServerCi';
  fundora?: Maybe<ServerCiStatus>;
};

/** Autogenerated return type of ConfirmBadgeNotifications. */
export type ConfirmBadgeNotificationsPayload = {
  __typename?: 'ConfirmBadgeNotificationsPayload';
  badgeNotifications: Array<UserBadge>;
};

/** Autogenerated return type of ConfirmCommunityNotifications. */
export type ConfirmCommunityNotificationsPayload = {
  __typename?: 'ConfirmCommunityNotificationsPayload';
  communityNotifications: Array<CommunityNotification>;
};

export type ConnectKbSecUserAccount = {
  __typename?: 'ConnectKbSecUserAccount';
  kbSecUserAccount: KbSecUserAccount;
  userPortfolio: UserPortfolio;
};

/** Autogenerated return type of ConnectKbSecUserAccountScreen. */
export type ConnectKbSecUserAccountScreenPayload = {
  __typename?: 'ConnectKbSecUserAccountScreenPayload';
  kbSecScreenApi: KbSecScreenApi;
};

export type CounterCurrency = {
  __typename?: 'CounterCurrency';
  symbol?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type CpsAd = {
  __typename?: 'CpsAd';
  adClickUrl: Scalars['String'];
  adContent: CpsAdContent;
  adStatus: AdStatusEnum;
  adType: AdTypeEnum;
  id: Scalars['ID'];
};

export type CpsAdContent = {
  __typename?: 'CpsAdContent';
  description: Scalars['String'];
  id: Scalars['ID'];
  logoImageUrl: Scalars['String'];
  name: Scalars['String'];
};

/** Autogenerated return type of CreateDividendPortfolioSample. */
export type CreateDividendPortfolioSamplePayload = {
  __typename?: 'CreateDividendPortfolioSamplePayload';
  errors: Array<Scalars['String']>;
  portfolio: UserPortfolio;
};

/** Autogenerated return type of CreateLectureContentOrder. */
export type CreateLectureContentOrderPayload = {
  __typename?: 'CreateLectureContentOrderPayload';
  order: ProductOrder;
};

/** Autogenerated return type of CreatePlaidLinkToken. */
export type CreatePlaidLinkTokenPayload = {
  __typename?: 'CreatePlaidLinkTokenPayload';
  linkToken?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreatePortfolioFromCryptoExchangeApiKey. */
export type CreatePortfolioFromCryptoExchangeApiKeyPayload = {
  __typename?: 'CreatePortfolioFromCryptoExchangeApiKeyPayload';
  userPortfolio?: Maybe<UserPortfolio>;
};

/** Autogenerated return type of CreatePortfolioFromPlaidPublicToken. */
export type CreatePortfolioFromPlaidPublicTokenPayload = {
  __typename?: 'CreatePortfolioFromPlaidPublicTokenPayload';
  userPortfolio?: Maybe<UserPortfolio>;
};

/** Autogenerated return type of CreatePortfolioFromSecuritiesAccount. */
export type CreatePortfolioFromSecuritiesAccountPayload = {
  __typename?: 'CreatePortfolioFromSecuritiesAccountPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  userPortfolio?: Maybe<UserPortfolio>;
};

/** Autogenerated return type of CreateSnp500DividendPortfolioSample. */
export type CreateSnp500DividendPortfolioSamplePayload = {
  __typename?: 'CreateSnp500DividendPortfolioSamplePayload';
  errors: Array<Scalars['String']>;
  portfolio: UserPortfolio;
};

export type Creator = {
  __typename?: 'Creator';
  nickname: Scalars['String'];
  userId?: Maybe<Scalars['ID']>;
};

export type CryptoCandlePrice = {
  __typename?: 'CryptoCandlePrice';
  c?: Maybe<Array<Scalars['String']>>;
  h?: Maybe<Array<Scalars['String']>>;
  l?: Maybe<Array<Scalars['String']>>;
  o?: Maybe<Array<Scalars['String']>>;
  pc?: Maybe<Array<Scalars['String']>>;
  symbol: Scalars['String'];
  t?: Maybe<Array<Scalars['Int']>>;
  v?: Maybe<Array<Scalars['String']>>;
};

export type CryptoCurrency = {
  __typename?: 'CryptoCurrency';
  assetTagId?: Maybe<Scalars['ID']>;
  currencyType?: Maybe<Scalars['String']>;
  decimalPoint: Scalars['Int'];
  followItemId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  isFollowing?: Maybe<Scalars['Boolean']>;
  name: LanguageString;
  symbol?: Maybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type CryptoCurrencyAsset = {
  __typename?: 'CryptoCurrencyAsset';
  base: CryptoCurrency;
  counter: Currency;
};

export type CryptoCurrencyDetail = {
  __typename?: 'CryptoCurrencyDetail';
  assetTagId?: Maybe<Scalars['ID']>;
  base: Scalars['String'];
  counter: Scalars['String'];
  counterCurrency: Currency;
  cryptoCurrencyExchangePrices?: Maybe<Array<CryptoCurrencyPrice>>;
  cryptoCurrencyPrice?: Maybe<CryptoCurrencyPrice>;
  currencyType?: Maybe<Scalars['String']>;
  decimalPoint: Scalars['Int'];
  favoriteItemUsersCount?: Maybe<Scalars['Int']>;
  followCryptoCurrencyId: Scalars['ID'];
  followItemId?: Maybe<Scalars['ID']>;
  followersCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  isFollowing?: Maybe<Scalars['Boolean']>;
  name: LanguageString;
  symbol: Scalars['String'];
  unit: Scalars['String'];
};

export type CryptoCurrencyPrice = {
  __typename?: 'CryptoCurrencyPrice';
  base: Scalars['String'];
  counter: Scalars['String'];
  dataSource?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  price?: Maybe<Scalars['String']>;
  priceChange?: Maybe<Scalars['String']>;
  priceChangePercent?: Maybe<Scalars['String']>;
  priceUpdatedAt?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CryptoCurrencyPriceUpdated. */
export type CryptoCurrencyPriceUpdatedPayload = {
  __typename?: 'CryptoCurrencyPriceUpdatedPayload';
  cryptoCurrencyPrice: CryptoCurrencyPrice;
};

export type CryptoExchange = {
  __typename?: 'CryptoExchange';
  accessKeyName?: Maybe<Scalars['String']>;
  hasAvgPriceFilled: Scalars['Boolean'];
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  logoImageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  secretKeyName?: Maybe<Scalars['String']>;
};

export type CryptoExchangeApiKey = {
  __typename?: 'CryptoExchangeApiKey';
  accessKey: Scalars['String'];
  createdAt: Scalars['String'];
  cryptoExchange: CryptoExchange;
  id: Scalars['ID'];
  secretKey: Scalars['String'];
};

export type Currency = {
  __typename?: 'Currency';
  currencyType?: Maybe<Scalars['String']>;
  decimalPoint: Scalars['Int'];
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  name: LanguageString;
  symbol?: Maybe<Scalars['String']>;
  unit: Scalars['String'];
};

export type CurrencyExchange = {
  __typename?: 'CurrencyExchange';
  base?: Maybe<Scalars['String']>;
  counter?: Maybe<Scalars['String']>;
  exchangePercent?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pair?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
};

export type CurrencyExchangeCandle = {
  __typename?: 'CurrencyExchangeCandle';
  base: Scalars['String'];
  c?: Maybe<Array<Scalars['String']>>;
  counter: Scalars['String'];
  h?: Maybe<Array<Scalars['String']>>;
  l?: Maybe<Array<Scalars['String']>>;
  o?: Maybe<Array<Scalars['String']>>;
  t?: Maybe<Array<Scalars['Int']>>;
};

export type CurrencyExchangeInput = {
  base?: InputMaybe<Scalars['String']>;
  counter?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CurrencyExchangeUpdated. */
export type CurrencyExchangeUpdatedPayload = {
  __typename?: 'CurrencyExchangeUpdatedPayload';
  currencyExchange: CurrencyExchange;
};

export type DecimalStockOrderInput = {
  amount: Scalars['Float'];
  amountType?: InputMaybe<KbSecDecimalOrderAmountEnum>;
  companyId: Scalars['ID'];
  tradeType: TradeTypeEnum;
};

export enum DecimalStockOrderStandardTypeEnum {
  /** Amount */
  Amount = 'AMOUNT',
  /** Price */
  Price = 'PRICE'
}

/** Autogenerated return type of DeleteUserPortfolioComment. */
export type DeleteUserPortfolioCommentPayload = {
  __typename?: 'DeleteUserPortfolioCommentPayload';
  comment: UserPortfolioComment;
  errors: Array<Scalars['String']>;
  portfolioComments: Array<UserPortfolioComment>;
};

/** Autogenerated return type of DeleteUserSignInSession. */
export type DeleteUserSignInSessionPayload = {
  __typename?: 'DeleteUserSignInSessionPayload';
  user: User;
};

export enum DeletedBy {
  /** Admin */
  Admin = 'ADMIN',
  /** Article deleted */
  ArticleDeleted = 'ARTICLE_DELETED',
  /** Report */
  Report = 'REPORT',
  /** Writer */
  Writer = 'WRITER'
}

export type DeviceInfoInput = {
  deviceType: Scalars['String'];
  deviceUniqueId: Scalars['String'];
  osType: Scalars['String'];
  pushToken: Scalars['String'];
};

/** Autogenerated return type of DisableDoNotDisturbMode. */
export type DisableDoNotDisturbModePayload = {
  __typename?: 'DisableDoNotDisturbModePayload';
  doNotDisturbMode: DoNotDisturbMode;
};

/** Autogenerated return type of DisableSharingFavoriteItemCategory. */
export type DisableSharingFavoriteItemCategoryPayload = {
  __typename?: 'DisableSharingFavoriteItemCategoryPayload';
  favoriteItemCategory: FavoriteItemCategory;
};

export type Disclosure = {
  __typename?: 'Disclosure';
  company: Company;
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  rcpNo?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type DividendCalendarRecord = {
  __typename?: 'DividendCalendarRecord';
  assetAmount?: Maybe<Scalars['Float']>;
  dividendHistory: DividendHistory;
};

export enum DividendCalendarSortTypeEnum {
  /** MARKET_DIVIDEND_RATE_ASCENDING */
  MarketDividendRateAscending = 'MARKET_DIVIDEND_RATE_ASCENDING',
  /** MARKET_DIVIDEND_RATE_DESCENDING */
  MarketDividendRateDescending = 'MARKET_DIVIDEND_RATE_DESCENDING'
}

export type DividendHistoriesExistingDaysForExternalChannel = {
  __typename?: 'DividendHistoriesExistingDaysForExternalChannel';
  dividendHistoriesExistingDays: Array<Scalars['String']>;
  totalCount: Scalars['Int'];
};

export type DividendHistory = {
  __typename?: 'DividendHistory';
  amount?: Maybe<Scalars['Float']>;
  company: Company;
  currency?: Maybe<Currency>;
  exDividendDate?: Maybe<Scalars['String']>;
  flag?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  paymentDate?: Maybe<Scalars['String']>;
  recordDate?: Maybe<Scalars['String']>;
};

export enum DividendHistoryBaseDateEnum {
  /** Ex dividend date base */
  ExDividendDate = 'EX_DIVIDEND_DATE',
  /** Payment date base */
  PaymentDate = 'PAYMENT_DATE'
}

export type DividendHistoryInput = {
  amount: Scalars['Float'];
  base: Scalars['String'];
  dataSource?: InputMaybe<Scalars['String']>;
  exDividendDate?: InputMaybe<Scalars['String']>;
  flag: Scalars['String'];
  frequency?: InputMaybe<Scalars['String']>;
  paymentDate: Scalars['String'];
  recordDate?: InputMaybe<Scalars['String']>;
};

export type DoNotDisturbMode = {
  __typename?: 'DoNotDisturbMode';
  endTime?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  startTime?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DoNotShowAd. */
export type DoNotShowAdPayload = {
  __typename?: 'DoNotShowAdPayload';
  ad: Ad;
};

export type EarningCalendar = {
  __typename?: 'EarningCalendar';
  company: Company;
  date: Scalars['String'];
  epsActual?: Maybe<Scalars['Float']>;
  epsEstimate?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  quarter?: Maybe<Scalars['Int']>;
  revenueActual?: Maybe<Scalars['Int']>;
  revenueEstimate?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['String']>;
};

export type EmailVerification = {
  __typename?: 'EmailVerification';
  email?: Maybe<Scalars['String']>;
  emailVerifiedAt?: Maybe<Scalars['String']>;
  verifyingEmailSentAt?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of EnableDoNotDisturbMode. */
export type EnableDoNotDisturbModePayload = {
  __typename?: 'EnableDoNotDisturbModePayload';
  doNotDisturbMode: DoNotDisturbMode;
};

/** Autogenerated return type of EnableSharingFavoriteItemCategory. */
export type EnableSharingFavoriteItemCategoryPayload = {
  __typename?: 'EnableSharingFavoriteItemCategoryPayload';
  favoriteItemCategory: FavoriteItemCategory;
};

export type Episode = {
  __typename?: 'Episode';
  attendanceHistory?: Maybe<LectureContentAttendanceHistory>;
  createdAt: Scalars['String'];
  episodeChapter?: Maybe<EpisodeChapter>;
  id: Scalars['ID'];
  isOpened: Scalars['Boolean'];
  isPreviewAvailable: Scalars['Boolean'];
  lectureReferenceDatas: Array<LectureReferenceData>;
  sequenceInChapter?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  subtitleUrl?: Maybe<Scalars['String']>;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['String'];
  videoDuration: Scalars['Float'];
  videoUrl: Scalars['String'];
};

export type EpisodeChapter = {
  __typename?: 'EpisodeChapter';
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isOpened: Scalars['Boolean'];
  sequence?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type EtcAsset = {
  __typename?: 'EtcAsset';
  category?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  name: LanguageString;
};

export enum EtcAssetCategory {
  /** Custom category */
  Custom = 'CUSTOM',
  /** Gold category */
  Gold = 'GOLD',
  /** Real estate category */
  RealEstate = 'REAL_ESTATE',
  /** Silver category */
  Silver = 'SILVER'
}

export type EtcCompanyAsset = {
  __typename?: 'EtcCompanyAsset';
  category?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  name: Scalars['String'];
  price?: Maybe<Scalars['String']>;
};

export type EtfDetail = {
  __typename?: 'EtfDetail';
  id: Scalars['ID'];
  stocks?: Maybe<Array<EtfDetailStockItem>>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type EtfDetailStockItem = {
  __typename?: 'EtfDetailStockItem';
  company: Company;
  ratio: Scalars['Float'];
};

export type EtfHoldingContainer = {
  __typename?: 'EtfHoldingContainer';
  atDate?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  holdings?: Maybe<Array<EtfHoldingItem>>;
  symbol?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
};

export type EtfHoldingInput = {
  country: Scalars['String'];
  ratio: Scalars['Float'];
  symbol: Scalars['String'];
};

export type EtfHoldingItem = {
  __typename?: 'EtfHoldingItem';
  cusip?: Maybe<Scalars['String']>;
  isin?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['String']>;
  share?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type EventStatus = {
  __typename?: 'EventStatus';
  endAt?: Maybe<Scalars['String']>;
  eventName: Scalars['String'];
  id: Scalars['ID'];
  isInProgress: Scalars['Boolean'];
  participantUserCounts?: Maybe<Scalars['Int']>;
  shareUrl?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ExposeAdContent. */
export type ExposeAdContentPayload = {
  __typename?: 'ExposeAdContentPayload';
  adContent: AdContent;
};

export enum ExternalChannelEnum {
  /** EBEST */
  Ebest = 'EBEST',
  /** SANG_SANG_IN */
  SangSangIn = 'SANG_SANG_IN'
}

export type FavoriteItem = {
  __typename?: 'FavoriteItem';
  company?: Maybe<Company>;
  cryptoCurrency?: Maybe<CryptoCurrency>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['ID']>;
  itemCategory?: Maybe<ItemCategory>;
};

export type FavoriteItemCategory = {
  __typename?: 'FavoriteItemCategory';
  categoryName?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<FavoriteItemCategoryComment>>;
  countOfStars?: Maybe<Scalars['Int']>;
  countOfView?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  items?: Maybe<Array<FavoriteItem>>;
  orderScore?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  slugSharedAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type FavoriteItemCategoryComment = {
  __typename?: 'FavoriteItemCategoryComment';
  comment: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  nickname?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  user: FavoriteItemCategoryCommentUser;
};

export type FavoriteItemCategoryCommentUser = {
  __typename?: 'FavoriteItemCategoryCommentUser';
  id?: Maybe<Scalars['ID']>;
  nickname: Scalars['String'];
};

export enum FavoriteItemCategoryFilter {
  /** Stars */
  Star = 'STAR',
  /** View */
  View = 'VIEW'
}

export type FeedFilteredByTag = {
  __typename?: 'FeedFilteredByTag';
  articles?: Maybe<Array<Article>>;
  assetTagTitle?: Maybe<AssetTagTitle>;
};

export type FeedTopic = {
  __typename?: 'FeedTopic';
  createdAt: Scalars['String'];
  feedTopicType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<LanguageString>;
  sortId: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type FinPongPlusApi = {
  __typename?: 'FinPongPlusApi';
  code: Scalars['String'];
  extraMessage: Scalars['String'];
};

export type FinPongPlusStatus = {
  __typename?: 'FinPongPlusStatus';
  hasFinPongPlusPortfolio: Scalars['Boolean'];
};

export type FollowCompany = {
  __typename?: 'FollowCompany';
  id: Scalars['ID'];
  logoImageUrl?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  symbol: Scalars['ID'];
};

export type FollowCryptoCurrency = {
  __typename?: 'FollowCryptoCurrency';
  id: Scalars['ID'];
  logoImageUrl?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  symbol: Scalars['ID'];
};

export type FollowItem = FollowCompany | FollowCryptoCurrency | FollowUser;

/** Autogenerated return type of FollowItem. */
export type FollowItemPayload = {
  __typename?: 'FollowItemPayload';
  item: SearchFollowItem;
};

/** Autogenerated return type of FollowItemsFromPortfolio. */
export type FollowItemsFromPortfolioPayload = {
  __typename?: 'FollowItemsFromPortfolioPayload';
  items: Array<SearchFollowItem>;
};

/** Autogenerated return type of FollowItems. */
export type FollowItemsPayload = {
  __typename?: 'FollowItemsPayload';
  items: Array<SearchFollowItem>;
};

export type FollowUser = {
  __typename?: 'FollowUser';
  description?: Maybe<Scalars['String']>;
  followersCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  nickname?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
};

export enum FollowingItemEnum {
  /** asset */
  Asset = 'ASSET',
  /** User */
  User = 'USER'
}

export type ForeignReserveStockOrderInput = {
  amount?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['ID'];
  orderType: TradeOrderEnum;
  price: Scalars['Float'];
  tradeType: TradeTypeEnum;
};

/** Autogenerated return type of ForkFavoriteItemCategoryToUser. */
export type ForkFavoriteItemCategoryToUserPayload = {
  __typename?: 'ForkFavoriteItemCategoryToUserPayload';
  errors: Array<Scalars['String']>;
  favoriteItemCategory?: Maybe<FavoriteItemCategory>;
};

export type FundoraAccount = {
  __typename?: 'FundoraAccount';
  accountInfoSequence: Scalars['String'];
  iconFileSequence: Scalars['String'];
  id: Scalars['ID'];
  logoFileSequence: Scalars['String'];
  portfolioSequence: Scalars['String'];
  salesLogoFileSequence: Scalars['String'];
};

export type FundoraPortfolioChatRoom = {
  __typename?: 'FundoraPortfolioChatRoom';
  chatRoom?: Maybe<ChatRoom>;
  isPortfolioJoined: Scalars['Boolean'];
};

export type FundoraUser = {
  __typename?: 'FundoraUser';
  username: Scalars['String'];
};

export type InvestingDiaryDepositWithdrawalLog = {
  __typename?: 'InvestingDiaryDepositWithdrawalLog';
  amount?: Maybe<Scalars['Float']>;
  category: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  date: Scalars['String'];
  emotion?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  memo?: Maybe<Scalars['String']>;
  ogTag?: Maybe<OgTag>;
  portfolio: UserPortfolio;
  side?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type InvestingDiaryDepositWithdrawalLogInput = {
  amount: Scalars['Float'];
  currencyId: Scalars['ID'];
  memo?: InputMaybe<Scalars['String']>;
  side?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type InvestingDiaryExchangeCurrencyLog = {
  __typename?: 'InvestingDiaryExchangeCurrencyLog';
  baseAmount?: Maybe<Scalars['Float']>;
  baseCurrency?: Maybe<Currency>;
  category: Scalars['String'];
  counterAmount?: Maybe<Scalars['Float']>;
  counterCurrency?: Maybe<Currency>;
  createdAt?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  emotion?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  memo?: Maybe<Scalars['String']>;
  ogTag?: Maybe<OgTag>;
  portfolio: UserPortfolio;
  updatedAt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type InvestingDiaryExchangeCurrencyLogInput = {
  baseAmount?: InputMaybe<Scalars['Float']>;
  baseCurrencyId?: InputMaybe<Scalars['ID']>;
  counterAmount?: InputMaybe<Scalars['Float']>;
  counterCurrencyId?: InputMaybe<Scalars['ID']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  memo?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type InvestingDiaryLog = InvestingDiaryDepositWithdrawalLog | InvestingDiaryExchangeCurrencyLog | InvestingDiaryMemoLog | InvestingDiaryTradeLog;

export type InvestingDiaryMemoLog = {
  __typename?: 'InvestingDiaryMemoLog';
  category: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  emotion?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  memo?: Maybe<Scalars['String']>;
  ogTag?: Maybe<OgTag>;
  portfolio: UserPortfolio;
  updatedAt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type InvestingDiaryMemoLogInput = {
  memo?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type InvestingDiaryTradeLog = {
  __typename?: 'InvestingDiaryTradeLog';
  amount?: Maybe<Scalars['Float']>;
  category: Scalars['String'];
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['String']>;
  cryptoCurrency?: Maybe<CryptoCurrency>;
  currency?: Maybe<Currency>;
  date: Scalars['String'];
  emotion?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  kbSecUserAccountConnectedAt?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  ogTag?: Maybe<OgTag>;
  portfolio: UserPortfolio;
  position?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  stockOrderHistoryId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type InvestingDiaryTradeLogInput = {
  amount?: InputMaybe<Scalars['Float']>;
  companyId?: InputMaybe<Scalars['ID']>;
  cryptoCurrencyId?: InputMaybe<Scalars['ID']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  memo?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
};

export type InvestingIdea = {
  __typename?: 'InvestingIdea';
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  investingIdeaCompanies?: Maybe<Array<Company>>;
  name: LanguageString;
  updatedAt?: Maybe<Scalars['String']>;
};

export type InvestingInsight = {
  __typename?: 'InvestingInsight';
  body: Scalars['String'];
  contentCreatedAt: Scalars['String'];
  contentType: Scalars['String'];
  createdAt: Scalars['String'];
  creator: Creator;
  dynamicLinkUrl: Scalars['String'];
  id: Scalars['ID'];
  language: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  originalUrl: Scalars['String'];
  platform: InvestingInsightPlatform;
  tags: Array<Scalars['String']>;
  thumbnailImageUrl: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type InvestingInsightPlatform = {
  __typename?: 'InvestingInsightPlatform';
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  names: LanguageString;
};

export type InvestingInsightTag = {
  __typename?: 'InvestingInsightTag';
  id: Scalars['ID'];
  name: Scalars['String'];
  names: LanguageString;
  sortId: Scalars['Int'];
};

export type InvestingKeyword = {
  __typename?: 'InvestingKeyword';
  id: Scalars['ID'];
  keyword: Scalars['String'];
  keywordCategory: Scalars['String'];
  language: Scalars['String'];
  referencedCount: Scalars['Int'];
};

export type InvestingKeywordWithIsSelected = {
  __typename?: 'InvestingKeywordWithIsSelected';
  id: Scalars['ID'];
  isSelected?: Maybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  keywordCategory: Scalars['String'];
  language: Scalars['String'];
  referencedCount: Scalars['Int'];
};

export enum ItemCategory {
  /** Company Asset */
  Company = 'COMPANY',
  /** Crypto Currency Asset */
  CryptoCurrency = 'CRYPTO_CURRENCY',
  /** Currency Asset */
  Currency = 'CURRENCY'
}

export type JoinTermsInput = {
  agreement: Scalars['String'];
  channelList: Array<Scalars['String']>;
  termsCode: Scalars['String'];
};

export type KbSecAccountPasswordVerification = {
  __typename?: 'KbSecAccountPasswordVerification';
  isVerified: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type KbSecAccountStatus = {
  __typename?: 'KbSecAccountStatus';
  hasAccount: Scalars['Boolean'];
  needToAgreeTerms: Scalars['Boolean'];
  newAccountRegisterUrl?: Maybe<Scalars['String']>;
};

export type KbSecAgreement = {
  __typename?: 'KbSecAgreement';
  ci: Scalars['String'];
  createdAt: Scalars['String'];
};

export enum KbSecDecimalOrderAmountEnum {
  /** All */
  All = 'ALL',
  /** Partial */
  Partial = 'PARTIAL'
}

export type KbSecFeeRatioOnOrder = {
  __typename?: 'KbSecFeeRatioOnOrder';
  feeRatio: Scalars['String'];
  isEventTarget: Scalars['Boolean'];
};

export type KbSecHoldingAssetAmount = {
  __typename?: 'KbSecHoldingAssetAmount';
  holdingAmount: Scalars['Float'];
  orderableAmount: Scalars['Float'];
  orderablePrice?: Maybe<Scalars['Float']>;
};

export type KbSecHoldingAssetAmountAtSell = {
  __typename?: 'KbSecHoldingAssetAmountAtSell';
  decimalHoldingAmount?: Maybe<Scalars['Float']>;
  decimalOrderableAmount?: Maybe<Scalars['Float']>;
  decimalOrderablePrice?: Maybe<Scalars['Float']>;
  generalHoldingAmount?: Maybe<Scalars['Float']>;
  generalOrderableAmount?: Maybe<Scalars['Float']>;
  generalOrderablePrice?: Maybe<Scalars['Float']>;
};

export type KbSecOrderableCashAmount = {
  __typename?: 'KbSecOrderableCashAmount';
  depositAmount?: Maybe<Scalars['Float']>;
  orderableCashAmount?: Maybe<Scalars['Float']>;
  totalOrderableCashAmount?: Maybe<Scalars['Float']>;
  usStockOrderableCashAmount?: Maybe<Scalars['Float']>;
  withdrawableCashAmount?: Maybe<Scalars['Float']>;
};

export type KbSecPrivacyTerms = {
  __typename?: 'KbSecPrivacyTerms';
  termsUrl: Scalars['String'];
};

export type KbSecPrivacyTermsAgreementHistory = {
  __typename?: 'KbSecPrivacyTermsAgreementHistory';
  termsUrl: Scalars['String'];
  userId: Scalars['String'];
};

export type KbSecPrivacyTermsAgreementStatus = {
  __typename?: 'KbSecPrivacyTermsAgreementStatus';
  needToAgreeTerms: Scalars['Boolean'];
  newAccountRegisterUrl: Scalars['String'];
};

export type KbSecRandomStockPrize = {
  __typename?: 'KbSecRandomStockPrize';
  companyId: Scalars['ID'];
  companyNames: LanguageString;
  imageUrl: Scalars['String'];
  ticker: Scalars['String'];
};

export type KbSecScreenApi = {
  __typename?: 'KbSecScreenApi';
  accessToken: Scalars['String'];
  accountNumber: Scalars['String'];
  authKey: Scalars['String'];
  benefitIsinCode?: Maybe<Scalars['String']>;
  callbackType: Scalars['String'];
  callbackUrl: Scalars['String'];
  channel: Scalars['String'];
  ci?: Maybe<Scalars['String']>;
  company?: Maybe<StockOrderHistoryCompany>;
  correctionTypeCode?: Maybe<Scalars['String']>;
  creditTypeCode?: Maybe<Scalars['String']>;
  decimalOrderSequence?: Maybe<Scalars['String']>;
  decimalOrderStandardTypeCode?: Maybe<Scalars['String']>;
  decimalTradeJobTypeCode?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  hashKey: Scalars['String'];
  issueNumber: Scalars['String'];
  linkUrl: Scalars['String'];
  orderAmount?: Maybe<Scalars['String']>;
  orderAmountTypeCode?: Maybe<Scalars['String']>;
  orderDate?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  orderPrice?: Maybe<Scalars['String']>;
  orderSequence?: Maybe<Scalars['String']>;
  orderStandardTypeCode?: Maybe<Scalars['String']>;
  orderType?: Maybe<Scalars['String']>;
  orderTypeCode?: Maybe<Scalars['String']>;
  originalOrderNumber?: Maybe<Scalars['String']>;
  overtimeOrderTypeCode?: Maybe<Scalars['String']>;
  paramValue: Scalars['String'];
  partnerCode: Scalars['String'];
  periodicalOrderNumber?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  ticker: Scalars['String'];
  timestamp: Scalars['String'];
  tradeTypeCode?: Maybe<Scalars['String']>;
  tvRvCode?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
};

export type KbSecStockOrderHistory = {
  __typename?: 'KbSecStockOrderHistory';
  accountNumber: Scalars['String'];
  appliedExchangeRate?: Maybe<Scalars['Float']>;
  appliedFeeRatio?: Maybe<Scalars['Float']>;
  benefitIsinCode?: Maybe<Scalars['String']>;
  company: StockOrderHistoryCompany;
  concludedAmount?: Maybe<Scalars['Float']>;
  concludedAt?: Maybe<Scalars['String']>;
  concludedDate?: Maybe<Scalars['String']>;
  concludedPrice?: Maybe<Scalars['Float']>;
  concludedTime?: Maybe<Scalars['String']>;
  currency: StockOrderHistoryCurrency;
  decimalConcludedPrice?: Maybe<Scalars['Float']>;
  decimalOrderPrice?: Maybe<Scalars['Float']>;
  decimalOrderSequence?: Maybe<Scalars['String']>;
  decimalOrderStandardType?: Maybe<Scalars['String']>;
  decimalTradeJobTypeCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCanceled: Scalars['Boolean'];
  isConcluded: Scalars['Boolean'];
  isRefused: Scalars['Boolean'];
  isReservedOrder: Scalars['Boolean'];
  isTransactioned?: Maybe<Scalars['Boolean']>;
  marketType: Scalars['String'];
  notConcludedAmount?: Maybe<Scalars['Float']>;
  orderAmount?: Maybe<Scalars['Float']>;
  orderCompletedAt?: Maybe<Scalars['String']>;
  orderDate: Scalars['String'];
  orderNumber: Scalars['String'];
  orderPrice?: Maybe<Scalars['Float']>;
  orderScheduledAt?: Maybe<Scalars['String']>;
  orderSequence?: Maybe<Scalars['String']>;
  orderStatus: Scalars['String'];
  orderTime?: Maybe<Scalars['String']>;
  orderType: Scalars['String'];
  orderedAt: Scalars['String'];
  organization: Scalars['String'];
  originalOrderNumber?: Maybe<Scalars['String']>;
  productNumber: Scalars['String'];
  refusedReason?: Maybe<Scalars['String']>;
  reserveOrderSequence?: Maybe<Scalars['String']>;
  totalConcludedAmount?: Maybe<Scalars['Float']>;
  tradeType: Scalars['String'];
  transactionScheduledAt?: Maybe<Scalars['String']>;
  userPortfolio?: Maybe<StockOrderHistoryPortfolio>;
};

export type KbSecUserAccount = {
  __typename?: 'KbSecUserAccount';
  accountConnectedAt?: Maybe<Scalars['String']>;
  accountName: Scalars['String'];
  accountNumber: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isRecentlyUsedAccount?: Maybe<Scalars['Boolean']>;
  productName: Scalars['String'];
  productNumber: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type KbSecUserAccountDeposit = {
  __typename?: 'KbSecUserAccountDeposit';
  afterNextDayDeposit?: Maybe<Scalars['Float']>;
  deposit?: Maybe<Scalars['Float']>;
  foreignCurrencyDepositConversionAmount?: Maybe<Scalars['Float']>;
  nextDayDeposit?: Maybe<Scalars['Float']>;
};

export type KbSecUserAccountTransactionHistory = {
  __typename?: 'KbSecUserAccountTransactionHistory';
  nextKey?: Maybe<Scalars['String']>;
  transactionHistories: Array<KbSecUserAccountTransactionHistoryRecord>;
};

export type KbSecUserAccountTransactionHistoryRecord = {
  __typename?: 'KbSecUserAccountTransactionHistoryRecord';
  counterPartyAccountName: Scalars['String'];
  counterPartyBankName: Scalars['String'];
  deposit?: Maybe<Scalars['Float']>;
  orderMediaName: Scalars['String'];
  transactionAmount: Scalars['Float'];
  transactionAt: Scalars['String'];
  transactionType: Scalars['String'];
};

export type KbSecUserPhoneVerificationStatus = {
  __typename?: 'KbSecUserPhoneVerificationStatus';
  ciStatus: Scalars['String'];
  isVerified: Scalars['Boolean'];
};

export type KoreanCertification = {
  __typename?: 'KoreanCertification';
  certification?: Maybe<Scalars['String']>;
  certificationPassword?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
};

export type KrRemoveReservedStockOrderInput = {
  amount: Scalars['Float'];
  companyId: Scalars['ID'];
  orderDate: Scalars['String'];
  orderNumber: Scalars['String'];
  orderType: TradeOrderEnum;
  price: Scalars['Float'];
  tradeType: TradeTypeEnum;
};

export type LandingLink = {
  __typename?: 'LandingLink';
  locale?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type LanguageString = {
  __typename?: 'LanguageString';
  en?: Maybe<Scalars['String']>;
  ko?: Maybe<Scalars['String']>;
};

export type LatestAgreements = {
  __typename?: 'LatestAgreements';
  marketing?: Maybe<Agreement>;
  privacy?: Maybe<Agreement>;
  terms?: Maybe<Agreement>;
};

export type LectureContent = {
  __typename?: 'LectureContent';
  author: CommunityUser;
  availabilityDays: Scalars['Int'];
  averageGrade: Scalars['Float'];
  cardImageUrl?: Maybe<Scalars['String']>;
  chatRoomId?: Maybe<Scalars['String']>;
  chatRoomUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  desktopThumbnailImageUrl?: Maybe<Scalars['String']>;
  episodesCount: Scalars['Int'];
  id: Scalars['ID'];
  introduction?: Maybe<Scalars['String']>;
  isOpened: Scalars['Boolean'];
  isSerializationScheduled: Scalars['Boolean'];
  isUserOwnedLectureContent: Scalars['Boolean'];
  isWished: Scalars['Boolean'];
  lectureAttendanceRate: Scalars['Float'];
  lectureReferenceDatas: Array<LectureReferenceData>;
  previewVideoUrl?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  relatedVideoTitle?: Maybe<Scalars['String']>;
  relatedVideoUrl?: Maybe<Scalars['String']>;
  reviewsCount: Scalars['Int'];
  serializationScheduleDescription?: Maybe<Scalars['String']>;
  serializationScheduleTitle?: Maybe<Scalars['String']>;
  serializationScheduledAt?: Maybe<Scalars['String']>;
  shareUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  summaryCardImageUrl?: Maybe<Scalars['String']>;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  timeSaleEndedAt?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['String'];
  wishedUsersCount: Scalars['Int'];
};

export type LectureContentAttendanceHistory = {
  __typename?: 'LectureContentAttendanceHistory';
  episodeAttendanceRate?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  lastEpisodeDurationPoint?: Maybe<Scalars['Float']>;
};

export type LectureContentOpenNotification = {
  __typename?: 'LectureContentOpenNotification';
  id: Scalars['ID'];
  lectureContentId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type LectureContentReview = {
  __typename?: 'LectureContentReview';
  communityUser: CommunityUser;
  content: Scalars['String'];
  createdAt: Scalars['String'];
  grade: Scalars['Float'];
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  isLiked: Scalars['Boolean'];
  likesCount: Scalars['Int'];
  replies: Array<LectureContentReviewReply>;
  repliesCount: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type LectureContentReviewReply = {
  __typename?: 'LectureContentReviewReply';
  communityUser: CommunityUser;
  content: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  updatedAt: Scalars['String'];
};

export enum LectureContentReviewSortTypeEnum {
  /** Grade high */
  GradeHigh = 'GRADE_HIGH',
  /** Grade low */
  GradeLow = 'GRADE_LOW',
  /** Latest */
  Latest = 'LATEST',
  /** Likes Count */
  LikesCount = 'LIKES_COUNT'
}

export type LectureContentReviewsWithGrade = {
  __typename?: 'LectureContentReviewsWithGrade';
  averageGrade: Scalars['Float'];
  myReview?: Maybe<LectureContentReview>;
  perfectReviewPercentage: Scalars['Float'];
  reviews: Array<LectureContentReview>;
  totalGrade: Scalars['Float'];
  totalReviewsCount: Scalars['Int'];
};

export type LectureContentTag = {
  __typename?: 'LectureContentTag';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type LectureReferenceData = {
  __typename?: 'LectureReferenceData';
  content: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type MailingGroup = {
  __typename?: 'MailingGroup';
  id: Scalars['ID'];
  name: LanguageString;
  subscribedUsers: Array<SubscribedUser>;
  subscribedUsersCount: Scalars['Int'];
};

export type MailingGroupEmailVerification = {
  __typename?: 'MailingGroupEmailVerification';
  email?: Maybe<Scalars['String']>;
  emailVerifiedAt?: Maybe<Scalars['String']>;
  verifyingEmailSentAt?: Maybe<Scalars['String']>;
};

export type MarketCalendar = {
  __typename?: 'MarketCalendar';
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  exchange?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  memo?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum MarketTypeEnum {
  /** After Market */
  AfterMarket = 'AFTER_MARKET',
  /** Closed */
  Closed = 'CLOSED',
  /** Day Market */
  DayMarket = 'DAY_MARKET',
  /** Market */
  Market = 'MARKET',
  /** Pre Market */
  PreMarket = 'PRE_MARKET'
}

export type MbtiResultCounter = {
  __typename?: 'MbtiResultCounter';
  count: Scalars['Int'];
  id: Scalars['ID'];
  mbtiType: Scalars['String'];
};

export type MbtiVisitorCounter = {
  __typename?: 'MbtiVisitorCounter';
  todayVisitorCounter: VisitorCounter;
  totalVisitorCounter: VisitorCounter;
};

/** Autogenerated return type of MigrateFundoraUserPhoneVerificationDataToKbSec. */
export type MigrateFundoraUserPhoneVerificationDataToKbSecPayload = {
  __typename?: 'MigrateFundoraUserPhoneVerificationDataToKbSecPayload';
  kbSecUserPhoneVerification: UserPhoneVerificationKr;
};

/** Autogenerated return type of MigrateKbSecUserPhoneVerificationDataToFundora. */
export type MigrateKbSecUserPhoneVerificationDataToFundoraPayload = {
  __typename?: 'MigrateKbSecUserPhoneVerificationDataToFundoraPayload';
  fundoraUserPhoneVerification: UserPhoneVerificationKr;
};

export type Mutation = {
  __typename?: 'Mutation';
  acquireBadge?: Maybe<AcquireBadgePayload>;
  addArticle?: Maybe<AddArticlePayload>;
  addArticleComment?: Maybe<AddArticleCommentPayload>;
  addAssetItemsToUserFavorite?: Maybe<AddAssetItemsToUserFavoritePayload>;
  addBackTestingProjectResult?: Maybe<AddBackTestingProjectResultPayload>;
  addBookmarkToArticle?: Maybe<AddBookmarkToArticlePayload>;
  addBuyForeignDecimalStockOrder?: Maybe<AddBuyForeignDecimalStockOrderPayload>;
  addBuyForeignStockOrder?: Maybe<AddBuyForeignStockOrderPayload>;
  addBuyKrDecimalStockOrder?: Maybe<AddBuyKrDecimalStockOrderPayload>;
  addBuyKrStockOrder?: Maybe<AddBuyKrStockOrderPayload>;
  addCommentToFavoriteItemCategory?: Maybe<AddCommentToFavoriteItemCategoryPayload>;
  addCommunityReport?: Maybe<AddCommunityReportPayload>;
  addCompanyAssetsToPortfolio?: Maybe<AddPortfolioAssetsPayload>;
  addCryptoCurrencyAssetsToPortfolio?: Maybe<AddCryptoCurrencyAssetsToPortfolioPayload>;
  addCryptoExchangeApiKeyToUser?: Maybe<AddCryptoExchangeApiKeyToUserPayload>;
  addCurrencyAssetsToPortfolio?: Maybe<AddCurrencyAssetsToPortfolioPayload>;
  addCustomPortfolioTopic?: Maybe<AddCustomPortfolioTopicPayload>;
  addDividendHistories?: Maybe<AddDividendHistoriesPayload>;
  addEtcAssetsToPortfolio?: Maybe<AddEtcAssetsToPortfolioPayload>;
  addFavoriteItemCategory?: Maybe<AddFavoriteItemCategoryPayload>;
  addInvestingKeywordToMe?: Maybe<AddInvestingKeywordToMePayload>;
  addItemsToFavoriteItemCategory?: Maybe<AddItemsToFavoriteItemCategoryPayload>;
  addKbSecUserAccount?: Maybe<AddKbSecUserAccountPayload>;
  addLectureContentAttendanceHistory?: Maybe<AddLectureContentAttendanceHistoryPayload>;
  addLectureContentOpenNotification?: Maybe<AddLectureContentOpenNotificationPayload>;
  addLectureContentReview?: Maybe<AddLectureContentReviewPayload>;
  addLikeToArticle?: Maybe<AddLikeToArticlePayload>;
  addLikeToLectureContentReview?: Maybe<AddLikeToLectureContentReviewPayload>;
  addLogToInvestingDiary?: Maybe<AddLogToInvestingDiaryPayload>;
  addMyFinPongPlusPortfoliosFromApp?: Maybe<AddMyFinPongPlusPortfoliosFromAppPayload>;
  addOrderItemsToUser?: Maybe<AddOrderItemsToUserPayload>;
  addPortfolioAssets?: Maybe<AddPortfolioAssetsPayload>;
  addPortfolioRecommendationReview?: Maybe<PortfolioRecommendationReview>;
  addPushClickHistory?: Maybe<PushClickHistory>;
  addReferralCodeFromKbAccountEvent?: Maybe<UserReferral>;
  addReplyToArticleComment?: Maybe<AddReplyToArticleCommentPayload>;
  addReplyToLectureContentReview?: Maybe<AddReplyToLectureContentReviewPayload>;
  addReserveBuyForeignStockOrder?: Maybe<AddReserveBuyForeignStockOrderPayload>;
  addReserveBuyKrStockOrder?: Maybe<AddReserveBuyKrStockOrderPayload>;
  addReserveSellForeignStockOrder?: Maybe<AddReserveSellForeignStockOrderPayload>;
  addReserveSellKrStockOrder?: Maybe<AddReserveSellKrStockOrderPayload>;
  addReviewRequestedStatus?: Maybe<AddReviewRequestedStatusPayload>;
  addSellForeignDecimalStockOrder?: Maybe<AddSellForeignDecimalStockOrderPayload>;
  addSellForeignStockOrder?: Maybe<AddSellForeignStockOrderPayload>;
  addSellKrDecimalStockOrder?: Maybe<AddSellKrDecimalStockOrderPayload>;
  addSellKrStockOrder?: Maybe<AddSellKrStockOrderPayload>;
  addStarToFavoriteItemCategory?: Maybe<AddStarToFavoriteItemCategoryPayload>;
  addStockOrderHistory?: Maybe<AddStockOrderHistoryPayload>;
  addWishToLectureContent?: Maybe<AddWishToLectureContentPayload>;
  agreeKbSecAccountTerms?: Maybe<AgreeKbSecAccountTermsPayload>;
  applyProfessionalInvestor?: Maybe<ApplyProfessionalInvestorPayload>;
  blockUser?: Maybe<BlockUserPayload>;
  clickAd?: Maybe<ClickAdPayload>;
  clickAdContent?: Maybe<ClickAdContentPayload>;
  clickCpsAd?: Maybe<ClickCpsAdPayload>;
  clickInvestingInsight?: Maybe<ClickInvestingInsightPayload>;
  confirmBadgeNotifications?: Maybe<ConfirmBadgeNotificationsPayload>;
  confirmCodeToVerifyPhoneNumber?: Maybe<PhoneNumberVerification>;
  confirmCommunityNotifications?: Maybe<ConfirmCommunityNotificationsPayload>;
  confirmTokenToVerifyEmail?: Maybe<EmailVerification>;
  connectKbSecUserAccount: ConnectKbSecUserAccount;
  connectKbSecUserAccountScreen?: Maybe<ConnectKbSecUserAccountScreenPayload>;
  connectPartnerWithUserData?: Maybe<AuthToken>;
  connectWithSamsungEncKey?: Maybe<AuthToken>;
  copyMyPortfolio?: Maybe<UserPortfolio>;
  createDividendPortfolioSample?: Maybe<CreateDividendPortfolioSamplePayload>;
  createLectureContentOrder?: Maybe<CreateLectureContentOrderPayload>;
  createPlaidLinkToken?: Maybe<CreatePlaidLinkTokenPayload>;
  createPortfolioFromCryptoExchangeApiKey?: Maybe<CreatePortfolioFromCryptoExchangeApiKeyPayload>;
  createPortfolioFromPlaidPublicToken?: Maybe<CreatePortfolioFromPlaidPublicTokenPayload>;
  createPortfolioFromSecuritiesAccount?: Maybe<CreatePortfolioFromSecuritiesAccountPayload>;
  createSnp500DividendPortfolioSample?: Maybe<CreateSnp500DividendPortfolioSamplePayload>;
  deleteUserPortfolioComment?: Maybe<DeleteUserPortfolioCommentPayload>;
  deleteUserSignInSession?: Maybe<DeleteUserSignInSessionPayload>;
  denyTokenToVerifyEmail?: Maybe<EmailVerification>;
  disableDoNotDisturbMode?: Maybe<DisableDoNotDisturbModePayload>;
  disableSharingFavoriteItemCategory?: Maybe<DisableSharingFavoriteItemCategoryPayload>;
  disableSharingPortfolio?: Maybe<PortfolioLink>;
  doNotShowAd?: Maybe<DoNotShowAdPayload>;
  enableDoNotDisturbMode?: Maybe<EnableDoNotDisturbModePayload>;
  enableSharingFavoriteItemCategory?: Maybe<EnableSharingFavoriteItemCategoryPayload>;
  enableSharingPortfolio?: Maybe<PortfolioLink>;
  exposeAdContent?: Maybe<ExposeAdContentPayload>;
  followItem?: Maybe<FollowItemPayload>;
  followItems?: Maybe<FollowItemsPayload>;
  followItemsFromPortfolio?: Maybe<FollowItemsFromPortfolioPayload>;
  forkFavoriteItemCategoryToUser?: Maybe<ForkFavoriteItemCategoryToUserPayload>;
  generateSignedCookiesForEpisode?: Maybe<CloudFrontSignedCookie>;
  kbSecAgreePrivacyTerms?: Maybe<KbSecPrivacyTermsAgreementHistory>;
  kbSecRandomStockPicking?: Maybe<KbSecRandomStockPrize>;
  kbSecReferralRandomStockPicking?: Maybe<KbSecRandomStockPrize>;
  migrateFundoraUserPhoneVerificationDataToKbSec?: Maybe<MigrateFundoraUserPhoneVerificationDataToKbSecPayload>;
  migrateKbSecUserPhoneVerificationDataToFundora?: Maybe<MigrateKbSecUserPhoneVerificationDataToFundoraPayload>;
  participateFundoraPreRegistrationEvent?: Maybe<ParticipateFundoraPreRegistrationEventPayload>;
  postUserPortfolioComment?: Maybe<PostUserPortfolioCommentPayload>;
  publishArticle?: Maybe<PublishArticlePayload>;
  randomStockPicking?: Maybe<StockPrize>;
  removeArticle?: Maybe<RemoveArticlePayload>;
  removeArticleComment?: Maybe<RemoveArticleCommentPayload>;
  removeArticles?: Maybe<RemoveArticlesPayload>;
  removeBackTestingProjectResult?: Maybe<RemoveBackTestingProjectResultPayload>;
  removeBookmarkFromArticle?: Maybe<RemoveBookmarkFromArticlePayload>;
  removeCommentFromFavoriteItemCategory?: Maybe<RemoveCommentFromFavoriteItemCategoryPayload>;
  removeCryptoExchangeApiKeyFromPortfolio?: Maybe<RemoveCryptoExchangeApiKeyFromPortfolioPayload>;
  removeCryptoExchangeApiKeyFromUser?: Maybe<RemoveCryptoExchangeApiKeyFromUserPayload>;
  removeFavoriteItemCategory?: Maybe<RemoveFavoriteItemCategoryPayload>;
  removeFinPongPlusConnect?: Maybe<RemoveFinPongPlusConnectPayload>;
  removeForeignDecimalStockOrder?: Maybe<RemoveForeignDecimalStockOrderPayload>;
  removeForeignStockOrder?: Maybe<RemoveForeignStockOrderPayload>;
  removeInvestingDiaryLog?: Maybe<RemoveInvestingDiaryLogPayload>;
  removeItemsToFavoriteItemCategory?: Maybe<RemoveItemsToFavoriteItemCategoryPayload>;
  removeKrDecimalStockOrder?: Maybe<RemoveKrDecimalStockOrderPayload>;
  removeKrStockOrder?: Maybe<RemoveKrStockOrderPayload>;
  removeLectureContentReview?: Maybe<RemoveLectureContentReviewPayload>;
  removeLectureContentReviewReply?: Maybe<RemoveLectureContentReviewReplyPayload>;
  removeLikeToArticle?: Maybe<RemoveLikeToArticlePayload>;
  removeLikeToLectureContentReview?: Maybe<RemoveLikeToLectureContentReviewPayload>;
  removeMyRepresentativeBadge?: Maybe<RemoveMyRepresentativeBadgePayload>;
  removePlaidConnectFromPortfolio?: Maybe<RemovePlaidConnectFromPortfolioPayload>;
  removePortfolio?: Maybe<RemovePortfolioPayload>;
  removePortfolioAssets?: Maybe<RemovePortfolioAssetsPayload>;
  removePortfolios?: Maybe<RemovePortfoliosPayload>;
  removeReserveForeignStockOrder?: Maybe<RemoveReserveForeignStockOrderPayload>;
  removeReserveKrStockOrder?: Maybe<RemoveReserveKrStockOrderPayload>;
  removeSecuritiesAccountFromPortfolio?: Maybe<RemoveSecuritiesAccountFromPortfolioPayload>;
  removeStarFromFavoriteItemCategory?: Maybe<RemoveStarFromFavoriteItemCategoryPayload>;
  removeTagsFromPortfolio?: Maybe<UserPortfolioTag>;
  removeWishToLectureContent?: Maybe<RemoveWishToLectureContentPayload>;
  reportDividendHistoryErrorAboutStock?: Maybe<ReportDividendHistoryErrorAboutStockPayload>;
  reportDividendMonthErrorAboutStock?: Maybe<ReportDividendMonthErrorAboutStockPayload>;
  reportLectureContentReview?: Maybe<ReportLectureContentReviewPayload>;
  reportLectureContentReviewReply?: Maybe<ReportLectureContentReviewReplyPayload>;
  reportNormalErrorAboutStock?: Maybe<ReportNormalErrorAboutStockPayload>;
  reportSectorErrorAboutStock?: Maybe<ReportSectorErrorAboutStockPayload>;
  reportUnresolvedSymbol?: Maybe<ReportUnresolvedSymbolPayload>;
  requestProfessionalInvestorVerification?: Maybe<RequestProfessionalInvestorVerificationPayload>;
  requestTerminateUserMembership?: Maybe<UserMembership>;
  requestTossPaymentFail?: Maybe<RequestTossPaymentFailPayload>;
  requestTossPaymentSuccess?: Maybe<RequestTossPaymentSuccessPayload>;
  requestUserPhoneVerificationForFundora?: Maybe<RequestUserPhoneVerificationForFundoraPayload>;
  requestUserPhoneVerificationForKbSec?: Maybe<RequestUserPhoneVerificationForKbSecPayload>;
  requestUserPhoneVerificationToKrTelecom?: Maybe<RequestUserPhoneVerificationToKrTelecomPayload>;
  requestUserPhoneVerificationToTelecom?: Maybe<PhoneNumberVerification>;
  saveArticleTemporary?: Maybe<SaveArticleTemporaryPayload>;
  saveDividendPortfolio?: Maybe<SaveDividendPortfolioPayload>;
  saveDividendPortfolioFromSamsung?: Maybe<SaveDividendPortfolioFromSamsungPayload>;
  sendChatPushMessageToUsers?: Maybe<PushMessage>;
  sendDownloadAppLinkUrlSms?: Maybe<SendDownloadAppLinkUrlSmsPayload>;
  sendEmailToSubscribeMailingGroup?: Maybe<MailingGroupEmailVerification>;
  sendEmailToVerifyEmail?: Maybe<EmailVerification>;
  sendPushMessageToDevice?: Maybe<PushMessage>;
  sendPushMessageToKeywordSubscribedUsers?: Maybe<PushMessage>;
  sendPushMessageToUser?: Maybe<PushMessage>;
  sendPushMessageToUsers?: Maybe<PushMessage>;
  sendSmsToVerifyPhoneNumber?: Maybe<PhoneNumberVerification>;
  signIn?: Maybe<AuthToken>;
  signInWithFundora?: Maybe<SignInResult>;
  signOut?: Maybe<SignOut>;
  signUpWithFundora?: Maybe<SignUpWithFundoraPayload>;
  subscribeMailingGroup?: Maybe<MailingGroupEmailVerification>;
  syncFundoraPortfolio?: Maybe<SyncFundoraPortfolioPayload>;
  syncFundoraPortfolios?: Maybe<SyncFundoraPortfoliosPayload>;
  synchronizeKbSecAccount?: Maybe<SynchronizeKbSecAccountPayload>;
  unblockUser?: Maybe<UnblockUserPayload>;
  unfollowItem?: Maybe<UnfollowItemPayload>;
  unfollowItems?: Maybe<UnfollowItemsPayload>;
  unsubscribeMailingGroup?: Maybe<MailingGroupEmailVerification>;
  updateArticle?: Maybe<UpdateArticlePayload>;
  updateArticleComment?: Maybe<UpdateArticleCommentPayload>;
  updateBackTestingProjectResult?: Maybe<UpdateBackTestingProjectResultPayload>;
  updateBaseCurrencyAtPortfolio?: Maybe<UpdateBaseCurrencyAtPortfolioPayload>;
  updateChatRoomNotificationFromFirestore?: Maybe<UpdateChatRoomNotificationFromFirestorePayload>;
  updateCryptoExchangeApiKeyFromPortfolio?: Maybe<UpdateCryptoExchangeApiKeyFromPortfolioPayload>;
  updateEtfDetail?: Maybe<UpdateEtfDetailPayload>;
  updateFavoriteItemCategory?: Maybe<UpdateFavoriteItemCategoryPayload>;
  updateFavoriteItemCategoryOrders?: Maybe<UpdateFavoriteItemCategoryOrdersPayload>;
  updateInvestingDiaryLog?: Maybe<UpdateInvestingDiaryLogPayload>;
  updateKbSecPortfolioAtBackground?: Maybe<Scalars['Boolean']>;
  updateLectureContentReview?: Maybe<UpdateLectureContentReviewPayload>;
  updateLectureContentReviewReply?: Maybe<UpdateLectureContentReviewReplyPayload>;
  updateMajorSecuritiesOrganization?: Maybe<UpdateMajorSecuritiesOrganizationPayload>;
  updateMyAppBiometric?: Maybe<UserSecurity>;
  updateMyAppPasscode?: Maybe<UserSecurity>;
  updateMyAppPassword?: Maybe<UserSecurity>;
  updateMyCompanySector?: Maybe<UpdateMyCompanySectorPayload>;
  updateMyDevice?: Maybe<UpdateMyDevicePayload>;
  updateMyFinPongPlusPortfolios?: Maybe<UpdateMyFinPongPlusPortfoliosPayload>;
  updateMyFinPongPlusPortfoliosFromApp?: Maybe<UpdateMyFinPongPlusPortfoliosFromAppPayload>;
  updateMyInvestingKeywords?: Maybe<UpdateMyInvestingKeywordsPayload>;
  updateMyNotificationSetting?: Maybe<UpdateMyNotificationSettingPayload>;
  updateMyPreference?: Maybe<UpdateMyPreferencePayload>;
  updateMyProfile?: Maybe<UpdateMyProfilePayload>;
  updateMyRepresentativeBadge?: Maybe<UpdateMyRepresentativeBadgePayload>;
  updatePortfolioAsset?: Maybe<UpdatePortfolioAssetPayload>;
  updatePortfolioFromCryptoExchangeApiKey?: Maybe<UpdatePortfolioFromCryptoExchangeApiKeyPayload>;
  updatePortfolioFromKbSecAccount?: Maybe<UpdatePortfolioFromKbSecAccountPayload>;
  updatePortfolioFromPlaid?: Maybe<UpdatePortfolioFromPlaidPayload>;
  updatePortfolioFromSecuritiesAccount?: Maybe<UpdatePortfolioFromSecuritiesAccountPayload>;
  updatePortfolioInformation?: Maybe<UpdatePortfolioInformationPayload>;
  updatePortfolioOrderScores?: Maybe<UpdatePortfolioOrderScoresPayload>;
  updatePortfolioSwitchOn?: Maybe<UpdatePortfolioSwitchOnPayload>;
  updateSignInSession?: Maybe<AuthToken>;
  updateSwitchPortfolio?: Maybe<UpdateSwitchPortfolioPayload>;
  updateTagsToPortfolio?: Maybe<UserPortfolioTag>;
  updateUserAgreements?: Maybe<UpdateUserAgreementsPayload>;
  updateUserNickname?: Maybe<Nickname>;
  updateUserSurvey?: Maybe<UserSurvey>;
  uploadKoreanCertification?: Maybe<KoreanCertification>;
  uploadLocalFavoriteItems?: Maybe<UploadLocalFavoriteItemsPayload>;
  uploadPortfolio?: Maybe<UploadPortfolioPayload>;
  verifyKbSecAccountPassword?: Maybe<KbSecAccountPasswordVerification>;
  verifyMyAppBiometric?: Maybe<AppAuth>;
  verifyMyAppPasscode?: Maybe<AppAuth>;
  verifyMyAppPassword?: Maybe<AppAuth>;
  verifyUserPhoneVerificationForFundora?: Maybe<VerifyUserPhoneVerificationForFundoraPayload>;
  verifyUserPhoneVerificationForKbSec?: Maybe<VerifyUserPhoneVerificationForKbSecPayload>;
  verifyUserPhoneVerificationFromKrTelecom?: Maybe<VerifyUserPhoneVerificationFromKrTelecomPayload>;
  verifyUserPhoneVerificationFromTelecom?: Maybe<PhoneNumberVerification>;
};


export type MutationAcquireBadgeArgs = {
  badgeId: Scalars['ID'];
};


export type MutationAddArticleArgs = {
  article: UploadArticle;
  language: Scalars['String'];
};


export type MutationAddArticleCommentArgs = {
  articleId: Scalars['ID'];
  comment: UploadArticleComment;
};


export type MutationAddAssetItemsToUserFavoriteArgs = {
  followCompanyIds?: InputMaybe<Array<Scalars['ID']>>;
  followCryptoCurrencyIds?: InputMaybe<Array<Scalars['ID']>>;
  language: Scalars['String'];
};


export type MutationAddBackTestingProjectResultArgs = {
  backTestingProjectInputData: BackTestingProjectInput;
};


export type MutationAddBookmarkToArticleArgs = {
  articleId: Scalars['ID'];
};


export type MutationAddBuyForeignDecimalStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  order: DecimalStockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
};


export type MutationAddBuyForeignStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  order: StockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
};


export type MutationAddBuyKrDecimalStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  order: DecimalStockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
};


export type MutationAddBuyKrStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  order: StockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
};


export type MutationAddCommentToFavoriteItemCategoryArgs = {
  categoryId: Scalars['ID'];
  comment: Scalars['String'];
};


export type MutationAddCommunityReportArgs = {
  communityReport: CommunityReportInput;
};


export type MutationAddCompanyAssetsToPortfolioArgs = {
  assets: Array<UploadCompanyAsset>;
  portfolioId: Scalars['ID'];
};


export type MutationAddCryptoCurrencyAssetsToPortfolioArgs = {
  assets: Array<UploadCryptoCurrencyAsset>;
  portfolioId: Scalars['ID'];
};


export type MutationAddCryptoExchangeApiKeyToUserArgs = {
  base64EncryptedAccessKey: Scalars['String'];
  base64EncryptedSecretKey?: InputMaybe<Scalars['String']>;
  cryptoExchangeId: Scalars['ID'];
};


export type MutationAddCurrencyAssetsToPortfolioArgs = {
  assets: Array<UploadCurrencyAsset>;
  portfolioId: Scalars['ID'];
};


export type MutationAddCustomPortfolioTopicArgs = {
  topicName: Scalars['String'];
};


export type MutationAddDividendHistoriesArgs = {
  country: Scalars['String'];
  histories: Array<DividendHistoryInput>;
  ticker: Scalars['String'];
};


export type MutationAddEtcAssetsToPortfolioArgs = {
  assets: Array<UploadEtcAsset>;
  portfolioId: Scalars['ID'];
};


export type MutationAddFavoriteItemCategoryArgs = {
  categoryName: Scalars['String'];
};


export type MutationAddInvestingKeywordToMeArgs = {
  investingKeyword: Scalars['String'];
  language: Scalars['String'];
};


export type MutationAddItemsToFavoriteItemCategoryArgs = {
  categoryId: Scalars['ID'];
  items: Array<UploadFavoriteItem>;
};


export type MutationAddKbSecUserAccountArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
};


export type MutationAddLectureContentAttendanceHistoryArgs = {
  episodeId: Scalars['ID'];
  lastEpisodeDurationPoint: Scalars['Float'];
  lectureContentId: Scalars['ID'];
};


export type MutationAddLectureContentOpenNotificationArgs = {
  lectureContentId: Scalars['ID'];
};


export type MutationAddLectureContentReviewArgs = {
  content: Scalars['String'];
  grade: Scalars['Float'];
  lectureContentId: Scalars['ID'];
};


export type MutationAddLikeToArticleArgs = {
  articleId: Scalars['ID'];
};


export type MutationAddLikeToLectureContentReviewArgs = {
  lectureContentReviewId: Scalars['ID'];
};


export type MutationAddLogToInvestingDiaryArgs = {
  date: Scalars['String'];
  depositWithdrawalLogInput?: InputMaybe<InvestingDiaryDepositWithdrawalLogInput>;
  emotion?: InputMaybe<Scalars['String']>;
  exchangeCurrencyLogInput?: InputMaybe<InvestingDiaryExchangeCurrencyLogInput>;
  memoLogInput?: InputMaybe<InvestingDiaryMemoLogInput>;
  portfolioSlug: Scalars['String'];
  tradeLogInput?: InputMaybe<InvestingDiaryTradeLogInput>;
};


export type MutationAddMyFinPongPlusPortfoliosFromAppArgs = {
  data: Scalars['String'];
  txId?: InputMaybe<Scalars['String']>;
};


export type MutationAddOrderItemsToUserArgs = {
  slug: Scalars['String'];
};


export type MutationAddPortfolioAssetsArgs = {
  assets: Array<UploadCompanyAsset>;
  portfolioId: Scalars['ID'];
};


export type MutationAddPortfolioRecommendationReviewArgs = {
  grade: Scalars['Float'];
  userPortfolioSlug: Scalars['String'];
};


export type MutationAddPushClickHistoryArgs = {
  deeplinkUrl: Scalars['String'];
};


export type MutationAddReferralCodeFromKbAccountEventArgs = {
  referralCode: Scalars['String'];
};


export type MutationAddReplyToArticleCommentArgs = {
  commentId: Scalars['ID'];
  reply: UploadArticleCommentReply;
};


export type MutationAddReplyToLectureContentReviewArgs = {
  content: Scalars['String'];
  lectureContentReviewId: Scalars['ID'];
};


export type MutationAddReserveBuyForeignStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  order: ForeignReserveStockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type MutationAddReserveBuyKrStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  order: StockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type MutationAddReserveSellForeignStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  order: ForeignReserveStockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type MutationAddReserveSellKrStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  order: StockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type MutationAddReviewRequestedStatusArgs = {
  reviewRequestedScreen: Scalars['String'];
  reviewedAt?: InputMaybe<Scalars['String']>;
};


export type MutationAddSellForeignDecimalStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  order: SellDecimalStockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
};


export type MutationAddSellForeignStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  order: StockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
};


export type MutationAddSellKrDecimalStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  order: SellDecimalStockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
};


export type MutationAddSellKrStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  order: StockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
};


export type MutationAddStarToFavoriteItemCategoryArgs = {
  categoryId: Scalars['ID'];
};


export type MutationAddStockOrderHistoryArgs = {
  accountNumber: Scalars['String'];
  accountPassword: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  isReservedOrder: Scalars['Boolean'];
  marketType: TradeMarketTypeEnum;
  orderAmount?: InputMaybe<Scalars['Float']>;
  orderNumber: Scalars['String'];
  orderPrice?: InputMaybe<Scalars['Float']>;
  orderType: TradeOrderEnum;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
  tradeType: TradeTypeEnum;
};


export type MutationAddWishToLectureContentArgs = {
  lectureContentId: Scalars['ID'];
};


export type MutationAgreeKbSecAccountTermsArgs = {
  ci?: InputMaybe<Scalars['String']>;
};


export type MutationApplyProfessionalInvestorArgs = {
  answers: Array<ProfessionalInvestorAnswersInput>;
  professionalInvestorApplicant: ProfessionalInvestorApplicantInput;
};


export type MutationBlockUserArgs = {
  userId: Scalars['ID'];
};


export type MutationClickAdArgs = {
  adId: Scalars['ID'];
};


export type MutationClickAdContentArgs = {
  adContentId: Scalars['ID'];
};


export type MutationClickCpsAdArgs = {
  id: Scalars['ID'];
};


export type MutationClickInvestingInsightArgs = {
  investingInsightId: Scalars['ID'];
  platform: ServicePlatformEnum;
};


export type MutationConfirmBadgeNotificationsArgs = {
  badgeIds: Array<Scalars['ID']>;
};


export type MutationConfirmCodeToVerifyPhoneNumberArgs = {
  code: Scalars['String'];
};


export type MutationConfirmCommunityNotificationsArgs = {
  communityNotificationIds: Array<Scalars['ID']>;
  language?: InputMaybe<Scalars['String']>;
};


export type MutationConfirmTokenToVerifyEmailArgs = {
  token: Scalars['String'];
};


export type MutationConnectKbSecUserAccountArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
};


export type MutationConnectKbSecUserAccountScreenArgs = {
  ci?: InputMaybe<Scalars['String']>;
};


export type MutationConnectPartnerWithUserDataArgs = {
  userData: Scalars['String'];
};


export type MutationConnectWithSamsungEncKeyArgs = {
  encKey: Scalars['String'];
};


export type MutationCopyMyPortfolioArgs = {
  name: Scalars['String'];
  portfolioIds: Array<Scalars['ID']>;
};


export type MutationCreateDividendPortfolioSampleArgs = {
  currencySymbol: Scalars['String'];
  monthlyDividendAmount: Scalars['Float'];
  tickers: Array<Scalars['String']>;
};


export type MutationCreateLectureContentOrderArgs = {
  lectureContentId: Scalars['ID'];
};


export type MutationCreatePortfolioFromCryptoExchangeApiKeyArgs = {
  cryptoExchangeApiKeyId: Scalars['ID'];
  portfolioName: Scalars['String'];
};


export type MutationCreatePortfolioFromPlaidPublicTokenArgs = {
  portfolioName: Scalars['String'];
  publicToken: Scalars['String'];
};


export type MutationCreatePortfolioFromSecuritiesAccountArgs = {
  accountNumber: Scalars['String'];
  accountPassword: Scalars['String'];
  certification: CodefCertificationMethodInput;
  isDepositConnected?: InputMaybe<Scalars['Boolean']>;
  isEtcCompanyAssetsConnected?: InputMaybe<Scalars['Boolean']>;
  isEtcCompanyCmaConnected?: InputMaybe<Scalars['Boolean']>;
  isEtcCompanyFundConnected?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
  portfolioName: Scalars['String'];
};


export type MutationCreateSnp500DividendPortfolioSampleArgs = {
  currencySymbol: Scalars['String'];
  monthlyDividendAmount: Scalars['Float'];
  tickers: Array<Scalars['String']>;
};


export type MutationDeleteUserPortfolioCommentArgs = {
  commentId: Scalars['ID'];
  portfolioSlug: Scalars['String'];
};


export type MutationDeleteUserSignInSessionArgs = {
  userId: Scalars['ID'];
};


export type MutationDenyTokenToVerifyEmailArgs = {
  token: Scalars['String'];
};


export type MutationDisableSharingFavoriteItemCategoryArgs = {
  favoriteItemCategoryId: Scalars['ID'];
};


export type MutationDisableSharingPortfolioArgs = {
  portfolioSlug: Scalars['String'];
};


export type MutationDoNotShowAdArgs = {
  adId: Scalars['ID'];
};


export type MutationEnableDoNotDisturbModeArgs = {
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};


export type MutationEnableSharingFavoriteItemCategoryArgs = {
  favoriteItemCategoryId: Scalars['ID'];
};


export type MutationEnableSharingPortfolioArgs = {
  portfolioSlug: Scalars['ID'];
};


export type MutationExposeAdContentArgs = {
  adContentId: Scalars['ID'];
};


export type MutationFollowItemArgs = {
  followCompanyId?: InputMaybe<Scalars['ID']>;
  followCryptoCurrencyId?: InputMaybe<Scalars['ID']>;
  followUserId?: InputMaybe<Scalars['ID']>;
  language: Scalars['String'];
};


export type MutationFollowItemsArgs = {
  followCompanyIds?: InputMaybe<Array<Scalars['ID']>>;
  followCryptoCurrencyIds?: InputMaybe<Array<Scalars['ID']>>;
  language: Scalars['String'];
};


export type MutationFollowItemsFromPortfolioArgs = {
  language: Scalars['String'];
  portfolioSlug?: InputMaybe<Scalars['String']>;
};


export type MutationForkFavoriteItemCategoryToUserArgs = {
  favoriteItemCategorySlug: Scalars['String'];
};


export type MutationGenerateSignedCookiesForEpisodeArgs = {
  episodeId: Scalars['ID'];
};


export type MutationKbSecAgreePrivacyTermsArgs = {
  ci?: InputMaybe<Scalars['String']>;
  termsUrl: Scalars['String'];
};


export type MutationKbSecRandomStockPickingArgs = {
  ci?: InputMaybe<Scalars['String']>;
};


export type MutationKbSecReferralRandomStockPickingArgs = {
  ci?: InputMaybe<Scalars['String']>;
};


export type MutationParticipateFundoraPreRegistrationEventArgs = {
  customerSource?: InputMaybe<Scalars['String']>;
};


export type MutationPostUserPortfolioCommentArgs = {
  comment: Scalars['String'];
  portfolioSlug: Scalars['String'];
};


export type MutationPublishArticleArgs = {
  articleId: Scalars['ID'];
};


export type MutationRandomStockPickingArgs = {
  ci?: InputMaybe<Scalars['String']>;
  eventName: Scalars['String'];
};


export type MutationRemoveArticleArgs = {
  articleId: Scalars['ID'];
};


export type MutationRemoveArticleCommentArgs = {
  commentId: Scalars['ID'];
};


export type MutationRemoveArticlesArgs = {
  articleIds: Array<Scalars['ID']>;
};


export type MutationRemoveBackTestingProjectResultArgs = {
  slug: Scalars['String'];
};


export type MutationRemoveBookmarkFromArticleArgs = {
  articleId: Scalars['ID'];
};


export type MutationRemoveCommentFromFavoriteItemCategoryArgs = {
  commentId: Scalars['ID'];
};


export type MutationRemoveCryptoExchangeApiKeyFromPortfolioArgs = {
  userPortfolioSlug: Scalars['String'];
};


export type MutationRemoveCryptoExchangeApiKeyFromUserArgs = {
  cryptoExchangeApiKeyId: Scalars['ID'];
};


export type MutationRemoveFavoriteItemCategoryArgs = {
  categoryId: Scalars['ID'];
};


export type MutationRemoveFinPongPlusConnectArgs = {
  ci: Scalars['String'];
};


export type MutationRemoveForeignDecimalStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  order: RemoveForeignDecimalStockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
};


export type MutationRemoveForeignStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  order: RemoveStockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveInvestingDiaryLogArgs = {
  investingDiaryLogId: Scalars['ID'];
};


export type MutationRemoveItemsToFavoriteItemCategoryArgs = {
  categoryId: Scalars['String'];
  items: Array<RemoveFavoriteItem>;
};


export type MutationRemoveKrDecimalStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  order: RemoveKrDecimalStockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
};


export type MutationRemoveKrStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  order: RemoveStockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
};


export type MutationRemoveLectureContentReviewArgs = {
  lectureContentReviewId: Scalars['ID'];
};


export type MutationRemoveLectureContentReviewReplyArgs = {
  lectureContentReviewReplyId: Scalars['ID'];
};


export type MutationRemoveLikeToArticleArgs = {
  articleId: Scalars['ID'];
};


export type MutationRemoveLikeToLectureContentReviewArgs = {
  lectureContentReviewId: Scalars['ID'];
};


export type MutationRemovePlaidConnectFromPortfolioArgs = {
  portfolioSlug: Scalars['String'];
};


export type MutationRemovePortfolioArgs = {
  portfolioId: Scalars['ID'];
};


export type MutationRemovePortfolioAssetsArgs = {
  assets: Array<RemoveUserAsset>;
  portfolioId: Scalars['ID'];
};


export type MutationRemovePortfoliosArgs = {
  portfolioIds: Array<Scalars['ID']>;
};


export type MutationRemoveReserveForeignStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  order: RemoveStockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
};


export type MutationRemoveReserveKrStockOrderArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  order: KrRemoveReservedStockOrderInput;
  organization: Scalars['String'];
  productNumber: Scalars['String'];
};


export type MutationRemoveSecuritiesAccountFromPortfolioArgs = {
  portfolioSlug: Scalars['String'];
};


export type MutationRemoveStarFromFavoriteItemCategoryArgs = {
  categoryId: Scalars['ID'];
};


export type MutationRemoveTagsFromPortfolioArgs = {
  portfolioId: Scalars['ID'];
  tags: Array<Scalars['String']>;
};


export type MutationRemoveWishToLectureContentArgs = {
  lectureContentId: Scalars['ID'];
};


export type MutationReportDividendHistoryErrorAboutStockArgs = {
  company: UploadStockCompany;
  fixedHistoryItem?: InputMaybe<UploadStockDividendHistory>;
  targetHistoryItem: UploadStockDividendHistory;
};


export type MutationReportDividendMonthErrorAboutStockArgs = {
  company: UploadStockCompany;
  fixedMonths: Array<Scalars['Int']>;
};


export type MutationReportLectureContentReviewArgs = {
  lectureContentReviewId: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationReportLectureContentReviewReplyArgs = {
  lectureContentReviewReplyId: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationReportNormalErrorAboutStockArgs = {
  company: UploadStockCompany;
  errorType: StockNormalError;
};


export type MutationReportSectorErrorAboutStockArgs = {
  company: UploadStockCompany;
  fixedSector: Scalars['String'];
};


export type MutationReportUnresolvedSymbolArgs = {
  company: UploadStockCompany;
};


export type MutationRequestProfessionalInvestorVerificationArgs = {
  imageFile: Scalars['Upload'];
};


export type MutationRequestTerminateUserMembershipArgs = {
  reason: Scalars['String'];
};


export type MutationRequestTossPaymentFailArgs = {
  code: Scalars['String'];
  message: Scalars['String'];
  orderId: Scalars['String'];
};


export type MutationRequestTossPaymentSuccessArgs = {
  amount: Scalars['Float'];
  orderId: Scalars['String'];
  paymentKey: Scalars['String'];
};


export type MutationRequestUserPhoneVerificationForFundoraArgs = {
  birthDate: Scalars['String'];
  genderNumber: Scalars['String'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  telecomType: Scalars['String'];
};


export type MutationRequestUserPhoneVerificationForKbSecArgs = {
  birthDate: Scalars['String'];
  genderNumber: Scalars['String'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  telecomType: Scalars['String'];
};


export type MutationRequestUserPhoneVerificationToKrTelecomArgs = {
  birthDate: Scalars['String'];
  genderNumber: Scalars['String'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  telecomType: Scalars['String'];
};


export type MutationRequestUserPhoneVerificationToTelecomArgs = {
  locale?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
};


export type MutationSaveArticleTemporaryArgs = {
  article: UploadArticle;
  articleId?: InputMaybe<Scalars['ID']>;
  language: Scalars['String'];
};


export type MutationSaveDividendPortfolioArgs = {
  portfolioName: Scalars['String'];
  portfolioSlug: Scalars['String'];
};


export type MutationSaveDividendPortfolioFromSamsungArgs = {
  portfolioName: Scalars['String'];
  portfolioSlug: Scalars['String'];
};


export type MutationSendChatPushMessageToUsersArgs = {
  body: Scalars['String'];
  linkUrl: Scalars['String'];
  message: Scalars['String'];
  title: Scalars['String'];
  userIds: Array<Scalars['String']>;
};


export type MutationSendDownloadAppLinkUrlSmsArgs = {
  locale?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
};


export type MutationSendEmailToSubscribeMailingGroupArgs = {
  email?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  mailingGroupName: Scalars['String'];
  marketingAgreement: Scalars['Boolean'];
  serviceAgreement: Scalars['Boolean'];
};


export type MutationSendEmailToVerifyEmailArgs = {
  email: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
};


export type MutationSendPushMessageToDeviceArgs = {
  body: Scalars['String'];
  deviceToken: Scalars['String'];
  linkUrl: Scalars['String'];
  message: Scalars['String'];
  title: Scalars['String'];
};


export type MutationSendPushMessageToKeywordSubscribedUsersArgs = {
  keyword: Scalars['String'];
  linkUrl: Scalars['String'];
  newsTitle: Scalars['String'];
  pushTransactionId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};


export type MutationSendPushMessageToUserArgs = {
  body: Scalars['String'];
  linkUrl: Scalars['String'];
  message: Scalars['String'];
  title: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationSendPushMessageToUsersArgs = {
  body: Scalars['String'];
  linkUrl: Scalars['String'];
  message: Scalars['String'];
  title: Scalars['String'];
  userIds: Array<Scalars['String']>;
};


export type MutationSendSmsToVerifyPhoneNumberArgs = {
  locale?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
};


export type MutationSignInArgs = {
  accessToken?: InputMaybe<Scalars['String']>;
  authClient?: InputMaybe<AuthClient>;
  authMethod: AuthMethod;
  authorizationCode?: InputMaybe<Scalars['String']>;
  idToken?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
};


export type MutationSignOutArgs = {
  registrationToken: Scalars['String'];
};


export type MutationSignUpWithFundoraArgs = {
  deviceInfo: DeviceInfoInput;
  email: Scalars['String'];
  joinTerms: Array<JoinTermsInput>;
};


export type MutationSubscribeMailingGroupArgs = {
  verifyingEmailToken: Scalars['String'];
};


export type MutationSyncFundoraPortfolioArgs = {
  accessToken: Scalars['String'];
  portfolioId: Scalars['ID'];
};


export type MutationSyncFundoraPortfoliosArgs = {
  accessToken: Scalars['String'];
};


export type MutationSynchronizeKbSecAccountArgs = {
  ci?: InputMaybe<Scalars['String']>;
};


export type MutationUnblockUserArgs = {
  userId: Scalars['ID'];
};


export type MutationUnfollowItemArgs = {
  followCompanyId?: InputMaybe<Scalars['ID']>;
  followCryptoCurrencyId?: InputMaybe<Scalars['ID']>;
  followUserId?: InputMaybe<Scalars['ID']>;
  language: Scalars['String'];
};


export type MutationUnfollowItemsArgs = {
  followCompanyIds?: InputMaybe<Array<Scalars['ID']>>;
  followCryptoCurrencyIds?: InputMaybe<Array<Scalars['ID']>>;
  followUserIds?: InputMaybe<Array<Scalars['ID']>>;
  language: Scalars['String'];
};


export type MutationUnsubscribeMailingGroupArgs = {
  email?: InputMaybe<Scalars['String']>;
  mailingGroupId: Scalars['ID'];
};


export type MutationUpdateArticleArgs = {
  article: UploadArticle;
  articleId: Scalars['ID'];
};


export type MutationUpdateArticleCommentArgs = {
  comment: UploadArticleComment;
  commentId: Scalars['ID'];
};


export type MutationUpdateBackTestingProjectResultArgs = {
  backTestingProjectInputData: BackTestingProjectInput;
  slug: Scalars['String'];
};


export type MutationUpdateBaseCurrencyAtPortfolioArgs = {
  baseCurrency: Scalars['String'];
  portfolioId: Scalars['String'];
};


export type MutationUpdateChatRoomNotificationFromFirestoreArgs = {
  chatId: Scalars['ID'];
  chatIdToken: Scalars['ID'];
  switchOn: Scalars['Boolean'];
};


export type MutationUpdateCryptoExchangeApiKeyFromPortfolioArgs = {
  cryptoExchangeApiKeyId: Scalars['ID'];
  userPortfolioSlug: Scalars['String'];
};


export type MutationUpdateEtfDetailArgs = {
  country: Scalars['String'];
  etfHoldings: Array<EtfHoldingInput>;
  symbol: Scalars['String'];
};


export type MutationUpdateFavoriteItemCategoryArgs = {
  categoryId: Scalars['ID'];
  categoryName: Scalars['String'];
};


export type MutationUpdateFavoriteItemCategoryOrdersArgs = {
  categoryOrders: Array<UpdateFavoriteCategoryOrder>;
};


export type MutationUpdateInvestingDiaryLogArgs = {
  date?: InputMaybe<Scalars['String']>;
  depositWithdrawalLogInput?: InputMaybe<InvestingDiaryDepositWithdrawalLogInput>;
  emotion?: InputMaybe<Scalars['String']>;
  exchangeCurrencyLogInput?: InputMaybe<InvestingDiaryExchangeCurrencyLogInput>;
  investingDiaryLogId: Scalars['ID'];
  memoLogInput?: InputMaybe<InvestingDiaryMemoLogInput>;
  tradeLogInput?: InputMaybe<InvestingDiaryTradeLogInput>;
};


export type MutationUpdateLectureContentReviewArgs = {
  content?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['Float']>;
  lectureContentReviewId: Scalars['ID'];
};


export type MutationUpdateLectureContentReviewReplyArgs = {
  content: Scalars['String'];
  lectureContentReviewReplyId: Scalars['ID'];
};


export type MutationUpdateMajorSecuritiesOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type MutationUpdateMyAppBiometricArgs = {
  appBiometricPublicKey: Scalars['String'];
};


export type MutationUpdateMyAppPasscodeArgs = {
  appPasswordPublicKey: Scalars['String'];
};


export type MutationUpdateMyAppPasswordArgs = {
  appPasswordPublicKey: Scalars['String'];
};


export type MutationUpdateMyCompanySectorArgs = {
  companyId: Scalars['ID'];
  companySectorId: Scalars['ID'];
};


export type MutationUpdateMyDeviceArgs = {
  communityLanguage?: InputMaybe<Scalars['String']>;
  registrationToken?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateMyFinPongPlusPortfoliosArgs = {
  ci: Scalars['String'];
};


export type MutationUpdateMyFinPongPlusPortfoliosFromAppArgs = {
  data: Scalars['String'];
  txId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateMyInvestingKeywordsArgs = {
  keywords: Array<Scalars['String']>;
  language: Scalars['String'];
};


export type MutationUpdateMyNotificationSettingArgs = {
  isEnabled: Scalars['Boolean'];
  notificationSettingId: Scalars['ID'];
};


export type MutationUpdateMyPreferenceArgs = {
  doNotShowFinPongPlusPopup?: InputMaybe<Scalars['Boolean']>;
  hasDownloadTermsAgreed?: InputMaybe<Scalars['Boolean']>;
  hasUploadTermsAgreed?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateMyProfileArgs = {
  profile: UpdateUserProfile;
};


export type MutationUpdateMyRepresentativeBadgeArgs = {
  badgeId: Scalars['ID'];
};


export type MutationUpdatePortfolioAssetArgs = {
  amount: Scalars['String'];
  assetId: Scalars['ID'];
  avgPrice?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  customPrice?: InputMaybe<Scalars['String']>;
  customTax?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['ID'];
};


export type MutationUpdatePortfolioFromCryptoExchangeApiKeyArgs = {
  userPortfolioSlug: Scalars['String'];
};


export type MutationUpdatePortfolioFromKbSecAccountArgs = {
  accountNumber: Scalars['String'];
  accountPassword: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  productNumber: Scalars['String'];
};


export type MutationUpdatePortfolioFromPlaidArgs = {
  portfolioSlug: Scalars['String'];
  publicToken?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePortfolioFromSecuritiesAccountArgs = {
  accountNumber: Scalars['String'];
  accountPassword: Scalars['String'];
  certification: CodefCertificationMethodInput;
  organizationId: Scalars['ID'];
  portfolioSlug: Scalars['String'];
};


export type MutationUpdatePortfolioInformationArgs = {
  portfolio: UpdatePortfolio;
};


export type MutationUpdatePortfolioOrderScoresArgs = {
  portfolioOrderScores: Array<PortfolioOrderScoresInput>;
};


export type MutationUpdatePortfolioSwitchOnArgs = {
  portfolioId: Scalars['ID'];
  portfolioSwitchOn: Scalars['Boolean'];
};


export type MutationUpdateSignInSessionArgs = {
  appVersion?: InputMaybe<Scalars['String']>;
  communityLanguage?: InputMaybe<Scalars['String']>;
  deviceRegistrationToken?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateSwitchPortfolioArgs = {
  switchPortfolioCurrencyId?: InputMaybe<Scalars['ID']>;
  switchPortfolioDividendTaxRate?: InputMaybe<Scalars['Float']>;
};


export type MutationUpdateTagsToPortfolioArgs = {
  portfolioId: Scalars['ID'];
  tags: Array<Scalars['String']>;
};


export type MutationUpdateUserAgreementsArgs = {
  agreementIds: Array<Scalars['ID']>;
};


export type MutationUpdateUserNicknameArgs = {
  nickname: Scalars['String'];
};


export type MutationUpdateUserSurveyArgs = {
  surveyCategory: Scalars['String'];
  surveyResult: Scalars['String'];
};


export type MutationUploadKoreanCertificationArgs = {
  certification: Scalars['String'];
  certificationPassword: Scalars['String'];
};


export type MutationUploadLocalFavoriteItemsArgs = {
  items: Array<UploadLocalFavoriteItem>;
};


export type MutationUploadPortfolioArgs = {
  assets?: InputMaybe<Array<UploadCompanyAsset>>;
  portfolio: UploadPortfolio;
};


export type MutationVerifyKbSecAccountPasswordArgs = {
  accountNumber?: InputMaybe<Scalars['String']>;
  accountPassword: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
};


export type MutationVerifyMyAppBiometricArgs = {
  payload: Scalars['String'];
  signature: Scalars['String'];
};


export type MutationVerifyMyAppPasscodeArgs = {
  payload: Scalars['String'];
  signature: Scalars['String'];
};


export type MutationVerifyMyAppPasswordArgs = {
  payload: Scalars['String'];
  signature: Scalars['String'];
};


export type MutationVerifyUserPhoneVerificationForFundoraArgs = {
  authNumber: Scalars['String'];
  clientRequestNumber: Scalars['String'];
};


export type MutationVerifyUserPhoneVerificationForKbSecArgs = {
  authNumber: Scalars['String'];
  clientRequestNumber: Scalars['String'];
};


export type MutationVerifyUserPhoneVerificationFromKrTelecomArgs = {
  authNumber: Scalars['String'];
  clientRequestNumber: Scalars['String'];
};


export type MutationVerifyUserPhoneVerificationFromTelecomArgs = {
  code: Scalars['String'];
};

export type MyDataToken = {
  __typename?: 'MyDataToken';
  accessToken: Scalars['String'];
};

export enum MyFollowingSortOrderEnum {
  /** Alphabetical Order */
  AlphabeticalOrder = 'ALPHABETICAL_ORDER',
  /** Recent Update Order */
  RecentUpdateOrder = 'RECENT_UPDATE_ORDER',
  /** Subscription Order */
  SubscriptionOrder = 'SUBSCRIPTION_ORDER'
}

export type MyMetaPortfolio = {
  __typename?: 'MyMetaPortfolio';
  portfolios?: Maybe<Array<UserPortfolio>>;
  switchPortfolio: SwitchPortfolio;
};

export type MyPortfolioItems = {
  __typename?: 'MyPortfolioItems';
  id: Scalars['ID'];
  items?: Maybe<Array<UserPortfolio>>;
};

export type MyProfile = {
  __typename?: 'MyProfile';
  articleCommentsCount?: Maybe<Scalars['Int']>;
  articlesCount?: Maybe<Scalars['Int']>;
  chatRoomUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  eventReferralCode?: Maybe<Scalars['String']>;
  eventReferralLinkUrl?: Maybe<Scalars['String']>;
  finPongPlusConnectedAt?: Maybe<Scalars['String']>;
  followersCount?: Maybe<Scalars['Int']>;
  followingsCount?: Maybe<Scalars['Int']>;
  hasUserBoughtLectureContent?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  investingKeywords?: Maybe<Array<InvestingKeyword>>;
  isFollowing?: Maybe<Scalars['Boolean']>;
  isLectureContentAuthor?: Maybe<Scalars['Boolean']>;
  lectureContents?: Maybe<Array<LectureContent>>;
  majorSecuritiesOrganization?: Maybe<Organization>;
  nickname?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  recentPortfolioCopiedAt?: Maybe<Scalars['String']>;
  representativeBadge?: Maybe<Badge>;
  updatedAt: Scalars['String'];
  userType?: Maybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export type MyPublicFavoriteItemCategories = {
  __typename?: 'MyPublicFavoriteItemCategories';
  myPublicFavoriteItemCategories: Array<FavoriteItemCategory>;
  myPublicFavoriteItemCategoriesCount: Scalars['Int'];
  totalUserFavoriteItemCategoriesCount: Scalars['Int'];
};

export type MyPublicPortfolios = {
  __typename?: 'MyPublicPortfolios';
  myPublicPortfolios: Array<UserPortfolio>;
  myPublicPortfoliosCount: Scalars['Int'];
  totalUserPortfoliosCount: Scalars['Int'];
};

export type Nickname = {
  __typename?: 'Nickname';
  errors: Array<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  token: Scalars['String'];
};

export type Notice = {
  __typename?: 'Notice';
  contentEn?: Maybe<Scalars['String']>;
  contentKo?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  imageUrlEn?: Maybe<Scalars['String']>;
  imageUrlKo?: Maybe<Scalars['String']>;
  titleEn: Scalars['String'];
  titleKo: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  category: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: LanguageString;
  updatedAt?: Maybe<Scalars['String']>;
};

export type OgMetadata = {
  __typename?: 'OgMetadata';
  ogImageHeight?: Maybe<Scalars['String']>;
  ogImageType?: Maybe<Scalars['String']>;
  ogImageWidth?: Maybe<Scalars['String']>;
};

export type OgTag = {
  __typename?: 'OgTag';
  charSet?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ogDescription?: Maybe<Scalars['String']>;
  ogImageUrl?: Maybe<Scalars['String']>;
  ogLocale?: Maybe<Scalars['String']>;
  ogMetadata?: Maybe<OgMetadata>;
  ogTitle?: Maybe<Scalars['String']>;
  ogType?: Maybe<Scalars['String']>;
  originalLink: Scalars['String'];
};

export enum Order {
  /** Asc */
  Asc = 'ASC',
  /** Desc */
  Desc = 'DESC'
}

export enum OrderStatusTypeEnum {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** CONCLUDED */
  Concluded = 'CONCLUDED',
  /** PENDING */
  Pending = 'PENDING'
}

export type Organization = {
  __typename?: 'Organization';
  androidDeepLink?: Maybe<Scalars['String']>;
  androidStoreLink?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  globalAndroidDeepLink?: Maybe<Scalars['String']>;
  globalAndroidStoreLink?: Maybe<Scalars['String']>;
  globalIosDeepLink?: Maybe<Scalars['String']>;
  globalIosStoreLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  iosDeepLink?: Maybe<Scalars['String']>;
  iosStoreLink?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type OrganizationReport = {
  __typename?: 'OrganizationReport';
  author?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  hankyungPdfLink?: Maybe<Scalars['String']>;
  hasWebsiteLink?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  mkLink?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  reportedAt?: Maybe<Scalars['String']>;
  targetPrice?: Maybe<Scalars['String']>;
  targetSide?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PaginationCompanies = {
  __typename?: 'PaginationCompanies';
  companies?: Maybe<Array<Company>>;
  currentPage: Scalars['Int'];
  currentPageCount: Scalars['Int'];
  nextPage?: Maybe<Scalars['Int']>;
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginationPortfolios = {
  __typename?: 'PaginationPortfolios';
  currentPage: Scalars['Int'];
  currentPageCount: Scalars['Int'];
  nextPage?: Maybe<Scalars['Int']>;
  perPage: Scalars['Int'];
  portfolios?: Maybe<Array<UserPortfolio>>;
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

/** Autogenerated return type of ParticipateFundoraPreRegistrationEvent. */
export type ParticipateFundoraPreRegistrationEventPayload = {
  __typename?: 'ParticipateFundoraPreRegistrationEventPayload';
  serviceEventParticipant: ServiceEventParticipant;
};

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  paymentMethod?: Maybe<PaymentMethodEnum>;
  paymentStatus?: Maybe<PaymentStatusEnum>;
  updatedAt: Scalars['String'];
};

export enum PaymentMethodEnum {
  /** Account transfer */
  AccountTransfer = 'ACCOUNT_TRANSFER',
  /** Credit card */
  CreditCard = 'CREDIT_CARD',
  /** Virtual account */
  VirtualAccount = 'VIRTUAL_ACCOUNT'
}

export type PaymentResult = {
  __typename?: 'PaymentResult';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  orderId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export enum PaymentStatusEnum {
  /** Failed */
  Failed = 'FAILED',
  /** Success */
  Success = 'SUCCESS'
}

export enum PeriodEnum {
  /** Annually */
  Annually = 'ANNUALLY',
  /** Monthly */
  Monthly = 'MONTHLY',
  /** None */
  None = 'NONE',
  /** Quarterly */
  Quarterly = 'QUARTERLY'
}

export type PhoneNumberVerification = {
  __typename?: 'PhoneNumberVerification';
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberVerifiedAt?: Maybe<Scalars['String']>;
  requestedPhoneNumber?: Maybe<Scalars['String']>;
  verifyingPhoneNumberSentAt?: Maybe<Scalars['String']>;
};

export type PortfolioDividendCalendar = {
  __typename?: 'PortfolioDividendCalendar';
  dividendCalendarRecords: Array<DividendCalendarRecord>;
  totalDividendAmount?: Maybe<Scalars['Float']>;
};

export type PortfolioLink = {
  __typename?: 'PortfolioLink';
  linkSharedAt?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
};

export type PortfolioOrderScoresInput = {
  orderScore: Scalars['Int'];
  portfolioId: Scalars['ID'];
};

export type PortfolioRecommendationReview = {
  __typename?: 'PortfolioRecommendationReview';
  grade: Scalars['Float'];
  id: Scalars['ID'];
  userId: Scalars['ID'];
  userPortfolioSlug: Scalars['String'];
};

export type PortfolioTopic = {
  __typename?: 'PortfolioTopic';
  id: Scalars['ID'];
  isCustomTopic?: Maybe<Scalars['Boolean']>;
  name: LanguageString;
  selectedCount?: Maybe<Scalars['Int']>;
  topicName: Scalars['String'];
};

/** Autogenerated return type of PostUserPortfolioComment. */
export type PostUserPortfolioCommentPayload = {
  __typename?: 'PostUserPortfolioCommentPayload';
  comment: UserPortfolioComment;
  errors: Array<Scalars['String']>;
  portfolioComments: Array<UserPortfolioComment>;
};

export type Product = {
  __typename?: 'Product';
  discountedPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  price: Scalars['Float'];
  productCategory: ProductCategory;
  slug: Scalars['String'];
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ProductOrder = {
  __typename?: 'ProductOrder';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  orderItems: Array<ProductOrderItem>;
  ordererName: Scalars['String'];
  payment: Payment;
  slug: Scalars['String'];
  totalAmount: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export type ProductOrderItem = {
  __typename?: 'ProductOrderItem';
  amount: Scalars['Float'];
  id: Scalars['ID'];
  product: Product;
  quantity: Scalars['Float'];
};

export type ProfessionalInvestor = {
  __typename?: 'ProfessionalInvestor';
  certificateImageUrl: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isVerified: Scalars['Boolean'];
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
  verifiedAt?: Maybe<Scalars['String']>;
};

export type ProfessionalInvestorAnswersInput = {
  answer: Array<Scalars['String']>;
  answerNumber: Array<Scalars['Int']>;
  question: Scalars['String'];
  questionNumber: Scalars['Int'];
};

export type ProfessionalInvestorApplicant = {
  __typename?: 'ProfessionalInvestorApplicant';
  createdAt: Scalars['String'];
  hasUserAgreeToPrivacyAgreement: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};

export type ProfessionalInvestorApplicantInput = {
  hasUserAgreeToPrivacyAgreement: Scalars['Boolean'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type ProfessionalInvestorApplyStatus = {
  __typename?: 'ProfessionalInvestorApplyStatus';
  appliedAt?: Maybe<Scalars['String']>;
  isUserApplied: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type ProfessionalInvestorBadgeAcquisitionStatus = {
  __typename?: 'ProfessionalInvestorBadgeAcquisitionStatus';
  badgeAcquiredAt?: Maybe<Scalars['String']>;
  isUserAcquiredBadge: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type PublicPortfolios = {
  __typename?: 'PublicPortfolios';
  page: Scalars['Int'];
  publicPortfolios?: Maybe<Array<UserPortfolio>>;
  totalCount: Scalars['Int'];
};

/** Autogenerated return type of PublishArticle. */
export type PublishArticlePayload = {
  __typename?: 'PublishArticlePayload';
  article: Article;
};

export type PushClickHistory = {
  __typename?: 'PushClickHistory';
  deeplinkUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pushCategory?: Maybe<Scalars['String']>;
  pushSentAt?: Maybe<Scalars['String']>;
  pushSentAtDatetime?: Maybe<Scalars['String']>;
  pushTarget?: Maybe<Scalars['String']>;
};

export type PushMessage = {
  __typename?: 'PushMessage';
  id: Scalars['ID'];
};

export type Query = {
  __typename?: 'Query';
  ad?: Maybe<Ad>;
  ads: Array<Ad>;
  aiHistoricalCryptoPrices: Array<CryptoCandlePrice>;
  aiHistoricalCurrencyExchanges: Array<CurrencyExchangeCandle>;
  aiHistoricalStockPrices: Array<StockCandlePrice>;
  allAgreements?: Maybe<AllAgreements>;
  article: Article;
  articleComments: Array<ArticleComment>;
  backTestingProject: BackTestingProject;
  badgeDetail: Badge;
  blockedUsers: Array<User>;
  categorizedCompanies: Array<CategorizedCompany>;
  closedMarketDays: Array<MarketCalendar>;
  codefCert: CodefCert;
  combineUserPortfolios?: Maybe<Array<UserPortfolio>>;
  companies?: Maybe<Array<Company>>;
  company?: Maybe<Company>;
  companyDetailById?: Maybe<CompanyDetail>;
  companyDetailByIds?: Maybe<Array<CompanyDetail>>;
  companyDetailByTicker?: Maybe<CompanyDetail>;
  companyDisclosures?: Maybe<Array<Disclosure>>;
  companyEarnings?: Maybe<Array<EarningCalendar>>;
  companySectors?: Maybe<Array<CompanySector>>;
  compareToServerCi: CompareToServerCi;
  cpsAd: CpsAd;
  cpsAds: Array<CpsAd>;
  cryptoCurrency?: Maybe<CryptoCurrency>;
  cryptoCurrencyDetail?: Maybe<CryptoCurrencyDetail>;
  cryptoCurrencyExchange?: Maybe<CurrencyExchange>;
  cryptoCurrencyExchanges?: Maybe<Array<CurrencyExchange>>;
  cryptoExchangeApiKeys: Array<CryptoExchangeApiKey>;
  cryptoExchanges: Array<CryptoExchange>;
  currencyExchange?: Maybe<CurrencyExchange>;
  currencyExchanges?: Maybe<Array<CurrencyExchange>>;
  dividendCalendar?: Maybe<Array<DividendHistory>>;
  dividendCalendarByDay: Array<DividendHistory>;
  dividendCalendarByMonth: Array<DividendHistory>;
  dividendCalendarForExternalChannelWithPagination: Array<DividendHistory>;
  dividendCalendarForPortfolios: PortfolioDividendCalendar;
  dividendCompanies?: Maybe<PaginationCompanies>;
  dividendCompaniesInSnp500?: Maybe<PaginationCompanies>;
  dividendCompaniesInSnp500ForExternalChannel?: Maybe<PaginationCompanies>;
  dividendHistories?: Maybe<Array<DividendHistory>>;
  dividendHistoriesExistingDays: Array<Scalars['String']>;
  dividendHistoriesExistingDaysForExternalChannel: DividendHistoriesExistingDaysForExternalChannel;
  dividendHistoriesInCompany?: Maybe<Array<DividendHistory>>;
  dividendHistoriesInFavoriteItemCategory?: Maybe<Array<DividendHistory>>;
  dividendHistoriesInPortfolios?: Maybe<Array<DividendHistory>>;
  dividendHistoriesInSnp500?: Maybe<Array<DividendHistory>>;
  dividendHistoriesInSnp500ForExternalChannel?: Maybe<Array<DividendHistory>>;
  doNotDisturbModeStatus: DoNotDisturbMode;
  earningCalendars?: Maybe<Array<EarningCalendar>>;
  episode: Episode;
  etfDetail?: Maybe<EtfDetail>;
  etfHoldingInformation?: Maybe<Array<EtfHoldingContainer>>;
  eventStatus: Array<EventStatus>;
  favoriteArticlesInTopic: Array<Article>;
  favoriteItemCategories?: Maybe<Array<FavoriteItemCategory>>;
  favoriteItemCategory?: Maybe<FavoriteItemCategory>;
  favoriteItemCategoryComments: Array<FavoriteItemCategoryComment>;
  feedFilteredByTag?: Maybe<FeedFilteredByTag>;
  feedTopics?: Maybe<Array<FeedTopic>>;
  fundoraPortfolioChatRoom: FundoraPortfolioChatRoom;
  getOgTag?: Maybe<OgTag>;
  historicalCryptoPrices: Array<CryptoCandlePrice>;
  historicalCurrencyExchanges: Array<CurrencyExchangeCandle>;
  historicalStockPrices: Array<StockCandlePrice>;
  investingDiaryLog: InvestingDiaryLog;
  investingDiaryLogs: Array<InvestingDiaryLog>;
  investingIdea: InvestingIdea;
  investingIdeas: Array<InvestingIdea>;
  investingInsight: InvestingInsight;
  investingInsightTags: Array<InvestingInsightTag>;
  investingInsights: Array<InvestingInsight>;
  kbSecAccountStatus?: Maybe<KbSecAccountStatus>;
  kbSecCheckFeeRatioOnOrder: KbSecFeeRatioOnOrder;
  kbSecCheckHoldingAssetAmount: KbSecHoldingAssetAmount;
  kbSecCheckHoldingAssetAmountAtSell: KbSecHoldingAssetAmountAtSell;
  kbSecCheckStockHoldingStatus: Scalars['Boolean'];
  kbSecForeignDecimalStockOrderableCashAmount: KbSecOrderableCashAmount;
  kbSecOrderableCashAmount: KbSecOrderableCashAmount;
  kbSecPrivacyTerms: KbSecPrivacyTerms;
  kbSecPrivacyTermsAgreementStatus?: Maybe<KbSecPrivacyTermsAgreementStatus>;
  kbSecRandomPickEventStatus: RandomPickEventStatus;
  kbSecRealizedProfitAndLossHistories: RealizedProfitAndLoss;
  kbSecUserAccountDeposit: KbSecUserAccountDeposit;
  kbSecUserAccountTransactionHistories: KbSecUserAccountTransactionHistory;
  kbSecUserPhoneVerificationStatus: KbSecUserPhoneVerificationStatus;
  latestAgreements: LatestAgreements;
  lectureContent: LectureContent;
  lectureContentDetailBySlug: LectureContent;
  lectureContentEpisodes: Array<Episode>;
  lectureContentReviews: LectureContentReviewsWithGrade;
  lectureContentTags: Array<LectureContentTag>;
  lectureContents: Array<LectureContent>;
  mailingGroup: MailingGroup;
  mailingGroups: Array<MailingGroup>;
  mbtiResultCounter: MbtiResultCounter;
  mbtiVisitorCounter: MbtiVisitorCounter;
  monthlyDividendEtfCompanies?: Maybe<Array<Company>>;
  myAd?: Maybe<Ad>;
  myAds: Array<Ad>;
  myArticles: Array<Article>;
  myBackTestingProjects: Array<BackTestingProject>;
  myBookmarkedArticles: Array<Article>;
  myCommentedArticles: Array<Article>;
  myCommunityNotifications?: Maybe<CommunityNotificationStatus>;
  myCommunityNotificationsWithLanguage?: Maybe<CommunityNotificationStatus>;
  myCompanySectors: Array<UserCompanySector>;
  myDataToken?: Maybe<MyDataToken>;
  myEventStatus: Array<UserEventStatus>;
  myFinPongPlus: FinPongPlusStatus;
  myFollowingFeed: Array<Article>;
  myFollowings: SearchFollowItems;
  myInvestingKeywords: Array<InvestingKeywordWithIsSelected>;
  myKbSecRandomPickEventParticipationStatus: RandomPickEventParticipationStatus;
  myKbSecRandomPickEventPrize: KbSecRandomStockPrize;
  myKbSecRandomPickReferralEventPrize: KbSecRandomStockPrize;
  myKbSecUserAccount: KbSecUserAccount;
  myKbSecUserAccounts: Array<KbSecUserAccount>;
  myKoreanCertification?: Maybe<KoreanCertification>;
  myMetaPortfolio: MyMetaPortfolio;
  myNewBadgeNotifications: Array<Badge>;
  myNotificationSettings?: Maybe<Array<UserNotificationSetting>>;
  myPortfolios: MyPortfolioItems;
  myPortfoliosFromPartner: PaginationPortfolios;
  myPortfoliosFromSamsung: PaginationPortfolios;
  myPreference: UserPreference;
  myProfile?: Maybe<MyProfile>;
  myPublicFavoriteItemCategories: MyPublicFavoriteItemCategories;
  myPublicPortfolios: MyPublicPortfolios;
  mySecuritiesAccounts: Array<UserAccount>;
  mySecurity: UserSecurity;
  myStarredFavoriteItemCategories?: Maybe<Array<FavoriteItemCategory>>;
  myTemporarySavedArticles: Array<Article>;
  myThisWeekDividendStocks?: Maybe<Array<DividendHistory>>;
  myUserPlaids: Array<UserPlaid>;
  newsLetters: Array<MailingGroup>;
  notice?: Maybe<Notice>;
  notices?: Maybe<Array<Notice>>;
  organizationReports?: Maybe<Array<OrganizationReport>>;
  portfolio?: Maybe<UserPortfolio>;
  portfolioRecommendationReviews?: Maybe<Array<PortfolioRecommendationReview>>;
  portfolioTags?: Maybe<UserPortfolioTag>;
  portfolios?: Maybe<Array<UserPortfolio>>;
  product: Product;
  productOrder: ProductOrder;
  professionalInvestorApplyStatus: ProfessionalInvestorApplyStatus;
  professionalInvestorBadgeAcquisitionStatus: ProfessionalInvestorBadgeAcquisitionStatus;
  professionalInvestorBadgeApplyStatus: ProfessionalInvestorApplyStatus;
  publicFavoriteItems: Array<FavoriteItem>;
  publicPortfolioTopics?: Maybe<Array<PortfolioTopic>>;
  publicPortfolios?: Maybe<PublicPortfolios>;
  publicPortfoliosByTags?: Maybe<Array<UserPortfolio>>;
  recentActiveChatRooms: Array<ChatRoom>;
  recommendedChatRoomTypes: Array<RecommendTypeChatRoom>;
  recommendedChatRooms: Array<ChatRoom>;
  recommendedFollows: SearchFollowItems;
  recommendedFollowsByUserFavorites: SearchFollowItems;
  recommendedLectureContents: Array<LectureContent>;
  reviewRequestedStatus: UserReviewRequestedStatus;
  richCategories?: Maybe<Array<RichCategory>>;
  searchArticles: SearchArticles;
  searchAssetTags?: Maybe<Array<AssetTag>>;
  searchCommunityArticles: SearchArticles;
  searchCommunityUsers: Array<CommunityUser>;
  searchCompany?: Maybe<Array<SearchCompany>>;
  searchCustomPortfolioTopics?: Maybe<Array<PortfolioTopic>>;
  searchFollows: SearchFollowItems;
  searchItem?: Maybe<Array<SearchCompany>>;
  searchUsersInArticle: Array<CommunityUser>;
  serviceOperations?: Maybe<ServiceOperations>;
  stockLearningCenterContents: Array<StockLearningCenterContent>;
  stockOrderHistories?: Maybe<Array<KbSecStockOrderHistory>>;
  stockOrderHistoriesByCompanyId: Array<KbSecStockOrderHistory>;
  stockOrderHistory: KbSecStockOrderHistory;
  supportedCompanySectors?: Maybe<Array<CompanySector>>;
  supportedCryptoCurrencyBases?: Maybe<Array<CryptoCurrency>>;
  supportedCurrencies?: Maybe<Array<Currency>>;
  supportedLiveSecuritiesOrganizations: Array<Organization>;
  supportedMetaPortfolioCurrencies?: Maybe<Array<Currency>>;
  supportedPortfolioCurrencies?: Maybe<Array<Currency>>;
  supportedSecuritiesOrganizations: Array<Organization>;
  thisWeekDividendStocks?: Maybe<Array<DividendHistory>>;
  thisWeekDividendStocksForExternalChannel?: Maybe<Array<DividendHistory>>;
  thisWeekDividendStocksInSnp500?: Maybe<Array<DividendHistory>>;
  timelineFeed?: Maybe<Array<Article>>;
  top100FavoriteItemCategories?: Maybe<Array<FavoriteItemCategory>>;
  top100FavoriteItems?: Maybe<Array<Top100FavoriteItem>>;
  user: User;
  userAcquiredBadgeList: Array<Badge>;
  userActivity: UserActivity;
  userAgreementStatus?: Maybe<UserAgreementStatus>;
  userArticles?: Maybe<Array<Article>>;
  userBadgeList: Array<Badge>;
  userFollowers: SearchFollowItems;
  userFollowings: SearchFollowItems;
  userOrderedLectureContent: UserOrderedLectureContent;
  userOrderedLectureContents: Array<UserOrderedLectureContent>;
  userOwnedLectureContent: UserOwnedLectureContent;
  userOwnedLectureContents: Array<UserOwnedLectureContent>;
  userPhoneVerificationStatus: UserPhoneVerificationStatus;
  userPortfolio?: Maybe<UserPortfolio>;
  userPortfolioComments: Array<UserPortfolioComment>;
  userProfile?: Maybe<UserProfile>;
  userPublicFavoriteItemCategories?: Maybe<Array<FavoriteItemCategory>>;
  userPublicPortfolios: Array<UserPortfolio>;
  userSurvey: Array<UserSurvey>;
  userVerification?: Maybe<UserVerification>;
  userWishedLectureContents: Array<LectureContent>;
  usersStarredFavoriteItemCategories?: Maybe<Array<FavoriteItemCategoryCommentUser>>;
  validateUserConnectedAssetsEvaluationAmount: Scalars['Boolean'];
  verifyUser: ApiUser;
  yearlyDividendSumFromFinPongPlusAccount: YearlyDividendSum;
};


export type QueryAdArgs = {
  adLocale: Scalars['String'];
  adPlatform: AdPlatformEnum;
  adType: AdTypeEnum;
};


export type QueryAdsArgs = {
  adLocale: Scalars['String'];
  adPlatform: AdPlatformEnum;
  adType: AdTypeEnum;
};


export type QueryAiHistoricalCryptoPricesArgs = {
  endDate: Scalars['String'];
  resolution: ResolutionEnum;
  startDate: Scalars['String'];
  symbols: Array<Scalars['String']>;
};


export type QueryAiHistoricalCurrencyExchangesArgs = {
  endDate: Scalars['String'];
  pairs: Array<CurrencyExchangeInput>;
  resolution: ResolutionEnum;
  startDate: Scalars['String'];
};


export type QueryAiHistoricalStockPricesArgs = {
  counterCurrency: Scalars['String'];
  endDate: Scalars['String'];
  resolution: ResolutionEnum;
  startDate: Scalars['String'];
  tickers: Array<StockTickerInput>;
};


export type QueryArticleArgs = {
  articleId: Scalars['ID'];
};


export type QueryArticleCommentsArgs = {
  articleId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryBackTestingProjectArgs = {
  slug: Scalars['ID'];
};


export type QueryBadgeDetailArgs = {
  badgeId: Scalars['ID'];
};


export type QueryBlockedUsersArgs = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryClosedMarketDaysArgs = {
  country: Scalars['String'];
  year: Scalars['String'];
};


export type QueryCombineUserPortfoliosArgs = {
  portfolioSlugs: Array<Scalars['ID']>;
};


export type QueryCompaniesArgs = {
  exchangeTickers?: InputMaybe<Array<CompanyInput>>;
  tickers?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryCompanyArgs = {
  country?: InputMaybe<Scalars['String']>;
  exchange?: InputMaybe<Scalars['String']>;
  ticker: Scalars['String'];
};


export type QueryCompanyDetailByIdArgs = {
  companyId: Scalars['ID'];
};


export type QueryCompanyDetailByIdsArgs = {
  companyIds: Array<Scalars['ID']>;
};


export type QueryCompanyDetailByTickerArgs = {
  country?: InputMaybe<Scalars['String']>;
  ticker: Scalars['String'];
};


export type QueryCompanyDisclosuresArgs = {
  companyIds: Array<Scalars['ID']>;
};


export type QueryCompanyEarningsArgs = {
  companyIds: Array<Scalars['ID']>;
};


export type QueryCompareToServerCiArgs = {
  ci: Scalars['String'];
};


export type QueryCpsAdArgs = {
  id: Scalars['ID'];
};


export type QueryCryptoCurrencyArgs = {
  id: Scalars['ID'];
};


export type QueryCryptoCurrencyDetailArgs = {
  base: Scalars['String'];
  counter: Scalars['String'];
  dataSource?: InputMaybe<Scalars['String']>;
};


export type QueryCryptoCurrencyExchangeArgs = {
  symbol: Scalars['String'];
};


export type QueryCryptoCurrencyExchangesArgs = {
  pairs?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryCryptoExchangeApiKeysArgs = {
  cryptoExchangeId?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryCryptoExchangesArgs = {
  language: Scalars['String'];
};


export type QueryCurrencyExchangeArgs = {
  symbol: Scalars['String'];
};


export type QueryCurrencyExchangesArgs = {
  pairs?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryDividendCalendarArgs = {
  date: Scalars['String'];
};


export type QueryDividendCalendarByDayArgs = {
  country?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  sortType: DividendCalendarSortTypeEnum;
};


export type QueryDividendCalendarByMonthArgs = {
  country?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  sortType: DividendCalendarSortTypeEnum;
};


export type QueryDividendCalendarForExternalChannelWithPaginationArgs = {
  channelName?: InputMaybe<ExternalChannelEnum>;
  date: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryDividendCalendarForPortfoliosArgs = {
  currencyId: Scalars['ID'];
  date: Scalars['String'];
  portfolioSlugs: Array<Scalars['String']>;
  taxRatio: Scalars['Float'];
};


export type QueryDividendCompaniesArgs = {
  months: Array<Scalars['Int']>;
  page: Scalars['Int'];
  per: Scalars['Int'];
  ref: DividendHistoryBaseDateEnum;
};


export type QueryDividendCompaniesInSnp500Args = {
  months: Array<Scalars['Int']>;
  page: Scalars['Int'];
  per: Scalars['Int'];
  ref: DividendHistoryBaseDateEnum;
};


export type QueryDividendCompaniesInSnp500ForExternalChannelArgs = {
  channelName: ExternalChannelEnum;
  months: Array<Scalars['Int']>;
  page: Scalars['Int'];
  per: Scalars['Int'];
  ref: DividendHistoryBaseDateEnum;
};


export type QueryDividendHistoriesArgs = {
  companyIds: Array<Scalars['ID']>;
};


export type QueryDividendHistoriesExistingDaysArgs = {
  country?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
};


export type QueryDividendHistoriesExistingDaysForExternalChannelArgs = {
  channelName: ExternalChannelEnum;
  country?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
};


export type QueryDividendHistoriesInCompanyArgs = {
  companyId: Scalars['ID'];
};


export type QueryDividendHistoriesInFavoriteItemCategoryArgs = {
  favoriteItemCategorySlug: Scalars['String'];
};


export type QueryDividendHistoriesInPortfoliosArgs = {
  portfolioSlugs: Array<Scalars['String']>;
};


export type QueryDividendHistoriesInSnp500Args = {
  companyIds: Array<Scalars['ID']>;
};


export type QueryDividendHistoriesInSnp500ForExternalChannelArgs = {
  channelName: ExternalChannelEnum;
  companyIds: Array<Scalars['ID']>;
};


export type QueryEarningCalendarsArgs = {
  date: Scalars['String'];
};


export type QueryEpisodeArgs = {
  episodeId: Scalars['ID'];
};


export type QueryEtfDetailArgs = {
  companyId: Scalars['ID'];
};


export type QueryEtfHoldingInformationArgs = {
  tickers: Array<StockTickerInput>;
};


export type QueryFavoriteArticlesInTopicArgs = {
  feedTopicId?: InputMaybe<Scalars['ID']>;
  language: Scalars['String'];
  limit: Scalars['Int'];
};


export type QueryFavoriteItemCategoryArgs = {
  slug: Array<Scalars['String']>;
};


export type QueryFavoriteItemCategoryCommentsArgs = {
  categoryId: Scalars['ID'];
};


export type QueryFeedFilteredByTagArgs = {
  assetTagId: Scalars['ID'];
  language: Scalars['String'];
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryFeedTopicsArgs = {
  communityLanguage?: InputMaybe<Scalars['String']>;
};


export type QueryFundoraPortfolioChatRoomArgs = {
  accessToken: Scalars['String'];
  portfolioSequence: Scalars['ID'];
};


export type QueryGetOgTagArgs = {
  originalLink: Scalars['String'];
  refetch?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHistoricalCryptoPricesArgs = {
  endDate: Scalars['String'];
  resolution: ResolutionEnum;
  startDate: Scalars['String'];
  symbols: Array<Scalars['String']>;
};


export type QueryHistoricalCurrencyExchangesArgs = {
  endDate: Scalars['String'];
  pairs: Array<CurrencyExchangeInput>;
  resolution: ResolutionEnum;
  startDate: Scalars['String'];
};


export type QueryHistoricalStockPricesArgs = {
  counterCurrency: Scalars['String'];
  endDate: Scalars['String'];
  resolution: ResolutionEnum;
  startDate: Scalars['String'];
  tickers: Array<StockTickerInput>;
};


export type QueryInvestingDiaryLogArgs = {
  logId?: InputMaybe<Scalars['ID']>;
};


export type QueryInvestingDiaryLogsArgs = {
  category?: InputMaybe<Scalars['String']>;
  portfolioSlug?: InputMaybe<Scalars['String']>;
  portfolioSlugs?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryInvestingIdeaArgs = {
  id: Scalars['ID'];
};


export type QueryInvestingInsightArgs = {
  investingInsightId: Scalars['ID'];
};


export type QueryInvestingInsightTagsArgs = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryInvestingInsightsArgs = {
  language: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  tagId: Scalars['ID'];
};


export type QueryKbSecAccountStatusArgs = {
  ci?: InputMaybe<Scalars['String']>;
};


export type QueryKbSecCheckFeeRatioOnOrderArgs = {
  accountNumber?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  marketType: TradeMarketTypeEnum;
  tradeType: TradeTypeEnum;
};


export type QueryKbSecCheckHoldingAssetAmountArgs = {
  accountNumber: Scalars['String'];
  accountPassword: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  marketType: TradeMarketTypeEnum;
  productNumber: Scalars['String'];
};


export type QueryKbSecCheckHoldingAssetAmountAtSellArgs = {
  accountNumber: Scalars['String'];
  accountPassword: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  productNumber: Scalars['String'];
};


export type QueryKbSecCheckStockHoldingStatusArgs = {
  accountNumber: Scalars['String'];
  accountPassword: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  productNumber: Scalars['String'];
};


export type QueryKbSecForeignDecimalStockOrderableCashAmountArgs = {
  accountNumber: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  productNumber: Scalars['String'];
};


export type QueryKbSecOrderableCashAmountArgs = {
  accountNumber?: InputMaybe<Scalars['String']>;
  accountPassword?: InputMaybe<Scalars['String']>;
  ci?: InputMaybe<Scalars['String']>;
  needRefresh: Scalars['Boolean'];
  productNumber?: InputMaybe<Scalars['String']>;
};


export type QueryKbSecPrivacyTermsAgreementStatusArgs = {
  ci?: InputMaybe<Scalars['String']>;
};


export type QueryKbSecRealizedProfitAndLossHistoriesArgs = {
  accountNumber: Scalars['String'];
  accountPassword: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  productNumber: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryKbSecUserAccountDepositArgs = {
  accountNumber: Scalars['String'];
  accountPassword: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  productNumber: Scalars['String'];
};


export type QueryKbSecUserAccountTransactionHistoriesArgs = {
  accountNumber: Scalars['String'];
  accountPassword: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  endDate: Scalars['String'];
  nextKey?: InputMaybe<Scalars['String']>;
  productNumber: Scalars['String'];
  startDate: Scalars['String'];
};


export type QueryLatestAgreementsArgs = {
  serviceName: Scalars['String'];
};


export type QueryLectureContentArgs = {
  lectureContentId: Scalars['ID'];
};


export type QueryLectureContentDetailBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryLectureContentEpisodesArgs = {
  lectureContentId: Scalars['ID'];
};


export type QueryLectureContentReviewsArgs = {
  lectureContentId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sortType?: InputMaybe<LectureContentReviewSortTypeEnum>;
};


export type QueryLectureContentTagsArgs = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryLectureContentsArgs = {
  lectureContentTagIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryMailingGroupArgs = {
  id: Scalars['ID'];
};


export type QueryMbtiResultCounterArgs = {
  mbtiType: Scalars['String'];
};


export type QueryMbtiVisitorCounterArgs = {
  category: Scalars['String'];
  date: Scalars['String'];
  language: Scalars['String'];
  name: Scalars['String'];
};


export type QueryMyAdArgs = {
  adLocale: Scalars['String'];
  adPlatform: AdPlatformEnum;
  adType: AdTypeEnum;
};


export type QueryMyAdsArgs = {
  adLocale: Scalars['String'];
  adPlatform: AdPlatformEnum;
  adType: AdTypeEnum;
};


export type QueryMyArticlesArgs = {
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryMyBookmarkedArticlesArgs = {
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryMyCommentedArticlesArgs = {
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryMyCommunityNotificationsWithLanguageArgs = {
  language: Scalars['String'];
};


export type QueryMyDataTokenArgs = {
  ci: Scalars['String'];
};


export type QueryMyEventStatusArgs = {
  ci?: InputMaybe<Scalars['String']>;
};


export type QueryMyFollowingFeedArgs = {
  language: Scalars['String'];
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
  userFollowingId?: InputMaybe<Scalars['ID']>;
};


export type QueryMyFollowingsArgs = {
  itemType?: InputMaybe<FollowingItemEnum>;
  language: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  sortOrderType: MyFollowingSortOrderEnum;
};


export type QueryMyInvestingKeywordsArgs = {
  language: Scalars['String'];
};


export type QueryMyKbSecRandomPickEventParticipationStatusArgs = {
  ci?: InputMaybe<Scalars['String']>;
};


export type QueryMyKbSecRandomPickEventPrizeArgs = {
  ci?: InputMaybe<Scalars['String']>;
};


export type QueryMyKbSecRandomPickReferralEventPrizeArgs = {
  ci?: InputMaybe<Scalars['String']>;
};


export type QueryMyPortfoliosFromPartnerArgs = {
  page: Scalars['Int'];
  per: Scalars['Int'];
};


export type QueryMyPortfoliosFromSamsungArgs = {
  page: Scalars['Int'];
  per: Scalars['Int'];
};


export type QueryMyPublicPortfoliosArgs = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryMySecuritiesAccountsArgs = {
  certification: CodefCertificationMethodInput;
  organizationId: Scalars['ID'];
};


export type QueryMyTemporarySavedArticlesArgs = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryNoticeArgs = {
  id: Scalars['ID'];
};


export type QueryNoticesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryOrganizationReportsArgs = {
  companyIds: Array<Scalars['ID']>;
};


export type QueryPortfolioArgs = {
  portfolioId: Scalars['ID'];
};


export type QueryPortfolioRecommendationReviewsArgs = {
  userPortfolioSlug: Scalars['String'];
};


export type QueryPortfolioTagsArgs = {
  portfolioId: Scalars['ID'];
};


export type QueryPortfoliosArgs = {
  portfolioIds: Array<Scalars['ID']>;
};


export type QueryProductArgs = {
  slug: Scalars['String'];
};


export type QueryProductOrderArgs = {
  slug: Scalars['String'];
};


export type QueryPublicFavoriteItemsArgs = {
  favoriteItemCategoryId: Scalars['ID'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryPublicPortfoliosArgs = {
  page: Scalars['Int'];
};


export type QueryPublicPortfoliosByTagsArgs = {
  tags: Array<Scalars['String']>;
};


export type QueryRecentActiveChatRoomsArgs = {
  language: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryRecommendedChatRoomTypesArgs = {
  language: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryRecommendedChatRoomsArgs = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  recommendTypeId: Scalars['ID'];
};


export type QueryRecommendedFollowsArgs = {
  itemType: FollowingItemEnum;
  language: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryRecommendedFollowsByUserFavoritesArgs = {
  itemType: FollowingItemEnum;
  language: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryRecommendedLectureContentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchArticlesArgs = {
  keyword: Scalars['String'];
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type QuerySearchAssetTagsArgs = {
  keyword: Scalars['String'];
  language: Scalars['String'];
};


export type QuerySearchCommunityArticlesArgs = {
  keyword: Scalars['String'];
  language: Scalars['String'];
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type QuerySearchCommunityUsersArgs = {
  keyword: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchCompanyArgs = {
  keyword: Scalars['String'];
};


export type QuerySearchCustomPortfolioTopicsArgs = {
  keyword: Scalars['String'];
};


export type QuerySearchFollowsArgs = {
  itemType: FollowingItemEnum;
  keyword: Scalars['String'];
  language: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchItemArgs = {
  keyword: Scalars['String'];
};


export type QuerySearchUsersInArticleArgs = {
  articleId?: InputMaybe<Scalars['ID']>;
  keyword: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryStockLearningCenterContentsArgs = {
  language: Scalars['String'];
};


export type QueryStockOrderHistoriesArgs = {
  accountNumber: Scalars['String'];
  accountPassword: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  productNumber: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  statusType: OrderStatusTypeEnum;
  tradeType?: InputMaybe<TradeTypeEnum>;
};


export type QueryStockOrderHistoriesByCompanyIdArgs = {
  accountNumber?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryStockOrderHistoryArgs = {
  accountNumber: Scalars['String'];
  accountPassword: Scalars['String'];
  ci?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  needRefresh: Scalars['Boolean'];
  productNumber: Scalars['String'];
};


export type QueryThisWeekDividendStocksForExternalChannelArgs = {
  channelName: ExternalChannelEnum;
};


export type QueryTimelineFeedArgs = {
  feedTopicId?: InputMaybe<Scalars['ID']>;
  includeInfluencerArticle?: InputMaybe<Scalars['Boolean']>;
  language: Scalars['String'];
  limit: Scalars['Int'];
  portfolioTopicId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryTop100FavoriteItemCategoriesArgs = {
  filter: FavoriteItemCategoryFilter;
  order: Order;
};


export type QueryTop100FavoriteItemsArgs = {
  itemCategory: ItemCategory;
  order: Order;
};


export type QueryUserArgs = {
  userId: Scalars['String'];
};


export type QueryUserAcquiredBadgeListArgs = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QueryUserArticlesArgs = {
  language: Scalars['String'];
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryUserBadgeListArgs = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QueryUserFollowersArgs = {
  language: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QueryUserFollowingsArgs = {
  itemType: FollowingItemEnum;
  language: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QueryUserOrderedLectureContentArgs = {
  userOwnedLectureContentId: Scalars['ID'];
};


export type QueryUserOrderedLectureContentsArgs = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryUserOwnedLectureContentArgs = {
  userOwnedLectureContentId: Scalars['ID'];
};


export type QueryUserOwnedLectureContentsArgs = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  status: UserOwnedLectureContentStatusEnum;
};


export type QueryUserPortfolioArgs = {
  portfolioSlug: Scalars['String'];
};


export type QueryUserPortfolioCommentsArgs = {
  portfolioSlug: Scalars['String'];
};


export type QueryUserProfileArgs = {
  userId: Scalars['ID'];
};


export type QueryUserPublicFavoriteItemCategoriesArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryUserPublicPortfoliosArgs = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryUserWishedLectureContentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryUsersStarredFavoriteItemCategoriesArgs = {
  categoryId: Scalars['ID'];
};


export type QueryValidateUserConnectedAssetsEvaluationAmountArgs = {
  evaluationAmount: Scalars['Float'];
};


export type QueryYearlyDividendSumFromFinPongPlusAccountArgs = {
  finPongPlusUserAccountId: Scalars['ID'];
};

export type RandomPickEventParticipationStatus = {
  __typename?: 'RandomPickEventParticipationStatus';
  isUserParticipated: Scalars['Boolean'];
};

export type RandomPickEventStatus = {
  __typename?: 'RandomPickEventStatus';
  isInProgress: Scalars['Boolean'];
};

export type RealizedProfitAndLoss = {
  __typename?: 'RealizedProfitAndLoss';
  histories: Array<RealizedProfitAndLossHistory>;
  totalForeignTradeFee: Scalars['Float'];
  totalKrTradeFee: Scalars['Float'];
  totalRealizedProfitAndLoss: Scalars['Float'];
};

export type RealizedProfitAndLossHistory = {
  __typename?: 'RealizedProfitAndLossHistory';
  buyAveragePrice: Scalars['Float'];
  company: StockOrderHistoryCompany;
  detailConcludedAmount: Scalars['Float'];
  id: Scalars['ID'];
  orderedAt: Scalars['String'];
  profitAndLossRatio: Scalars['Float'];
  realizedProfitAndLoss: Scalars['Float'];
  sellConcludedPrice: Scalars['Float'];
};

/** Autogenerated return type of RealtimeCryptoCurrencyPrice. */
export type RealtimeCryptoCurrencyPricePayload = {
  __typename?: 'RealtimeCryptoCurrencyPricePayload';
  cryptoCurrencyPrices: Array<CryptoCurrencyPrice>;
};

/** Autogenerated return type of RealtimeCurrencyExchanges. */
export type RealtimeCurrencyExchangesPayload = {
  __typename?: 'RealtimeCurrencyExchangesPayload';
  currencyExchanges: Array<CurrencyExchange>;
};

/** Autogenerated return type of RealtimeStockPrice. */
export type RealtimeStockPricePayload = {
  __typename?: 'RealtimeStockPricePayload';
  companyPrices: Array<CompanyPrice>;
};

export type RecommendTypeChatRoom = {
  __typename?: 'RecommendTypeChatRoom';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Autogenerated return type of RemoveArticleComment. */
export type RemoveArticleCommentPayload = {
  __typename?: 'RemoveArticleCommentPayload';
  comment?: Maybe<ArticleComment>;
};

/** Autogenerated return type of RemoveArticle. */
export type RemoveArticlePayload = {
  __typename?: 'RemoveArticlePayload';
  article: Article;
};

/** Autogenerated return type of RemoveArticles. */
export type RemoveArticlesPayload = {
  __typename?: 'RemoveArticlesPayload';
  articles: Array<Article>;
};

/** Autogenerated return type of RemoveBackTestingProjectResult. */
export type RemoveBackTestingProjectResultPayload = {
  __typename?: 'RemoveBackTestingProjectResultPayload';
  backTestingProject?: Maybe<BackTestingProject>;
};

/** Autogenerated return type of RemoveBookmarkFromArticle. */
export type RemoveBookmarkFromArticlePayload = {
  __typename?: 'RemoveBookmarkFromArticlePayload';
  article: Article;
};

/** Autogenerated return type of RemoveCommentFromFavoriteItemCategory. */
export type RemoveCommentFromFavoriteItemCategoryPayload = {
  __typename?: 'RemoveCommentFromFavoriteItemCategoryPayload';
  category?: Maybe<FavoriteItemCategory>;
};

/** Autogenerated return type of RemoveCryptoExchangeApiKeyFromPortfolio. */
export type RemoveCryptoExchangeApiKeyFromPortfolioPayload = {
  __typename?: 'RemoveCryptoExchangeApiKeyFromPortfolioPayload';
  userPortfolio?: Maybe<UserPortfolio>;
};

/** Autogenerated return type of RemoveCryptoExchangeApiKeyFromUser. */
export type RemoveCryptoExchangeApiKeyFromUserPayload = {
  __typename?: 'RemoveCryptoExchangeApiKeyFromUserPayload';
  cryptoExchangeApiKey: CryptoExchangeApiKey;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type RemoveFavoriteItem = {
  favoriteItemId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of RemoveFavoriteItemCategory. */
export type RemoveFavoriteItemCategoryPayload = {
  __typename?: 'RemoveFavoriteItemCategoryPayload';
  category: FavoriteItemCategory;
};

/** Autogenerated return type of RemoveFinPongPlusConnect. */
export type RemoveFinPongPlusConnectPayload = {
  __typename?: 'RemoveFinPongPlusConnectPayload';
  finPongPlusApi: FinPongPlusApi;
};

export type RemoveForeignDecimalStockOrderInput = {
  companyId: Scalars['ID'];
  orderDate: Scalars['String'];
  orderNumber: Scalars['String'];
  orderType: TradeOrderEnum;
  tradeType: TradeTypeEnum;
};

/** Autogenerated return type of RemoveForeignDecimalStockOrder. */
export type RemoveForeignDecimalStockOrderPayload = {
  __typename?: 'RemoveForeignDecimalStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of RemoveForeignStockOrder. */
export type RemoveForeignStockOrderPayload = {
  __typename?: 'RemoveForeignStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of RemoveInvestingDiaryLog. */
export type RemoveInvestingDiaryLogPayload = {
  __typename?: 'RemoveInvestingDiaryLogPayload';
  investingDiaryLog: InvestingDiaryLog;
};

/** Autogenerated return type of RemoveItemsToFavoriteItemCategory. */
export type RemoveItemsToFavoriteItemCategoryPayload = {
  __typename?: 'RemoveItemsToFavoriteItemCategoryPayload';
  category: FavoriteItemCategory;
};

export type RemoveKrDecimalStockOrderInput = {
  amount?: InputMaybe<Scalars['Float']>;
  benefitIsinCode: Scalars['String'];
  companyId: Scalars['ID'];
  decimalOrderSequence: Scalars['String'];
  decimalOrderStandardType?: InputMaybe<DecimalStockOrderStandardTypeEnum>;
  decimalTradeJobTypeCode: Scalars['String'];
  orderDate: Scalars['String'];
  orderNumber: Scalars['String'];
  orderSequence: Scalars['String'];
  orderType: TradeOrderEnum;
  price?: InputMaybe<Scalars['Float']>;
  tradeType: TradeTypeEnum;
};

/** Autogenerated return type of RemoveKrDecimalStockOrder. */
export type RemoveKrDecimalStockOrderPayload = {
  __typename?: 'RemoveKrDecimalStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of RemoveKrStockOrder. */
export type RemoveKrStockOrderPayload = {
  __typename?: 'RemoveKrStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of RemoveLectureContentReview. */
export type RemoveLectureContentReviewPayload = {
  __typename?: 'RemoveLectureContentReviewPayload';
  lectureContentReview: LectureContentReview;
};

/** Autogenerated return type of RemoveLectureContentReviewReply. */
export type RemoveLectureContentReviewReplyPayload = {
  __typename?: 'RemoveLectureContentReviewReplyPayload';
  lectureContentReviewReply: LectureContentReviewReply;
};

/** Autogenerated return type of RemoveLikeToArticle. */
export type RemoveLikeToArticlePayload = {
  __typename?: 'RemoveLikeToArticlePayload';
  article: Article;
  articleLike?: Maybe<ArticleLike>;
};

/** Autogenerated return type of RemoveLikeToLectureContentReview. */
export type RemoveLikeToLectureContentReviewPayload = {
  __typename?: 'RemoveLikeToLectureContentReviewPayload';
  lectureContentReview: LectureContentReview;
};

/** Autogenerated return type of RemoveMyRepresentativeBadge. */
export type RemoveMyRepresentativeBadgePayload = {
  __typename?: 'RemoveMyRepresentativeBadgePayload';
  badge?: Maybe<Badge>;
};

/** Autogenerated return type of RemovePlaidConnectFromPortfolio. */
export type RemovePlaidConnectFromPortfolioPayload = {
  __typename?: 'RemovePlaidConnectFromPortfolioPayload';
  userPortfolio?: Maybe<UserPortfolio>;
};

/** Autogenerated return type of RemovePortfolioAssets. */
export type RemovePortfolioAssetsPayload = {
  __typename?: 'RemovePortfolioAssetsPayload';
  errors: Array<Scalars['String']>;
  portfolio: UserPortfolio;
};

/** Autogenerated return type of RemovePortfolio. */
export type RemovePortfolioPayload = {
  __typename?: 'RemovePortfolioPayload';
  errors: Array<Scalars['String']>;
  items: Array<UserPortfolio>;
};

/** Autogenerated return type of RemovePortfolios. */
export type RemovePortfoliosPayload = {
  __typename?: 'RemovePortfoliosPayload';
  errors: Array<Scalars['String']>;
  items: Array<UserPortfolio>;
};

/** Autogenerated return type of RemoveReserveForeignStockOrder. */
export type RemoveReserveForeignStockOrderPayload = {
  __typename?: 'RemoveReserveForeignStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of RemoveReserveKrStockOrder. */
export type RemoveReserveKrStockOrderPayload = {
  __typename?: 'RemoveReserveKrStockOrderPayload';
  kbSecScreenApi: KbSecScreenApi;
};

/** Autogenerated return type of RemoveSecuritiesAccountFromPortfolio. */
export type RemoveSecuritiesAccountFromPortfolioPayload = {
  __typename?: 'RemoveSecuritiesAccountFromPortfolioPayload';
  errors: Array<Scalars['String']>;
  portfolio: UserPortfolio;
};

/** Autogenerated return type of RemoveStarFromFavoriteItemCategory. */
export type RemoveStarFromFavoriteItemCategoryPayload = {
  __typename?: 'RemoveStarFromFavoriteItemCategoryPayload';
  category?: Maybe<FavoriteItemCategory>;
};

export type RemoveStockOrderInput = {
  amount: Scalars['Float'];
  companyId: Scalars['ID'];
  orderNumber: Scalars['String'];
  orderType: TradeOrderEnum;
  price: Scalars['Float'];
  tradeType: TradeTypeEnum;
};

export type RemoveUserAsset = {
  id: Scalars['ID'];
};

/** Autogenerated return type of RemoveWishToLectureContent. */
export type RemoveWishToLectureContentPayload = {
  __typename?: 'RemoveWishToLectureContentPayload';
  userWishedLectureContent: UserWishedLectureContent;
};

export type Report = {
  __typename?: 'Report';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  reason: Scalars['String'];
  reportType: Scalars['String'];
  updatedAt: Scalars['String'];
};

/** Autogenerated return type of ReportDividendHistoryErrorAboutStock. */
export type ReportDividendHistoryErrorAboutStockPayload = {
  __typename?: 'ReportDividendHistoryErrorAboutStockPayload';
  errors: Array<Scalars['String']>;
  stockInfoErrorRequest: StockInfoErrorRequest;
};

/** Autogenerated return type of ReportDividendMonthErrorAboutStock. */
export type ReportDividendMonthErrorAboutStockPayload = {
  __typename?: 'ReportDividendMonthErrorAboutStockPayload';
  errors: Array<Scalars['String']>;
  stockInfoErrorRequest: StockInfoErrorRequest;
};

/** Autogenerated return type of ReportLectureContentReview. */
export type ReportLectureContentReviewPayload = {
  __typename?: 'ReportLectureContentReviewPayload';
  report: Report;
};

/** Autogenerated return type of ReportLectureContentReviewReply. */
export type ReportLectureContentReviewReplyPayload = {
  __typename?: 'ReportLectureContentReviewReplyPayload';
  report: Report;
};

/** Autogenerated return type of ReportNormalErrorAboutStock. */
export type ReportNormalErrorAboutStockPayload = {
  __typename?: 'ReportNormalErrorAboutStockPayload';
  errors: Array<Scalars['String']>;
  stockInfoErrorRequest: StockInfoErrorRequest;
};

/** Autogenerated return type of ReportSectorErrorAboutStock. */
export type ReportSectorErrorAboutStockPayload = {
  __typename?: 'ReportSectorErrorAboutStockPayload';
  errors: Array<Scalars['String']>;
  stockInfoErrorRequest: StockInfoErrorRequest;
};

/** Autogenerated return type of ReportUnresolvedSymbol. */
export type ReportUnresolvedSymbolPayload = {
  __typename?: 'ReportUnresolvedSymbolPayload';
  errors: Array<Scalars['String']>;
  stockInfoErrorRequest: StockInfoErrorRequest;
};

/** Autogenerated return type of RequestProfessionalInvestorVerification. */
export type RequestProfessionalInvestorVerificationPayload = {
  __typename?: 'RequestProfessionalInvestorVerificationPayload';
  professionalInvestor: ProfessionalInvestor;
};

/** Autogenerated return type of RequestTossPaymentFail. */
export type RequestTossPaymentFailPayload = {
  __typename?: 'RequestTossPaymentFailPayload';
  paymentResult?: Maybe<PaymentResult>;
};

/** Autogenerated return type of RequestTossPaymentSuccess. */
export type RequestTossPaymentSuccessPayload = {
  __typename?: 'RequestTossPaymentSuccessPayload';
  paymentResult?: Maybe<PaymentResult>;
};

/** Autogenerated return type of RequestUserPhoneVerificationForFundora. */
export type RequestUserPhoneVerificationForFundoraPayload = {
  __typename?: 'RequestUserPhoneVerificationForFundoraPayload';
  fundoraUserPhoneVerification?: Maybe<UserPhoneVerificationKr>;
};

/** Autogenerated return type of RequestUserPhoneVerificationForKbSec. */
export type RequestUserPhoneVerificationForKbSecPayload = {
  __typename?: 'RequestUserPhoneVerificationForKbSecPayload';
  kbSecUserPhoneVerification?: Maybe<UserPhoneVerificationKr>;
};

/** Autogenerated return type of RequestUserPhoneVerificationToKrTelecom. */
export type RequestUserPhoneVerificationToKrTelecomPayload = {
  __typename?: 'RequestUserPhoneVerificationToKrTelecomPayload';
  userPhoneVerificationKr?: Maybe<UserPhoneVerificationKr>;
  userPhoneVerificationKrHistory?: Maybe<UserPhoneVerificationKr>;
};

export enum ResolutionEnum {
  /** Month */
  M = 'M',
  /** Week */
  W = 'W'
}

export type ReviewRequestedStatus = {
  __typename?: 'ReviewRequestedStatus';
  reviewRequestedAt: Scalars['String'];
  reviewRequestedScreen: Scalars['String'];
  reviewedAt?: Maybe<Scalars['String']>;
};

export type RichCategory = {
  __typename?: 'RichCategory';
  createdAt?: Maybe<Scalars['String']>;
  favoriteItemCategory: FavoriteItemCategory;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  richName?: Maybe<LanguageString>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of SaveArticleTemporary. */
export type SaveArticleTemporaryPayload = {
  __typename?: 'SaveArticleTemporaryPayload';
  article: Article;
};

/** Autogenerated return type of SaveDividendPortfolioFromSamsung. */
export type SaveDividendPortfolioFromSamsungPayload = {
  __typename?: 'SaveDividendPortfolioFromSamsungPayload';
  portfolio: UserPortfolio;
};

/** Autogenerated return type of SaveDividendPortfolio. */
export type SaveDividendPortfolioPayload = {
  __typename?: 'SaveDividendPortfolioPayload';
  portfolio: UserPortfolio;
};

export type SearchArticles = {
  __typename?: 'SearchArticles';
  articles: Array<Article>;
};

export type SearchCompany = {
  __typename?: 'SearchCompany';
  categoryType?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  country?: Maybe<Scalars['String']>;
  cryptoCurrencyId?: Maybe<Scalars['ID']>;
  currency?: Maybe<Currency>;
  currencySymbol?: Maybe<Scalars['String']>;
  dataSource?: Maybe<Scalars['String']>;
  decimalPoint?: Maybe<Scalars['Int']>;
  exchange?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subExchange?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
};

export type SearchFollowItem = {
  __typename?: 'SearchFollowItem';
  categoryType: Scalars['String'];
  followItem?: Maybe<FollowItem>;
  hasNewArticle?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isFollowing: Scalars['Boolean'];
  userFollowingId?: Maybe<Scalars['ID']>;
};

export type SearchFollowItems = {
  __typename?: 'SearchFollowItems';
  items: Array<SearchFollowItem>;
  totalCount: Scalars['Int'];
};

export type SellDecimalStockOrderInput = {
  amount: Scalars['Float'];
  amountType: KbSecDecimalOrderAmountEnum;
  companyId: Scalars['ID'];
  tradeType: TradeTypeEnum;
};

/** Autogenerated return type of SendDownloadAppLinkUrlSms. */
export type SendDownloadAppLinkUrlSmsPayload = {
  __typename?: 'SendDownloadAppLinkUrlSmsPayload';
  landingLink?: Maybe<LandingLink>;
};

export type ServerCiStatus = {
  __typename?: 'ServerCiStatus';
  isCiValueSame: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
};

export type ServiceEventParticipant = {
  __typename?: 'ServiceEventParticipant';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
  userName: Scalars['String'];
};

export type ServiceOperationStatus = {
  __typename?: 'ServiceOperationStatus';
  isServiceSupported: Scalars['Boolean'];
};

export type ServiceOperations = {
  __typename?: 'ServiceOperations';
  fundora: ServiceOperationStatus;
  kbSec: ServiceOperationStatus;
};

export enum ServicePlatformEnum {
  /** App */
  App = 'APP',
  /** Mobile Web */
  MobileWeb = 'MOBILE_WEB',
  /** PC Web */
  PcWeb = 'PC_WEB'
}

export type SignInResult = {
  __typename?: 'SignInResult';
  token: Scalars['String'];
  username: Scalars['String'];
};

export type SignOut = {
  __typename?: 'SignOut';
  deviceRegistrationToken: Scalars['String'];
};

/** Autogenerated return type of SignUpWithFundora. */
export type SignUpWithFundoraPayload = {
  __typename?: 'SignUpWithFundoraPayload';
  fundoraUser: FundoraUser;
};

export type StockCandlePrice = {
  __typename?: 'StockCandlePrice';
  baseCurrency?: Maybe<Scalars['String']>;
  c?: Maybe<Array<Scalars['String']>>;
  counterCurrency?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  h?: Maybe<Array<Scalars['String']>>;
  l?: Maybe<Array<Scalars['String']>>;
  o?: Maybe<Array<Scalars['String']>>;
  pc?: Maybe<Array<Scalars['String']>>;
  t?: Maybe<Array<Scalars['Int']>>;
  ticker: Scalars['String'];
  v?: Maybe<Array<Scalars['String']>>;
};

export type StockInfoErrorRequest = {
  __typename?: 'StockInfoErrorRequest';
  country: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  errorType: Scalars['String'];
  id: Scalars['ID'];
  ticker: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type StockLearningCenterContent = {
  __typename?: 'StockLearningCenterContent';
  articleId?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  createdAt: Scalars['String'];
  dynamicLinkUrl: Scalars['String'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  language: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
  visibleAt?: Maybe<Scalars['String']>;
};

export enum StockNormalError {
  /** Company name */
  CompanyName = 'COMPANY_NAME',
  /** Dividend Suspend */
  DividendSuspend = 'DIVIDEND_SUSPEND',
  /** Logo */
  Logo = 'LOGO',
  /** Need to update information */
  NeedToUpdate = 'NEED_TO_UPDATE'
}

export type StockOrderHistoryCompany = {
  __typename?: 'StockOrderHistoryCompany';
  id: Scalars['ID'];
  logoImageUrl: Scalars['String'];
  names: LanguageString;
  symbol: Scalars['String'];
};

export type StockOrderHistoryCurrency = {
  __typename?: 'StockOrderHistoryCurrency';
  currencyType: Scalars['String'];
  id: Scalars['ID'];
  symbol: Scalars['String'];
  unit: Scalars['String'];
};

export type StockOrderHistoryPortfolio = {
  __typename?: 'StockOrderHistoryPortfolio';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type StockOrderInput = {
  amount?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['ID'];
  orderType: TradeOrderEnum;
  price: Scalars['Float'];
  tradeType: TradeTypeEnum;
};

/**
 *   [Stock Price]
 * flow: Company -> StockPrice
 * fields: ticker, price, price_change_percent, updated_at
 *   spec ref: https://www.notion.so/therichteam/StockPrice-dcbbdd6b0e434625b4cea6d4158b3459
 *
 */
export type StockPrice = {
  __typename?: 'StockPrice';
  id?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['String']>;
  priceChangePercent?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of StockPriceUpdated. */
export type StockPriceUpdatedPayload = {
  __typename?: 'StockPriceUpdatedPayload';
  companyPrice: CompanyPrice;
};

export type StockPrize = {
  __typename?: 'StockPrize';
  companyId: Scalars['ID'];
  companyNames: LanguageString;
  imageUrl: Scalars['String'];
  ticker: Scalars['String'];
};

export type StockTickerInput = {
  country?: InputMaybe<Scalars['String']>;
  ticker: Scalars['String'];
};

export type SubscribedUser = {
  __typename?: 'SubscribedUser';
  email: Scalars['String'];
  userId?: Maybe<Scalars['ID']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  cryptoCurrencyPriceUpdated: CryptoCurrencyPriceUpdatedPayload;
  currencyExchangeUpdated: CurrencyExchangeUpdatedPayload;
  realtimeCryptoCurrencyPrice: RealtimeCryptoCurrencyPricePayload;
  realtimeCurrencyExchanges: RealtimeCurrencyExchangesPayload;
  realtimeStockPrice: RealtimeStockPricePayload;
  stockPriceUpdated: StockPriceUpdatedPayload;
};


export type SubscriptionCryptoCurrencyPriceUpdatedArgs = {
  base: Scalars['String'];
  counter: Scalars['String'];
  dataSource?: InputMaybe<Scalars['String']>;
};


export type SubscriptionCurrencyExchangeUpdatedArgs = {
  base: Scalars['String'];
  counter: Scalars['String'];
};


export type SubscriptionRealtimeCryptoCurrencyPriceArgs = {
  counter: Scalars['String'];
  cryptoCurrencyIds: Array<Scalars['ID']>;
};


export type SubscriptionRealtimeCurrencyExchangesArgs = {
  pairs?: InputMaybe<Array<Scalars['String']>>;
};


export type SubscriptionRealtimeStockPriceArgs = {
  companyIds: Array<Scalars['ID']>;
};


export type SubscriptionStockPriceUpdatedArgs = {
  companyId: Scalars['ID'];
};

export type SwitchPortfolio = {
  __typename?: 'SwitchPortfolio';
  createdAt?: Maybe<Scalars['String']>;
  currency: Currency;
  dividendTaxRate?: Maybe<Scalars['Float']>;
  evaluationAmount: Scalars['Float'];
  id: Scalars['ID'];
  monthlyDividendAmount: Scalars['Float'];
  previousDayEvaluationAmount: Scalars['Float'];
  purchaseAmount: Scalars['Float'];
  supportedCurrencies: Array<Currency>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of SyncFundoraPortfolio. */
export type SyncFundoraPortfolioPayload = {
  __typename?: 'SyncFundoraPortfolioPayload';
  portfolio: UserPortfolio;
};

/** Autogenerated return type of SyncFundoraPortfolios. */
export type SyncFundoraPortfoliosPayload = {
  __typename?: 'SyncFundoraPortfoliosPayload';
  portfolios: Array<UserPortfolio>;
};

/** Autogenerated return type of SynchronizeKbSecAccount. */
export type SynchronizeKbSecAccountPayload = {
  __typename?: 'SynchronizeKbSecAccountPayload';
  kbSecUserAccount?: Maybe<KbSecUserAccount>;
};

export type Top100FavoriteItem = {
  __typename?: 'Top100FavoriteItem';
  company?: Maybe<Company>;
  cryptoCurrency?: Maybe<CryptoCurrency>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['ID']>;
  itemCategory?: Maybe<ItemCategory>;
  refererCount?: Maybe<Scalars['Int']>;
};

export enum TradeMarketTypeEnum {
  /** FOREIGN DECIMAL MARKET */
  ForeignDecimalMarket = 'FOREIGN_DECIMAL_MARKET',
  /** FOREIGN MARKET */
  ForeignMarket = 'FOREIGN_MARKET',
  /** KR DECIMAL MARKET */
  KrDecimalMarket = 'KR_DECIMAL_MARKET',
  /** KR MARKET */
  KrMarket = 'KR_MARKET'
}

export enum TradeOrderEnum {
  /** DECIMAL ORDER */
  DecimalOrder = 'DECIMAL_ORDER',
  /** LIMIT ORDER */
  LimitOrder = 'LIMIT_ORDER',
  /** MARKET ORDER */
  MarketOrder = 'MARKET_ORDER'
}

export enum TradeTypeEnum {
  /** BUYING */
  Buying = 'BUYING',
  /** SELLING */
  Selling = 'SELLING'
}

/** Autogenerated return type of UnblockUser. */
export type UnblockUserPayload = {
  __typename?: 'UnblockUserPayload';
  user: User;
};

/** Autogenerated return type of UnfollowItem. */
export type UnfollowItemPayload = {
  __typename?: 'UnfollowItemPayload';
  item: SearchFollowItem;
};

/** Autogenerated return type of UnfollowItems. */
export type UnfollowItemsPayload = {
  __typename?: 'UnfollowItemsPayload';
  items: Array<SearchFollowItem>;
};

/** Autogenerated return type of UpdateArticleComment. */
export type UpdateArticleCommentPayload = {
  __typename?: 'UpdateArticleCommentPayload';
  comment?: Maybe<ArticleComment>;
};

/** Autogenerated return type of UpdateArticle. */
export type UpdateArticlePayload = {
  __typename?: 'UpdateArticlePayload';
  article: Article;
};

/** Autogenerated return type of UpdateBackTestingProjectResult. */
export type UpdateBackTestingProjectResultPayload = {
  __typename?: 'UpdateBackTestingProjectResultPayload';
  backTestingProjectResult?: Maybe<BackTestingProject>;
};

/** Autogenerated return type of UpdateBaseCurrencyAtPortfolio. */
export type UpdateBaseCurrencyAtPortfolioPayload = {
  __typename?: 'UpdateBaseCurrencyAtPortfolioPayload';
  errors: Array<Scalars['String']>;
  portfolio: UserPortfolio;
};

/** Autogenerated return type of UpdateChatRoomNotificationFromFirestore. */
export type UpdateChatRoomNotificationFromFirestorePayload = {
  __typename?: 'UpdateChatRoomNotificationFromFirestorePayload';
  chatRoomNotification: ChatRoomNotification;
};

/** Autogenerated return type of UpdateCryptoExchangeApiKeyFromPortfolio. */
export type UpdateCryptoExchangeApiKeyFromPortfolioPayload = {
  __typename?: 'UpdateCryptoExchangeApiKeyFromPortfolioPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  userPortfolio?: Maybe<UserPortfolio>;
};

/** Autogenerated return type of UpdateEtfDetail. */
export type UpdateEtfDetailPayload = {
  __typename?: 'UpdateEtfDetailPayload';
  etfDetail: EtfDetail;
};

export type UpdateFavoriteCategoryOrder = {
  categoryId: Scalars['ID'];
  orderScore: Scalars['Int'];
};

/** Autogenerated return type of UpdateFavoriteItemCategoryOrders. */
export type UpdateFavoriteItemCategoryOrdersPayload = {
  __typename?: 'UpdateFavoriteItemCategoryOrdersPayload';
  categories: Array<FavoriteItemCategory>;
};

/** Autogenerated return type of UpdateFavoriteItemCategory. */
export type UpdateFavoriteItemCategoryPayload = {
  __typename?: 'UpdateFavoriteItemCategoryPayload';
  category: FavoriteItemCategory;
};

/** Autogenerated return type of UpdateInvestingDiaryLog. */
export type UpdateInvestingDiaryLogPayload = {
  __typename?: 'UpdateInvestingDiaryLogPayload';
  investingDiaryLog: InvestingDiaryLog;
};

/** Autogenerated return type of UpdateLectureContentReview. */
export type UpdateLectureContentReviewPayload = {
  __typename?: 'UpdateLectureContentReviewPayload';
  lectureContentReview: LectureContentReview;
};

/** Autogenerated return type of UpdateLectureContentReviewReply. */
export type UpdateLectureContentReviewReplyPayload = {
  __typename?: 'UpdateLectureContentReviewReplyPayload';
  lectureContentReviewReply: LectureContentReviewReply;
};

/** Autogenerated return type of UpdateMajorSecuritiesOrganization. */
export type UpdateMajorSecuritiesOrganizationPayload = {
  __typename?: 'UpdateMajorSecuritiesOrganizationPayload';
  user: MyProfile;
};

/** Autogenerated return type of UpdateMyCompanySector. */
export type UpdateMyCompanySectorPayload = {
  __typename?: 'UpdateMyCompanySectorPayload';
  errors: Array<Scalars['String']>;
  userCompanySector: UserCompanySector;
};

/** Autogenerated return type of UpdateMyDevice. */
export type UpdateMyDevicePayload = {
  __typename?: 'UpdateMyDevicePayload';
  userDevice?: Maybe<UserDevice>;
};

/** Autogenerated return type of UpdateMyFinPongPlusPortfoliosFromApp. */
export type UpdateMyFinPongPlusPortfoliosFromAppPayload = {
  __typename?: 'UpdateMyFinPongPlusPortfoliosFromAppPayload';
  portfolios: Array<UserPortfolio>;
};

/** Autogenerated return type of UpdateMyFinPongPlusPortfolios. */
export type UpdateMyFinPongPlusPortfoliosPayload = {
  __typename?: 'UpdateMyFinPongPlusPortfoliosPayload';
  portfolios: Array<UserPortfolio>;
};

/** Autogenerated return type of UpdateMyInvestingKeywords. */
export type UpdateMyInvestingKeywordsPayload = {
  __typename?: 'UpdateMyInvestingKeywordsPayload';
  myInvestingKeywords: Array<InvestingKeyword>;
};

/** Autogenerated return type of UpdateMyNotificationSetting. */
export type UpdateMyNotificationSettingPayload = {
  __typename?: 'UpdateMyNotificationSettingPayload';
  errors: Array<Scalars['String']>;
  myNotificationSettings: Array<UserNotificationSetting>;
};

/** Autogenerated return type of UpdateMyPreference. */
export type UpdateMyPreferencePayload = {
  __typename?: 'UpdateMyPreferencePayload';
  userPreference: UserPreference;
};

/** Autogenerated return type of UpdateMyProfile. */
export type UpdateMyProfilePayload = {
  __typename?: 'UpdateMyProfilePayload';
  user: UserProfile;
};

/** Autogenerated return type of UpdateMyRepresentativeBadge. */
export type UpdateMyRepresentativeBadgePayload = {
  __typename?: 'UpdateMyRepresentativeBadgePayload';
  badge: Badge;
};

export type UpdatePortfolio = {
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dividendTaxRate?: InputMaybe<Scalars['Float']>;
  finPongPlusDisconnectConfirmed?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  investingAmount?: InputMaybe<Scalars['Float']>;
  isDepositConnected?: InputMaybe<Scalars['Boolean']>;
  isEtcCompanyAssetsConnected?: InputMaybe<Scalars['Boolean']>;
  isEtcCompanyCmaConnected?: InputMaybe<Scalars['Boolean']>;
  isEtcCompanyFundConnected?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  orderScore?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of UpdatePortfolioAsset. */
export type UpdatePortfolioAssetPayload = {
  __typename?: 'UpdatePortfolioAssetPayload';
  asset: UserAsset;
  errors: Array<Scalars['String']>;
};

/** Autogenerated return type of UpdatePortfolioFromCryptoExchangeApiKey. */
export type UpdatePortfolioFromCryptoExchangeApiKeyPayload = {
  __typename?: 'UpdatePortfolioFromCryptoExchangeApiKeyPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  userPortfolio?: Maybe<UserPortfolio>;
};

/** Autogenerated return type of UpdatePortfolioFromKbSecAccount. */
export type UpdatePortfolioFromKbSecAccountPayload = {
  __typename?: 'UpdatePortfolioFromKbSecAccountPayload';
  userPortfolio?: Maybe<UserPortfolio>;
};

/** Autogenerated return type of UpdatePortfolioFromPlaid. */
export type UpdatePortfolioFromPlaidPayload = {
  __typename?: 'UpdatePortfolioFromPlaidPayload';
  userPortfolio?: Maybe<UserPortfolio>;
};

/** Autogenerated return type of UpdatePortfolioFromSecuritiesAccount. */
export type UpdatePortfolioFromSecuritiesAccountPayload = {
  __typename?: 'UpdatePortfolioFromSecuritiesAccountPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  userPortfolio?: Maybe<UserPortfolio>;
};

/** Autogenerated return type of UpdatePortfolioInformation. */
export type UpdatePortfolioInformationPayload = {
  __typename?: 'UpdatePortfolioInformationPayload';
  portfolio: UserPortfolio;
};

/** Autogenerated return type of UpdatePortfolioOrderScores. */
export type UpdatePortfolioOrderScoresPayload = {
  __typename?: 'UpdatePortfolioOrderScoresPayload';
  portfolios: Array<UserPortfolio>;
};

/** Autogenerated return type of UpdatePortfolioSwitchOn. */
export type UpdatePortfolioSwitchOnPayload = {
  __typename?: 'UpdatePortfolioSwitchOnPayload';
  portfolio: UserPortfolio;
  switchPortfolio: SwitchPortfolio;
};

/** Autogenerated return type of UpdateSwitchPortfolio. */
export type UpdateSwitchPortfolioPayload = {
  __typename?: 'UpdateSwitchPortfolioPayload';
  switchPortfolio: SwitchPortfolio;
};

/** Autogenerated return type of UpdateUserAgreements. */
export type UpdateUserAgreementsPayload = {
  __typename?: 'UpdateUserAgreementsPayload';
  errors: Array<Scalars['String']>;
  userAgreements: Array<UserAgreement>;
};

export type UpdateUserProfile = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  keywords?: InputMaybe<Array<Scalars['String']>>;
  nickname?: InputMaybe<Scalars['String']>;
};

export type UploadArticle = {
  content?: InputMaybe<ArticleContentInput>;
  feedTopicId?: InputMaybe<Scalars['ID']>;
  portfolioTopicIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type UploadArticleComment = {
  content: ArticleCommentContentInput;
};

export type UploadArticleCommentReply = {
  content: ArticleCommentContentInput;
};

export type UploadCompanyAsset = {
  amount?: InputMaybe<Scalars['String']>;
  avgPrice?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  exchange?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
};

export type UploadCryptoCurrencyAsset = {
  amount: Scalars['String'];
  avgPrice: Scalars['String'];
  baseSymbol: Scalars['String'];
  counterSymbol: Scalars['String'];
};

export type UploadCurrencyAsset = {
  amount?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
};

export type UploadEtcAsset = {
  amount?: InputMaybe<Scalars['String']>;
  avgPrice?: InputMaybe<Scalars['String']>;
  category: EtcAssetCategory;
  currency: Scalars['String'];
  customPrice: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type UploadFavoriteItem = {
  itemId?: InputMaybe<Scalars['ID']>;
  itemKind: UploadFavoriteItemKind;
};

export enum UploadFavoriteItemKind {
  /** Company Asset */
  Company = 'COMPANY',
  /** Crypto Currency Asset */
  CryptoCurrency = 'CRYPTO_CURRENCY',
  /** Currency Asset */
  Currency = 'CURRENCY'
}

export type UploadLocalFavoriteItem = {
  itemKind: UploadFavoriteItemKind;
  itemSymbol: Scalars['String'];
};

/** Autogenerated return type of UploadLocalFavoriteItems. */
export type UploadLocalFavoriteItemsPayload = {
  __typename?: 'UploadLocalFavoriteItemsPayload';
  category?: Maybe<FavoriteItemCategory>;
};

export type UploadPortfolio = {
  baseCurrency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dividendTaxRate?: InputMaybe<Scalars['Float']>;
  investingAmount?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UploadPortfolio. */
export type UploadPortfolioPayload = {
  __typename?: 'UploadPortfolioPayload';
  errors: Array<Scalars['String']>;
  items: Array<UserPortfolio>;
};

export type UploadStockCompany = {
  country: Scalars['String'];
  ticker: Scalars['String'];
};

export type UploadStockDividendHistory = {
  amount: Scalars['String'];
  exDividendDate: Scalars['String'];
  frequency: Scalars['String'];
  paymentDate: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  chatRoomUrl?: Maybe<Scalars['String']>;
  defaultFavoriteItemCategoryAddedAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  followersCount?: Maybe<Scalars['Int']>;
  followingsCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  nickname?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  recentPortfolioCopiedAt?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  userStatus?: Maybe<Scalars['String']>;
  userStatusUpdatedAt?: Maybe<Scalars['String']>;
};

export type UserAccount = {
  __typename?: 'UserAccount';
  accountDisplayNumber?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isAccountPasswordRequired?: Maybe<Scalars['Boolean']>;
  isUserAccountConnected?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Organization>;
};

export type UserActivity = {
  __typename?: 'UserActivity';
  id: Scalars['ID'];
  lastFinPongPlusPortfolioUpdatedAt?: Maybe<Scalars['String']>;
  lastFundoraPortfolioUpdatedAt?: Maybe<Scalars['String']>;
  lastKbPortfolioUpdatedAt?: Maybe<Scalars['String']>;
};

export type UserAgreement = {
  __typename?: 'UserAgreement';
  agreement?: Maybe<Agreement>;
  agreementStatus?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['String'];
};

export type UserAgreementItem = {
  __typename?: 'UserAgreementItem';
  latestAgreement?: Maybe<Agreement>;
  latestUserAgreement?: Maybe<UserAgreement>;
};

export type UserAgreementStatus = {
  __typename?: 'UserAgreementStatus';
  marketing?: Maybe<UserAgreementItem>;
  privacy?: Maybe<UserAgreementItem>;
  terms?: Maybe<UserAgreementItem>;
};

export type UserAsset = {
  __typename?: 'UserAsset';
  amount?: Maybe<Scalars['String']>;
  assetCategory: AssetCategory;
  avgPrice?: Maybe<Scalars['String']>;
  avgPriceCurrency?: Maybe<Currency>;
  company?: Maybe<Company>;
  companyAsset?: Maybe<Company>;
  cryptoCurrencyAsset?: Maybe<CryptoCurrencyAsset>;
  cryptoExchangeApiKeyId?: Maybe<Scalars['ID']>;
  currencyAsset?: Maybe<Currency>;
  customPrice?: Maybe<Scalars['String']>;
  customTax?: Maybe<Scalars['String']>;
  etcAsset?: Maybe<EtcAsset>;
  etcCompanyAsset?: Maybe<EtcCompanyAsset>;
  finPongPlusConnectedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  kbSecUserAccountConnectedAt?: Maybe<Scalars['String']>;
  kbSecUserAccountId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  userAccount?: Maybe<UserAccount>;
  userPlaidId?: Maybe<Scalars['ID']>;
};

export type UserBadge = {
  __typename?: 'UserBadge';
  badgeId: Scalars['ID'];
  id: Scalars['ID'];
  isNotified: Scalars['Boolean'];
  notifiedAt?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type UserCompanySector = {
  __typename?: 'UserCompanySector';
  company: Company;
  companySector: CompanySector;
  id: Scalars['ID'];
  user: User;
};

export type UserDevice = {
  __typename?: 'UserDevice';
  communityLanguage?: Maybe<Scalars['String']>;
  registrationToken?: Maybe<Scalars['String']>;
};

export type UserEventStatus = {
  __typename?: 'UserEventStatus';
  eventName: Scalars['String'];
  hasReferralParticipationAvailable: Scalars['Boolean'];
  participatedAt?: Maybe<Scalars['String']>;
  referralParticipatedAt?: Maybe<Scalars['String']>;
};

export type UserMembership = {
  __typename?: 'UserMembership';
  errors: Array<Scalars['String']>;
  id: Scalars['ID'];
  reason: Scalars['String'];
  user: User;
};

export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  notificationSetting: NotificationSetting;
  updatedAt?: Maybe<Scalars['String']>;
};

export type UserOrderedLectureContent = {
  __typename?: 'UserOrderedLectureContent';
  createdAt: Scalars['String'];
  expiredAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lectureContent: LectureContent;
  order: ProductOrder;
  orderItem: ProductOrderItem;
  refundedAt?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type UserOwnedLectureContent = {
  __typename?: 'UserOwnedLectureContent';
  createdAt: Scalars['String'];
  expiredAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isReviewed: Scalars['Boolean'];
  lectureContent: LectureContent;
  refundedAt?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updatedAt: Scalars['String'];
};

export enum UserOwnedLectureContentStatusEnum {
  /** Active */
  Active = 'ACTIVE',
  /** Expired */
  Expired = 'EXPIRED',
  /** Refunded */
  Refunded = 'REFUNDED'
}

export type UserPhoneVerificationKr = {
  __typename?: 'UserPhoneVerificationKr';
  ci?: Maybe<Scalars['String']>;
  clientRequestNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type UserPhoneVerificationStatus = {
  __typename?: 'UserPhoneVerificationStatus';
  fundoraUserPhoneVerification: KbSecUserPhoneVerificationStatus;
  kbSecUserPhoneVerification: KbSecUserPhoneVerificationStatus;
};

export type UserPlaid = {
  __typename?: 'UserPlaid';
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  itemId: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type UserPortfolio = {
  __typename?: 'UserPortfolio';
  assets: Array<UserAsset>;
  createdAt?: Maybe<Scalars['String']>;
  cryptoExchangeApiKey?: Maybe<CryptoExchangeApiKey>;
  cryptoExchangeApiKeyConnectedAt?: Maybe<Scalars['String']>;
  cryptoExchangeApiKeyId?: Maybe<Scalars['ID']>;
  currency?: Maybe<Currency>;
  depositConnectedAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dividendTaxRate?: Maybe<Scalars['Float']>;
  etcCompanyAssetsConnectedAt?: Maybe<Scalars['String']>;
  etcCompanyCmaConnectedAt?: Maybe<Scalars['String']>;
  etcCompanyFundConnectedAt?: Maybe<Scalars['String']>;
  evaluationAmount?: Maybe<Scalars['Float']>;
  finPongPlusConnectedAt?: Maybe<Scalars['String']>;
  finPongPlusDisconnectConfirmedAt?: Maybe<Scalars['String']>;
  finPongPlusDisconnectedAt?: Maybe<Scalars['String']>;
  fundoraAccount?: Maybe<FundoraAccount>;
  fundoraAccountConnectedAt?: Maybe<Scalars['String']>;
  hashedUserAccountNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  investingAmount?: Maybe<Scalars['Float']>;
  kbSecUserAccount?: Maybe<KbSecUserAccount>;
  kbSecUserAccountConnectedAt?: Maybe<Scalars['String']>;
  kbSecUserAccountId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  orderScore: Scalars['Int'];
  portfolioLink?: Maybe<PortfolioLink>;
  portfolioSwitchOn?: Maybe<Scalars['Boolean']>;
  purchaseAmount?: Maybe<Scalars['Float']>;
  slug?: Maybe<Scalars['String']>;
  slugSharedAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  user: UserPortfolioUser;
  userAccount?: Maybe<UserAccount>;
  userAccountAssetsNextUpdatedAt?: Maybe<Scalars['String']>;
  userAccountAssetsUpdatedAt?: Maybe<Scalars['String']>;
  userAccountConnectedAt?: Maybe<Scalars['String']>;
  userPlaidConnectedAt?: Maybe<Scalars['String']>;
  userPlaidId?: Maybe<Scalars['ID']>;
};

export type UserPortfolioComment = {
  __typename?: 'UserPortfolioComment';
  comment: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['String'];
  user: User;
};

export type UserPortfolioTag = {
  __typename?: 'UserPortfolioTag';
  tagNames?: Maybe<Array<Scalars['String']>>;
  userPortfolioId?: Maybe<Scalars['ID']>;
};

export type UserPortfolioUser = {
  __typename?: 'UserPortfolioUser';
  id?: Maybe<Scalars['ID']>;
  nickname: Scalars['String'];
};

export type UserPreference = {
  __typename?: 'UserPreference';
  doNotShowFinPongPlusPopupCheckedAt?: Maybe<Scalars['String']>;
  downloadTermsAgreedAt?: Maybe<Scalars['String']>;
  hasDoNotShowFinPongPlusPopupChecked: Scalars['Boolean'];
  hasDownloadTermsAgreed: Scalars['Boolean'];
  hasUploadTermsAgreed: Scalars['Boolean'];
  uploadTermsAgreedAt?: Maybe<Scalars['String']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  articleCommentsCount?: Maybe<Scalars['Int']>;
  articlesCount?: Maybe<Scalars['Int']>;
  chatRoomUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  defaultFavoriteItemCategoryAddedAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  favoriteItemsCount?: Maybe<Scalars['Int']>;
  followItemId?: Maybe<Scalars['ID']>;
  followersCount?: Maybe<Scalars['Int']>;
  followingsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  investingKeywords: Array<InvestingKeyword>;
  isFollowing?: Maybe<Scalars['Boolean']>;
  isLectureContentAuthor?: Maybe<Scalars['Boolean']>;
  lectureContents?: Maybe<Array<LectureContent>>;
  nickname?: Maybe<Scalars['String']>;
  portfolioAssetsCount?: Maybe<Scalars['Int']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  representativeBadge?: Maybe<Badge>;
  updatedAt: Scalars['String'];
  userChatDeepLinkUrl?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
};

export type UserReferral = {
  __typename?: 'UserReferral';
  referralCode: Scalars['String'];
};

export type UserReviewRequestedStatus = {
  __typename?: 'UserReviewRequestedStatus';
  isUserReviewed: Scalars['Boolean'];
  reviewRequestedStatuses: Array<ReviewRequestedStatus>;
};

export type UserSecurity = {
  __typename?: 'UserSecurity';
  appBiometricPublicKey?: Maybe<Scalars['String']>;
  appPasswordPublicKey?: Maybe<Scalars['String']>;
  passwordEncryptKey: Scalars['String'];
  updatedAtTimestamp: Scalars['Int'];
};

export type UserSurvey = {
  __typename?: 'UserSurvey';
  createdAt?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  surveyCategory?: Maybe<Scalars['String']>;
  surveyCount?: Maybe<Scalars['Int']>;
  surveyResult?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type UserVerification = {
  __typename?: 'UserVerification';
  email?: Maybe<Scalars['String']>;
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  isKrPhoneNumberVerified?: Maybe<Scalars['Boolean']>;
  isPhoneNumberVerified?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
  stepOfEmailVerification?: Maybe<Scalars['String']>;
};

export type UserWishedLectureContent = {
  __typename?: 'UserWishedLectureContent';
  communityUser: CommunityUser;
  id: Scalars['ID'];
  lectureContent: LectureContent;
};

/** Autogenerated return type of VerifyUserPhoneVerificationForFundora. */
export type VerifyUserPhoneVerificationForFundoraPayload = {
  __typename?: 'VerifyUserPhoneVerificationForFundoraPayload';
  fundoraUserPhoneVerification?: Maybe<UserPhoneVerificationKr>;
};

/** Autogenerated return type of VerifyUserPhoneVerificationForKbSec. */
export type VerifyUserPhoneVerificationForKbSecPayload = {
  __typename?: 'VerifyUserPhoneVerificationForKbSecPayload';
  kbSecUserPhoneVerification?: Maybe<UserPhoneVerificationKr>;
};

/** Autogenerated return type of VerifyUserPhoneVerificationFromKrTelecom. */
export type VerifyUserPhoneVerificationFromKrTelecomPayload = {
  __typename?: 'VerifyUserPhoneVerificationFromKrTelecomPayload';
  userPhoneVerificationKr?: Maybe<UserPhoneVerificationKr>;
};

export type VisitorCounter = {
  __typename?: 'VisitorCounter';
  category: Scalars['String'];
  createdAt: Scalars['String'];
  date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
  viewCount: Scalars['Int'];
};

export type YearlyDividendSum = {
  __typename?: 'YearlyDividendSum';
  accountType: Scalars['String'];
  foreignStockCfdAccountYearlyDividendTax: Scalars['Float'];
  foreignStockIsaAccountYearlyDividendTax: Scalars['Float'];
  foreignStockNormalAccountYearlyDividendTax: Scalars['Float'];
  foreignStockYearlyDividendSum: Scalars['Float'];
  foreignStockYearlyDividendSumAfterTax: Scalars['Float'];
  foreignStockYearlyDividendTax: Scalars['Float'];
};

export type InvestingInsightTagFieldsFragment = { __typename?: 'InvestingInsightTag', id: string, sortId: number, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } };

export type InvestingInsightFieldsFragment = { __typename?: 'InvestingInsight', id: string, body: string, dynamicLinkUrl: string, originalUrl: string, thumbnailImageUrl: string, title: string, creator: { __typename?: 'Creator', nickname: string, userId?: string | null }, platform: { __typename?: 'InvestingInsightPlatform', id: string, imageUrl?: string | null, name: string, names: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } };

export type ClickInvestingInsightMutationVariables = Exact<{
  investingInsightId: Scalars['ID'];
  platform: ServicePlatformEnum;
}>;


export type ClickInvestingInsightMutation = { __typename?: 'Mutation', clickInvestingInsight?: { __typename?: 'ClickInvestingInsightPayload', investingInsight: { __typename?: 'InvestingInsight', id: string } } | null };

export type InvestingInsightTagsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
}>;


export type InvestingInsightTagsQuery = { __typename?: 'Query', investingInsightTags: Array<{ __typename?: 'InvestingInsightTag', id: string, sortId: number, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }> };

export type InvestingInsightsQueryVariables = Exact<{
  language: Scalars['String'];
  tagId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
}>;


export type InvestingInsightsQuery = { __typename?: 'Query', investingInsights: Array<{ __typename?: 'InvestingInsight', id: string, body: string, dynamicLinkUrl: string, originalUrl: string, thumbnailImageUrl: string, title: string, creator: { __typename?: 'Creator', nickname: string, userId?: string | null }, platform: { __typename?: 'InvestingInsightPlatform', id: string, imageUrl?: string | null, name: string, names: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } }> };

export type InvestingInsightQueryVariables = Exact<{
  investingInsightId: Scalars['ID'];
}>;


export type InvestingInsightQuery = { __typename?: 'Query', investingInsight: { __typename?: 'InvestingInsight', id: string, body: string, dynamicLinkUrl: string, originalUrl: string, thumbnailImageUrl: string, title: string, creator: { __typename?: 'Creator', nickname: string, userId?: string | null }, platform: { __typename?: 'InvestingInsightPlatform', id: string, imageUrl?: string | null, name: string, names: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } } };

export type AdFieldsFragment = { __typename?: 'Ad', id: string, adClickCount: number, adClickUrl: string, adDescription: string, adExposureCount: number, adFinishTime?: string | null, adLocales: Array<string>, adStartTime?: string | null, adStatus: AdStatusEnum, adSupportedPlatform: string, adTitle: string, doNotShowUntil: number, adContent: { __typename?: 'AdContent', contentType: string, contentUrl: string, id: string, name?: string | null } };

export type AdContentFieldsFragment = { __typename?: 'AdContent', contentType: string, contentUrl: string, id: string, name?: string | null };

export type ClickAdMutationVariables = Exact<{
  adId: Scalars['ID'];
}>;


export type ClickAdMutation = { __typename?: 'Mutation', clickAd?: { __typename?: 'ClickAdPayload', ad: { __typename?: 'Ad', id: string } } | null };

export type DoNotShowAdMutationVariables = Exact<{
  adId: Scalars['ID'];
}>;


export type DoNotShowAdMutation = { __typename?: 'Mutation', doNotShowAd?: { __typename?: 'DoNotShowAdPayload', ad: { __typename?: 'Ad', id: string } } | null };

export type AdsQueryVariables = Exact<{
  adLocale: Scalars['String'];
  adPlatform: AdPlatformEnum;
  adType: AdTypeEnum;
}>;


export type AdsQuery = { __typename?: 'Query', ads: Array<{ __typename?: 'Ad', id: string, adClickCount: number, adClickUrl: string, adDescription: string, adExposureCount: number, adFinishTime?: string | null, adLocales: Array<string>, adStartTime?: string | null, adStatus: AdStatusEnum, adSupportedPlatform: string, adTitle: string, doNotShowUntil: number, adContent: { __typename?: 'AdContent', contentType: string, contentUrl: string, id: string, name?: string | null } }> };

export type MyAdsQueryVariables = Exact<{
  adLocale: Scalars['String'];
  adPlatform: AdPlatformEnum;
  adType: AdTypeEnum;
}>;


export type MyAdsQuery = { __typename?: 'Query', myAds: Array<{ __typename?: 'Ad', id: string, adClickCount: number, adClickUrl: string, adDescription: string, adExposureCount: number, adFinishTime?: string | null, adLocales: Array<string>, adStartTime?: string | null, adStatus: AdStatusEnum, adSupportedPlatform: string, adTitle: string, doNotShowUntil: number, adContent: { __typename?: 'AdContent', contentType: string, contentUrl: string, id: string, name?: string | null } }> };

export type UserAgreementStatusFieldsFragment = { __typename?: 'UserAgreementStatus', marketing?: { __typename?: 'UserAgreementItem', latestAgreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null, latestUserAgreement?: { __typename?: 'UserAgreement', createdAt: string, id: string, updatedAt: string, agreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null } | null } | null, privacy?: { __typename?: 'UserAgreementItem', latestAgreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null, latestUserAgreement?: { __typename?: 'UserAgreement', createdAt: string, id: string, updatedAt: string, agreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null } | null } | null, terms?: { __typename?: 'UserAgreementItem', latestAgreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null, latestUserAgreement?: { __typename?: 'UserAgreement', createdAt: string, id: string, updatedAt: string, agreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null } | null } | null };

export type UserAgreementItemFieldsFragment = { __typename?: 'UserAgreementItem', latestAgreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null, latestUserAgreement?: { __typename?: 'UserAgreement', createdAt: string, id: string, updatedAt: string, agreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null } | null };

export type AgreementFieldsFragment = { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string };

export type UserAgreementFieldsFragment = { __typename?: 'UserAgreement', createdAt: string, id: string, updatedAt: string, agreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null };

export type LatestAgreementsFieldsFragment = { __typename?: 'LatestAgreements', marketing?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null, privacy?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null, terms?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null };

export type UpdateUserAgreementsMutationVariables = Exact<{
  agreementIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateUserAgreementsMutation = { __typename?: 'Mutation', updateUserAgreements?: { __typename?: 'UpdateUserAgreementsPayload', userAgreements: Array<{ __typename?: 'UserAgreement', createdAt: string, id: string, updatedAt: string, agreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null }> } | null };

export type UserAgreementStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAgreementStatusQuery = { __typename?: 'Query', userAgreementStatus?: { __typename?: 'UserAgreementStatus', marketing?: { __typename?: 'UserAgreementItem', latestAgreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null, latestUserAgreement?: { __typename?: 'UserAgreement', createdAt: string, id: string, updatedAt: string, agreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null } | null } | null, privacy?: { __typename?: 'UserAgreementItem', latestAgreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null, latestUserAgreement?: { __typename?: 'UserAgreement', createdAt: string, id: string, updatedAt: string, agreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null } | null } | null, terms?: { __typename?: 'UserAgreementItem', latestAgreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null, latestUserAgreement?: { __typename?: 'UserAgreement', createdAt: string, id: string, updatedAt: string, agreement?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null } | null } | null } | null };

export type LatestAgreementsQueryVariables = Exact<{
  serviceName: Scalars['String'];
}>;


export type LatestAgreementsQuery = { __typename?: 'Query', latestAgreements: { __typename?: 'LatestAgreements', marketing?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null, privacy?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null, terms?: { __typename?: 'Agreement', contentEn?: string | null, contentKo?: string | null, createdAt: string, id: string, isRequired: boolean, titleEn?: string | null, titleKo?: string | null, updatedAt: string } | null } };

export type EtcAssetFieldsFragment = { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } };

export type EtcCompanyAssetFieldsFragment = { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null };

export type UserAssetFieldsFragment = { __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null };

export type AddCurrencyAssetsToPortfolioMutationVariables = Exact<{
  portfolioId: Scalars['ID'];
  assets: Array<UploadCurrencyAsset> | UploadCurrencyAsset;
}>;


export type AddCurrencyAssetsToPortfolioMutation = { __typename?: 'Mutation', addCurrencyAssetsToPortfolio?: { __typename?: 'AddCurrencyAssetsToPortfolioPayload', portfolio: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } } | null };

export type AddCompanyAssetsToPortfolioMutationVariables = Exact<{
  portfolioId: Scalars['ID'];
  assets: Array<UploadCompanyAsset> | UploadCompanyAsset;
}>;


export type AddCompanyAssetsToPortfolioMutation = { __typename?: 'Mutation', addCompanyAssetsToPortfolio?: { __typename?: 'AddPortfolioAssetsPayload', portfolio: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } } | null };

export type AddEtcAssetsToPortfolioMutationVariables = Exact<{
  portfolioId: Scalars['ID'];
  assets: Array<UploadEtcAsset> | UploadEtcAsset;
}>;


export type AddEtcAssetsToPortfolioMutation = { __typename?: 'Mutation', addEtcAssetsToPortfolio?: { __typename?: 'AddEtcAssetsToPortfolioPayload', portfolio: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } } | null };

export type AddCryptoCurrencyAssetsToPortfolioMutationVariables = Exact<{
  portfolioId: Scalars['ID'];
  assets: Array<UploadCryptoCurrencyAsset> | UploadCryptoCurrencyAsset;
}>;


export type AddCryptoCurrencyAssetsToPortfolioMutation = { __typename?: 'Mutation', addCryptoCurrencyAssetsToPortfolio?: { __typename?: 'AddCryptoCurrencyAssetsToPortfolioPayload', portfolio: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } } | null };

export type RemovePortfolioAssetsMutationVariables = Exact<{
  portfolioId: Scalars['ID'];
  assetId: Scalars['ID'];
}>;


export type RemovePortfolioAssetsMutation = { __typename?: 'Mutation', removePortfolioAssets?: { __typename?: 'RemovePortfolioAssetsPayload', portfolio: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } } | null };

export type UpdatePortfolioAssetMutationVariables = Exact<{
  portfolioId: Scalars['ID'];
  assetId: Scalars['ID'];
  avgPrice?: InputMaybe<Scalars['String']>;
  amount: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  customPrice?: InputMaybe<Scalars['String']>;
  customTax?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePortfolioAssetMutation = { __typename?: 'Mutation', updatePortfolioAsset?: { __typename?: 'UpdatePortfolioAssetPayload', asset: { __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null } } | null };

export type BackTestingStockFieldsFragment = { __typename?: 'BackTestingStock', country: string, ticker: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null };

export type BackTestingPortfolioStockFieldsFragment = { __typename?: 'BackTestingStock', country: string, ticker: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null };

export type BackTestingCryptoFieldsFragment = { __typename?: 'BackTestingCrypto', base: string, counter: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null };

export type BackTestingPortfolioCryptoFieldsFragment = { __typename?: 'BackTestingCrypto', base: string, counter: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null };

export type BackTestingPortfolioFieldsFragment = { __typename?: 'BackTestingPortfolio', sortId?: string | null, portfolioName: string, assets?: Array<{ __typename?: 'BackTestingCrypto', base: string, counter: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | { __typename?: 'BackTestingStock', country: string, ticker: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }> | null };

export type BackTestingProjectFieldsFragment = { __typename?: 'BackTestingProject', id?: string | null, title: string, currencySymbol: string, startPeriod: string, endPeriod: string, initialAmount: number, cashFlowType: PeriodEnum, cashFlowAmount?: number | null, rebalancingType: PeriodEnum, slug: string, slugSharedAt?: string | null, createdAt: string, updatedAt: string, imageUrl?: string | null, userId?: string | null, cases: Array<{ __typename?: 'BackTestingCrypto', base: string, counter: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | { __typename?: 'BackTestingPortfolio', sortId?: string | null, portfolioName: string, assets?: Array<{ __typename?: 'BackTestingCrypto', base: string, counter: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | { __typename?: 'BackTestingStock', country: string, ticker: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }> | null } | { __typename?: 'BackTestingStock', country: string, ticker: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }>, result: { __typename?: 'BackTestingResult', times: Array<number>, cases: Array<{ __typename?: 'BackTestingResultCase', sortId?: string | null, balancesByTime: Array<number>, maxDrawdown: number, cagr: number, worstYear: number, worstYearReturnRate: number, bestYear: number, bestYearReturnRate?: number | null }> } };

export type AddBackTestingProjectResultMutationVariables = Exact<{
  backTestingProjectInputData: BackTestingProjectInput;
}>;


export type AddBackTestingProjectResultMutation = { __typename?: 'Mutation', addBackTestingProjectResult?: { __typename?: 'AddBackTestingProjectResultPayload', backTestingProjectResult?: { __typename?: 'BackTestingProject', id?: string | null, title: string, currencySymbol: string, startPeriod: string, endPeriod: string, initialAmount: number, cashFlowType: PeriodEnum, cashFlowAmount?: number | null, rebalancingType: PeriodEnum, slug: string, slugSharedAt?: string | null, createdAt: string, updatedAt: string, imageUrl?: string | null, userId?: string | null, cases: Array<{ __typename?: 'BackTestingCrypto', base: string, counter: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | { __typename?: 'BackTestingPortfolio', sortId?: string | null, portfolioName: string, assets?: Array<{ __typename?: 'BackTestingCrypto', base: string, counter: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | { __typename?: 'BackTestingStock', country: string, ticker: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }> | null } | { __typename?: 'BackTestingStock', country: string, ticker: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }>, result: { __typename?: 'BackTestingResult', times: Array<number>, cases: Array<{ __typename?: 'BackTestingResultCase', sortId?: string | null, balancesByTime: Array<number>, maxDrawdown: number, cagr: number, worstYear: number, worstYearReturnRate: number, bestYear: number, bestYearReturnRate?: number | null }> } } | null } | null };

export type UpdateBackTestingProjectResultMutationVariables = Exact<{
  backTestingProjectInputData: BackTestingProjectInput;
  slug: Scalars['String'];
}>;


export type UpdateBackTestingProjectResultMutation = { __typename?: 'Mutation', updateBackTestingProjectResult?: { __typename?: 'UpdateBackTestingProjectResultPayload', backTestingProjectResult?: { __typename?: 'BackTestingProject', id?: string | null, title: string, currencySymbol: string, startPeriod: string, endPeriod: string, initialAmount: number, cashFlowType: PeriodEnum, cashFlowAmount?: number | null, rebalancingType: PeriodEnum, slug: string, slugSharedAt?: string | null, createdAt: string, updatedAt: string, imageUrl?: string | null, userId?: string | null, cases: Array<{ __typename?: 'BackTestingCrypto', base: string, counter: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | { __typename?: 'BackTestingPortfolio', sortId?: string | null, portfolioName: string, assets?: Array<{ __typename?: 'BackTestingCrypto', base: string, counter: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | { __typename?: 'BackTestingStock', country: string, ticker: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }> | null } | { __typename?: 'BackTestingStock', country: string, ticker: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }>, result: { __typename?: 'BackTestingResult', times: Array<number>, cases: Array<{ __typename?: 'BackTestingResultCase', sortId?: string | null, balancesByTime: Array<number>, maxDrawdown: number, cagr: number, worstYear: number, worstYearReturnRate: number, bestYear: number, bestYearReturnRate?: number | null }> } } | null } | null };

export type RemoveBackTestingProjectResultMutationVariables = Exact<{
  slug: Scalars['String'];
}>;


export type RemoveBackTestingProjectResultMutation = { __typename?: 'Mutation', removeBackTestingProjectResult?: { __typename?: 'RemoveBackTestingProjectResultPayload', backTestingProject?: { __typename?: 'BackTestingProject', id?: string | null } | null } | null };

export type MyBackTestingProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyBackTestingProjectsQuery = { __typename?: 'Query', myBackTestingProjects: Array<{ __typename?: 'BackTestingProject', id?: string | null, title: string, currencySymbol: string, startPeriod: string, endPeriod: string, initialAmount: number, cashFlowType: PeriodEnum, cashFlowAmount?: number | null, rebalancingType: PeriodEnum, slug: string, slugSharedAt?: string | null, createdAt: string, updatedAt: string, imageUrl?: string | null, userId?: string | null, cases: Array<{ __typename?: 'BackTestingCrypto', base: string, counter: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | { __typename?: 'BackTestingPortfolio', sortId?: string | null, portfolioName: string, assets?: Array<{ __typename?: 'BackTestingCrypto', base: string, counter: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | { __typename?: 'BackTestingStock', country: string, ticker: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }> | null } | { __typename?: 'BackTestingStock', country: string, ticker: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }>, result: { __typename?: 'BackTestingResult', times: Array<number>, cases: Array<{ __typename?: 'BackTestingResultCase', sortId?: string | null, balancesByTime: Array<number>, maxDrawdown: number, cagr: number, worstYear: number, worstYearReturnRate: number, bestYear: number, bestYearReturnRate?: number | null }> } }> };

export type BackTestingProjectQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type BackTestingProjectQuery = { __typename?: 'Query', backTestingProject: { __typename?: 'BackTestingProject', id?: string | null, title: string, currencySymbol: string, startPeriod: string, endPeriod: string, initialAmount: number, cashFlowType: PeriodEnum, cashFlowAmount?: number | null, rebalancingType: PeriodEnum, slug: string, slugSharedAt?: string | null, createdAt: string, updatedAt: string, imageUrl?: string | null, userId?: string | null, cases: Array<{ __typename?: 'BackTestingCrypto', base: string, counter: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | { __typename?: 'BackTestingPortfolio', sortId?: string | null, portfolioName: string, assets?: Array<{ __typename?: 'BackTestingCrypto', base: string, counter: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | { __typename?: 'BackTestingStock', country: string, ticker: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }> | null } | { __typename?: 'BackTestingStock', country: string, ticker: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }>, result: { __typename?: 'BackTestingResult', times: Array<number>, cases: Array<{ __typename?: 'BackTestingResultCase', sortId?: string | null, balancesByTime: Array<number>, maxDrawdown: number, cagr: number, worstYear: number, worstYearReturnRate: number, bestYear: number, bestYearReturnRate?: number | null }> } } };

export type BadgeFieldsFragment = { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } };

export type UpdateMyRepresentativeBadgeMutationVariables = Exact<{
  badgeId: Scalars['ID'];
}>;


export type UpdateMyRepresentativeBadgeMutation = { __typename?: 'Mutation', updateMyRepresentativeBadge?: { __typename?: 'UpdateMyRepresentativeBadgePayload', badge: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null };

export type RemoveMyRepresentativeBadgeMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveMyRepresentativeBadgeMutation = { __typename?: 'Mutation', removeMyRepresentativeBadge?: { __typename?: 'RemoveMyRepresentativeBadgePayload', badge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null };

export type AcquireBadgeMutationVariables = Exact<{
  badgeId: Scalars['ID'];
}>;


export type AcquireBadgeMutation = { __typename?: 'Mutation', acquireBadge?: { __typename?: 'AcquireBadgePayload', badge: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null };

export type UserBadgeListQueryVariables = Exact<{
  userId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
}>;


export type UserBadgeListQuery = { __typename?: 'Query', userBadgeList: Array<{ __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }> };

export type UserAcquiredBadgeListQueryVariables = Exact<{
  userId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
}>;


export type UserAcquiredBadgeListQuery = { __typename?: 'Query', userAcquiredBadgeList: Array<{ __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }> };

export type BadgeDetailQueryVariables = Exact<{
  badgeId: Scalars['ID'];
}>;


export type BadgeDetailQuery = { __typename?: 'Query', badgeDetail: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } };

export type AssetTagFieldsFragment = { __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string };

export type AssetTagTitleFieldsFragment = { __typename?: 'AssetTagTitle', categoryType: string, companyId?: string | null, country?: string | null, cryptoCurrencyId?: string | null, id: string, name: string, price?: string | null, priceChangePercent?: string | null, symbol?: string | null, isFollowing: boolean, userFollowingId?: string | null, counterCurrency: { __typename?: 'CounterCurrency', symbol?: string | null, unit?: string | null } };

export type CounterCurrencyFieldsFragment = { __typename?: 'CounterCurrency', symbol?: string | null, unit?: string | null };

export type ArticleFieldsFragment = { __typename?: 'Article', id: string, title?: string | null, language: string, userId: string, commentsCount?: number | null, isBookmarked: boolean, isLiked: boolean, likesCount?: number | null, portfolioTopicIds?: Array<string> | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, dynamicLinkUrl?: string | null, feedTopic?: { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | null, content: Array<{ __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } } | { __typename?: 'ArticleContentBackTestingProject' } | { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } } | { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } } | { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } } | { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, assetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null, portfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null };

type ArticleContentFields_ArticleContentAsset_Fragment = { __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } };

type ArticleContentFields_ArticleContentBackTestingProject_Fragment = { __typename?: 'ArticleContentBackTestingProject' };

type ArticleContentFields_ArticleContentImage_Fragment = { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } };

type ArticleContentFields_ArticleContentOgTag_Fragment = { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } };

type ArticleContentFields_ArticleContentPortfolio_Fragment = { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } };

type ArticleContentFields_ArticleContentText_Fragment = { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } };

export type ArticleContentFieldsFragment = ArticleContentFields_ArticleContentAsset_Fragment | ArticleContentFields_ArticleContentBackTestingProject_Fragment | ArticleContentFields_ArticleContentImage_Fragment | ArticleContentFields_ArticleContentOgTag_Fragment | ArticleContentFields_ArticleContentPortfolio_Fragment | ArticleContentFields_ArticleContentText_Fragment;

export type ArticleContentAssetFieldsFragment = { __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } };

export type ArticleContentBackTestingProjectFieldsFragment = { __typename?: 'ArticleContentBackTestingProject', categoryType: string, content: { __typename?: 'BackTestingProject', id?: string | null, title: string, currencySymbol: string, startPeriod: string, endPeriod: string, initialAmount: number, cashFlowType: PeriodEnum, cashFlowAmount?: number | null, rebalancingType: PeriodEnum, slug: string, slugSharedAt?: string | null, createdAt: string, updatedAt: string, imageUrl?: string | null, userId?: string | null, cases: Array<{ __typename?: 'BackTestingCrypto', base: string, counter: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | { __typename?: 'BackTestingPortfolio', sortId?: string | null, portfolioName: string, assets?: Array<{ __typename?: 'BackTestingCrypto', base: string, counter: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | { __typename?: 'BackTestingStock', country: string, ticker: string, weight?: number | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }> | null } | { __typename?: 'BackTestingStock', country: string, ticker: string, sortId?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }>, result: { __typename?: 'BackTestingResult', times: Array<number>, cases: Array<{ __typename?: 'BackTestingResultCase', sortId?: string | null, balancesByTime: Array<number>, maxDrawdown: number, cagr: number, worstYear: number, worstYearReturnRate: number, bestYear: number, bestYearReturnRate?: number | null }> } } };

export type ArticleContentPortfolioFieldsFragment = { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } };

export type ArticleContentTextFieldsFragment = { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } };

export type ArticleContentImageFieldsFragment = { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } };

export type ArticleContentOgTagFieldsFragment = { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } };

export type ArticleContentAssetContentFieldsFragment = { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } };

export type ArticleContentPortfolioContentFieldsFragment = { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null };

export type ArticleContentImageContentFieldsFragment = { __typename?: 'ArticleContentImageContent', imageUrl: string };

type ArticleContentSubTextComponentFields_ArticleContentTextSubTextComponentCrypto_Fragment = { __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } };

type ArticleContentSubTextComponentFields_ArticleContentTextSubTextComponentStock_Fragment = { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } };

type ArticleContentSubTextComponentFields_ArticleContentTextSubTextComponentText_Fragment = { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string };

type ArticleContentSubTextComponentFields_ArticleContentTextSubTextComponentUser_Fragment = { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string };

export type ArticleContentSubTextComponentFieldsFragment = ArticleContentSubTextComponentFields_ArticleContentTextSubTextComponentCrypto_Fragment | ArticleContentSubTextComponentFields_ArticleContentTextSubTextComponentStock_Fragment | ArticleContentSubTextComponentFields_ArticleContentTextSubTextComponentText_Fragment | ArticleContentSubTextComponentFields_ArticleContentTextSubTextComponentUser_Fragment;

export type ArticleContentTextSubTextComponentCryptoFieldsFragment = { __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } };

export type ArticleContentTextSubTextComponentStockFieldsFragment = { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } };

export type ArticleContentTextSubTextComponentTextFieldsFragment = { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string };

export type ArticleContentTextSubTextComponentUserFieldsFragment = { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string };

export type ArticleCommentFieldsFragment = { __typename?: 'ArticleComment', id: string, articleId?: string | null, parentCommentId?: string | null, repliesCount?: number | null, userId: string, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, content: Array<{ __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, replies?: Array<{ __typename?: 'ArticleCommentReply', id: string, parentCommentId?: string | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, userId: string, content: Array<{ __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } }> | null, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } };

export type ArticleCommentContentFieldsFragment = { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } };

export type ArticleCommentReplyFieldsFragment = { __typename?: 'ArticleCommentReply', id: string, parentCommentId?: string | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, userId: string, content: Array<{ __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } };

export type FeedTopicFieldsFragment = { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null };

export type PortfolioTopicFieldsFragment = { __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } };

export type CommunityNotificationUserFieldsFragment = { __typename?: 'CommunityNotificationUser', nickname?: string | null, profileImageUrl?: string | null, userId: string };

export type CommunityUserFieldsFragment = { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null };

export type SearchFollowItemsFieldsFragment = { __typename?: 'SearchFollowItems', totalCount: number, items: Array<{ __typename?: 'SearchFollowItem', id?: string | null, hasNewArticle?: boolean | null, userFollowingId?: string | null, categoryType: string, isFollowing: boolean, followItem?: { __typename?: 'FollowCompany', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowCryptoCurrency', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowUser', id: string, nickname?: string | null, profileImageUrl?: string | null, description?: string | null, followersCount?: number | null } | null }> };

export type SearchFollowItemFieldsFragment = { __typename?: 'SearchFollowItem', id?: string | null, hasNewArticle?: boolean | null, userFollowingId?: string | null, categoryType: string, isFollowing: boolean, followItem?: { __typename?: 'FollowCompany', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowCryptoCurrency', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowUser', id: string, nickname?: string | null, profileImageUrl?: string | null, description?: string | null, followersCount?: number | null } | null };

type FollowItemFields_FollowCompany_Fragment = { __typename?: 'FollowCompany', id: string, logoImageUrl?: string | null, name: string, symbol: string };

type FollowItemFields_FollowCryptoCurrency_Fragment = { __typename?: 'FollowCryptoCurrency', id: string, logoImageUrl?: string | null, name: string, symbol: string };

type FollowItemFields_FollowUser_Fragment = { __typename?: 'FollowUser', id: string, nickname?: string | null, profileImageUrl?: string | null, description?: string | null, followersCount?: number | null };

export type FollowItemFieldsFragment = FollowItemFields_FollowCompany_Fragment | FollowItemFields_FollowCryptoCurrency_Fragment | FollowItemFields_FollowUser_Fragment;

export type FollowCompanyFieldsFragment = { __typename?: 'FollowCompany', id: string, logoImageUrl?: string | null, name: string, symbol: string };

export type FollowCryptoCurrencyFieldsFragment = { __typename?: 'FollowCryptoCurrency', id: string, logoImageUrl?: string | null, name: string, symbol: string };

export type FollowUserFieldsFragment = { __typename?: 'FollowUser', id: string, nickname?: string | null, profileImageUrl?: string | null, description?: string | null, followersCount?: number | null };

export type OgTagFieldsFragment = { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null };

export type AddArticleMutationVariables = Exact<{
  language: Scalars['String'];
  article: UploadArticle;
}>;


export type AddArticleMutation = { __typename?: 'Mutation', addArticle?: { __typename?: 'AddArticlePayload', article: { __typename?: 'Article', id: string, title?: string | null, language: string, userId: string, commentsCount?: number | null, isBookmarked: boolean, isLiked: boolean, likesCount?: number | null, portfolioTopicIds?: Array<string> | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, dynamicLinkUrl?: string | null, feedTopic?: { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | null, content: Array<{ __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } } | { __typename?: 'ArticleContentBackTestingProject' } | { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } } | { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } } | { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } } | { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, assetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null, portfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null } } | null };

export type UpdateArticleMutationVariables = Exact<{
  articleId: Scalars['ID'];
  article: UploadArticle;
}>;


export type UpdateArticleMutation = { __typename?: 'Mutation', updateArticle?: { __typename?: 'UpdateArticlePayload', article: { __typename?: 'Article', id: string, title?: string | null, language: string, userId: string, commentsCount?: number | null, isBookmarked: boolean, isLiked: boolean, likesCount?: number | null, portfolioTopicIds?: Array<string> | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, dynamicLinkUrl?: string | null, feedTopic?: { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | null, content: Array<{ __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } } | { __typename?: 'ArticleContentBackTestingProject' } | { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } } | { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } } | { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } } | { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, assetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null, portfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null } } | null };

export type RemoveArticleMutationVariables = Exact<{
  articleId: Scalars['ID'];
}>;


export type RemoveArticleMutation = { __typename?: 'Mutation', removeArticle?: { __typename?: 'RemoveArticlePayload', article: { __typename?: 'Article', id: string } } | null };

export type AddArticleCommentMutationVariables = Exact<{
  articleId: Scalars['ID'];
  commnet: UploadArticleComment;
}>;


export type AddArticleCommentMutation = { __typename?: 'Mutation', addArticleComment?: { __typename?: 'AddArticleCommentPayload', comment: { __typename?: 'ArticleComment', id: string, articleId?: string | null, parentCommentId?: string | null, repliesCount?: number | null, userId: string, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, content: Array<{ __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, replies?: Array<{ __typename?: 'ArticleCommentReply', id: string, parentCommentId?: string | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, userId: string, content: Array<{ __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } }> | null, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } } } | null };

export type UpdateArticleCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
  commnet: UploadArticleComment;
}>;


export type UpdateArticleCommentMutation = { __typename?: 'Mutation', updateArticleComment?: { __typename?: 'UpdateArticleCommentPayload', comment?: { __typename?: 'ArticleComment', id: string, articleId?: string | null, parentCommentId?: string | null, repliesCount?: number | null, userId: string, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, content: Array<{ __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, replies?: Array<{ __typename?: 'ArticleCommentReply', id: string, parentCommentId?: string | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, userId: string, content: Array<{ __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } }> | null, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } } | null } | null };

export type RemoveArticleCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
}>;


export type RemoveArticleCommentMutation = { __typename?: 'Mutation', removeArticleComment?: { __typename?: 'RemoveArticleCommentPayload', comment?: { __typename?: 'ArticleComment', id: string } | null } | null };

export type AddReplyToArticleCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
  reply: UploadArticleCommentReply;
}>;


export type AddReplyToArticleCommentMutation = { __typename?: 'Mutation', addReplyToArticleComment?: { __typename?: 'AddReplyToArticleCommentPayload', reply: { __typename?: 'ArticleCommentReply', id: string, parentCommentId?: string | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, userId: string, content: Array<{ __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } } } | null };

export type AddArticleToLikeMutationVariables = Exact<{
  articleId: Scalars['ID'];
}>;


export type AddArticleToLikeMutation = { __typename?: 'Mutation', addLikeToArticle?: { __typename?: 'AddLikeToArticlePayload', article?: { __typename?: 'Article', id: string, isLiked: boolean, likesCount?: number | null } | null } | null };

export type RemoveArticleToLikeMutationVariables = Exact<{
  articleId: Scalars['ID'];
}>;


export type RemoveArticleToLikeMutation = { __typename?: 'Mutation', removeLikeToArticle?: { __typename?: 'RemoveLikeToArticlePayload', article: { __typename?: 'Article', id: string, isLiked: boolean, likesCount?: number | null } } | null };

export type AddBookmarkToArticleMutationVariables = Exact<{
  articleId: Scalars['ID'];
}>;


export type AddBookmarkToArticleMutation = { __typename?: 'Mutation', addBookmarkToArticle?: { __typename?: 'AddBookmarkToArticlePayload', article: { __typename?: 'Article', id: string, isBookmarked: boolean } } | null };

export type RemoveBookmarkFromArticleMutationVariables = Exact<{
  articleId: Scalars['ID'];
}>;


export type RemoveBookmarkFromArticleMutation = { __typename?: 'Mutation', removeBookmarkFromArticle?: { __typename?: 'RemoveBookmarkFromArticlePayload', article: { __typename?: 'Article', id: string, isBookmarked: boolean } } | null };

export type ConfirmCommunityNotificationsMutationVariables = Exact<{
  communityNotificationIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ConfirmCommunityNotificationsMutation = { __typename?: 'Mutation', confirmCommunityNotifications?: { __typename?: 'ConfirmCommunityNotificationsPayload', communityNotifications: Array<{ __typename?: 'CommunityNotification', id: string, hasConfirmed?: boolean | null, createdAt: string, notificationCategoryType: string, receiverUserId: string, content: { __typename?: 'CommunityNotificationContent', deeplinkUrl?: string | null, notificationMessage?: string | null, notificationMessageTemplate?: string | null, receiverArticleCommentId?: string | null, receiverArticleId?: string | null, senderArticleCommentId?: string | null }, sender: { __typename?: 'CommunityNotificationUser', nickname?: string | null, profileImageUrl?: string | null, userId: string } }> } | null };

export type FollowItemMutationVariables = Exact<{
  followUserId?: InputMaybe<Scalars['ID']>;
  followCompanyId?: InputMaybe<Scalars['ID']>;
  followCryptoCurrencyId?: InputMaybe<Scalars['ID']>;
  language: Scalars['String'];
}>;


export type FollowItemMutation = { __typename?: 'Mutation', followItem?: { __typename?: 'FollowItemPayload', item: { __typename?: 'SearchFollowItem', id?: string | null, isFollowing: boolean } } | null };

export type FollowItemsMutationVariables = Exact<{
  followCompanyIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  followCryptoCurrencyIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  language: Scalars['String'];
}>;


export type FollowItemsMutation = { __typename?: 'Mutation', followItems?: { __typename?: 'FollowItemsPayload', items: Array<{ __typename?: 'SearchFollowItem', id?: string | null, isFollowing: boolean }> } | null };

export type UnfollowItemMutationVariables = Exact<{
  followUserId?: InputMaybe<Scalars['ID']>;
  followCompanyId?: InputMaybe<Scalars['ID']>;
  followCryptoCurrencyId?: InputMaybe<Scalars['ID']>;
  language: Scalars['String'];
}>;


export type UnfollowItemMutation = { __typename?: 'Mutation', unfollowItem?: { __typename?: 'UnfollowItemPayload', item: { __typename?: 'SearchFollowItem', id?: string | null, isFollowing: boolean } } | null };

export type UnfollowItemsMutationVariables = Exact<{
  followUserIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  followCompanyIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  followCryptoCurrencyIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  language: Scalars['String'];
}>;


export type UnfollowItemsMutation = { __typename?: 'Mutation', unfollowItems?: { __typename?: 'UnfollowItemsPayload', items: Array<{ __typename?: 'SearchFollowItem', id?: string | null, isFollowing: boolean }> } | null };

export type AddCommunityReportMutationVariables = Exact<{
  communityReport: CommunityReportInput;
}>;


export type AddCommunityReportMutation = { __typename?: 'Mutation', addCommunityReport?: { __typename?: 'AddCommunityReportPayload', communityReport: { __typename?: 'CommunityReportObject', reporterId: string } } | null };

export type BlockUserMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type BlockUserMutation = { __typename?: 'Mutation', blockUser?: { __typename?: 'BlockUserPayload', user: { __typename?: 'User', id?: string | null, nickname?: string | null } } | null };

export type UnblockUserMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UnblockUserMutation = { __typename?: 'Mutation', unblockUser?: { __typename?: 'UnblockUserPayload', user: { __typename?: 'User', id?: string | null, nickname?: string | null } } | null };

export type FeedTopicsWithPortfolioTopicsQueryVariables = Exact<{
  communityLanguage?: InputMaybe<Scalars['String']>;
}>;


export type FeedTopicsWithPortfolioTopicsQuery = { __typename?: 'Query', feedTopics?: Array<{ __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null }> | null, publicPortfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null };

export type PublicPortfolioTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicPortfolioTopicsQuery = { __typename?: 'Query', publicPortfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null };

export type TimelineFeedQueryVariables = Exact<{
  language: Scalars['String'];
  limit: Scalars['Int'];
  feedTopicId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['String']>;
  portfolioTopicId?: InputMaybe<Scalars['ID']>;
  includeInfluencerArticle?: InputMaybe<Scalars['Boolean']>;
}>;


export type TimelineFeedQuery = { __typename?: 'Query', timelineFeed?: Array<{ __typename?: 'Article', id: string, title?: string | null, language: string, userId: string, commentsCount?: number | null, isBookmarked: boolean, isLiked: boolean, likesCount?: number | null, portfolioTopicIds?: Array<string> | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, dynamicLinkUrl?: string | null, feedTopic?: { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | null, content: Array<{ __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } } | { __typename?: 'ArticleContentBackTestingProject' } | { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } } | { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } } | { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } } | { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, assetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null, portfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null }> | null };

export type FeedFilteredByTagQueryVariables = Exact<{
  language: Scalars['String'];
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
  assetTagId: Scalars['ID'];
}>;


export type FeedFilteredByTagQuery = { __typename?: 'Query', feedFilteredByTag?: { __typename?: 'FeedFilteredByTag', articles?: Array<{ __typename?: 'Article', id: string, title?: string | null, language: string, userId: string, commentsCount?: number | null, isBookmarked: boolean, isLiked: boolean, likesCount?: number | null, portfolioTopicIds?: Array<string> | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, dynamicLinkUrl?: string | null, feedTopic?: { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | null, content: Array<{ __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } } | { __typename?: 'ArticleContentBackTestingProject' } | { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } } | { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } } | { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } } | { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, assetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null, portfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null }> | null, assetTagTitle?: { __typename?: 'AssetTagTitle', categoryType: string, companyId?: string | null, country?: string | null, cryptoCurrencyId?: string | null, id: string, name: string, price?: string | null, priceChangePercent?: string | null, symbol?: string | null, isFollowing: boolean, userFollowingId?: string | null, counterCurrency: { __typename?: 'CounterCurrency', symbol?: string | null, unit?: string | null } } | null } | null };

export type ArticleQueryVariables = Exact<{
  articleId: Scalars['ID'];
}>;


export type ArticleQuery = { __typename?: 'Query', article: { __typename?: 'Article', id: string, title?: string | null, language: string, userId: string, commentsCount?: number | null, isBookmarked: boolean, isLiked: boolean, likesCount?: number | null, portfolioTopicIds?: Array<string> | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, dynamicLinkUrl?: string | null, feedTopic?: { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | null, content: Array<{ __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } } | { __typename?: 'ArticleContentBackTestingProject' } | { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } } | { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } } | { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } } | { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, assetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null, portfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null } };

export type FavoriteArticlesInTopicQueryVariables = Exact<{
  feedTopicId?: InputMaybe<Scalars['ID']>;
  language: Scalars['String'];
  limit: Scalars['Int'];
}>;


export type FavoriteArticlesInTopicQuery = { __typename?: 'Query', favoriteArticlesInTopic: Array<{ __typename?: 'Article', id: string, title?: string | null, language: string, userId: string, commentsCount?: number | null, isBookmarked: boolean, isLiked: boolean, likesCount?: number | null, portfolioTopicIds?: Array<string> | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, dynamicLinkUrl?: string | null, feedTopic?: { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | null, content: Array<{ __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } } | { __typename?: 'ArticleContentBackTestingProject' } | { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } } | { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } } | { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } } | { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, assetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null, portfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null }> };

export type ArticleCommentsQueryVariables = Exact<{
  articleId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ArticleCommentsQuery = { __typename?: 'Query', articleComments: Array<{ __typename?: 'ArticleComment', id: string, articleId?: string | null, parentCommentId?: string | null, repliesCount?: number | null, userId: string, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, content: Array<{ __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, replies?: Array<{ __typename?: 'ArticleCommentReply', id: string, parentCommentId?: string | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, userId: string, content: Array<{ __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } }> | null, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } }> };

export type SearchAssetTagsQueryVariables = Exact<{
  keyword: Scalars['String'];
  language: Scalars['String'];
}>;


export type SearchAssetTagsQuery = { __typename?: 'Query', searchAssetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null };

export type MyFollowingsQueryVariables = Exact<{
  itemType?: InputMaybe<FollowingItemEnum>;
  language: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
  sortOrderType: MyFollowingSortOrderEnum;
}>;


export type MyFollowingsQuery = { __typename?: 'Query', myFollowings: { __typename?: 'SearchFollowItems', totalCount: number, items: Array<{ __typename?: 'SearchFollowItem', id?: string | null, hasNewArticle?: boolean | null, userFollowingId?: string | null, categoryType: string, isFollowing: boolean, followItem?: { __typename?: 'FollowCompany', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowCryptoCurrency', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowUser', id: string, nickname?: string | null, profileImageUrl?: string | null, description?: string | null, followersCount?: number | null } | null }> } };

export type MyFollowingFeedQueryVariables = Exact<{
  language: Scalars['String'];
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
  userFollowingId?: InputMaybe<Scalars['ID']>;
}>;


export type MyFollowingFeedQuery = { __typename?: 'Query', myFollowingFeed: Array<{ __typename?: 'Article', id: string, title?: string | null, language: string, userId: string, commentsCount?: number | null, isBookmarked: boolean, isLiked: boolean, likesCount?: number | null, portfolioTopicIds?: Array<string> | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, dynamicLinkUrl?: string | null, feedTopic?: { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | null, content: Array<{ __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } } | { __typename?: 'ArticleContentBackTestingProject' } | { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } } | { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } } | { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } } | { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, assetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null, portfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null }> };

export type UserFollowingsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
  language: Scalars['String'];
  itemType: FollowingItemEnum;
  userId: Scalars['ID'];
}>;


export type UserFollowingsQuery = { __typename?: 'Query', userFollowings: { __typename?: 'SearchFollowItems', totalCount: number, items: Array<{ __typename?: 'SearchFollowItem', id?: string | null, hasNewArticle?: boolean | null, userFollowingId?: string | null, categoryType: string, isFollowing: boolean, followItem?: { __typename?: 'FollowCompany', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowCryptoCurrency', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowUser', id: string, nickname?: string | null, profileImageUrl?: string | null, description?: string | null, followersCount?: number | null } | null }> } };

export type UserFollowersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
  language: Scalars['String'];
  userId: Scalars['ID'];
}>;


export type UserFollowersQuery = { __typename?: 'Query', userFollowers: { __typename?: 'SearchFollowItems', totalCount: number, items: Array<{ __typename?: 'SearchFollowItem', id?: string | null, hasNewArticle?: boolean | null, userFollowingId?: string | null, categoryType: string, isFollowing: boolean, followItem?: { __typename?: 'FollowCompany', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowCryptoCurrency', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowUser', id: string, nickname?: string | null, profileImageUrl?: string | null, description?: string | null, followersCount?: number | null } | null }> } };

export type RecommendedFollowsQueryVariables = Exact<{
  itemType: FollowingItemEnum;
  language: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
}>;


export type RecommendedFollowsQuery = { __typename?: 'Query', recommendedFollows: { __typename?: 'SearchFollowItems', totalCount: number, items: Array<{ __typename?: 'SearchFollowItem', id?: string | null, hasNewArticle?: boolean | null, userFollowingId?: string | null, categoryType: string, isFollowing: boolean, followItem?: { __typename?: 'FollowCompany', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowCryptoCurrency', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowUser', id: string, nickname?: string | null, profileImageUrl?: string | null, description?: string | null, followersCount?: number | null } | null }> } };

export type SearchFollowsQueryVariables = Exact<{
  itemType: FollowingItemEnum;
  language: Scalars['String'];
  keyword: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
}>;


export type SearchFollowsQuery = { __typename?: 'Query', searchFollows: { __typename?: 'SearchFollowItems', totalCount: number, items: Array<{ __typename?: 'SearchFollowItem', id?: string | null, hasNewArticle?: boolean | null, userFollowingId?: string | null, categoryType: string, isFollowing: boolean, followItem?: { __typename?: 'FollowCompany', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowCryptoCurrency', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowUser', id: string, nickname?: string | null, profileImageUrl?: string | null, description?: string | null, followersCount?: number | null } | null }> } };

export type SearchCommunityArticlesQueryVariables = Exact<{
  keyword: Scalars['String'];
  language: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
}>;


export type SearchCommunityArticlesQuery = { __typename?: 'Query', searchCommunityArticles: { __typename?: 'SearchArticles', articles: Array<{ __typename?: 'Article', id: string, title?: string | null, language: string, userId: string, commentsCount?: number | null, isBookmarked: boolean, isLiked: boolean, likesCount?: number | null, portfolioTopicIds?: Array<string> | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, dynamicLinkUrl?: string | null, feedTopic?: { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | null, content: Array<{ __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } } | { __typename?: 'ArticleContentBackTestingProject' } | { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } } | { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } } | { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } } | { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, assetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null, portfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null }> } };

export type SearchCommunityUsersQueryVariables = Exact<{
  keyword: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
}>;


export type SearchCommunityUsersQuery = { __typename?: 'Query', searchCommunityUsers: Array<{ __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> };

export type SearchUsersInArticleQueryVariables = Exact<{
  articleId: Scalars['ID'];
  keyword: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type SearchUsersInArticleQuery = { __typename?: 'Query', searchUsersInArticle: Array<{ __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> };

export type BlockedUsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
}>;


export type BlockedUsersQuery = { __typename?: 'Query', blockedUsers: Array<{ __typename?: 'User', description?: string | null, followersCount?: number | null, followingsCount?: number | null, id?: string | null, nickname?: string | null, profileImageUrl?: string | null, tags?: Array<string> | null, userStatus?: string | null, userStatusUpdatedAt?: string | null, chatRoomUrl?: string | null }> };

export type RecommendedFollowsByUserFavoritesQueryVariables = Exact<{
  itemType: FollowingItemEnum;
  language: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
}>;


export type RecommendedFollowsByUserFavoritesQuery = { __typename?: 'Query', recommendedFollowsByUserFavorites: { __typename?: 'SearchFollowItems', totalCount: number, items: Array<{ __typename?: 'SearchFollowItem', id?: string | null, hasNewArticle?: boolean | null, userFollowingId?: string | null, categoryType: string, isFollowing: boolean, followItem?: { __typename?: 'FollowCompany', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowCryptoCurrency', id: string, logoImageUrl?: string | null, name: string, symbol: string } | { __typename?: 'FollowUser', id: string, nickname?: string | null, profileImageUrl?: string | null, description?: string | null, followersCount?: number | null } | null }> } };

export type GetOgTagQueryVariables = Exact<{
  originalLink: Scalars['String'];
  refetch?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetOgTagQuery = { __typename?: 'Query', getOgTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null };

export type CompanyFieldsFragment = { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null };

export type CompanyDetailFieldsFragment = { __typename?: 'CompanyDetail', assetTagId?: string | null, country?: string | null, dividendFrequency?: string | null, exDividendMonths?: Array<number> | null, exchange?: string | null, id: string, industry?: string | null, isExist?: boolean | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, listDate?: string | null, logoImageUrl?: string | null, name?: string | null, needTtm?: boolean | null, paymentMonths?: Array<number> | null, sector?: string | null, symbol?: string | null, ticker?: string | null, chartSymbol?: string | null, companyName: { __typename?: 'LanguageString', en?: string | null, ko?: string | null }, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null };

export type CompanyDetailOnlyCommunityFieldsFragment = { __typename?: 'CompanyDetail', id: string, isFollowing?: boolean | null, followItemId?: string | null };

export type CompanyPriceFieldsFragment = { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null };

export type NewsCompanyDetailFragment = { __typename?: 'CompanyDetail', id: string, ticker?: string | null, country?: string | null, companyName: { __typename?: 'LanguageString', en?: string | null, ko?: string | null }, companyPrice?: { __typename?: 'CompanyPrice', priceChangePercent?: string | null } | null };

export type StockPriceFieldsFragment = { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null };

export type CompanyDetailByIdQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyDetailByIdQuery = { __typename?: 'Query', companyDetailById?: { __typename?: 'CompanyDetail', assetTagId?: string | null, country?: string | null, dividendFrequency?: string | null, exDividendMonths?: Array<number> | null, exchange?: string | null, id: string, industry?: string | null, isExist?: boolean | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, listDate?: string | null, logoImageUrl?: string | null, name?: string | null, needTtm?: boolean | null, paymentMonths?: Array<number> | null, sector?: string | null, symbol?: string | null, ticker?: string | null, chartSymbol?: string | null, companyName: { __typename?: 'LanguageString', en?: string | null, ko?: string | null }, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null };

export type CompanyDetailByTickerQueryVariables = Exact<{
  ticker: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
}>;


export type CompanyDetailByTickerQuery = { __typename?: 'Query', companyDetailByTicker?: { __typename?: 'CompanyDetail', assetTagId?: string | null, country?: string | null, dividendFrequency?: string | null, exDividendMonths?: Array<number> | null, exchange?: string | null, id: string, industry?: string | null, isExist?: boolean | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, listDate?: string | null, logoImageUrl?: string | null, name?: string | null, needTtm?: boolean | null, paymentMonths?: Array<number> | null, sector?: string | null, symbol?: string | null, ticker?: string | null, chartSymbol?: string | null, companyName: { __typename?: 'LanguageString', en?: string | null, ko?: string | null }, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null };

export type CompanyDetailOnlyCommunityQueryVariables = Exact<{
  ticker: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
}>;


export type CompanyDetailOnlyCommunityQuery = { __typename?: 'Query', companyDetailByTicker?: { __typename?: 'CompanyDetail', id: string, isFollowing?: boolean | null, followItemId?: string | null } | null };

export type CompanyDetailByIdsQueryVariables = Exact<{
  companyIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CompanyDetailByIdsQuery = { __typename?: 'Query', companyDetailByIds?: Array<{ __typename?: 'CompanyDetail', assetTagId?: string | null, country?: string | null, dividendFrequency?: string | null, exDividendMonths?: Array<number> | null, exchange?: string | null, id: string, industry?: string | null, isExist?: boolean | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, listDate?: string | null, logoImageUrl?: string | null, name?: string | null, needTtm?: boolean | null, paymentMonths?: Array<number> | null, sector?: string | null, symbol?: string | null, ticker?: string | null, chartSymbol?: string | null, companyName: { __typename?: 'LanguageString', en?: string | null, ko?: string | null }, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> | null };

export type CompanyDetailByIdsForNewsQueryVariables = Exact<{
  companyIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CompanyDetailByIdsForNewsQuery = { __typename?: 'Query', companyDetailByIds?: Array<{ __typename?: 'CompanyDetail', id: string, ticker?: string | null, country?: string | null, companyName: { __typename?: 'LanguageString', en?: string | null, ko?: string | null }, companyPrice?: { __typename?: 'CompanyPrice', priceChangePercent?: string | null } | null }> | null };

export type RealtimeStockPriceSubscriptionVariables = Exact<{
  companyIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RealtimeStockPriceSubscription = { __typename?: 'Subscription', realtimeStockPrice: { __typename?: 'RealtimeStockPricePayload', companyPrices: Array<{ __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null }> } };

export type StockPriceUpdatedSubscriptionVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type StockPriceUpdatedSubscription = { __typename?: 'Subscription', stockPriceUpdated: { __typename?: 'StockPriceUpdatedPayload', companyPrice: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } } };

export type CryptoCurrencyFieldsFragment = { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } };

export type CryptoCurrencyAssetFieldsFragment = { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } };

export type CryptoCurrencyDetailFieldsFragment = { __typename?: 'CryptoCurrencyDetail', assetTagId?: string | null, base: string, counter: string, currencyType?: string | null, decimalPoint: number, id: string, imageUrl: string, symbol: string, unit: string, cryptoCurrencyPrice?: { __typename?: 'CryptoCurrencyPrice', base: string, counter: string, id: string, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null } | null, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null }, counterCurrency: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } };

export type CryptoCurrencyDetailOnlyCommunityFieldsFragment = { __typename?: 'CryptoCurrencyDetail', id: string, followCryptoCurrencyId: string, followItemId?: string | null, isFollowing?: boolean | null };

export type CryptoCurrencyPriceFieldsFragment = { __typename?: 'CryptoCurrencyPrice', base: string, counter: string, id: string, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null };

export type CryptoCurrencyExchangeQueryVariables = Exact<{
  symbol: Scalars['String'];
}>;


export type CryptoCurrencyExchangeQuery = { __typename?: 'Query', cryptoCurrencyExchange?: { __typename?: 'CurrencyExchange', id: string, exchangePercent?: string | null, exchangeRate?: string | null, pair?: string | null, symbol?: string | null } | null };

export type CryptoCurrencyExchangesQueryVariables = Exact<{
  pairs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CryptoCurrencyExchangesQuery = { __typename?: 'Query', cryptoCurrencyExchanges?: Array<{ __typename?: 'CurrencyExchange', id: string, exchangePercent?: string | null, exchangeRate?: string | null, pair?: string | null, symbol?: string | null }> | null };

export type SupportedCryptoCurrencyBasesQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportedCryptoCurrencyBasesQuery = { __typename?: 'Query', cryptos?: Array<{ __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }> | null };

export type CryptoCurrencyDetailQueryVariables = Exact<{
  base: Scalars['String'];
  counter: Scalars['String'];
}>;


export type CryptoCurrencyDetailQuery = { __typename?: 'Query', cryptoCurrencyDetail?: { __typename?: 'CryptoCurrencyDetail', assetTagId?: string | null, base: string, counter: string, currencyType?: string | null, decimalPoint: number, id: string, imageUrl: string, symbol: string, unit: string, cryptoCurrencyPrice?: { __typename?: 'CryptoCurrencyPrice', base: string, counter: string, id: string, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null } | null, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null }, counterCurrency: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null };

export type CryptoCurrencyDetailOnlyCommunityQueryVariables = Exact<{
  base: Scalars['String'];
  counter: Scalars['String'];
}>;


export type CryptoCurrencyDetailOnlyCommunityQuery = { __typename?: 'Query', cryptoCurrencyDetail?: { __typename?: 'CryptoCurrencyDetail', id: string, followCryptoCurrencyId: string, followItemId?: string | null, isFollowing?: boolean | null } | null };

export type CryptoCurrencyPriceUpdatedSubscriptionVariables = Exact<{
  base: Scalars['String'];
  counter: Scalars['String'];
  dataSource?: InputMaybe<Scalars['String']>;
}>;


export type CryptoCurrencyPriceUpdatedSubscription = { __typename?: 'Subscription', cryptoCurrencyPriceUpdated: { __typename?: 'CryptoCurrencyPriceUpdatedPayload', cryptoCurrencyPrice: { __typename?: 'CryptoCurrencyPrice', base: string, counter: string, id: string, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null } } };

export type CurrencyFieldsFragment = { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } };

export type SupportedCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportedCurrenciesQuery = { __typename?: 'Query', supportedCurrencies?: Array<{ __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }> | null };

export type DividendHistoryApi1FieldsFragment = { __typename?: 'DividendHistory', id: string, amount?: number | null, exDividendDate?: string | null, flag?: string | null, frequency?: string | null, paymentDate?: string | null, recordDate?: string | null, company: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null };

export type DividendHistoryFieldsFragment = { __typename?: 'DividendHistory', id: string, amount?: number | null, paymentDate?: string | null, recordDate?: string | null, exDividendDate?: string | null, frequency?: string | null, flag?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, company: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } };

export type DividendCalendarRecordFieldsFragment = { __typename?: 'DividendCalendarRecord', assetAmount?: number | null, dividendHistory: { __typename?: 'DividendHistory', amount?: number | null, exDividendDate?: string | null, flag?: string | null, frequency?: string | null, id: string, paymentDate?: string | null, recordDate?: string | null, company: { __typename?: 'Company', country?: string | null, dividendFrequency?: string | null, exDividendMonths?: Array<number> | null, exchange?: string | null, id: string, logoUrl?: string | null, name?: string | null, needTtm?: boolean | null, paymentMonths?: Array<number> | null, ticker?: string | null, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, updatedAt?: string | null } | null, companyName: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }, currency?: { __typename?: 'Currency', id: string, decimalPoint: number, symbol?: string | null, unit: string } | null } };

export type ThisWeekDividendStocksQueryVariables = Exact<{ [key: string]: never; }>;


export type ThisWeekDividendStocksQuery = { __typename?: 'Query', thisWeekDividendStocks?: Array<{ __typename?: 'DividendHistory', id: string, amount?: number | null, exDividendDate?: string | null, flag?: string | null, frequency?: string | null, paymentDate?: string | null, recordDate?: string | null, company: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> | null };

export type DividendCalendarForPortfoliosQueryVariables = Exact<{
  portfolioSlugs: Array<Scalars['String']> | Scalars['String'];
  currencyId: Scalars['ID'];
  taxRatio: Scalars['Float'];
  date: Scalars['String'];
}>;


export type DividendCalendarForPortfoliosQuery = { __typename?: 'Query', dividendCalendarForPortfolios: { __typename?: 'PortfolioDividendCalendar', totalDividendAmount?: number | null, dividendCalendarRecords: Array<{ __typename?: 'DividendCalendarRecord', assetAmount?: number | null, dividendHistory: { __typename?: 'DividendHistory', amount?: number | null, exDividendDate?: string | null, flag?: string | null, frequency?: string | null, id: string, paymentDate?: string | null, recordDate?: string | null, company: { __typename?: 'Company', country?: string | null, dividendFrequency?: string | null, exDividendMonths?: Array<number> | null, exchange?: string | null, id: string, logoUrl?: string | null, name?: string | null, needTtm?: boolean | null, paymentMonths?: Array<number> | null, ticker?: string | null, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, updatedAt?: string | null } | null, companyName: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }, currency?: { __typename?: 'Currency', id: string, decimalPoint: number, symbol?: string | null, unit: string } | null } }> } };

export type MarketCalendarFieldsFragment = { __typename?: 'MarketCalendar', date?: string | null, memo?: string | null, country?: string | null };

export type PaginationCompaniesFieldsFragment = { __typename?: 'PaginationCompanies', totalCount: number, totalPages: number, currentPage: number, currentPageCount: number, perPage: number, nextPage?: number | null, companies?: Array<{ __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> | null };

export type EbestUserPortfolioFragment = { __typename?: 'UserPortfolio', id?: string | null, name: string, createdAt?: string | null, slug?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }> };

export type DividendHistoriesExistingDaysForExternalChannelFieldsFragment = { __typename?: 'DividendHistoriesExistingDaysForExternalChannel', dividendHistoriesExistingDays: Array<string>, totalCount: number };

export type ConnectPartnerWithUserDataMutationVariables = Exact<{
  userData: Scalars['String'];
}>;


export type ConnectPartnerWithUserDataMutation = { __typename?: 'Mutation', connectPartnerWithUserData?: { __typename?: 'AuthToken', deviceRegistrationToken?: string | null, isNewUser?: boolean | null, nickname?: string | null, token: string } | null };

export type ClosedMarketDaysQueryVariables = Exact<{
  country: Scalars['String'];
  year: Scalars['String'];
}>;


export type ClosedMarketDaysQuery = { __typename?: 'Query', closedMarketDays: Array<{ __typename?: 'MarketCalendar', date?: string | null, memo?: string | null, country?: string | null }> };

export type ThisWeekDividendStocksInSnp500QueryVariables = Exact<{ [key: string]: never; }>;


export type ThisWeekDividendStocksInSnp500Query = { __typename?: 'Query', thisWeekDividendStocksInSnp500?: Array<{ __typename?: 'DividendHistory', id: string, amount?: number | null, paymentDate?: string | null, recordDate?: string | null, exDividendDate?: string | null, frequency?: string | null, flag?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, company: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } }> | null };

export type DividendCompaniesInSnp500QueryVariables = Exact<{
  ref: DividendHistoryBaseDateEnum;
  months: Array<Scalars['Int']> | Scalars['Int'];
  page: Scalars['Int'];
  per: Scalars['Int'];
}>;


export type DividendCompaniesInSnp500Query = { __typename?: 'Query', dividendCompaniesInSnp500?: { __typename?: 'PaginationCompanies', totalCount: number, totalPages: number, currentPage: number, currentPageCount: number, perPage: number, nextPage?: number | null, companies?: Array<{ __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> | null } | null };

export type MyPortfoliosFromEbestQueryVariables = Exact<{
  page: Scalars['Int'];
  per: Scalars['Int'];
}>;


export type MyPortfoliosFromEbestQuery = { __typename?: 'Query', myPortfoliosFromPartner: { __typename?: 'PaginationPortfolios', totalCount: number, totalPages: number, currentPage: number, currentPageCount: number, perPage: number, nextPage?: number | null, portfolios?: Array<{ __typename?: 'UserPortfolio', id?: string | null, name: string, createdAt?: string | null, slug?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }> }> | null } };

export type DividendHistoriesExistingDaysForExternalChannelQueryVariables = Exact<{
  channelName: ExternalChannelEnum;
  date: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
}>;


export type DividendHistoriesExistingDaysForExternalChannelQuery = { __typename?: 'Query', dividendHistoriesExistingDaysForExternalChannel: { __typename?: 'DividendHistoriesExistingDaysForExternalChannel', dividendHistoriesExistingDays: Array<string>, totalCount: number } };

export type DividendCalendarForExternalChannelWithPaginationQueryVariables = Exact<{
  channelName?: InputMaybe<ExternalChannelEnum>;
  date: Scalars['String'];
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type DividendCalendarForExternalChannelWithPaginationQuery = { __typename?: 'Query', dividendCalendarForExternalChannelWithPagination: Array<{ __typename?: 'DividendHistory', id: string, amount?: number | null, paymentDate?: string | null, recordDate?: string | null, exDividendDate?: string | null, frequency?: string | null, flag?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, company: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } }> };

export type CurrencyExchangeFieldsFragment = { __typename?: 'CurrencyExchange', id: string, exchangePercent?: string | null, exchangeRate?: string | null, pair?: string | null, symbol?: string | null };

export type AllExchangesQueryVariables = Exact<{
  pairsForFiats?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  pairsForCryptos?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AllExchangesQuery = { __typename?: 'Query', currencyExchanges?: Array<{ __typename?: 'CurrencyExchange', id: string, exchangePercent?: string | null, exchangeRate?: string | null, pair?: string | null, symbol?: string | null }> | null, cryptoCurrencyExchanges?: Array<{ __typename?: 'CurrencyExchange', id: string, exchangePercent?: string | null, exchangeRate?: string | null, pair?: string | null, symbol?: string | null }> | null };

export type CurrencyExchangesQueryVariables = Exact<{
  pairs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CurrencyExchangesQuery = { __typename?: 'Query', currencyExchanges?: Array<{ __typename?: 'CurrencyExchange', id: string, exchangePercent?: string | null, exchangeRate?: string | null, pair?: string | null, symbol?: string | null }> | null };

export type FavoriteItemFieldsFragment = { __typename?: 'FavoriteItem', id?: string | null, itemCategory?: ItemCategory | null, company?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, cryptoCurrency?: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null };

export type FavoriteItemCategoryWithoutItemsFieldsFragment = { __typename?: 'FavoriteItemCategory', id?: string | null, slug?: string | null, slugSharedAt?: string | null, categoryName?: string | null, createdAt?: string | null, updatedAt?: string | null, orderScore?: number | null };

export type FavoriteItemCategoryFieldsFragment = { __typename?: 'FavoriteItemCategory', countOfStars?: number | null, countOfView?: number | null, id?: string | null, slug?: string | null, slugSharedAt?: string | null, categoryName?: string | null, createdAt?: string | null, updatedAt?: string | null, orderScore?: number | null, items?: Array<{ __typename?: 'FavoriteItem', id?: string | null, itemCategory?: ItemCategory | null, company?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, cryptoCurrency?: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> | null };

export type UpdateFavoriteItemCategoryOrdersMutationVariables = Exact<{
  categoryOrders: Array<UpdateFavoriteCategoryOrder> | UpdateFavoriteCategoryOrder;
}>;


export type UpdateFavoriteItemCategoryOrdersMutation = { __typename?: 'Mutation', updateFavoriteItemCategoryOrders?: { __typename?: 'UpdateFavoriteItemCategoryOrdersPayload', categories: Array<{ __typename?: 'FavoriteItemCategory', id?: string | null, slug?: string | null, slugSharedAt?: string | null, categoryName?: string | null, createdAt?: string | null, updatedAt?: string | null, orderScore?: number | null }> } | null };

export type AddFavoriteItemCategoryMutationVariables = Exact<{
  categoryName: Scalars['String'];
}>;


export type AddFavoriteItemCategoryMutation = { __typename?: 'Mutation', addFavoriteItemCategory?: { __typename?: 'AddFavoriteItemCategoryPayload', category?: { __typename?: 'FavoriteItemCategory', id?: string | null, slug?: string | null, slugSharedAt?: string | null, categoryName?: string | null, createdAt?: string | null, updatedAt?: string | null, orderScore?: number | null } | null } | null };

export type UpdateFavoriteItemCategoryMutationVariables = Exact<{
  categoryId: Scalars['ID'];
  categoryName: Scalars['String'];
}>;


export type UpdateFavoriteItemCategoryMutation = { __typename?: 'Mutation', updateFavoriteItemCategory?: { __typename?: 'UpdateFavoriteItemCategoryPayload', category: { __typename?: 'FavoriteItemCategory', id?: string | null, slug?: string | null, slugSharedAt?: string | null, categoryName?: string | null, createdAt?: string | null, updatedAt?: string | null, orderScore?: number | null } } | null };

export type RemoveFavoriteItemCategoryMutationVariables = Exact<{
  categoryId: Scalars['ID'];
}>;


export type RemoveFavoriteItemCategoryMutation = { __typename?: 'Mutation', removeFavoriteItemCategory?: { __typename?: 'RemoveFavoriteItemCategoryPayload', category: { __typename?: 'FavoriteItemCategory', id?: string | null } } | null };

export type AddItemsToFavoriteItemCategoryMutationVariables = Exact<{
  categoryId: Scalars['ID'];
  items: Array<UploadFavoriteItem> | UploadFavoriteItem;
}>;


export type AddItemsToFavoriteItemCategoryMutation = { __typename?: 'Mutation', addItemsToFavoriteItemCategory?: { __typename?: 'AddItemsToFavoriteItemCategoryPayload', category: { __typename?: 'FavoriteItemCategory', countOfStars?: number | null, countOfView?: number | null, id?: string | null, slug?: string | null, slugSharedAt?: string | null, categoryName?: string | null, createdAt?: string | null, updatedAt?: string | null, orderScore?: number | null, items?: Array<{ __typename?: 'FavoriteItem', id?: string | null, itemCategory?: ItemCategory | null, company?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, cryptoCurrency?: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> | null } } | null };

export type RemoveItemsToFavoriteItemCategoryMutationVariables = Exact<{
  categoryId: Scalars['String'];
  items: Array<RemoveFavoriteItem> | RemoveFavoriteItem;
}>;


export type RemoveItemsToFavoriteItemCategoryMutation = { __typename?: 'Mutation', removeItemsToFavoriteItemCategory?: { __typename?: 'RemoveItemsToFavoriteItemCategoryPayload', category: { __typename?: 'FavoriteItemCategory', countOfStars?: number | null, countOfView?: number | null, id?: string | null, slug?: string | null, slugSharedAt?: string | null, categoryName?: string | null, createdAt?: string | null, updatedAt?: string | null, orderScore?: number | null, items?: Array<{ __typename?: 'FavoriteItem', id?: string | null, itemCategory?: ItemCategory | null, company?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, cryptoCurrency?: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> | null } } | null };

export type EnableSharingFavoriteItemCategoryMutationVariables = Exact<{
  favoriteItemCategoryId: Scalars['ID'];
}>;


export type EnableSharingFavoriteItemCategoryMutation = { __typename?: 'Mutation', enableSharingFavoriteItemCategory?: { __typename?: 'EnableSharingFavoriteItemCategoryPayload', favoriteItemCategory: { __typename?: 'FavoriteItemCategory', id?: string | null, slug?: string | null, slugSharedAt?: string | null, categoryName?: string | null, createdAt?: string | null, updatedAt?: string | null, orderScore?: number | null } } | null };

export type DisableSharingFavoriteItemCategoryMutationVariables = Exact<{
  favoriteItemCategoryId: Scalars['ID'];
}>;


export type DisableSharingFavoriteItemCategoryMutation = { __typename?: 'Mutation', disableSharingFavoriteItemCategory?: { __typename?: 'DisableSharingFavoriteItemCategoryPayload', favoriteItemCategory: { __typename?: 'FavoriteItemCategory', id?: string | null, slug?: string | null, slugSharedAt?: string | null, categoryName?: string | null, createdAt?: string | null, updatedAt?: string | null, orderScore?: number | null } } | null };

export type FavoriteItemCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoriteItemCategoriesQuery = { __typename?: 'Query', favorites?: Array<{ __typename?: 'FavoriteItemCategory', id?: string | null, slug?: string | null, slugSharedAt?: string | null, categoryName?: string | null, createdAt?: string | null, updatedAt?: string | null, orderScore?: number | null }> | null };

export type FavoriteItemCategoryQueryVariables = Exact<{
  slug: Array<Scalars['String']> | Scalars['String'];
}>;


export type FavoriteItemCategoryQuery = { __typename?: 'Query', favorite?: { __typename?: 'FavoriteItemCategory', countOfStars?: number | null, countOfView?: number | null, id?: string | null, slug?: string | null, slugSharedAt?: string | null, categoryName?: string | null, createdAt?: string | null, updatedAt?: string | null, orderScore?: number | null, items?: Array<{ __typename?: 'FavoriteItem', id?: string | null, itemCategory?: ItemCategory | null, company?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, cryptoCurrency?: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> | null } | null };

type TradingDiaryLogFields_InvestingDiaryDepositWithdrawalLog_Fragment = { __typename?: 'InvestingDiaryDepositWithdrawalLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, side?: string | null, amount?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null };

type TradingDiaryLogFields_InvestingDiaryExchangeCurrencyLog_Fragment = { __typename?: 'InvestingDiaryExchangeCurrencyLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, counterAmount?: number | null, exchangeRate?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, baseCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, counterCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null };

type TradingDiaryLogFields_InvestingDiaryMemoLog_Fragment = { __typename?: 'InvestingDiaryMemoLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null };

type TradingDiaryLogFields_InvestingDiaryTradeLog_Fragment = { __typename?: 'InvestingDiaryTradeLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, amount?: number | null, position?: string | null, price?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, company?: { __typename?: 'Company', id: string, ticker?: string | null, country?: string | null, name?: string | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrency?: { __typename?: 'CryptoCurrency', id: string, symbol?: string | null, decimalPoint: number, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null };

export type TradingDiaryLogFieldsFragment = TradingDiaryLogFields_InvestingDiaryDepositWithdrawalLog_Fragment | TradingDiaryLogFields_InvestingDiaryExchangeCurrencyLog_Fragment | TradingDiaryLogFields_InvestingDiaryMemoLog_Fragment | TradingDiaryLogFields_InvestingDiaryTradeLog_Fragment;

export type AddLogToInvestingDiaryMutationVariables = Exact<{
  portfolioSlug: Scalars['String'];
  date: Scalars['String'];
  emotion?: InputMaybe<Scalars['String']>;
  tradeLogInput?: InputMaybe<InvestingDiaryTradeLogInput>;
  memoLogInput?: InputMaybe<InvestingDiaryMemoLogInput>;
  exchangeCurrencyLogInput?: InputMaybe<InvestingDiaryExchangeCurrencyLogInput>;
  depositWithdrawalLogInput?: InputMaybe<InvestingDiaryDepositWithdrawalLogInput>;
}>;


export type AddLogToInvestingDiaryMutation = { __typename?: 'Mutation', addLogToInvestingDiary?: { __typename?: 'AddLogToInvestingDiaryPayload', investingDiaryLog?: { __typename?: 'InvestingDiaryDepositWithdrawalLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, side?: string | null, amount?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | { __typename?: 'InvestingDiaryExchangeCurrencyLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, counterAmount?: number | null, exchangeRate?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, baseCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, counterCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | { __typename?: 'InvestingDiaryMemoLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null } | { __typename?: 'InvestingDiaryTradeLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, amount?: number | null, position?: string | null, price?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, company?: { __typename?: 'Company', id: string, ticker?: string | null, country?: string | null, name?: string | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrency?: { __typename?: 'CryptoCurrency', id: string, symbol?: string | null, decimalPoint: number, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null } | null };

export type UpdateInvestingDiaryLogMutationVariables = Exact<{
  investingDiaryLogId: Scalars['ID'];
  date: Scalars['String'];
  emotion?: InputMaybe<Scalars['String']>;
  tradeLogInput?: InputMaybe<InvestingDiaryTradeLogInput>;
  memoLogInput?: InputMaybe<InvestingDiaryMemoLogInput>;
  exchangeCurrencyLogInput?: InputMaybe<InvestingDiaryExchangeCurrencyLogInput>;
  depositWithdrawalLogInput?: InputMaybe<InvestingDiaryDepositWithdrawalLogInput>;
}>;


export type UpdateInvestingDiaryLogMutation = { __typename?: 'Mutation', updateInvestingDiaryLog?: { __typename?: 'UpdateInvestingDiaryLogPayload', investingDiaryLog: { __typename?: 'InvestingDiaryDepositWithdrawalLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, side?: string | null, amount?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | { __typename?: 'InvestingDiaryExchangeCurrencyLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, counterAmount?: number | null, exchangeRate?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, baseCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, counterCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | { __typename?: 'InvestingDiaryMemoLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null } | { __typename?: 'InvestingDiaryTradeLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, amount?: number | null, position?: string | null, price?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, company?: { __typename?: 'Company', id: string, ticker?: string | null, country?: string | null, name?: string | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrency?: { __typename?: 'CryptoCurrency', id: string, symbol?: string | null, decimalPoint: number, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } } | null };

export type RemoveInvestingDiaryLogMutationVariables = Exact<{
  investingDiaryLogId: Scalars['ID'];
}>;


export type RemoveInvestingDiaryLogMutation = { __typename?: 'Mutation', removeInvestingDiaryLog?: { __typename?: 'RemoveInvestingDiaryLogPayload', investingDiaryLog: { __typename?: 'InvestingDiaryDepositWithdrawalLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, side?: string | null, amount?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | { __typename?: 'InvestingDiaryExchangeCurrencyLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, counterAmount?: number | null, exchangeRate?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, baseCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, counterCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | { __typename?: 'InvestingDiaryMemoLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null } | { __typename?: 'InvestingDiaryTradeLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, amount?: number | null, position?: string | null, price?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, company?: { __typename?: 'Company', id: string, ticker?: string | null, country?: string | null, name?: string | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrency?: { __typename?: 'CryptoCurrency', id: string, symbol?: string | null, decimalPoint: number, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } } | null };

export type InvestingDiaryLogsQueryVariables = Exact<{
  portfolioSlugs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
}>;


export type InvestingDiaryLogsQuery = { __typename?: 'Query', investingDiaryLogs: Array<{ __typename?: 'InvestingDiaryDepositWithdrawalLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, side?: string | null, amount?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | { __typename?: 'InvestingDiaryExchangeCurrencyLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, counterAmount?: number | null, exchangeRate?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, baseCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, counterCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | { __typename?: 'InvestingDiaryMemoLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null } | { __typename?: 'InvestingDiaryTradeLog', id: string, date: string, category: string, memo?: string | null, url?: string | null, createdAt?: string | null, updatedAt?: string | null, emotion?: string | null, amount?: number | null, position?: string | null, price?: number | null, ogTag?: { __typename?: 'OgTag', id: string, charSet?: string | null, ogDescription?: string | null, ogImageUrl?: string | null, ogLocale?: string | null, ogTitle?: string | null, ogType?: string | null, originalLink: string, ogMetadata?: { __typename?: 'OgMetadata', ogImageHeight?: string | null, ogImageType?: string | null, ogImageWidth?: string | null } | null } | null, company?: { __typename?: 'Company', id: string, ticker?: string | null, country?: string | null, name?: string | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrency?: { __typename?: 'CryptoCurrency', id: string, symbol?: string | null, decimalPoint: number, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> };

export type EventFieldsFragment = { __typename?: 'EventStatus', endAt?: string | null, eventName: string, id: string, isInProgress: boolean, shareUrl?: string | null, startAt?: string | null };

export type EventStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type EventStatusQuery = { __typename?: 'Query', eventStatus: Array<{ __typename?: 'EventStatus', endAt?: string | null, eventName: string, id: string, isInProgress: boolean, shareUrl?: string | null, startAt?: string | null }> };

export type MailingGroupEmailVerificationFieldsFragment = { __typename?: 'MailingGroupEmailVerification', email?: string | null, emailVerifiedAt?: string | null, verifyingEmailSentAt?: string | null };

export type MailingGroupFieldsFragment = { __typename?: 'MailingGroup', id: string, subscribedUsersCount: number, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null }, subscribedUsers: Array<{ __typename?: 'SubscribedUser', email: string, userId?: string | null }> };

export type LanguageStringFieldsFragment = { __typename?: 'LanguageString', en?: string | null, ko?: string | null };

export type SubscribedUserFieldsFragment = { __typename?: 'SubscribedUser', email: string, userId?: string | null };

export type SendEmailToSubscribeMailingGroupMutationVariables = Exact<{
  locale: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  mailingGroupName: Scalars['String'];
  serviceAgreement: Scalars['Boolean'];
  marketingAgreement: Scalars['Boolean'];
}>;


export type SendEmailToSubscribeMailingGroupMutation = { __typename?: 'Mutation', sendEmailToSubscribeMailingGroup?: { __typename?: 'MailingGroupEmailVerification', email?: string | null, emailVerifiedAt?: string | null, verifyingEmailSentAt?: string | null } | null };

export type SubscribeMailingGroupMutationVariables = Exact<{
  verifyingEmailToken: Scalars['String'];
}>;


export type SubscribeMailingGroupMutation = { __typename?: 'Mutation', subscribeMailingGroup?: { __typename?: 'MailingGroupEmailVerification', email?: string | null, emailVerifiedAt?: string | null, verifyingEmailSentAt?: string | null } | null };

export type UnsubscribeMailingGroupMutationVariables = Exact<{
  mailingGroupId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
}>;


export type UnsubscribeMailingGroupMutation = { __typename?: 'Mutation', unsubscribeMailingGroup?: { __typename?: 'MailingGroupEmailVerification', email?: string | null, emailVerifiedAt?: string | null, verifyingEmailSentAt?: string | null } | null };

export type NewsLettersQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsLettersQuery = { __typename?: 'Query', newsLetters: Array<{ __typename?: 'MailingGroup', id: string, subscribedUsersCount: number, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null }, subscribedUsers: Array<{ __typename?: 'SubscribedUser', email: string, userId?: string | null }> }> };

export type MailingGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type MailingGroupsQuery = { __typename?: 'Query', mailingGroups: Array<{ __typename?: 'MailingGroup', id: string, subscribedUsersCount: number, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null }, subscribedUsers: Array<{ __typename?: 'SubscribedUser', email: string, userId?: string | null }> }> };

export type MailingGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MailingGroupQuery = { __typename?: 'Query', mailingGroup: { __typename?: 'MailingGroup', id: string, subscribedUsersCount: number, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null }, subscribedUsers: Array<{ __typename?: 'SubscribedUser', email: string, userId?: string | null }> } };

export type NoticeFieldFragment = { __typename?: 'Notice', id: string, contentEn?: string | null, contentKo?: string | null, createdAt?: string | null, titleEn: string, titleKo: string, updatedAt?: string | null, imageUrl?: string | null, imageUrlEn?: string | null, imageUrlKo?: string | null };

export type NoticesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type NoticesQuery = { __typename?: 'Query', notices?: Array<{ __typename?: 'Notice', id: string, contentEn?: string | null, contentKo?: string | null, createdAt?: string | null, titleEn: string, titleKo: string, updatedAt?: string | null, imageUrl?: string | null, imageUrlEn?: string | null, imageUrlKo?: string | null }> | null };

export type NoticeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NoticeQuery = { __typename?: 'Query', notice?: { __typename?: 'Notice', id: string, contentEn?: string | null, contentKo?: string | null, createdAt?: string | null, titleEn: string, titleKo: string, updatedAt?: string | null, imageUrl?: string | null, imageUrlEn?: string | null, imageUrlKo?: string | null } | null };

export type GeneratorPortfolioFieldsFragment = { __typename?: 'UserPortfolio', id?: string | null, createdAt?: string | null, depositConnectedAt?: string | null, description?: string | null, name: string, slug?: string | null, updatedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, amount?: string | null, avgPrice?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, decimalPoint: number, symbol?: string | null } | null, companyAsset?: { __typename?: 'Company', id: string, country?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, sector?: string | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, currency?: { __typename?: 'Currency', id: string, decimalPoint: number, symbol?: string | null } | null, stockPrice?: { __typename?: 'StockPrice', price?: string | null } | null } | null }>, currency?: { __typename?: 'Currency', id: string, decimalPoint: number, symbol?: string | null } | null };

export type CategorizedCompanyFieldsFragment = { __typename?: 'CategorizedCompany', id: string, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, companies?: Array<{ __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> | null };

export type CreateSnp500DividendPortfolioMutationVariables = Exact<{
  monthlyDividendAmount: Scalars['Float'];
  currencySymbol: Scalars['String'];
  tickers: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateSnp500DividendPortfolioMutation = { __typename?: 'Mutation', createDividendPortfolioSample?: { __typename?: 'CreateDividendPortfolioSamplePayload', portfolio: { __typename?: 'UserPortfolio', id?: string | null, createdAt?: string | null, depositConnectedAt?: string | null, description?: string | null, name: string, slug?: string | null, updatedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, amount?: string | null, avgPrice?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, decimalPoint: number, symbol?: string | null } | null, companyAsset?: { __typename?: 'Company', id: string, country?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, sector?: string | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, currency?: { __typename?: 'Currency', id: string, decimalPoint: number, symbol?: string | null } | null, stockPrice?: { __typename?: 'StockPrice', price?: string | null } | null } | null }>, currency?: { __typename?: 'Currency', id: string, decimalPoint: number, symbol?: string | null } | null } } | null };

export type SaveDividendPortfolioMutationVariables = Exact<{
  portfolioSlug: Scalars['String'];
  portfolioName: Scalars['String'];
}>;


export type SaveDividendPortfolioMutation = { __typename?: 'Mutation', saveDividendPortfolioFromSamsung?: { __typename?: 'SaveDividendPortfolioFromSamsungPayload', portfolio: { __typename?: 'UserPortfolio', id?: string | null, createdAt?: string | null, depositConnectedAt?: string | null, description?: string | null, name: string, slug?: string | null, updatedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, amount?: string | null, avgPrice?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, decimalPoint: number, symbol?: string | null } | null, companyAsset?: { __typename?: 'Company', id: string, country?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, sector?: string | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, currency?: { __typename?: 'Currency', id: string, decimalPoint: number, symbol?: string | null } | null, stockPrice?: { __typename?: 'StockPrice', price?: string | null } | null } | null }>, currency?: { __typename?: 'Currency', id: string, decimalPoint: number, symbol?: string | null } | null } } | null };

export type CategorizedCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorizedCompaniesQuery = { __typename?: 'Query', categorizedCompanies: Array<{ __typename?: 'CategorizedCompany', id: string, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, companies?: Array<{ __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> | null }> };

export type DividendHistoriesInSnp500QueryVariables = Exact<{
  companyIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DividendHistoriesInSnp500Query = { __typename?: 'Query', dividendHistoriesInSnp500?: Array<{ __typename?: 'DividendHistory', id: string, amount?: number | null, paymentDate?: string | null, recordDate?: string | null, exDividendDate?: string | null, frequency?: string | null, flag?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, company: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } }> | null };

export type GetPortfolioBySlugQueryVariables = Exact<{
  portfolioSlug: Scalars['String'];
}>;


export type GetPortfolioBySlugQuery = { __typename?: 'Query', userPortfolio?: { __typename?: 'UserPortfolio', id?: string | null, createdAt?: string | null, depositConnectedAt?: string | null, description?: string | null, name: string, slug?: string | null, updatedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, currency?: { __typename?: 'Currency', id: string, decimalPoint: number, symbol?: string | null, unit: string } | null } | null };

export type UserPortfolioFieldsFragment = { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null };

export type UserPortfolioItemsFieldsFragment = { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null };

export type CommonUserPortfolioItemsFieldsFragment = { __typename?: 'UserPortfolio', id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null };

export type SwitchPortfolioFieldsFragment = { __typename?: 'SwitchPortfolio', id: string, evaluationAmount: number, monthlyDividendAmount: number, previousDayEvaluationAmount: number, purchaseAmount: number, currency: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, supportedCurrencies: Array<{ __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }> };

export type UserPortfolioCommentFieldsFragment = { __typename?: 'UserPortfolioComment', id: string, comment: string, createdAt: string, updatedAt: string, user: { __typename?: 'User', description?: string | null, followersCount?: number | null, followingsCount?: number | null, id?: string | null, nickname?: string | null, profileImageUrl?: string | null, tags?: Array<string> | null, userStatus?: string | null, userStatusUpdatedAt?: string | null, chatRoomUrl?: string | null } };

export type CryptoExchangeFieldsFragment = { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null };

export type CryptoExchangeApiKeyFieldsFragment = { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } };

export type UploadPortfolioMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  baseCurrency?: InputMaybe<Scalars['String']>;
  dividendTaxRate?: InputMaybe<Scalars['Float']>;
  assets?: InputMaybe<Array<UploadCompanyAsset> | UploadCompanyAsset>;
}>;


export type UploadPortfolioMutation = { __typename?: 'Mutation', uploadPortfolio?: { __typename?: 'UploadPortfolioPayload', items: Array<{ __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null }> } | null };

export type UpdatePortfolioInformationMutationVariables = Exact<{
  portfolioId: Scalars['ID'];
  portfolioName?: InputMaybe<Scalars['String']>;
  portfolioDescription?: InputMaybe<Scalars['String']>;
  baseCurrency?: InputMaybe<Scalars['String']>;
  dividendTaxRate?: InputMaybe<Scalars['Float']>;
}>;


export type UpdatePortfolioInformationMutation = { __typename?: 'Mutation', updatePortfolioInformation?: { __typename?: 'UpdatePortfolioInformationPayload', portfolio: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } } | null };

export type UpdateSwitchPortfolioMutationVariables = Exact<{
  switchPortfolioCurrencyId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateSwitchPortfolioMutation = { __typename?: 'Mutation', updateSwitchPortfolio?: { __typename?: 'UpdateSwitchPortfolioPayload', switchPortfolio: { __typename?: 'SwitchPortfolio', id: string, evaluationAmount: number, monthlyDividendAmount: number, previousDayEvaluationAmount: number, purchaseAmount: number, currency: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, supportedCurrencies: Array<{ __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }> } } | null };

export type UpdatePortfolioSwitchOnMutationVariables = Exact<{
  portfolioId: Scalars['ID'];
  portfolioSwitchOn: Scalars['Boolean'];
}>;


export type UpdatePortfolioSwitchOnMutation = { __typename?: 'Mutation', updatePortfolioSwitchOn?: { __typename?: 'UpdatePortfolioSwitchOnPayload', portfolio: { __typename?: 'UserPortfolio', id?: string | null, portfolioSwitchOn?: boolean | null }, switchPortfolio: { __typename?: 'SwitchPortfolio', id: string, evaluationAmount: number, monthlyDividendAmount: number, previousDayEvaluationAmount: number, purchaseAmount: number, currency: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, supportedCurrencies: Array<{ __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }> } } | null };

export type UpdatePortfolioOrderScoresMutationVariables = Exact<{
  portfolioOrderScores: Array<PortfolioOrderScoresInput> | PortfolioOrderScoresInput;
}>;


export type UpdatePortfolioOrderScoresMutation = { __typename?: 'Mutation', updatePortfolioOrderScores?: { __typename?: 'UpdatePortfolioOrderScoresPayload', portfolios: Array<{ __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null }> } | null };

export type RemovePortfolioMutationVariables = Exact<{
  portfolioId: Scalars['ID'];
}>;


export type RemovePortfolioMutation = { __typename?: 'Mutation', removePortfolio?: { __typename?: 'RemovePortfolioPayload', items: Array<{ __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null }> } | null };

export type EnableSharingPortfolioMutationVariables = Exact<{
  portfolioSlug: Scalars['ID'];
}>;


export type EnableSharingPortfolioMutation = { __typename?: 'Mutation', enableSharingPortfolio?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null };

export type DisableSharingPortfolioMutationVariables = Exact<{
  portfolioSlug: Scalars['String'];
}>;


export type DisableSharingPortfolioMutation = { __typename?: 'Mutation', disableSharingPortfolio?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null };

export type PostUserPortfolioCommentMutationVariables = Exact<{
  portfolioSlug: Scalars['String'];
  comment: Scalars['String'];
}>;


export type PostUserPortfolioCommentMutation = { __typename?: 'Mutation', postUserPortfolioComment?: { __typename?: 'PostUserPortfolioCommentPayload', comment: { __typename?: 'UserPortfolioComment', id: string, comment: string, createdAt: string, updatedAt: string, user: { __typename?: 'User', description?: string | null, followersCount?: number | null, followingsCount?: number | null, id?: string | null, nickname?: string | null, profileImageUrl?: string | null, tags?: Array<string> | null, userStatus?: string | null, userStatusUpdatedAt?: string | null, chatRoomUrl?: string | null } } } | null };

export type DeleteUserPortfolioCommentMutationVariables = Exact<{
  portfolioSlug: Scalars['String'];
  commentId: Scalars['ID'];
}>;


export type DeleteUserPortfolioCommentMutation = { __typename?: 'Mutation', deleteUserPortfolioComment?: { __typename?: 'DeleteUserPortfolioCommentPayload', comment: { __typename?: 'UserPortfolioComment', id: string, comment: string, createdAt: string, updatedAt: string, user: { __typename?: 'User', description?: string | null, followersCount?: number | null, followingsCount?: number | null, id?: string | null, nickname?: string | null, profileImageUrl?: string | null, tags?: Array<string> | null, userStatus?: string | null, userStatusUpdatedAt?: string | null, chatRoomUrl?: string | null } }, portfolioComments: Array<{ __typename?: 'UserPortfolioComment', id: string, comment: string, createdAt: string, updatedAt: string, user: { __typename?: 'User', description?: string | null, followersCount?: number | null, followingsCount?: number | null, id?: string | null, nickname?: string | null, profileImageUrl?: string | null, tags?: Array<string> | null, userStatus?: string | null, userStatusUpdatedAt?: string | null, chatRoomUrl?: string | null } }> } | null };

export type RemoveSecuritiesAccountFromPortfolioMutationVariables = Exact<{
  portfolioSlug: Scalars['String'];
}>;


export type RemoveSecuritiesAccountFromPortfolioMutation = { __typename?: 'Mutation', removeSecuritiesAccountFromPortfolio?: { __typename?: 'RemoveSecuritiesAccountFromPortfolioPayload', portfolio: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } } | null };

export type AddCryptoExchangeApiKeyToUserMutationVariables = Exact<{
  cryptoExchangeId: Scalars['ID'];
  base64EncryptedAccessKey: Scalars['String'];
  base64EncryptedSecretKey?: InputMaybe<Scalars['String']>;
}>;


export type AddCryptoExchangeApiKeyToUserMutation = { __typename?: 'Mutation', addCryptoExchangeApiKeyToUser?: { __typename?: 'AddCryptoExchangeApiKeyToUserPayload', cryptoExchangeApiKey: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } } | null };

export type RemoveCryptoExchangeApiKeyFromUserMutationVariables = Exact<{
  cryptoExchangeApiKeyId: Scalars['ID'];
}>;


export type RemoveCryptoExchangeApiKeyFromUserMutation = { __typename?: 'Mutation', removeCryptoExchangeApiKeyFromUser?: { __typename?: 'RemoveCryptoExchangeApiKeyFromUserPayload', errors?: Array<string> | null, cryptoExchangeApiKey: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } } | null };

export type CreatePortfolioFromCryptoExchangeApiKeyMutationVariables = Exact<{
  cryptoExchangeApiKeyId: Scalars['ID'];
  portfolioName: Scalars['String'];
}>;


export type CreatePortfolioFromCryptoExchangeApiKeyMutation = { __typename?: 'Mutation', createPortfolioFromCryptoExchangeApiKey?: { __typename?: 'CreatePortfolioFromCryptoExchangeApiKeyPayload', userPortfolio?: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } | null } | null };

export type UpdatePortfolioFromCryptoExchangeApiKeyMutationVariables = Exact<{
  userPortfolioSlug: Scalars['String'];
}>;


export type UpdatePortfolioFromCryptoExchangeApiKeyMutation = { __typename?: 'Mutation', updatePortfolioFromCryptoExchangeApiKey?: { __typename?: 'UpdatePortfolioFromCryptoExchangeApiKeyPayload', errors?: Array<string> | null, userPortfolio?: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } | null } | null };

export type RemoveCryptoExchangeApiKeyFromPortfolioMutationVariables = Exact<{
  userPortfolioSlug: Scalars['String'];
}>;


export type RemoveCryptoExchangeApiKeyFromPortfolioMutation = { __typename?: 'Mutation', removeCryptoExchangeApiKeyFromPortfolio?: { __typename?: 'RemoveCryptoExchangeApiKeyFromPortfolioPayload', userPortfolio?: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } | null } | null };

export type CreatePlaidLinkTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreatePlaidLinkTokenMutation = { __typename?: 'Mutation', createPlaidLinkToken?: { __typename?: 'CreatePlaidLinkTokenPayload', linkToken?: string | null } | null };

export type CreatePortfolioFromPlaidPublicTokenMutationVariables = Exact<{
  portfolioName: Scalars['String'];
  publicToken: Scalars['String'];
}>;


export type CreatePortfolioFromPlaidPublicTokenMutation = { __typename?: 'Mutation', createPortfolioFromPlaidPublicToken?: { __typename?: 'CreatePortfolioFromPlaidPublicTokenPayload', userPortfolio?: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } | null } | null };

export type UpdatePortfolioFromPlaidMutationVariables = Exact<{
  portfolioSlug: Scalars['String'];
  publicToken?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePortfolioFromPlaidMutation = { __typename?: 'Mutation', updatePortfolioFromPlaid?: { __typename?: 'UpdatePortfolioFromPlaidPayload', userPortfolio?: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } | null } | null };

export type RemovePlaidConnectFromPortfolioMutationVariables = Exact<{
  portfolioSlug: Scalars['String'];
}>;


export type RemovePlaidConnectFromPortfolioMutation = { __typename?: 'Mutation', removePlaidConnectFromPortfolio?: { __typename?: 'RemovePlaidConnectFromPortfolioPayload', userPortfolio?: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } | null } | null };

export type MyPortfoliosQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPortfoliosQuery = { __typename?: 'Query', myPortfolios: { __typename?: 'MyPortfolioItems', items?: Array<{ __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null }> | null } };

export type MyMetaPortfolioQueryVariables = Exact<{ [key: string]: never; }>;


export type MyMetaPortfolioQuery = { __typename?: 'Query', myMetaPortfolio: { __typename?: 'MyMetaPortfolio', switchPortfolio: { __typename?: 'SwitchPortfolio', id: string, evaluationAmount: number, monthlyDividendAmount: number, previousDayEvaluationAmount: number, purchaseAmount: number, currency: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, supportedCurrencies: Array<{ __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }> }, portfolios?: Array<{ __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null }> | null } };

export type MyMetaSwitchPortfolioCurrencyQueryVariables = Exact<{ [key: string]: never; }>;


export type MyMetaSwitchPortfolioCurrencyQuery = { __typename?: 'Query', myMetaPortfolio: { __typename?: 'MyMetaPortfolio', switchPortfolio: { __typename?: 'SwitchPortfolio', currency: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, supportedCurrencies: Array<{ __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }> } } };

export type UserPortfolioQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type UserPortfolioQuery = { __typename?: 'Query', userPortfolio?: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } | null };

export type PortfolioWithCommentsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PortfolioWithCommentsQuery = { __typename?: 'Query', userPortfolio?: { __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null } | null, userPortfolioComments: Array<{ __typename?: 'UserPortfolioComment', id: string, comment: string, createdAt: string, updatedAt: string, user: { __typename?: 'User', description?: string | null, followersCount?: number | null, followingsCount?: number | null, id?: string | null, nickname?: string | null, profileImageUrl?: string | null, tags?: Array<string> | null, userStatus?: string | null, userStatusUpdatedAt?: string | null, chatRoomUrl?: string | null } }> };

export type CombinedPortfolioWithExchangesQueryVariables = Exact<{
  slugs: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CombinedPortfolioWithExchangesQuery = { __typename?: 'Query', combineUserPortfolios?: Array<{ __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, assets: Array<{ __typename?: 'UserAsset', id: string, assetCategory: AssetCategory, amount?: string | null, avgPrice?: string | null, customTax?: string | null, customPrice?: string | null, name?: string | null, cryptoExchangeApiKeyId?: string | null, userPlaidId?: string | null, avgPriceCurrency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, companyAsset?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, currencyAsset?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, cryptoCurrencyAsset?: { __typename?: 'CryptoCurrencyAsset', base: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } }, counter: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } } | null, etcAsset?: { __typename?: 'EtcAsset', category?: string | null, imageUrl: string, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, etcCompanyAsset?: { __typename?: 'EtcCompanyAsset', id: string, category?: string | null, name: string, price?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null }>, portfolioLink?: { __typename?: 'PortfolioLink', linkUrl?: string | null, linkSharedAt?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null }> | null };

export type CryptoExchangesQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type CryptoExchangesQuery = { __typename?: 'Query', cryptoExchanges: Array<{ __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null }> };

export type CryptoExchangeApiKeysQueryVariables = Exact<{
  cryptoExchangeId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CryptoExchangeApiKeysQuery = { __typename?: 'Query', cryptoExchangeApiKeys: Array<{ __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } }> };

export type MySecurityQueryVariables = Exact<{ [key: string]: never; }>;


export type MySecurityQuery = { __typename?: 'Query', mySecurity: { __typename?: 'UserSecurity', passwordEncryptKey: string, updatedAtTimestamp: number } };

export type ProfessionalInvestorApplicantFieldsFragment = { __typename?: 'ProfessionalInvestorApplicant', createdAt: string, hasUserAgreeToPrivacyAgreement: boolean, id: string, name: string, phoneNumber: string, updatedAt: string, userId: string };

export type ProfessionalInvestorFieldsFragment = { __typename?: 'ProfessionalInvestor', certificateImageUrl: string, createdAt: string, id: string, isVerified: boolean, updatedAt: string, userId: string, verifiedAt?: string | null };

export type ApplyProfessionalInvestorMutationVariables = Exact<{
  answers: Array<ProfessionalInvestorAnswersInput> | ProfessionalInvestorAnswersInput;
  professionalInvestorApplicant: ProfessionalInvestorApplicantInput;
}>;


export type ApplyProfessionalInvestorMutation = { __typename?: 'Mutation', applyProfessionalInvestor?: { __typename?: 'ApplyProfessionalInvestorPayload', professionalInvestorApplicant: { __typename?: 'ProfessionalInvestorApplicant', createdAt: string, hasUserAgreeToPrivacyAgreement: boolean, id: string, name: string, phoneNumber: string, updatedAt: string, userId: string } } | null };

export type RequestProfessionalInvestorVerificationMutationVariables = Exact<{
  imageFile: Scalars['Upload'];
}>;


export type RequestProfessionalInvestorVerificationMutation = { __typename?: 'Mutation', requestProfessionalInvestorVerification?: { __typename?: 'RequestProfessionalInvestorVerificationPayload', professionalInvestor: { __typename?: 'ProfessionalInvestor', certificateImageUrl: string, createdAt: string, id: string, isVerified: boolean, updatedAt: string, userId: string, verifiedAt?: string | null } } | null };

export type ProfessionalInvestorApplyStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfessionalInvestorApplyStatusQuery = { __typename?: 'Query', professionalInvestorApplyStatus: { __typename?: 'ProfessionalInvestorApplyStatus', appliedAt?: string | null, isUserApplied: boolean, userId: string } };

export type ProfessionalInvestorBadgeApplyStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfessionalInvestorBadgeApplyStatusQuery = { __typename?: 'Query', professionalInvestorBadgeApplyStatus: { __typename?: 'ProfessionalInvestorApplyStatus', appliedAt?: string | null, isUserApplied: boolean, userId: string } };

export type ProfessionalInvestorBadgeAcquisitionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfessionalInvestorBadgeAcquisitionStatusQuery = { __typename?: 'Query', professionalInvestorBadgeAcquisitionStatus: { __typename?: 'ProfessionalInvestorBadgeAcquisitionStatus', badgeAcquiredAt?: string | null, isUserAcquiredBadge: boolean, userId: string } };

export type MyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileQuery = { __typename?: 'Query', myProfile?: { __typename?: 'MyProfile', id: string, nickname?: string | null, articleCommentsCount?: number | null, articlesCount?: number | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null };

export type SearchCompanyFieldsFragment = { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null };

export type ReportUnresolvedSymbolMutationVariables = Exact<{
  ticker: Scalars['String'];
  country: Scalars['String'];
}>;


export type ReportUnresolvedSymbolMutation = { __typename?: 'Mutation', reportUnresolvedSymbol?: { __typename?: 'ReportUnresolvedSymbolPayload', stockInfoErrorRequest: { __typename?: 'StockInfoErrorRequest', country: string, createdAt?: string | null, detail?: string | null, errorType: string, id: string, ticker: string, updatedAt?: string | null } } | null };

export type SearchCompanyQueryVariables = Exact<{
  keyword: Scalars['String'];
}>;


export type SearchCompanyQuery = { __typename?: 'Query', searchCompany?: Array<{ __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null }> | null };

export type UserCompanySectorFieldsFragment = { __typename?: 'UserCompanySector', id: string, company: { __typename?: 'Company', id: string }, companySector: { __typename?: 'CompanySector', id: string, name: string, companySectorName: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } };

export type CompanySectorFieldsFragment = { __typename?: 'CompanySector', id: string, name: string, companySectorName: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } };

export type UpdateMyCompanySectorMutationVariables = Exact<{
  companyId: Scalars['ID'];
  companySectorId: Scalars['ID'];
}>;


export type UpdateMyCompanySectorMutation = { __typename?: 'Mutation', updateMyCompanySector?: { __typename?: 'UpdateMyCompanySectorPayload', userCompanySector: { __typename?: 'UserCompanySector', id: string, company: { __typename?: 'Company', id: string }, companySector: { __typename?: 'CompanySector', id: string, name: string, companySectorName: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } } } | null };

export type SupportedCompanySectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportedCompanySectorsQuery = { __typename?: 'Query', supportedCompanySectors?: Array<{ __typename?: 'CompanySector', id: string, name: string, companySectorName: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null };

export type MyCompanySectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCompanySectorsQuery = { __typename?: 'Query', myCompanySectors: Array<{ __typename?: 'UserCompanySector', id: string, company: { __typename?: 'Company', id: string }, companySector: { __typename?: 'CompanySector', id: string, name: string, companySectorName: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } }> };

export type MbtiVisitorCounterFieldsFragment = { __typename?: 'MbtiVisitorCounter', todayVisitorCounter: { __typename?: 'VisitorCounter', category: string, createdAt: string, date?: string | null, id: string, language: string, name: string, updatedAt: string, viewCount: number }, totalVisitorCounter: { __typename?: 'VisitorCounter', category: string, createdAt: string, date?: string | null, id: string, language: string, name: string, updatedAt: string, viewCount: number } };

export type MbtiResultCounterFieldsFragment = { __typename?: 'MbtiResultCounter', count: number, id: string, mbtiType: string };

export type MbtiVisitorCounterQueryVariables = Exact<{
  language: Scalars['String'];
  category: Scalars['String'];
  name: Scalars['String'];
  date: Scalars['String'];
}>;


export type MbtiVisitorCounterQuery = { __typename?: 'Query', mbtiVisitorCounter: { __typename?: 'MbtiVisitorCounter', todayVisitorCounter: { __typename?: 'VisitorCounter', category: string, createdAt: string, date?: string | null, id: string, language: string, name: string, updatedAt: string, viewCount: number }, totalVisitorCounter: { __typename?: 'VisitorCounter', category: string, createdAt: string, date?: string | null, id: string, language: string, name: string, updatedAt: string, viewCount: number } } };

export type MbtiResultCounterQueryVariables = Exact<{
  mbtiType: Scalars['String'];
}>;


export type MbtiResultCounterQuery = { __typename?: 'Query', mbtiResultCounter: { __typename?: 'MbtiResultCounter', count: number, id: string, mbtiType: string } };

export type AuthTokenFieldsFragment = { __typename?: 'AuthToken', deviceRegistrationToken?: string | null, isNewUser?: boolean | null, nickname?: string | null, token: string };

export type UserPortfolioUserFieldsFragment = { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string };

export type UserAccountFieldsFragment = { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null };

export type UserFieldsFragment = { __typename?: 'User', description?: string | null, followersCount?: number | null, followingsCount?: number | null, id?: string | null, nickname?: string | null, profileImageUrl?: string | null, tags?: Array<string> | null, userStatus?: string | null, userStatusUpdatedAt?: string | null, chatRoomUrl?: string | null };

export type MyProfileFieldsFragment = { __typename?: 'MyProfile', id: string, nickname?: string | null, description?: string | null, followersCount?: number | null, followingsCount?: number | null, articleCommentsCount?: number | null, articlesCount?: number | null, profileImageUrl?: string | null, createdAt: string, updatedAt: string, userType?: string | null, chatRoomUrl?: string | null, investingKeywords?: Array<{ __typename?: 'InvestingKeyword', id: string, keyword: string, keywordCategory: string, language: string, referencedCount: number }> | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null };

export type UserSurveyFieldsFragment = { __typename?: 'UserSurvey', id?: string | null, surveyCategory?: string | null, surveyCount?: number | null, surveyResult?: string | null, createdAt?: string | null, updatedAt?: string | null };

export type InvestingKeywordFieldsFragment = { __typename?: 'InvestingKeyword', id: string, keyword: string, keywordCategory: string, language: string, referencedCount: number };

export type InvestingKeywordWithIsSelectedFieldsFragment = { __typename?: 'InvestingKeywordWithIsSelected', id: string, isSelected?: boolean | null, keyword: string, keywordCategory: string, language: string, referencedCount: number };

export type UserProfileFieldsFragment = { __typename?: 'UserProfile', articleCommentsCount?: number | null, articlesCount?: number | null, createdAt: string, description?: string | null, followersCount?: number | null, followingsCount?: number | null, id: string, isFollowing?: boolean | null, defaultFavoriteItemCategoryAddedAt?: string | null, nickname?: string | null, profileImageUrl?: string | null, updatedAt: string, userType?: string | null, followItemId?: string | null, chatRoomUrl?: string | null, portfolioAssetsCount?: number | null, favoriteItemsCount?: number | null, investingKeywords: Array<{ __typename?: 'InvestingKeyword', id: string, keyword: string, keywordCategory: string, language: string, referencedCount: number }> };

export type UserProfileOnlyCommunityFieldsFragment = { __typename?: 'UserProfile', id: string, followersCount?: number | null, followingsCount?: number | null, isFollowing?: boolean | null, followItemId?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null };

export type CommunityNotificationStatusFieldsFragment = { __typename?: 'CommunityNotificationStatus', hasUnconfirmedNotification: boolean, communityNotifications: Array<{ __typename?: 'CommunityNotification', id: string, hasConfirmed?: boolean | null, createdAt: string, notificationCategoryType: string, receiverUserId: string, content: { __typename?: 'CommunityNotificationContent', deeplinkUrl?: string | null, notificationMessage?: string | null, notificationMessageTemplate?: string | null, receiverArticleCommentId?: string | null, receiverArticleId?: string | null, senderArticleCommentId?: string | null }, sender: { __typename?: 'CommunityNotificationUser', nickname?: string | null, profileImageUrl?: string | null, userId: string } }> };

export type CommunityNotificationFieldsFragment = { __typename?: 'CommunityNotification', id: string, hasConfirmed?: boolean | null, createdAt: string, notificationCategoryType: string, receiverUserId: string, content: { __typename?: 'CommunityNotificationContent', deeplinkUrl?: string | null, notificationMessage?: string | null, notificationMessageTemplate?: string | null, receiverArticleCommentId?: string | null, receiverArticleId?: string | null, senderArticleCommentId?: string | null }, sender: { __typename?: 'CommunityNotificationUser', nickname?: string | null, profileImageUrl?: string | null, userId: string } };

export type CommunityNotificationContentFieldsFragment = { __typename?: 'CommunityNotificationContent', deeplinkUrl?: string | null, notificationMessage?: string | null, notificationMessageTemplate?: string | null, receiverArticleCommentId?: string | null, receiverArticleId?: string | null, senderArticleCommentId?: string | null };

export type UserVerificationFieldsFragment = { __typename?: 'UserVerification', email?: string | null, isEmailVerified?: boolean | null, isKrPhoneNumberVerified?: boolean | null, isPhoneNumberVerified?: boolean | null, phoneNumber?: string | null, stepOfEmailVerification?: string | null };

export type UserPhoneVerificationKrFieldsFragment = { __typename?: 'UserPhoneVerificationKr', clientRequestNumber?: string | null, phoneNumber?: string | null };

export type SignInMutationVariables = Exact<{
  authMethod: AuthMethod;
  accessToken?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  idToken?: InputMaybe<Scalars['String']>;
  authorizationCode?: InputMaybe<Scalars['String']>;
}>;


export type SignInMutation = { __typename?: 'Mutation', signIn?: { __typename?: 'AuthToken', deviceRegistrationToken?: string | null, isNewUser?: boolean | null, nickname?: string | null, token: string } | null };

export type UpdateMyProfileMutationVariables = Exact<{
  profile: UpdateUserProfile;
}>;


export type UpdateMyProfileMutation = { __typename?: 'Mutation', updateMyProfile?: { __typename?: 'UpdateMyProfilePayload', user: { __typename?: 'UserProfile', articleCommentsCount?: number | null, articlesCount?: number | null, createdAt: string, description?: string | null, followersCount?: number | null, followingsCount?: number | null, id: string, isFollowing?: boolean | null, defaultFavoriteItemCategoryAddedAt?: string | null, nickname?: string | null, profileImageUrl?: string | null, updatedAt: string, userType?: string | null, followItemId?: string | null, chatRoomUrl?: string | null, portfolioAssetsCount?: number | null, favoriteItemsCount?: number | null, investingKeywords: Array<{ __typename?: 'InvestingKeyword', id: string, keyword: string, keywordCategory: string, language: string, referencedCount: number }> } } | null };

export type RequestTerminateUserMembershipMutationVariables = Exact<{
  reason: Scalars['String'];
}>;


export type RequestTerminateUserMembershipMutation = { __typename?: 'Mutation', requestTerminateUserMembership?: { __typename?: 'UserMembership', id: string, reason: string } | null };

export type UpdateUserSurveyMutationVariables = Exact<{
  surveyCategory: Scalars['String'];
  surveyResult: Scalars['String'];
}>;


export type UpdateUserSurveyMutation = { __typename?: 'Mutation', updateUserSurvey?: { __typename?: 'UserSurvey', id?: string | null, surveyCategory?: string | null, surveyCount?: number | null, surveyResult?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type ConfirmTokenToVerifyEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ConfirmTokenToVerifyEmailMutation = { __typename?: 'Mutation', confirmTokenToVerifyEmail?: { __typename?: 'EmailVerification', emailVerifiedAt?: string | null } | null };

export type DenyTokenToVerifyEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type DenyTokenToVerifyEmailMutation = { __typename?: 'Mutation', denyTokenToVerifyEmail?: { __typename?: 'EmailVerification', emailVerifiedAt?: string | null } | null };

export type SendEmailToVerifyEmailMutationVariables = Exact<{
  email: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
}>;


export type SendEmailToVerifyEmailMutation = { __typename?: 'Mutation', sendEmailToVerifyEmail?: { __typename?: 'EmailVerification', email?: string | null } | null };

export type UpdateSignInSessionMutationVariables = Exact<{
  deviceRegistrationToken?: InputMaybe<Scalars['String']>;
  appVersion?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  communityLanguage?: InputMaybe<Scalars['String']>;
}>;


export type UpdateSignInSessionMutation = { __typename?: 'Mutation', updateSignInSession?: { __typename?: 'AuthToken', deviceRegistrationToken?: string | null, isNewUser?: boolean | null, nickname?: string | null, token: string } | null };

export type RequestUserPhoneVerificationToKrTelecomMutationVariables = Exact<{
  name: Scalars['String'];
  birthDate: Scalars['String'];
  genderNumber: Scalars['String'];
  telecomType: Scalars['String'];
  phoneNumber: Scalars['String'];
}>;


export type RequestUserPhoneVerificationToKrTelecomMutation = { __typename?: 'Mutation', requestUserPhoneVerificationToKrTelecom?: { __typename?: 'RequestUserPhoneVerificationToKrTelecomPayload', userPhoneVerificationKr?: { __typename?: 'UserPhoneVerificationKr', clientRequestNumber?: string | null, phoneNumber?: string | null } | null } | null };

export type VerifyUserPhoneVerificationFromKrTelecomMutationVariables = Exact<{
  clientRequestNumber: Scalars['String'];
  authNumber: Scalars['String'];
}>;


export type VerifyUserPhoneVerificationFromKrTelecomMutation = { __typename?: 'Mutation', verifyUserPhoneVerificationFromKrTelecom?: { __typename?: 'VerifyUserPhoneVerificationFromKrTelecomPayload', userPhoneVerificationKr?: { __typename?: 'UserPhoneVerificationKr', clientRequestNumber?: string | null, phoneNumber?: string | null } | null } | null };

export type MyProfileWithServeyAndVerificationQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileWithServeyAndVerificationQuery = { __typename?: 'Query', myProfile?: { __typename?: 'MyProfile', id: string, nickname?: string | null, description?: string | null, followersCount?: number | null, followingsCount?: number | null, articleCommentsCount?: number | null, articlesCount?: number | null, profileImageUrl?: string | null, createdAt: string, updatedAt: string, userType?: string | null, chatRoomUrl?: string | null, investingKeywords?: Array<{ __typename?: 'InvestingKeyword', id: string, keyword: string, keywordCategory: string, language: string, referencedCount: number }> | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, userSurvey: Array<{ __typename?: 'UserSurvey', id?: string | null, surveyCategory?: string | null, surveyCount?: number | null, surveyResult?: string | null, createdAt?: string | null, updatedAt?: string | null }>, userVerification?: { __typename?: 'UserVerification', email?: string | null, isEmailVerified?: boolean | null, isKrPhoneNumberVerified?: boolean | null, isPhoneNumberVerified?: boolean | null, phoneNumber?: string | null, stepOfEmailVerification?: string | null } | null };

export type UserProfileQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UserProfileQuery = { __typename?: 'Query', userProfile?: { __typename?: 'UserProfile', articleCommentsCount?: number | null, articlesCount?: number | null, createdAt: string, description?: string | null, followersCount?: number | null, followingsCount?: number | null, id: string, isFollowing?: boolean | null, defaultFavoriteItemCategoryAddedAt?: string | null, nickname?: string | null, profileImageUrl?: string | null, updatedAt: string, userType?: string | null, followItemId?: string | null, chatRoomUrl?: string | null, portfolioAssetsCount?: number | null, favoriteItemsCount?: number | null, investingKeywords: Array<{ __typename?: 'InvestingKeyword', id: string, keyword: string, keywordCategory: string, language: string, referencedCount: number }> } | null };

export type UserProfileOnlyCommunityQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UserProfileOnlyCommunityQuery = { __typename?: 'Query', userProfile?: { __typename?: 'UserProfile', id: string, followersCount?: number | null, followingsCount?: number | null, isFollowing?: boolean | null, followItemId?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null };

export type UserVerificationQueryVariables = Exact<{ [key: string]: never; }>;


export type UserVerificationQuery = { __typename?: 'Query', userVerification?: { __typename?: 'UserVerification', email?: string | null, isEmailVerified?: boolean | null, isKrPhoneNumberVerified?: boolean | null, isPhoneNumberVerified?: boolean | null, phoneNumber?: string | null, stepOfEmailVerification?: string | null } | null };

export type MyCommunityNotificationsWithLanguageQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type MyCommunityNotificationsWithLanguageQuery = { __typename?: 'Query', myCommunityNotifications?: { __typename?: 'CommunityNotificationStatus', hasUnconfirmedNotification: boolean, communityNotifications: Array<{ __typename?: 'CommunityNotification', id: string, hasConfirmed?: boolean | null, createdAt: string, notificationCategoryType: string, receiverUserId: string, content: { __typename?: 'CommunityNotificationContent', deeplinkUrl?: string | null, notificationMessage?: string | null, notificationMessageTemplate?: string | null, receiverArticleCommentId?: string | null, receiverArticleId?: string | null, senderArticleCommentId?: string | null }, sender: { __typename?: 'CommunityNotificationUser', nickname?: string | null, profileImageUrl?: string | null, userId: string } }> } | null };

export type MyInvestingKeywordsQueryVariables = Exact<{
  language: Scalars['String'];
}>;


export type MyInvestingKeywordsQuery = { __typename?: 'Query', myInvestingKeywords: Array<{ __typename?: 'InvestingKeywordWithIsSelected', id: string, isSelected?: boolean | null, keyword: string, keywordCategory: string, language: string, referencedCount: number }> };

export type UserArticlesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
  language: Scalars['String'];
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
}>;


export type UserArticlesQuery = { __typename?: 'Query', userArticles?: Array<{ __typename?: 'Article', id: string, title?: string | null, language: string, userId: string, commentsCount?: number | null, isBookmarked: boolean, isLiked: boolean, likesCount?: number | null, portfolioTopicIds?: Array<string> | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, dynamicLinkUrl?: string | null, feedTopic?: { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | null, content: Array<{ __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } } | { __typename?: 'ArticleContentBackTestingProject' } | { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } } | { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } } | { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } } | { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, assetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null, portfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null }> | null };

export type MyArticlesQueryVariables = Exact<{
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
}>;


export type MyArticlesQuery = { __typename?: 'Query', myArticles: Array<{ __typename?: 'Article', id: string, title?: string | null, language: string, userId: string, commentsCount?: number | null, isBookmarked: boolean, isLiked: boolean, likesCount?: number | null, portfolioTopicIds?: Array<string> | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, dynamicLinkUrl?: string | null, feedTopic?: { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | null, content: Array<{ __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } } | { __typename?: 'ArticleContentBackTestingProject' } | { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } } | { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } } | { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } } | { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, assetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null, portfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null }> };

export type MyCommentedArticlesQueryVariables = Exact<{
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
}>;


export type MyCommentedArticlesQuery = { __typename?: 'Query', myCommentedArticles: Array<{ __typename?: 'Article', id: string, title?: string | null, language: string, userId: string, commentsCount?: number | null, isBookmarked: boolean, isLiked: boolean, likesCount?: number | null, portfolioTopicIds?: Array<string> | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, dynamicLinkUrl?: string | null, feedTopic?: { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | null, content: Array<{ __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } } | { __typename?: 'ArticleContentBackTestingProject' } | { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } } | { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } } | { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } } | { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, assetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null, portfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null }> };

export type MyBookmarkedArticlesQueryVariables = Exact<{
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
}>;


export type MyBookmarkedArticlesQuery = { __typename?: 'Query', myBookmarkedArticles: Array<{ __typename?: 'Article', id: string, title?: string | null, language: string, userId: string, commentsCount?: number | null, isBookmarked: boolean, isLiked: boolean, likesCount?: number | null, portfolioTopicIds?: Array<string> | null, createdAt: string, updatedAt: string, deletedAt?: string | null, deletedBy?: DeletedBy | null, dynamicLinkUrl?: string | null, feedTopic?: { __typename?: 'FeedTopic', id: string, feedTopicType?: string | null, name?: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } | null } | null, content: Array<{ __typename?: 'ArticleContentAsset', categoryType: string, content: { __typename?: 'ArticleContentAssetContent', asset: { __typename?: 'SearchCompany', categoryType?: string | null, country?: string | null, decimalPoint?: number | null, exchange?: string | null, id: string, imageUrl?: string | null, name?: string | null, subExchange?: string | null, ticker?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null } | null } } } | { __typename?: 'ArticleContentBackTestingProject' } | { __typename?: 'ArticleContentImage', categoryType: string, content: { __typename?: 'ArticleContentImageContent', imageUrl: string } } | { __typename?: 'ArticleContentOgTag', categoryType: string, content: { __typename?: 'ArticleContentOgTagContent', ogDescription?: string | null, ogImageUrl?: string | null, ogTitle?: string | null, url?: string | null } } | { __typename?: 'ArticleContentPortfolio', categoryType: string, content: { __typename?: 'ArticleContentPortfolioContent', imageUrl: string, name?: string | null, portfolioLink?: string | null, slug: string, slugs?: Array<string> | null, baseCurrencySymbol?: string | null, evaluationAmount?: number | null, purchaseAmount?: number | null, hasPortfolioAccessEnabled?: boolean | null, revenueVerifiedAt?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, unit: string, decimalPoint: number } | null } } | { __typename?: 'ArticleContentText', categoryType: string, content: { __typename?: 'ArticleContentTextContent', subTextComponents: Array<{ __typename?: 'ArticleContentTextSubTextComponentCrypto', assetTagId: string, componentType: string, cryptoCurrencyId: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentStock', assetTagId: string, companyId: string, componentType: string, country: string, ticker: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } } | { __typename?: 'ArticleContentTextSubTextComponentText', componentType: string, text: string } | { __typename?: 'ArticleContentTextSubTextComponentUser', componentType: string, userId: string, nickname: string }> } }>, communityUser: { __typename?: 'CommunityUser', id?: string | null, nickname?: string | null, description?: string | null, profileImageUrl?: string | null, userType?: string | null, representativeBadge?: { __typename?: 'Badge', deeplinkUrl?: string | null, dimmedImageUrl: string, id: string, imageUrl: string, isAcquired: boolean, isRepresentativeBadge: boolean, isAcquireConditionAchieved: boolean, supportedLanguages: Array<string>, verificationUrl?: string | null, acquireCondition?: { __typename?: 'BadgeAcquireCondition', id: string, requiredValue: number, type: string, achievementStatusMessages: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, category: { __typename?: 'BadgeCategory', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, descriptions: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, level: { __typename?: 'BadgeLevel', id: string, name: string, names?: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } | null }, names: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }, assetTags?: Array<{ __typename?: 'AssetTag', categoryType: string, companyId?: string | null, cryptoCurrencyId?: string | null, id: string, imageUrl?: string | null, name: string, relativeSearchKeywords?: Array<string> | null, symbol: string }> | null, portfolioTopics?: Array<{ __typename?: 'PortfolioTopic', id: string, isCustomTopic?: boolean | null, selectedCount?: number | null, topicName: string, name: { __typename?: 'LanguageString', en?: string | null, ko?: string | null } }> | null }> };

export type MyPublicFavoriteItemCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPublicFavoriteItemCategoriesQuery = { __typename?: 'Query', myPublicFavorites: { __typename?: 'MyPublicFavoriteItemCategories', publicFavoritesCount: number, favoritesCount: number, favorites: Array<{ __typename?: 'FavoriteItemCategory', id?: string | null, slug?: string | null, slugSharedAt?: string | null, categoryName?: string | null, createdAt?: string | null, updatedAt?: string | null, orderScore?: number | null }> } };

export type UserPublicPortfoliosQueryVariables = Exact<{
  userId: Scalars['ID'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
}>;


export type UserPublicPortfoliosQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null }> };

export type MyPublicPortfoliosQueryVariables = Exact<{
  limit: Scalars['Int'];
  page: Scalars['Int'];
}>;


export type MyPublicPortfoliosQuery = { __typename?: 'Query', myPublicPortfolios: { __typename?: 'MyPublicPortfolios', myPublicPortfoliosCount: number, totalUserPortfoliosCount: number, portfolios: Array<{ __typename?: 'UserPortfolio', portfolioSwitchOn?: boolean | null, evaluationAmount?: number | null, purchaseAmount?: number | null, id?: string | null, slug?: string | null, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, dividendTaxRate?: number | null, userAccountAssetsNextUpdatedAt?: string | null, userAccountAssetsUpdatedAt?: string | null, userAccountConnectedAt?: string | null, cryptoExchangeApiKeyConnectedAt?: string | null, cryptoExchangeApiKeyId?: string | null, slugSharedAt?: string | null, userPlaidConnectedAt?: string | null, userPlaidId?: string | null, kbSecUserAccountConnectedAt?: string | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, user: { __typename?: 'UserPortfolioUser', id?: string | null, nickname: string }, userAccount?: { __typename?: 'UserAccount', id?: string | null, accountDisplayNumber?: string | null, accountName?: string | null, accountNumber?: string | null, isAccountPasswordRequired?: boolean | null, organization?: { __typename?: 'Organization', id: string, code?: string | null, name?: string | null, imageUrl?: string | null } | null } | null, cryptoExchangeApiKey?: { __typename?: 'CryptoExchangeApiKey', id: string, accessKey: string, createdAt: string, cryptoExchange: { __typename?: 'CryptoExchange', accessKeyName?: string | null, hasAvgPriceFilled: boolean, id: string, isEnabled: boolean, logoImageUrl?: string | null, name: string, secretKeyName?: string | null } } | null }> } };

export type UserPublicFavoriteItemCategoriesQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UserPublicFavoriteItemCategoriesQuery = { __typename?: 'Query', favorites?: Array<{ __typename?: 'FavoriteItemCategory', id?: string | null, slug?: string | null, slugSharedAt?: string | null, categoryName?: string | null, createdAt?: string | null, updatedAt?: string | null, orderScore?: number | null }> | null };

export type PublicFavoriteItemsQueryVariables = Exact<{
  favoriteItemCategoryId: Scalars['ID'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
}>;


export type PublicFavoriteItemsQuery = { __typename?: 'Query', publicFavoriteItems: Array<{ __typename?: 'FavoriteItem', id?: string | null, itemCategory?: ItemCategory | null, company?: { __typename?: 'Company', id: string, isExist?: boolean | null, logoUrl?: string | null, name?: string | null, base?: string | null, baseSymbol?: string | null, ticker?: string | null, country?: string | null, sector?: string | null, paymentMonths?: Array<number> | null, exDividendMonths?: Array<number> | null, exchange?: string | null, industry?: string | null, listDate?: string | null, needTtm?: boolean | null, securityGroup?: string | null, subExchange?: string | null, symbol?: string | null, assetTagId?: string | null, lastYearRegularDividendAmount?: number | null, latestRegularDividendAmount?: number | null, companyName: { __typename?: 'LanguageString', ko?: string | null, en?: string | null }, stockPrice?: { __typename?: 'StockPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, ticker?: string | null, updatedAt?: string | null } | null, companyPrice?: { __typename?: 'CompanyPrice', id?: string | null, price?: string | null, priceChangePercent?: string | null, priceUpdatedAt?: string | null, ticker?: string | null } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null } | null, cryptoCurrency?: { __typename?: 'CryptoCurrency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, assetTagId?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null, currency?: { __typename?: 'Currency', id: string, imageUrl: string, symbol?: string | null, unit: string, decimalPoint: number, currencyType?: string | null, name: { __typename?: 'LanguageString', ko?: string | null, en?: string | null } } | null }> };

export const InvestingInsightTagFieldsFragmentDoc = gql`
    fragment InvestingInsightTagFields on InvestingInsightTag {
  id
  names {
    ko
    en
  }
  sortId
}
    `;
export const InvestingInsightFieldsFragmentDoc = gql`
    fragment InvestingInsightFields on InvestingInsight {
  id
  body
  creator {
    nickname
    userId
  }
  dynamicLinkUrl
  originalUrl
  platform {
    id
    imageUrl
    name
    names {
      en
      ko
    }
  }
  thumbnailImageUrl
  title
}
    `;
export const AdContentFieldsFragmentDoc = gql`
    fragment AdContentFields on AdContent {
  contentType
  contentUrl
  id
  name
}
    `;
export const AdFieldsFragmentDoc = gql`
    fragment AdFields on Ad {
  id
  adClickCount
  adClickUrl
  adContent {
    ...AdContentFields
  }
  adDescription
  adExposureCount
  adFinishTime
  adLocales
  adStartTime
  adStatus
  adSupportedPlatform
  adTitle
  doNotShowUntil
}
    ${AdContentFieldsFragmentDoc}`;
export const AgreementFieldsFragmentDoc = gql`
    fragment AgreementFields on Agreement {
  contentEn
  contentKo
  createdAt
  id
  isRequired
  titleEn
  titleKo
  updatedAt
}
    `;
export const UserAgreementFieldsFragmentDoc = gql`
    fragment UserAgreementFields on UserAgreement {
  agreement {
    ...AgreementFields
  }
  createdAt
  id
  updatedAt
}
    ${AgreementFieldsFragmentDoc}`;
export const UserAgreementItemFieldsFragmentDoc = gql`
    fragment UserAgreementItemFields on UserAgreementItem {
  latestAgreement {
    ...AgreementFields
  }
  latestUserAgreement {
    ...UserAgreementFields
  }
}
    ${AgreementFieldsFragmentDoc}
${UserAgreementFieldsFragmentDoc}`;
export const UserAgreementStatusFieldsFragmentDoc = gql`
    fragment UserAgreementStatusFields on UserAgreementStatus {
  marketing {
    ...UserAgreementItemFields
  }
  privacy {
    ...UserAgreementItemFields
  }
  terms {
    ...UserAgreementItemFields
  }
}
    ${UserAgreementItemFieldsFragmentDoc}`;
export const LatestAgreementsFieldsFragmentDoc = gql`
    fragment LatestAgreementsFields on LatestAgreements {
  marketing {
    ...AgreementFields
  }
  privacy {
    ...AgreementFields
  }
  terms {
    ...AgreementFields
  }
}
    ${AgreementFieldsFragmentDoc}`;
export const CounterCurrencyFieldsFragmentDoc = gql`
    fragment CounterCurrencyFields on CounterCurrency {
  symbol
  unit
}
    `;
export const AssetTagTitleFieldsFragmentDoc = gql`
    fragment AssetTagTitleFields on AssetTagTitle {
  categoryType
  companyId
  country
  cryptoCurrencyId
  id
  name
  price
  priceChangePercent
  symbol
  isFollowing
  userFollowingId
  counterCurrency {
    ...CounterCurrencyFields
  }
}
    ${CounterCurrencyFieldsFragmentDoc}`;
export const FeedTopicFieldsFragmentDoc = gql`
    fragment FeedTopicFields on FeedTopic {
  id
  feedTopicType
  name {
    en
    ko
  }
}
    `;
export const SearchCompanyFieldsFragmentDoc = gql`
    fragment SearchCompanyFields on SearchCompany {
  categoryType
  country
  decimalPoint
  exchange
  id
  imageUrl
  name
  subExchange
  ticker
  currency {
    id
    imageUrl
    symbol
    unit
    decimalPoint
    currencyType
  }
}
    `;
export const ArticleContentAssetContentFieldsFragmentDoc = gql`
    fragment ArticleContentAssetContentFields on ArticleContentAssetContent {
  asset {
    ...SearchCompanyFields
  }
}
    ${SearchCompanyFieldsFragmentDoc}`;
export const ArticleContentAssetFieldsFragmentDoc = gql`
    fragment ArticleContentAssetFields on ArticleContentAsset {
  categoryType
  content {
    ...ArticleContentAssetContentFields
  }
}
    ${ArticleContentAssetContentFieldsFragmentDoc}`;
export const ArticleContentPortfolioContentFieldsFragmentDoc = gql`
    fragment ArticleContentPortfolioContentFields on ArticleContentPortfolioContent {
  imageUrl
  name
  portfolioLink
  slug
  slugs
  baseCurrencySymbol
  evaluationAmount
  purchaseAmount
  currency {
    symbol
    unit
    decimalPoint
  }
  hasPortfolioAccessEnabled
  revenueVerifiedAt
}
    `;
export const ArticleContentPortfolioFieldsFragmentDoc = gql`
    fragment ArticleContentPortfolioFields on ArticleContentPortfolio {
  categoryType
  content {
    ...ArticleContentPortfolioContentFields
  }
}
    ${ArticleContentPortfolioContentFieldsFragmentDoc}`;
export const ArticleContentTextSubTextComponentCryptoFieldsFragmentDoc = gql`
    fragment ArticleContentTextSubTextComponentCryptoFields on ArticleContentTextSubTextComponentCrypto {
  assetTagId
  componentType
  cryptoCurrencyId
  name {
    en
    ko
  }
}
    `;
export const ArticleContentTextSubTextComponentStockFieldsFragmentDoc = gql`
    fragment ArticleContentTextSubTextComponentStockFields on ArticleContentTextSubTextComponentStock {
  assetTagId
  companyId
  componentType
  country
  ticker
  name {
    en
    ko
  }
}
    `;
export const ArticleContentTextSubTextComponentTextFieldsFragmentDoc = gql`
    fragment ArticleContentTextSubTextComponentTextFields on ArticleContentTextSubTextComponentText {
  componentType
  text
}
    `;
export const ArticleContentTextSubTextComponentUserFieldsFragmentDoc = gql`
    fragment ArticleContentTextSubTextComponentUserFields on ArticleContentTextSubTextComponentUser {
  componentType
  userId
  nickname
}
    `;
export const ArticleContentSubTextComponentFieldsFragmentDoc = gql`
    fragment ArticleContentSubTextComponentFields on ArticleContentSubTextComponent {
  ... on ArticleContentTextSubTextComponentCrypto {
    ...ArticleContentTextSubTextComponentCryptoFields
  }
  ... on ArticleContentTextSubTextComponentStock {
    ...ArticleContentTextSubTextComponentStockFields
  }
  ... on ArticleContentTextSubTextComponentText {
    ...ArticleContentTextSubTextComponentTextFields
  }
  ... on ArticleContentTextSubTextComponentUser {
    ...ArticleContentTextSubTextComponentUserFields
  }
}
    ${ArticleContentTextSubTextComponentCryptoFieldsFragmentDoc}
${ArticleContentTextSubTextComponentStockFieldsFragmentDoc}
${ArticleContentTextSubTextComponentTextFieldsFragmentDoc}
${ArticleContentTextSubTextComponentUserFieldsFragmentDoc}`;
export const ArticleContentTextFieldsFragmentDoc = gql`
    fragment ArticleContentTextFields on ArticleContentText {
  categoryType
  content {
    subTextComponents {
      ...ArticleContentSubTextComponentFields
    }
  }
}
    ${ArticleContentSubTextComponentFieldsFragmentDoc}`;
export const ArticleContentImageContentFieldsFragmentDoc = gql`
    fragment ArticleContentImageContentFields on ArticleContentImageContent {
  imageUrl
}
    `;
export const ArticleContentImageFieldsFragmentDoc = gql`
    fragment ArticleContentImageFields on ArticleContentImage {
  categoryType
  content {
    ...ArticleContentImageContentFields
  }
}
    ${ArticleContentImageContentFieldsFragmentDoc}`;
export const ArticleContentOgTagFieldsFragmentDoc = gql`
    fragment ArticleContentOgTagFields on ArticleContentOgTag {
  categoryType
  content {
    ogDescription
    ogImageUrl
    ogTitle
    url
  }
}
    `;
export const ArticleContentFieldsFragmentDoc = gql`
    fragment ArticleContentFields on ArticleContent {
  ... on ArticleContentAsset {
    ...ArticleContentAssetFields
  }
  ... on ArticleContentPortfolio {
    ...ArticleContentPortfolioFields
  }
  ... on ArticleContentText {
    ...ArticleContentTextFields
  }
  ... on ArticleContentImage {
    ...ArticleContentImageFields
  }
  ... on ArticleContentOgTag {
    ...ArticleContentOgTagFields
  }
}
    ${ArticleContentAssetFieldsFragmentDoc}
${ArticleContentPortfolioFieldsFragmentDoc}
${ArticleContentTextFieldsFragmentDoc}
${ArticleContentImageFieldsFragmentDoc}
${ArticleContentOgTagFieldsFragmentDoc}`;
export const BadgeFieldsFragmentDoc = gql`
    fragment BadgeFields on Badge {
  acquireCondition {
    id
    achievementStatusMessages {
      ko
      en
    }
    requiredValue
    type
  }
  category {
    id
    names {
      ko
      en
    }
    name
  }
  deeplinkUrl
  descriptions {
    ko
    en
  }
  dimmedImageUrl
  id
  imageUrl
  isAcquired
  isRepresentativeBadge
  isAcquireConditionAchieved
  level {
    id
    names {
      ko
      en
    }
    name
  }
  names {
    ko
    en
  }
  supportedLanguages
  verificationUrl
}
    `;
export const CommunityUserFieldsFragmentDoc = gql`
    fragment CommunityUserFields on CommunityUser {
  id
  nickname
  description
  profileImageUrl
  userType
  representativeBadge {
    ...BadgeFields
  }
}
    ${BadgeFieldsFragmentDoc}`;
export const AssetTagFieldsFragmentDoc = gql`
    fragment AssetTagFields on AssetTag {
  categoryType
  companyId
  cryptoCurrencyId
  id
  imageUrl
  name
  relativeSearchKeywords
  symbol
}
    `;
export const PortfolioTopicFieldsFragmentDoc = gql`
    fragment PortfolioTopicFields on PortfolioTopic {
  id
  isCustomTopic
  name {
    en
    ko
  }
  selectedCount
  topicName
}
    `;
export const ArticleFieldsFragmentDoc = gql`
    fragment ArticleFields on Article {
  id
  title
  feedTopic {
    ...FeedTopicFields
  }
  content {
    ...ArticleContentFields
  }
  language
  userId
  communityUser {
    ...CommunityUserFields
  }
  commentsCount
  isBookmarked
  isLiked
  likesCount
  assetTags {
    ...AssetTagFields
  }
  portfolioTopicIds
  portfolioTopics {
    ...PortfolioTopicFields
  }
  createdAt
  updatedAt
  deletedAt
  deletedBy
  dynamicLinkUrl
}
    ${FeedTopicFieldsFragmentDoc}
${ArticleContentFieldsFragmentDoc}
${CommunityUserFieldsFragmentDoc}
${AssetTagFieldsFragmentDoc}
${PortfolioTopicFieldsFragmentDoc}`;
export const BackTestingStockFieldsFragmentDoc = gql`
    fragment BackTestingStockFields on BackTestingStock {
  name {
    en
    ko
  }
  country
  ticker
  sortId
}
    `;
export const BackTestingCryptoFieldsFragmentDoc = gql`
    fragment BackTestingCryptoFields on BackTestingCrypto {
  name {
    en
    ko
  }
  base
  counter
  sortId
}
    `;
export const BackTestingPortfolioStockFieldsFragmentDoc = gql`
    fragment BackTestingPortfolioStockFields on BackTestingStock {
  name {
    en
    ko
  }
  country
  ticker
  weight
}
    `;
export const BackTestingPortfolioCryptoFieldsFragmentDoc = gql`
    fragment BackTestingPortfolioCryptoFields on BackTestingCrypto {
  name {
    en
    ko
  }
  base
  counter
  weight
}
    `;
export const BackTestingPortfolioFieldsFragmentDoc = gql`
    fragment BackTestingPortfolioFields on BackTestingPortfolio {
  portfolioName: name
  sortId
  assets {
    ... on BackTestingStock {
      ...BackTestingPortfolioStockFields
    }
    ... on BackTestingCrypto {
      ...BackTestingPortfolioCryptoFields
    }
  }
}
    ${BackTestingPortfolioStockFieldsFragmentDoc}
${BackTestingPortfolioCryptoFieldsFragmentDoc}`;
export const BackTestingProjectFieldsFragmentDoc = gql`
    fragment BackTestingProjectFields on BackTestingProject {
  id
  title
  currencySymbol
  startPeriod
  endPeriod
  initialAmount
  cashFlowType
  cashFlowAmount
  rebalancingType
  cases {
    ... on BackTestingStock {
      ...BackTestingStockFields
    }
    ... on BackTestingCrypto {
      ...BackTestingCryptoFields
    }
    ... on BackTestingPortfolio {
      ...BackTestingPortfolioFields
    }
  }
  result {
    times
    cases {
      sortId
      balancesByTime
      maxDrawdown
      cagr
      worstYear
      worstYearReturnRate
      bestYear
      bestYearReturnRate
    }
  }
  slug
  slugSharedAt
  createdAt
  updatedAt
  imageUrl
  userId
}
    ${BackTestingStockFieldsFragmentDoc}
${BackTestingCryptoFieldsFragmentDoc}
${BackTestingPortfolioFieldsFragmentDoc}`;
export const ArticleContentBackTestingProjectFieldsFragmentDoc = gql`
    fragment ArticleContentBackTestingProjectFields on ArticleContentBackTestingProject {
  categoryType
  content {
    ...BackTestingProjectFields
  }
}
    ${BackTestingProjectFieldsFragmentDoc}`;
export const ArticleCommentContentFieldsFragmentDoc = gql`
    fragment ArticleCommentContentFields on ArticleCommentContent {
  ... on ArticleContentText {
    ...ArticleContentTextFields
  }
}
    ${ArticleContentTextFieldsFragmentDoc}`;
export const ArticleCommentReplyFieldsFragmentDoc = gql`
    fragment ArticleCommentReplyFields on ArticleCommentReply {
  id
  content {
    ...ArticleCommentContentFields
  }
  parentCommentId
  createdAt
  updatedAt
  deletedAt
  deletedBy
  communityUser {
    ...CommunityUserFields
  }
  userId
}
    ${ArticleCommentContentFieldsFragmentDoc}
${CommunityUserFieldsFragmentDoc}`;
export const ArticleCommentFieldsFragmentDoc = gql`
    fragment ArticleCommentFields on ArticleComment {
  id
  content {
    ...ArticleCommentContentFields
  }
  articleId
  parentCommentId
  replies {
    ...ArticleCommentReplyFields
  }
  repliesCount
  communityUser {
    ...CommunityUserFields
  }
  userId
  createdAt
  updatedAt
  deletedAt
  deletedBy
}
    ${ArticleCommentContentFieldsFragmentDoc}
${ArticleCommentReplyFieldsFragmentDoc}
${CommunityUserFieldsFragmentDoc}`;
export const FollowCompanyFieldsFragmentDoc = gql`
    fragment FollowCompanyFields on FollowCompany {
  id
  logoImageUrl
  name
  symbol
}
    `;
export const FollowCryptoCurrencyFieldsFragmentDoc = gql`
    fragment FollowCryptoCurrencyFields on FollowCryptoCurrency {
  id
  logoImageUrl
  name
  symbol
}
    `;
export const FollowUserFieldsFragmentDoc = gql`
    fragment FollowUserFields on FollowUser {
  id
  nickname
  profileImageUrl
  description
  followersCount
}
    `;
export const FollowItemFieldsFragmentDoc = gql`
    fragment FollowItemFields on FollowItem {
  ... on FollowCompany {
    ...FollowCompanyFields
  }
  ... on FollowCryptoCurrency {
    ...FollowCryptoCurrencyFields
  }
  ... on FollowUser {
    ...FollowUserFields
  }
}
    ${FollowCompanyFieldsFragmentDoc}
${FollowCryptoCurrencyFieldsFragmentDoc}
${FollowUserFieldsFragmentDoc}`;
export const SearchFollowItemFieldsFragmentDoc = gql`
    fragment SearchFollowItemFields on SearchFollowItem {
  id
  hasNewArticle
  userFollowingId
  categoryType
  isFollowing
  followItem {
    ...FollowItemFields
  }
}
    ${FollowItemFieldsFragmentDoc}`;
export const SearchFollowItemsFieldsFragmentDoc = gql`
    fragment SearchFollowItemsFields on SearchFollowItems {
  items {
    ...SearchFollowItemFields
  }
  totalCount
}
    ${SearchFollowItemFieldsFragmentDoc}`;
export const CompanyPriceFieldsFragmentDoc = gql`
    fragment CompanyPriceFields on CompanyPrice {
  id
  price
  priceChangePercent
  priceUpdatedAt
  ticker
}
    `;
export const CurrencyFieldsFragmentDoc = gql`
    fragment CurrencyFields on Currency {
  id
  imageUrl
  symbol
  unit
  decimalPoint
  currencyType
  name {
    ko
    en
  }
}
    `;
export const CompanyDetailFieldsFragmentDoc = gql`
    fragment CompanyDetailFields on CompanyDetail {
  assetTagId
  companyName {
    en
    ko
  }
  country
  companyPrice {
    ...CompanyPriceFields
  }
  currency {
    ...CurrencyFields
  }
  dividendFrequency
  exDividendMonths
  exchange
  id
  industry
  isExist
  lastYearRegularDividendAmount
  latestRegularDividendAmount
  listDate
  logoImageUrl
  name
  needTtm
  paymentMonths
  sector
  symbol
  ticker
  chartSymbol
}
    ${CompanyPriceFieldsFragmentDoc}
${CurrencyFieldsFragmentDoc}`;
export const CompanyDetailOnlyCommunityFieldsFragmentDoc = gql`
    fragment CompanyDetailOnlyCommunityFields on CompanyDetail {
  id
  isFollowing
  followItemId
}
    `;
export const NewsCompanyDetailFragmentDoc = gql`
    fragment NewsCompanyDetail on CompanyDetail {
  id
  ticker
  country
  companyName {
    en
    ko
  }
  companyPrice {
    priceChangePercent
  }
}
    `;
export const CryptoCurrencyPriceFieldsFragmentDoc = gql`
    fragment CryptoCurrencyPriceFields on CryptoCurrencyPrice {
  base
  counter
  id
  price
  priceChangePercent
  priceUpdatedAt
}
    `;
export const CryptoCurrencyDetailFieldsFragmentDoc = gql`
    fragment CryptoCurrencyDetailFields on CryptoCurrencyDetail {
  assetTagId
  base
  counter
  cryptoCurrencyPrice {
    ...CryptoCurrencyPriceFields
  }
  currencyType
  decimalPoint
  id
  imageUrl
  name {
    en
    ko
  }
  symbol
  unit
  counterCurrency {
    ...CurrencyFields
  }
}
    ${CryptoCurrencyPriceFieldsFragmentDoc}
${CurrencyFieldsFragmentDoc}`;
export const CryptoCurrencyDetailOnlyCommunityFieldsFragmentDoc = gql`
    fragment CryptoCurrencyDetailOnlyCommunityFields on CryptoCurrencyDetail {
  id
  followCryptoCurrencyId
  followItemId
  isFollowing
}
    `;
export const StockPriceFieldsFragmentDoc = gql`
    fragment StockPriceFields on StockPrice {
  id
  price
  priceChangePercent
  ticker
  updatedAt
}
    `;
export const CompanyFieldsFragmentDoc = gql`
    fragment CompanyFields on Company {
  id
  isExist
  logoUrl
  name
  base
  baseSymbol
  companyName {
    ko
    en
  }
  stockPrice {
    ...StockPriceFields
  }
  companyPrice {
    ...CompanyPriceFields
  }
  ticker
  country
  currency {
    ...CurrencyFields
  }
  sector
  paymentMonths
  exDividendMonths
  exchange
  industry
  listDate
  needTtm
  securityGroup
  subExchange
  symbol
  assetTagId
  lastYearRegularDividendAmount
  latestRegularDividendAmount
}
    ${StockPriceFieldsFragmentDoc}
${CompanyPriceFieldsFragmentDoc}
${CurrencyFieldsFragmentDoc}`;
export const DividendHistoryApi1FieldsFragmentDoc = gql`
    fragment DividendHistoryApi1Fields on DividendHistory {
  id
  amount
  exDividendDate
  flag
  frequency
  paymentDate
  recordDate
  company {
    ...CompanyFields
  }
  currency {
    ...CurrencyFields
  }
}
    ${CompanyFieldsFragmentDoc}
${CurrencyFieldsFragmentDoc}`;
export const DividendHistoryFieldsFragmentDoc = gql`
    fragment DividendHistoryFields on DividendHistory {
  id
  amount
  paymentDate
  recordDate
  exDividendDate
  frequency
  flag
  currency {
    ...CurrencyFields
  }
  company {
    ...CompanyFields
  }
}
    ${CurrencyFieldsFragmentDoc}
${CompanyFieldsFragmentDoc}`;
export const DividendCalendarRecordFieldsFragmentDoc = gql`
    fragment DividendCalendarRecordFields on DividendCalendarRecord {
  assetAmount
  dividendHistory {
    amount
    company {
      country
      dividendFrequency
      exDividendMonths
      exchange
      id
      logoUrl
      name
      needTtm
      paymentMonths
      stockPrice {
        id
        price
        priceChangePercent
        updatedAt
      }
      ticker
      companyName {
        en
        ko
      }
    }
    currency {
      id
      decimalPoint
      symbol
      unit
    }
    exDividendDate
    flag
    frequency
    id
    paymentDate
    recordDate
  }
}
    `;
export const MarketCalendarFieldsFragmentDoc = gql`
    fragment MarketCalendarFields on MarketCalendar {
  date
  memo
  country
}
    `;
export const PaginationCompaniesFieldsFragmentDoc = gql`
    fragment PaginationCompaniesFields on PaginationCompanies {
  totalCount
  totalPages
  currentPage
  currentPageCount
  perPage
  nextPage
  companies {
    ...CompanyFields
  }
}
    ${CompanyFieldsFragmentDoc}`;
export const CryptoCurrencyFieldsFragmentDoc = gql`
    fragment CryptoCurrencyFields on CryptoCurrency {
  id
  imageUrl
  symbol
  unit
  decimalPoint
  name {
    ko
    en
  }
  assetTagId
}
    `;
export const CryptoCurrencyAssetFieldsFragmentDoc = gql`
    fragment CryptoCurrencyAssetFields on CryptoCurrencyAsset {
  base {
    ...CryptoCurrencyFields
  }
  counter {
    ...CurrencyFields
  }
}
    ${CryptoCurrencyFieldsFragmentDoc}
${CurrencyFieldsFragmentDoc}`;
export const EtcAssetFieldsFragmentDoc = gql`
    fragment EtcAssetFields on EtcAsset {
  category
  imageUrl
  currency {
    ...CurrencyFields
  }
  name {
    ko
    en
  }
}
    ${CurrencyFieldsFragmentDoc}`;
export const EtcCompanyAssetFieldsFragmentDoc = gql`
    fragment EtcCompanyAssetFields on EtcCompanyAsset {
  id
  category
  currency {
    ...CurrencyFields
  }
  name
  price
}
    ${CurrencyFieldsFragmentDoc}`;
export const UserAccountFieldsFragmentDoc = gql`
    fragment UserAccountFields on UserAccount {
  id
  accountDisplayNumber
  accountName
  accountNumber
  isAccountPasswordRequired
  organization {
    id
    code
    name
    imageUrl
  }
}
    `;
export const UserAssetFieldsFragmentDoc = gql`
    fragment UserAssetFields on UserAsset {
  id
  assetCategory
  amount
  avgPrice
  avgPriceCurrency {
    ...CurrencyFields
  }
  customTax
  customPrice
  name
  companyAsset {
    ...CompanyFields
  }
  currencyAsset {
    ...CurrencyFields
  }
  cryptoCurrencyAsset {
    ...CryptoCurrencyAssetFields
  }
  etcAsset {
    ...EtcAssetFields
  }
  etcCompanyAsset {
    ...EtcCompanyAssetFields
  }
  userAccount {
    ...UserAccountFields
  }
  cryptoExchangeApiKeyId
  userPlaidId
}
    ${CurrencyFieldsFragmentDoc}
${CompanyFieldsFragmentDoc}
${CryptoCurrencyAssetFieldsFragmentDoc}
${EtcAssetFieldsFragmentDoc}
${EtcCompanyAssetFieldsFragmentDoc}
${UserAccountFieldsFragmentDoc}`;
export const EbestUserPortfolioFragmentDoc = gql`
    fragment EbestUserPortfolio on UserPortfolio {
  id
  name
  createdAt
  slug
  assets {
    ...UserAssetFields
  }
}
    ${UserAssetFieldsFragmentDoc}`;
export const DividendHistoriesExistingDaysForExternalChannelFieldsFragmentDoc = gql`
    fragment DividendHistoriesExistingDaysForExternalChannelFields on DividendHistoriesExistingDaysForExternalChannel {
  dividendHistoriesExistingDays
  totalCount
}
    `;
export const CurrencyExchangeFieldsFragmentDoc = gql`
    fragment CurrencyExchangeFields on CurrencyExchange {
  id
  exchangePercent
  exchangeRate
  pair
  symbol
}
    `;
export const FavoriteItemCategoryWithoutItemsFieldsFragmentDoc = gql`
    fragment FavoriteItemCategoryWithoutItemsFields on FavoriteItemCategory {
  id
  slug
  slugSharedAt
  categoryName
  createdAt
  updatedAt
  orderScore
}
    `;
export const FavoriteItemFieldsFragmentDoc = gql`
    fragment FavoriteItemFields on FavoriteItem {
  id
  itemCategory
  company {
    ...CompanyFields
  }
  cryptoCurrency {
    ...CryptoCurrencyFields
  }
  currency {
    ...CurrencyFields
  }
}
    ${CompanyFieldsFragmentDoc}
${CryptoCurrencyFieldsFragmentDoc}
${CurrencyFieldsFragmentDoc}`;
export const FavoriteItemCategoryFieldsFragmentDoc = gql`
    fragment FavoriteItemCategoryFields on FavoriteItemCategory {
  ...FavoriteItemCategoryWithoutItemsFields
  items {
    ...FavoriteItemFields
  }
  countOfStars
  countOfView
}
    ${FavoriteItemCategoryWithoutItemsFieldsFragmentDoc}
${FavoriteItemFieldsFragmentDoc}`;
export const OgTagFieldsFragmentDoc = gql`
    fragment OgTagFields on OgTag {
  id
  charSet
  ogDescription
  ogImageUrl
  ogLocale
  ogMetadata {
    ogImageHeight
    ogImageType
    ogImageWidth
  }
  ogTitle
  ogType
  originalLink
}
    `;
export const TradingDiaryLogFieldsFragmentDoc = gql`
    fragment TradingDiaryLogFields on InvestingDiaryLog {
  ... on InvestingDiaryMemoLog {
    id
    date
    category
    memo
    url
    createdAt
    updatedAt
    emotion
    ogTag {
      ...OgTagFields
    }
  }
  ... on InvestingDiaryTradeLog {
    id
    date
    category
    memo
    url
    createdAt
    updatedAt
    emotion
    ogTag {
      ...OgTagFields
    }
    amount
    position
    price
    company {
      id
      ticker
      country
      companyName {
        ko
        en
      }
      name
    }
    cryptoCurrency {
      id
      symbol
      decimalPoint
      name {
        ko
        en
      }
    }
    currency {
      ...CurrencyFields
    }
  }
  ... on InvestingDiaryDepositWithdrawalLog {
    id
    date
    category
    memo
    url
    createdAt
    updatedAt
    emotion
    ogTag {
      ...OgTagFields
    }
    currency {
      ...CurrencyFields
    }
    side
    amount
  }
  ... on InvestingDiaryExchangeCurrencyLog {
    id
    date
    category
    memo
    url
    createdAt
    updatedAt
    emotion
    ogTag {
      ...OgTagFields
    }
    counterAmount
    exchangeRate
    baseCurrency {
      ...CurrencyFields
    }
    counterCurrency {
      ...CurrencyFields
    }
  }
}
    ${OgTagFieldsFragmentDoc}
${CurrencyFieldsFragmentDoc}`;
export const EventFieldsFragmentDoc = gql`
    fragment EventFields on EventStatus {
  endAt
  eventName
  id
  isInProgress
  shareUrl
  startAt
}
    `;
export const MailingGroupEmailVerificationFieldsFragmentDoc = gql`
    fragment MailingGroupEmailVerificationFields on MailingGroupEmailVerification {
  email
  emailVerifiedAt
  verifyingEmailSentAt
}
    `;
export const LanguageStringFieldsFragmentDoc = gql`
    fragment LanguageStringFields on LanguageString {
  en
  ko
}
    `;
export const SubscribedUserFieldsFragmentDoc = gql`
    fragment SubscribedUserFields on SubscribedUser {
  email
  userId
}
    `;
export const MailingGroupFieldsFragmentDoc = gql`
    fragment MailingGroupFields on MailingGroup {
  id
  name {
    ...LanguageStringFields
  }
  subscribedUsers {
    ...SubscribedUserFields
  }
  subscribedUsersCount
}
    ${LanguageStringFieldsFragmentDoc}
${SubscribedUserFieldsFragmentDoc}`;
export const NoticeFieldFragmentDoc = gql`
    fragment NoticeField on Notice {
  id
  contentEn
  contentKo
  createdAt
  titleEn
  titleKo
  updatedAt
  imageUrl
  imageUrlEn
  imageUrlKo
}
    `;
export const GeneratorPortfolioFieldsFragmentDoc = gql`
    fragment GeneratorPortfolioFields on UserPortfolio {
  id
  assets {
    id
    amount
    avgPrice
    avgPriceCurrency {
      id
      decimalPoint
      symbol
    }
    companyAsset {
      id
      companyName {
        ko
        en
      }
      country
      currency {
        id
        decimalPoint
        symbol
      }
      lastYearRegularDividendAmount
      latestRegularDividendAmount
      sector
      stockPrice {
        price
      }
    }
  }
  createdAt
  currency {
    id
    decimalPoint
    symbol
  }
  depositConnectedAt
  description
  name
  slug
  updatedAt
}
    `;
export const CategorizedCompanyFieldsFragmentDoc = gql`
    fragment CategorizedCompanyFields on CategorizedCompany {
  id
  name {
    ko
    en
  }
  companies {
    ...CompanyFields
  }
}
    ${CompanyFieldsFragmentDoc}`;
export const UserPortfolioUserFieldsFragmentDoc = gql`
    fragment UserPortfolioUserFields on UserPortfolioUser {
  id
  nickname
}
    `;
export const CryptoExchangeFieldsFragmentDoc = gql`
    fragment CryptoExchangeFields on CryptoExchange {
  accessKeyName
  hasAvgPriceFilled
  id
  isEnabled
  logoImageUrl
  name
  secretKeyName
  logoImageUrl
}
    `;
export const CryptoExchangeApiKeyFieldsFragmentDoc = gql`
    fragment CryptoExchangeApiKeyFields on CryptoExchangeApiKey {
  id
  accessKey
  createdAt
  cryptoExchange {
    ...CryptoExchangeFields
  }
}
    ${CryptoExchangeFieldsFragmentDoc}`;
export const CommonUserPortfolioItemsFieldsFragmentDoc = gql`
    fragment CommonUserPortfolioItemsFields on UserPortfolio {
  id
  slug
  name
  description
  createdAt
  updatedAt
  dividendTaxRate
  currency {
    ...CurrencyFields
  }
  user {
    ...UserPortfolioUserFields
  }
  userAccount {
    ...UserAccountFields
  }
  userAccountAssetsNextUpdatedAt
  userAccountAssetsUpdatedAt
  userAccountConnectedAt
  cryptoExchangeApiKeyConnectedAt
  cryptoExchangeApiKeyId
  cryptoExchangeApiKey {
    ...CryptoExchangeApiKeyFields
  }
  slugSharedAt
  userPlaidConnectedAt
  userPlaidId
  kbSecUserAccountConnectedAt
}
    ${CurrencyFieldsFragmentDoc}
${UserPortfolioUserFieldsFragmentDoc}
${UserAccountFieldsFragmentDoc}
${CryptoExchangeApiKeyFieldsFragmentDoc}`;
export const UserPortfolioFieldsFragmentDoc = gql`
    fragment UserPortfolioFields on UserPortfolio {
  ...CommonUserPortfolioItemsFields
  assets {
    ...UserAssetFields
  }
  portfolioLink {
    linkUrl
    linkSharedAt
  }
  portfolioSwitchOn
  evaluationAmount
  purchaseAmount
}
    ${CommonUserPortfolioItemsFieldsFragmentDoc}
${UserAssetFieldsFragmentDoc}`;
export const UserPortfolioItemsFieldsFragmentDoc = gql`
    fragment UserPortfolioItemsFields on UserPortfolio {
  ...CommonUserPortfolioItemsFields
  portfolioSwitchOn
  evaluationAmount
  purchaseAmount
}
    ${CommonUserPortfolioItemsFieldsFragmentDoc}`;
export const SwitchPortfolioFieldsFragmentDoc = gql`
    fragment SwitchPortfolioFields on SwitchPortfolio {
  id
  currency {
    ...CurrencyFields
  }
  evaluationAmount
  monthlyDividendAmount
  previousDayEvaluationAmount
  purchaseAmount
  supportedCurrencies {
    ...CurrencyFields
  }
}
    ${CurrencyFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  description
  followersCount
  followingsCount
  id
  nickname
  profileImageUrl
  tags
  userStatus
  userStatusUpdatedAt
  chatRoomUrl
}
    `;
export const UserPortfolioCommentFieldsFragmentDoc = gql`
    fragment UserPortfolioCommentFields on UserPortfolioComment {
  id
  comment
  createdAt
  updatedAt
  user {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const ProfessionalInvestorApplicantFieldsFragmentDoc = gql`
    fragment ProfessionalInvestorApplicantFields on ProfessionalInvestorApplicant {
  createdAt
  hasUserAgreeToPrivacyAgreement
  id
  name
  phoneNumber
  updatedAt
  userId
}
    `;
export const ProfessionalInvestorFieldsFragmentDoc = gql`
    fragment ProfessionalInvestorFields on ProfessionalInvestor {
  certificateImageUrl
  createdAt
  id
  isVerified
  updatedAt
  userId
  verifiedAt
}
    `;
export const CompanySectorFieldsFragmentDoc = gql`
    fragment CompanySectorFields on CompanySector {
  id
  name
  companySectorName {
    en
    ko
  }
}
    `;
export const UserCompanySectorFieldsFragmentDoc = gql`
    fragment UserCompanySectorFields on UserCompanySector {
  id
  company {
    id
  }
  companySector {
    ...CompanySectorFields
  }
}
    ${CompanySectorFieldsFragmentDoc}`;
export const MbtiVisitorCounterFieldsFragmentDoc = gql`
    fragment MbtiVisitorCounterFields on MbtiVisitorCounter {
  todayVisitorCounter {
    category
    createdAt
    date
    id
    language
    name
    updatedAt
    viewCount
  }
  totalVisitorCounter {
    category
    createdAt
    date
    id
    language
    name
    updatedAt
    viewCount
  }
}
    `;
export const MbtiResultCounterFieldsFragmentDoc = gql`
    fragment MbtiResultCounterFields on MbtiResultCounter {
  count
  id
  mbtiType
}
    `;
export const AuthTokenFieldsFragmentDoc = gql`
    fragment AuthTokenFields on AuthToken {
  deviceRegistrationToken
  isNewUser
  nickname
  token
}
    `;
export const InvestingKeywordFieldsFragmentDoc = gql`
    fragment InvestingKeywordFields on InvestingKeyword {
  id
  keyword
  keywordCategory
  language
  referencedCount
}
    `;
export const MyProfileFieldsFragmentDoc = gql`
    fragment MyProfileFields on MyProfile {
  id
  nickname
  description
  followersCount
  followingsCount
  articleCommentsCount
  articlesCount
  profileImageUrl
  investingKeywords {
    ...InvestingKeywordFields
  }
  representativeBadge {
    ...BadgeFields
  }
  createdAt
  updatedAt
  userType
  chatRoomUrl
}
    ${InvestingKeywordFieldsFragmentDoc}
${BadgeFieldsFragmentDoc}`;
export const UserSurveyFieldsFragmentDoc = gql`
    fragment UserSurveyFields on UserSurvey {
  id
  surveyCategory
  surveyCount
  surveyResult
  createdAt
  updatedAt
}
    `;
export const InvestingKeywordWithIsSelectedFieldsFragmentDoc = gql`
    fragment InvestingKeywordWithIsSelectedFields on InvestingKeywordWithIsSelected {
  id
  isSelected
  keyword
  keywordCategory
  language
  referencedCount
}
    `;
export const UserProfileFieldsFragmentDoc = gql`
    fragment UserProfileFields on UserProfile {
  articleCommentsCount
  articlesCount
  createdAt
  description
  followersCount
  followingsCount
  id
  isFollowing
  defaultFavoriteItemCategoryAddedAt
  nickname
  profileImageUrl
  updatedAt
  investingKeywords {
    ...InvestingKeywordFields
  }
  userType
  followItemId
  chatRoomUrl
  portfolioAssetsCount
  favoriteItemsCount
}
    ${InvestingKeywordFieldsFragmentDoc}`;
export const UserProfileOnlyCommunityFieldsFragmentDoc = gql`
    fragment UserProfileOnlyCommunityFields on UserProfile {
  id
  followersCount
  followingsCount
  isFollowing
  followItemId
  representativeBadge {
    ...BadgeFields
  }
}
    ${BadgeFieldsFragmentDoc}`;
export const CommunityNotificationContentFieldsFragmentDoc = gql`
    fragment CommunityNotificationContentFields on CommunityNotificationContent {
  deeplinkUrl
  notificationMessage
  notificationMessageTemplate
  receiverArticleCommentId
  receiverArticleId
  senderArticleCommentId
}
    `;
export const CommunityNotificationUserFieldsFragmentDoc = gql`
    fragment CommunityNotificationUserFields on CommunityNotificationUser {
  nickname
  profileImageUrl
  userId
}
    `;
export const CommunityNotificationFieldsFragmentDoc = gql`
    fragment CommunityNotificationFields on CommunityNotification {
  id
  hasConfirmed
  content {
    ...CommunityNotificationContentFields
  }
  createdAt
  notificationCategoryType
  receiverUserId
  sender {
    ...CommunityNotificationUserFields
  }
}
    ${CommunityNotificationContentFieldsFragmentDoc}
${CommunityNotificationUserFieldsFragmentDoc}`;
export const CommunityNotificationStatusFieldsFragmentDoc = gql`
    fragment CommunityNotificationStatusFields on CommunityNotificationStatus {
  communityNotifications {
    ...CommunityNotificationFields
  }
  hasUnconfirmedNotification
}
    ${CommunityNotificationFieldsFragmentDoc}`;
export const UserVerificationFieldsFragmentDoc = gql`
    fragment UserVerificationFields on UserVerification {
  email
  isEmailVerified
  isKrPhoneNumberVerified
  isPhoneNumberVerified
  phoneNumber
  stepOfEmailVerification
}
    `;
export const UserPhoneVerificationKrFieldsFragmentDoc = gql`
    fragment UserPhoneVerificationKrFields on UserPhoneVerificationKr {
  clientRequestNumber
  phoneNumber
}
    `;
export const ClickInvestingInsightDocument = gql`
    mutation ClickInvestingInsight($investingInsightId: ID!, $platform: ServicePlatformEnum!) {
  clickInvestingInsight(
    investingInsightId: $investingInsightId
    platform: $platform
  ) {
    investingInsight {
      id
    }
  }
}
    `;
export type ClickInvestingInsightMutationFn = Apollo.MutationFunction<ClickInvestingInsightMutation, ClickInvestingInsightMutationVariables>;

/**
 * __useClickInvestingInsightMutation__
 *
 * To run a mutation, you first call `useClickInvestingInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClickInvestingInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clickInvestingInsightMutation, { data, loading, error }] = useClickInvestingInsightMutation({
 *   variables: {
 *      investingInsightId: // value for 'investingInsightId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useClickInvestingInsightMutation(baseOptions?: Apollo.MutationHookOptions<ClickInvestingInsightMutation, ClickInvestingInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClickInvestingInsightMutation, ClickInvestingInsightMutationVariables>(ClickInvestingInsightDocument, options);
      }
export type ClickInvestingInsightMutationHookResult = ReturnType<typeof useClickInvestingInsightMutation>;
export type ClickInvestingInsightMutationResult = Apollo.MutationResult<ClickInvestingInsightMutation>;
export type ClickInvestingInsightMutationOptions = Apollo.BaseMutationOptions<ClickInvestingInsightMutation, ClickInvestingInsightMutationVariables>;
export const InvestingInsightTagsDocument = gql`
    query InvestingInsightTags($page: Int, $limit: Int!) {
  investingInsightTags(page: $page, limit: $limit) {
    ...InvestingInsightTagFields
  }
}
    ${InvestingInsightTagFieldsFragmentDoc}`;

/**
 * __useInvestingInsightTagsQuery__
 *
 * To run a query within a React component, call `useInvestingInsightTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestingInsightTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestingInsightTagsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useInvestingInsightTagsQuery(baseOptions: Apollo.QueryHookOptions<InvestingInsightTagsQuery, InvestingInsightTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestingInsightTagsQuery, InvestingInsightTagsQueryVariables>(InvestingInsightTagsDocument, options);
      }
export function useInvestingInsightTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestingInsightTagsQuery, InvestingInsightTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestingInsightTagsQuery, InvestingInsightTagsQueryVariables>(InvestingInsightTagsDocument, options);
        }
export type InvestingInsightTagsQueryHookResult = ReturnType<typeof useInvestingInsightTagsQuery>;
export type InvestingInsightTagsLazyQueryHookResult = ReturnType<typeof useInvestingInsightTagsLazyQuery>;
export type InvestingInsightTagsQueryResult = Apollo.QueryResult<InvestingInsightTagsQuery, InvestingInsightTagsQueryVariables>;
export const InvestingInsightsDocument = gql`
    query InvestingInsights($language: String!, $tagId: ID!, $page: Int, $limit: Int!) {
  investingInsights(
    language: $language
    tagId: $tagId
    page: $page
    limit: $limit
  ) {
    ...InvestingInsightFields
  }
}
    ${InvestingInsightFieldsFragmentDoc}`;

/**
 * __useInvestingInsightsQuery__
 *
 * To run a query within a React component, call `useInvestingInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestingInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestingInsightsQuery({
 *   variables: {
 *      language: // value for 'language'
 *      tagId: // value for 'tagId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useInvestingInsightsQuery(baseOptions: Apollo.QueryHookOptions<InvestingInsightsQuery, InvestingInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestingInsightsQuery, InvestingInsightsQueryVariables>(InvestingInsightsDocument, options);
      }
export function useInvestingInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestingInsightsQuery, InvestingInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestingInsightsQuery, InvestingInsightsQueryVariables>(InvestingInsightsDocument, options);
        }
export type InvestingInsightsQueryHookResult = ReturnType<typeof useInvestingInsightsQuery>;
export type InvestingInsightsLazyQueryHookResult = ReturnType<typeof useInvestingInsightsLazyQuery>;
export type InvestingInsightsQueryResult = Apollo.QueryResult<InvestingInsightsQuery, InvestingInsightsQueryVariables>;
export const InvestingInsightDocument = gql`
    query InvestingInsight($investingInsightId: ID!) {
  investingInsight(investingInsightId: $investingInsightId) {
    ...InvestingInsightFields
  }
}
    ${InvestingInsightFieldsFragmentDoc}`;

/**
 * __useInvestingInsightQuery__
 *
 * To run a query within a React component, call `useInvestingInsightQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestingInsightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestingInsightQuery({
 *   variables: {
 *      investingInsightId: // value for 'investingInsightId'
 *   },
 * });
 */
export function useInvestingInsightQuery(baseOptions: Apollo.QueryHookOptions<InvestingInsightQuery, InvestingInsightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestingInsightQuery, InvestingInsightQueryVariables>(InvestingInsightDocument, options);
      }
export function useInvestingInsightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestingInsightQuery, InvestingInsightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestingInsightQuery, InvestingInsightQueryVariables>(InvestingInsightDocument, options);
        }
export type InvestingInsightQueryHookResult = ReturnType<typeof useInvestingInsightQuery>;
export type InvestingInsightLazyQueryHookResult = ReturnType<typeof useInvestingInsightLazyQuery>;
export type InvestingInsightQueryResult = Apollo.QueryResult<InvestingInsightQuery, InvestingInsightQueryVariables>;
export const ClickAdDocument = gql`
    mutation ClickAd($adId: ID!) {
  clickAd(adId: $adId) {
    ad {
      id
    }
  }
}
    `;
export type ClickAdMutationFn = Apollo.MutationFunction<ClickAdMutation, ClickAdMutationVariables>;

/**
 * __useClickAdMutation__
 *
 * To run a mutation, you first call `useClickAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClickAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clickAdMutation, { data, loading, error }] = useClickAdMutation({
 *   variables: {
 *      adId: // value for 'adId'
 *   },
 * });
 */
export function useClickAdMutation(baseOptions?: Apollo.MutationHookOptions<ClickAdMutation, ClickAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClickAdMutation, ClickAdMutationVariables>(ClickAdDocument, options);
      }
export type ClickAdMutationHookResult = ReturnType<typeof useClickAdMutation>;
export type ClickAdMutationResult = Apollo.MutationResult<ClickAdMutation>;
export type ClickAdMutationOptions = Apollo.BaseMutationOptions<ClickAdMutation, ClickAdMutationVariables>;
export const DoNotShowAdDocument = gql`
    mutation DoNotShowAd($adId: ID!) {
  doNotShowAd(adId: $adId) {
    ad {
      id
    }
  }
}
    `;
export type DoNotShowAdMutationFn = Apollo.MutationFunction<DoNotShowAdMutation, DoNotShowAdMutationVariables>;

/**
 * __useDoNotShowAdMutation__
 *
 * To run a mutation, you first call `useDoNotShowAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoNotShowAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doNotShowAdMutation, { data, loading, error }] = useDoNotShowAdMutation({
 *   variables: {
 *      adId: // value for 'adId'
 *   },
 * });
 */
export function useDoNotShowAdMutation(baseOptions?: Apollo.MutationHookOptions<DoNotShowAdMutation, DoNotShowAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoNotShowAdMutation, DoNotShowAdMutationVariables>(DoNotShowAdDocument, options);
      }
export type DoNotShowAdMutationHookResult = ReturnType<typeof useDoNotShowAdMutation>;
export type DoNotShowAdMutationResult = Apollo.MutationResult<DoNotShowAdMutation>;
export type DoNotShowAdMutationOptions = Apollo.BaseMutationOptions<DoNotShowAdMutation, DoNotShowAdMutationVariables>;
export const AdsDocument = gql`
    query Ads($adLocale: String!, $adPlatform: AdPlatformEnum!, $adType: AdTypeEnum!) {
  ads(adLocale: $adLocale, adPlatform: $adPlatform, adType: $adType) {
    ...AdFields
  }
}
    ${AdFieldsFragmentDoc}`;

/**
 * __useAdsQuery__
 *
 * To run a query within a React component, call `useAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdsQuery({
 *   variables: {
 *      adLocale: // value for 'adLocale'
 *      adPlatform: // value for 'adPlatform'
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useAdsQuery(baseOptions: Apollo.QueryHookOptions<AdsQuery, AdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdsQuery, AdsQueryVariables>(AdsDocument, options);
      }
export function useAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdsQuery, AdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdsQuery, AdsQueryVariables>(AdsDocument, options);
        }
export type AdsQueryHookResult = ReturnType<typeof useAdsQuery>;
export type AdsLazyQueryHookResult = ReturnType<typeof useAdsLazyQuery>;
export type AdsQueryResult = Apollo.QueryResult<AdsQuery, AdsQueryVariables>;
export const MyAdsDocument = gql`
    query MyAds($adLocale: String!, $adPlatform: AdPlatformEnum!, $adType: AdTypeEnum!) {
  myAds(adLocale: $adLocale, adPlatform: $adPlatform, adType: $adType) {
    ...AdFields
  }
}
    ${AdFieldsFragmentDoc}`;

/**
 * __useMyAdsQuery__
 *
 * To run a query within a React component, call `useMyAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAdsQuery({
 *   variables: {
 *      adLocale: // value for 'adLocale'
 *      adPlatform: // value for 'adPlatform'
 *      adType: // value for 'adType'
 *   },
 * });
 */
export function useMyAdsQuery(baseOptions: Apollo.QueryHookOptions<MyAdsQuery, MyAdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAdsQuery, MyAdsQueryVariables>(MyAdsDocument, options);
      }
export function useMyAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAdsQuery, MyAdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAdsQuery, MyAdsQueryVariables>(MyAdsDocument, options);
        }
export type MyAdsQueryHookResult = ReturnType<typeof useMyAdsQuery>;
export type MyAdsLazyQueryHookResult = ReturnType<typeof useMyAdsLazyQuery>;
export type MyAdsQueryResult = Apollo.QueryResult<MyAdsQuery, MyAdsQueryVariables>;
export const UpdateUserAgreementsDocument = gql`
    mutation UpdateUserAgreements($agreementIds: [ID!]!) {
  updateUserAgreements(agreementIds: $agreementIds) {
    userAgreements {
      ...UserAgreementFields
    }
  }
}
    ${UserAgreementFieldsFragmentDoc}`;
export type UpdateUserAgreementsMutationFn = Apollo.MutationFunction<UpdateUserAgreementsMutation, UpdateUserAgreementsMutationVariables>;

/**
 * __useUpdateUserAgreementsMutation__
 *
 * To run a mutation, you first call `useUpdateUserAgreementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAgreementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAgreementsMutation, { data, loading, error }] = useUpdateUserAgreementsMutation({
 *   variables: {
 *      agreementIds: // value for 'agreementIds'
 *   },
 * });
 */
export function useUpdateUserAgreementsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAgreementsMutation, UpdateUserAgreementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAgreementsMutation, UpdateUserAgreementsMutationVariables>(UpdateUserAgreementsDocument, options);
      }
export type UpdateUserAgreementsMutationHookResult = ReturnType<typeof useUpdateUserAgreementsMutation>;
export type UpdateUserAgreementsMutationResult = Apollo.MutationResult<UpdateUserAgreementsMutation>;
export type UpdateUserAgreementsMutationOptions = Apollo.BaseMutationOptions<UpdateUserAgreementsMutation, UpdateUserAgreementsMutationVariables>;
export const UserAgreementStatusDocument = gql`
    query UserAgreementStatus {
  userAgreementStatus {
    ...UserAgreementStatusFields
  }
}
    ${UserAgreementStatusFieldsFragmentDoc}`;

/**
 * __useUserAgreementStatusQuery__
 *
 * To run a query within a React component, call `useUserAgreementStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAgreementStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAgreementStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAgreementStatusQuery(baseOptions?: Apollo.QueryHookOptions<UserAgreementStatusQuery, UserAgreementStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAgreementStatusQuery, UserAgreementStatusQueryVariables>(UserAgreementStatusDocument, options);
      }
export function useUserAgreementStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAgreementStatusQuery, UserAgreementStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAgreementStatusQuery, UserAgreementStatusQueryVariables>(UserAgreementStatusDocument, options);
        }
export type UserAgreementStatusQueryHookResult = ReturnType<typeof useUserAgreementStatusQuery>;
export type UserAgreementStatusLazyQueryHookResult = ReturnType<typeof useUserAgreementStatusLazyQuery>;
export type UserAgreementStatusQueryResult = Apollo.QueryResult<UserAgreementStatusQuery, UserAgreementStatusQueryVariables>;
export const LatestAgreementsDocument = gql`
    query LatestAgreements($serviceName: String!) {
  latestAgreements(serviceName: $serviceName) {
    ...LatestAgreementsFields
  }
}
    ${LatestAgreementsFieldsFragmentDoc}`;

/**
 * __useLatestAgreementsQuery__
 *
 * To run a query within a React component, call `useLatestAgreementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestAgreementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestAgreementsQuery({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *   },
 * });
 */
export function useLatestAgreementsQuery(baseOptions: Apollo.QueryHookOptions<LatestAgreementsQuery, LatestAgreementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestAgreementsQuery, LatestAgreementsQueryVariables>(LatestAgreementsDocument, options);
      }
export function useLatestAgreementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestAgreementsQuery, LatestAgreementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestAgreementsQuery, LatestAgreementsQueryVariables>(LatestAgreementsDocument, options);
        }
export type LatestAgreementsQueryHookResult = ReturnType<typeof useLatestAgreementsQuery>;
export type LatestAgreementsLazyQueryHookResult = ReturnType<typeof useLatestAgreementsLazyQuery>;
export type LatestAgreementsQueryResult = Apollo.QueryResult<LatestAgreementsQuery, LatestAgreementsQueryVariables>;
export const AddCurrencyAssetsToPortfolioDocument = gql`
    mutation AddCurrencyAssetsToPortfolio($portfolioId: ID!, $assets: [UploadCurrencyAsset!]!) {
  addCurrencyAssetsToPortfolio(portfolioId: $portfolioId, assets: $assets) {
    portfolio {
      ...UserPortfolioFields
    }
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;
export type AddCurrencyAssetsToPortfolioMutationFn = Apollo.MutationFunction<AddCurrencyAssetsToPortfolioMutation, AddCurrencyAssetsToPortfolioMutationVariables>;

/**
 * __useAddCurrencyAssetsToPortfolioMutation__
 *
 * To run a mutation, you first call `useAddCurrencyAssetsToPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCurrencyAssetsToPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCurrencyAssetsToPortfolioMutation, { data, loading, error }] = useAddCurrencyAssetsToPortfolioMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      assets: // value for 'assets'
 *   },
 * });
 */
export function useAddCurrencyAssetsToPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<AddCurrencyAssetsToPortfolioMutation, AddCurrencyAssetsToPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCurrencyAssetsToPortfolioMutation, AddCurrencyAssetsToPortfolioMutationVariables>(AddCurrencyAssetsToPortfolioDocument, options);
      }
export type AddCurrencyAssetsToPortfolioMutationHookResult = ReturnType<typeof useAddCurrencyAssetsToPortfolioMutation>;
export type AddCurrencyAssetsToPortfolioMutationResult = Apollo.MutationResult<AddCurrencyAssetsToPortfolioMutation>;
export type AddCurrencyAssetsToPortfolioMutationOptions = Apollo.BaseMutationOptions<AddCurrencyAssetsToPortfolioMutation, AddCurrencyAssetsToPortfolioMutationVariables>;
export const AddCompanyAssetsToPortfolioDocument = gql`
    mutation AddCompanyAssetsToPortfolio($portfolioId: ID!, $assets: [UploadCompanyAsset!]!) {
  addCompanyAssetsToPortfolio(portfolioId: $portfolioId, assets: $assets) {
    portfolio {
      ...UserPortfolioFields
    }
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;
export type AddCompanyAssetsToPortfolioMutationFn = Apollo.MutationFunction<AddCompanyAssetsToPortfolioMutation, AddCompanyAssetsToPortfolioMutationVariables>;

/**
 * __useAddCompanyAssetsToPortfolioMutation__
 *
 * To run a mutation, you first call `useAddCompanyAssetsToPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyAssetsToPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyAssetsToPortfolioMutation, { data, loading, error }] = useAddCompanyAssetsToPortfolioMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      assets: // value for 'assets'
 *   },
 * });
 */
export function useAddCompanyAssetsToPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyAssetsToPortfolioMutation, AddCompanyAssetsToPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyAssetsToPortfolioMutation, AddCompanyAssetsToPortfolioMutationVariables>(AddCompanyAssetsToPortfolioDocument, options);
      }
export type AddCompanyAssetsToPortfolioMutationHookResult = ReturnType<typeof useAddCompanyAssetsToPortfolioMutation>;
export type AddCompanyAssetsToPortfolioMutationResult = Apollo.MutationResult<AddCompanyAssetsToPortfolioMutation>;
export type AddCompanyAssetsToPortfolioMutationOptions = Apollo.BaseMutationOptions<AddCompanyAssetsToPortfolioMutation, AddCompanyAssetsToPortfolioMutationVariables>;
export const AddEtcAssetsToPortfolioDocument = gql`
    mutation AddEtcAssetsToPortfolio($portfolioId: ID!, $assets: [UploadEtcAsset!]!) {
  addEtcAssetsToPortfolio(portfolioId: $portfolioId, assets: $assets) {
    portfolio {
      ...UserPortfolioFields
    }
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;
export type AddEtcAssetsToPortfolioMutationFn = Apollo.MutationFunction<AddEtcAssetsToPortfolioMutation, AddEtcAssetsToPortfolioMutationVariables>;

/**
 * __useAddEtcAssetsToPortfolioMutation__
 *
 * To run a mutation, you first call `useAddEtcAssetsToPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEtcAssetsToPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEtcAssetsToPortfolioMutation, { data, loading, error }] = useAddEtcAssetsToPortfolioMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      assets: // value for 'assets'
 *   },
 * });
 */
export function useAddEtcAssetsToPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<AddEtcAssetsToPortfolioMutation, AddEtcAssetsToPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEtcAssetsToPortfolioMutation, AddEtcAssetsToPortfolioMutationVariables>(AddEtcAssetsToPortfolioDocument, options);
      }
export type AddEtcAssetsToPortfolioMutationHookResult = ReturnType<typeof useAddEtcAssetsToPortfolioMutation>;
export type AddEtcAssetsToPortfolioMutationResult = Apollo.MutationResult<AddEtcAssetsToPortfolioMutation>;
export type AddEtcAssetsToPortfolioMutationOptions = Apollo.BaseMutationOptions<AddEtcAssetsToPortfolioMutation, AddEtcAssetsToPortfolioMutationVariables>;
export const AddCryptoCurrencyAssetsToPortfolioDocument = gql`
    mutation AddCryptoCurrencyAssetsToPortfolio($portfolioId: ID!, $assets: [UploadCryptoCurrencyAsset!]!) {
  addCryptoCurrencyAssetsToPortfolio(portfolioId: $portfolioId, assets: $assets) {
    portfolio {
      ...UserPortfolioFields
    }
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;
export type AddCryptoCurrencyAssetsToPortfolioMutationFn = Apollo.MutationFunction<AddCryptoCurrencyAssetsToPortfolioMutation, AddCryptoCurrencyAssetsToPortfolioMutationVariables>;

/**
 * __useAddCryptoCurrencyAssetsToPortfolioMutation__
 *
 * To run a mutation, you first call `useAddCryptoCurrencyAssetsToPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCryptoCurrencyAssetsToPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCryptoCurrencyAssetsToPortfolioMutation, { data, loading, error }] = useAddCryptoCurrencyAssetsToPortfolioMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      assets: // value for 'assets'
 *   },
 * });
 */
export function useAddCryptoCurrencyAssetsToPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<AddCryptoCurrencyAssetsToPortfolioMutation, AddCryptoCurrencyAssetsToPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCryptoCurrencyAssetsToPortfolioMutation, AddCryptoCurrencyAssetsToPortfolioMutationVariables>(AddCryptoCurrencyAssetsToPortfolioDocument, options);
      }
export type AddCryptoCurrencyAssetsToPortfolioMutationHookResult = ReturnType<typeof useAddCryptoCurrencyAssetsToPortfolioMutation>;
export type AddCryptoCurrencyAssetsToPortfolioMutationResult = Apollo.MutationResult<AddCryptoCurrencyAssetsToPortfolioMutation>;
export type AddCryptoCurrencyAssetsToPortfolioMutationOptions = Apollo.BaseMutationOptions<AddCryptoCurrencyAssetsToPortfolioMutation, AddCryptoCurrencyAssetsToPortfolioMutationVariables>;
export const RemovePortfolioAssetsDocument = gql`
    mutation RemovePortfolioAssets($portfolioId: ID!, $assetId: ID!) {
  removePortfolioAssets(portfolioId: $portfolioId, assets: [{id: $assetId}]) {
    portfolio {
      ...UserPortfolioFields
    }
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;
export type RemovePortfolioAssetsMutationFn = Apollo.MutationFunction<RemovePortfolioAssetsMutation, RemovePortfolioAssetsMutationVariables>;

/**
 * __useRemovePortfolioAssetsMutation__
 *
 * To run a mutation, you first call `useRemovePortfolioAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePortfolioAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePortfolioAssetsMutation, { data, loading, error }] = useRemovePortfolioAssetsMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useRemovePortfolioAssetsMutation(baseOptions?: Apollo.MutationHookOptions<RemovePortfolioAssetsMutation, RemovePortfolioAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePortfolioAssetsMutation, RemovePortfolioAssetsMutationVariables>(RemovePortfolioAssetsDocument, options);
      }
export type RemovePortfolioAssetsMutationHookResult = ReturnType<typeof useRemovePortfolioAssetsMutation>;
export type RemovePortfolioAssetsMutationResult = Apollo.MutationResult<RemovePortfolioAssetsMutation>;
export type RemovePortfolioAssetsMutationOptions = Apollo.BaseMutationOptions<RemovePortfolioAssetsMutation, RemovePortfolioAssetsMutationVariables>;
export const UpdatePortfolioAssetDocument = gql`
    mutation UpdatePortfolioAsset($portfolioId: ID!, $assetId: ID!, $avgPrice: String, $amount: String!, $name: String, $customPrice: String, $customTax: String) {
  updatePortfolioAsset(
    portfolioId: $portfolioId
    assetId: $assetId
    avgPrice: $avgPrice
    amount: $amount
    name: $name
    customPrice: $customPrice
    customTax: $customTax
  ) {
    asset {
      ...UserAssetFields
    }
  }
}
    ${UserAssetFieldsFragmentDoc}`;
export type UpdatePortfolioAssetMutationFn = Apollo.MutationFunction<UpdatePortfolioAssetMutation, UpdatePortfolioAssetMutationVariables>;

/**
 * __useUpdatePortfolioAssetMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioAssetMutation, { data, loading, error }] = useUpdatePortfolioAssetMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      assetId: // value for 'assetId'
 *      avgPrice: // value for 'avgPrice'
 *      amount: // value for 'amount'
 *      name: // value for 'name'
 *      customPrice: // value for 'customPrice'
 *      customTax: // value for 'customTax'
 *   },
 * });
 */
export function useUpdatePortfolioAssetMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioAssetMutation, UpdatePortfolioAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioAssetMutation, UpdatePortfolioAssetMutationVariables>(UpdatePortfolioAssetDocument, options);
      }
export type UpdatePortfolioAssetMutationHookResult = ReturnType<typeof useUpdatePortfolioAssetMutation>;
export type UpdatePortfolioAssetMutationResult = Apollo.MutationResult<UpdatePortfolioAssetMutation>;
export type UpdatePortfolioAssetMutationOptions = Apollo.BaseMutationOptions<UpdatePortfolioAssetMutation, UpdatePortfolioAssetMutationVariables>;
export const AddBackTestingProjectResultDocument = gql`
    mutation AddBackTestingProjectResult($backTestingProjectInputData: BackTestingProjectInput!) {
  addBackTestingProjectResult(
    backTestingProjectInputData: $backTestingProjectInputData
  ) {
    backTestingProjectResult {
      ...BackTestingProjectFields
    }
  }
}
    ${BackTestingProjectFieldsFragmentDoc}`;
export type AddBackTestingProjectResultMutationFn = Apollo.MutationFunction<AddBackTestingProjectResultMutation, AddBackTestingProjectResultMutationVariables>;

/**
 * __useAddBackTestingProjectResultMutation__
 *
 * To run a mutation, you first call `useAddBackTestingProjectResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBackTestingProjectResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBackTestingProjectResultMutation, { data, loading, error }] = useAddBackTestingProjectResultMutation({
 *   variables: {
 *      backTestingProjectInputData: // value for 'backTestingProjectInputData'
 *   },
 * });
 */
export function useAddBackTestingProjectResultMutation(baseOptions?: Apollo.MutationHookOptions<AddBackTestingProjectResultMutation, AddBackTestingProjectResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBackTestingProjectResultMutation, AddBackTestingProjectResultMutationVariables>(AddBackTestingProjectResultDocument, options);
      }
export type AddBackTestingProjectResultMutationHookResult = ReturnType<typeof useAddBackTestingProjectResultMutation>;
export type AddBackTestingProjectResultMutationResult = Apollo.MutationResult<AddBackTestingProjectResultMutation>;
export type AddBackTestingProjectResultMutationOptions = Apollo.BaseMutationOptions<AddBackTestingProjectResultMutation, AddBackTestingProjectResultMutationVariables>;
export const UpdateBackTestingProjectResultDocument = gql`
    mutation UpdateBackTestingProjectResult($backTestingProjectInputData: BackTestingProjectInput!, $slug: String!) {
  updateBackTestingProjectResult(
    backTestingProjectInputData: $backTestingProjectInputData
    slug: $slug
  ) {
    backTestingProjectResult {
      ...BackTestingProjectFields
    }
  }
}
    ${BackTestingProjectFieldsFragmentDoc}`;
export type UpdateBackTestingProjectResultMutationFn = Apollo.MutationFunction<UpdateBackTestingProjectResultMutation, UpdateBackTestingProjectResultMutationVariables>;

/**
 * __useUpdateBackTestingProjectResultMutation__
 *
 * To run a mutation, you first call `useUpdateBackTestingProjectResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBackTestingProjectResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBackTestingProjectResultMutation, { data, loading, error }] = useUpdateBackTestingProjectResultMutation({
 *   variables: {
 *      backTestingProjectInputData: // value for 'backTestingProjectInputData'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useUpdateBackTestingProjectResultMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBackTestingProjectResultMutation, UpdateBackTestingProjectResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBackTestingProjectResultMutation, UpdateBackTestingProjectResultMutationVariables>(UpdateBackTestingProjectResultDocument, options);
      }
export type UpdateBackTestingProjectResultMutationHookResult = ReturnType<typeof useUpdateBackTestingProjectResultMutation>;
export type UpdateBackTestingProjectResultMutationResult = Apollo.MutationResult<UpdateBackTestingProjectResultMutation>;
export type UpdateBackTestingProjectResultMutationOptions = Apollo.BaseMutationOptions<UpdateBackTestingProjectResultMutation, UpdateBackTestingProjectResultMutationVariables>;
export const RemoveBackTestingProjectResultDocument = gql`
    mutation RemoveBackTestingProjectResult($slug: String!) {
  removeBackTestingProjectResult(slug: $slug) {
    backTestingProject {
      id
    }
  }
}
    `;
export type RemoveBackTestingProjectResultMutationFn = Apollo.MutationFunction<RemoveBackTestingProjectResultMutation, RemoveBackTestingProjectResultMutationVariables>;

/**
 * __useRemoveBackTestingProjectResultMutation__
 *
 * To run a mutation, you first call `useRemoveBackTestingProjectResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBackTestingProjectResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBackTestingProjectResultMutation, { data, loading, error }] = useRemoveBackTestingProjectResultMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useRemoveBackTestingProjectResultMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBackTestingProjectResultMutation, RemoveBackTestingProjectResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBackTestingProjectResultMutation, RemoveBackTestingProjectResultMutationVariables>(RemoveBackTestingProjectResultDocument, options);
      }
export type RemoveBackTestingProjectResultMutationHookResult = ReturnType<typeof useRemoveBackTestingProjectResultMutation>;
export type RemoveBackTestingProjectResultMutationResult = Apollo.MutationResult<RemoveBackTestingProjectResultMutation>;
export type RemoveBackTestingProjectResultMutationOptions = Apollo.BaseMutationOptions<RemoveBackTestingProjectResultMutation, RemoveBackTestingProjectResultMutationVariables>;
export const MyBackTestingProjectsDocument = gql`
    query MyBackTestingProjects {
  myBackTestingProjects {
    ...BackTestingProjectFields
  }
}
    ${BackTestingProjectFieldsFragmentDoc}`;

/**
 * __useMyBackTestingProjectsQuery__
 *
 * To run a query within a React component, call `useMyBackTestingProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBackTestingProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBackTestingProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyBackTestingProjectsQuery(baseOptions?: Apollo.QueryHookOptions<MyBackTestingProjectsQuery, MyBackTestingProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyBackTestingProjectsQuery, MyBackTestingProjectsQueryVariables>(MyBackTestingProjectsDocument, options);
      }
export function useMyBackTestingProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyBackTestingProjectsQuery, MyBackTestingProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyBackTestingProjectsQuery, MyBackTestingProjectsQueryVariables>(MyBackTestingProjectsDocument, options);
        }
export type MyBackTestingProjectsQueryHookResult = ReturnType<typeof useMyBackTestingProjectsQuery>;
export type MyBackTestingProjectsLazyQueryHookResult = ReturnType<typeof useMyBackTestingProjectsLazyQuery>;
export type MyBackTestingProjectsQueryResult = Apollo.QueryResult<MyBackTestingProjectsQuery, MyBackTestingProjectsQueryVariables>;
export const BackTestingProjectDocument = gql`
    query BackTestingProject($slug: ID!) {
  backTestingProject(slug: $slug) {
    ...BackTestingProjectFields
  }
}
    ${BackTestingProjectFieldsFragmentDoc}`;

/**
 * __useBackTestingProjectQuery__
 *
 * To run a query within a React component, call `useBackTestingProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackTestingProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackTestingProjectQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useBackTestingProjectQuery(baseOptions: Apollo.QueryHookOptions<BackTestingProjectQuery, BackTestingProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BackTestingProjectQuery, BackTestingProjectQueryVariables>(BackTestingProjectDocument, options);
      }
export function useBackTestingProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BackTestingProjectQuery, BackTestingProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BackTestingProjectQuery, BackTestingProjectQueryVariables>(BackTestingProjectDocument, options);
        }
export type BackTestingProjectQueryHookResult = ReturnType<typeof useBackTestingProjectQuery>;
export type BackTestingProjectLazyQueryHookResult = ReturnType<typeof useBackTestingProjectLazyQuery>;
export type BackTestingProjectQueryResult = Apollo.QueryResult<BackTestingProjectQuery, BackTestingProjectQueryVariables>;
export const UpdateMyRepresentativeBadgeDocument = gql`
    mutation UpdateMyRepresentativeBadge($badgeId: ID!) {
  updateMyRepresentativeBadge(badgeId: $badgeId) {
    badge {
      ...BadgeFields
    }
  }
}
    ${BadgeFieldsFragmentDoc}`;
export type UpdateMyRepresentativeBadgeMutationFn = Apollo.MutationFunction<UpdateMyRepresentativeBadgeMutation, UpdateMyRepresentativeBadgeMutationVariables>;

/**
 * __useUpdateMyRepresentativeBadgeMutation__
 *
 * To run a mutation, you first call `useUpdateMyRepresentativeBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyRepresentativeBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyRepresentativeBadgeMutation, { data, loading, error }] = useUpdateMyRepresentativeBadgeMutation({
 *   variables: {
 *      badgeId: // value for 'badgeId'
 *   },
 * });
 */
export function useUpdateMyRepresentativeBadgeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyRepresentativeBadgeMutation, UpdateMyRepresentativeBadgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyRepresentativeBadgeMutation, UpdateMyRepresentativeBadgeMutationVariables>(UpdateMyRepresentativeBadgeDocument, options);
      }
export type UpdateMyRepresentativeBadgeMutationHookResult = ReturnType<typeof useUpdateMyRepresentativeBadgeMutation>;
export type UpdateMyRepresentativeBadgeMutationResult = Apollo.MutationResult<UpdateMyRepresentativeBadgeMutation>;
export type UpdateMyRepresentativeBadgeMutationOptions = Apollo.BaseMutationOptions<UpdateMyRepresentativeBadgeMutation, UpdateMyRepresentativeBadgeMutationVariables>;
export const RemoveMyRepresentativeBadgeDocument = gql`
    mutation RemoveMyRepresentativeBadge {
  removeMyRepresentativeBadge {
    badge {
      ...BadgeFields
    }
  }
}
    ${BadgeFieldsFragmentDoc}`;
export type RemoveMyRepresentativeBadgeMutationFn = Apollo.MutationFunction<RemoveMyRepresentativeBadgeMutation, RemoveMyRepresentativeBadgeMutationVariables>;

/**
 * __useRemoveMyRepresentativeBadgeMutation__
 *
 * To run a mutation, you first call `useRemoveMyRepresentativeBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMyRepresentativeBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMyRepresentativeBadgeMutation, { data, loading, error }] = useRemoveMyRepresentativeBadgeMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveMyRepresentativeBadgeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMyRepresentativeBadgeMutation, RemoveMyRepresentativeBadgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMyRepresentativeBadgeMutation, RemoveMyRepresentativeBadgeMutationVariables>(RemoveMyRepresentativeBadgeDocument, options);
      }
export type RemoveMyRepresentativeBadgeMutationHookResult = ReturnType<typeof useRemoveMyRepresentativeBadgeMutation>;
export type RemoveMyRepresentativeBadgeMutationResult = Apollo.MutationResult<RemoveMyRepresentativeBadgeMutation>;
export type RemoveMyRepresentativeBadgeMutationOptions = Apollo.BaseMutationOptions<RemoveMyRepresentativeBadgeMutation, RemoveMyRepresentativeBadgeMutationVariables>;
export const AcquireBadgeDocument = gql`
    mutation AcquireBadge($badgeId: ID!) {
  acquireBadge(badgeId: $badgeId) {
    badge {
      ...BadgeFields
    }
  }
}
    ${BadgeFieldsFragmentDoc}`;
export type AcquireBadgeMutationFn = Apollo.MutationFunction<AcquireBadgeMutation, AcquireBadgeMutationVariables>;

/**
 * __useAcquireBadgeMutation__
 *
 * To run a mutation, you first call `useAcquireBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcquireBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acquireBadgeMutation, { data, loading, error }] = useAcquireBadgeMutation({
 *   variables: {
 *      badgeId: // value for 'badgeId'
 *   },
 * });
 */
export function useAcquireBadgeMutation(baseOptions?: Apollo.MutationHookOptions<AcquireBadgeMutation, AcquireBadgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcquireBadgeMutation, AcquireBadgeMutationVariables>(AcquireBadgeDocument, options);
      }
export type AcquireBadgeMutationHookResult = ReturnType<typeof useAcquireBadgeMutation>;
export type AcquireBadgeMutationResult = Apollo.MutationResult<AcquireBadgeMutation>;
export type AcquireBadgeMutationOptions = Apollo.BaseMutationOptions<AcquireBadgeMutation, AcquireBadgeMutationVariables>;
export const UserBadgeListDocument = gql`
    query UserBadgeList($userId: ID!, $page: Int, $limit: Int!) {
  userBadgeList(userId: $userId, page: $page, limit: $limit) {
    ...BadgeFields
  }
}
    ${BadgeFieldsFragmentDoc}`;

/**
 * __useUserBadgeListQuery__
 *
 * To run a query within a React component, call `useUserBadgeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBadgeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBadgeListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUserBadgeListQuery(baseOptions: Apollo.QueryHookOptions<UserBadgeListQuery, UserBadgeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBadgeListQuery, UserBadgeListQueryVariables>(UserBadgeListDocument, options);
      }
export function useUserBadgeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBadgeListQuery, UserBadgeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBadgeListQuery, UserBadgeListQueryVariables>(UserBadgeListDocument, options);
        }
export type UserBadgeListQueryHookResult = ReturnType<typeof useUserBadgeListQuery>;
export type UserBadgeListLazyQueryHookResult = ReturnType<typeof useUserBadgeListLazyQuery>;
export type UserBadgeListQueryResult = Apollo.QueryResult<UserBadgeListQuery, UserBadgeListQueryVariables>;
export const UserAcquiredBadgeListDocument = gql`
    query UserAcquiredBadgeList($userId: ID!, $page: Int, $limit: Int!) {
  userAcquiredBadgeList(userId: $userId, page: $page, limit: $limit) {
    ...BadgeFields
  }
}
    ${BadgeFieldsFragmentDoc}`;

/**
 * __useUserAcquiredBadgeListQuery__
 *
 * To run a query within a React component, call `useUserAcquiredBadgeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAcquiredBadgeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAcquiredBadgeListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUserAcquiredBadgeListQuery(baseOptions: Apollo.QueryHookOptions<UserAcquiredBadgeListQuery, UserAcquiredBadgeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAcquiredBadgeListQuery, UserAcquiredBadgeListQueryVariables>(UserAcquiredBadgeListDocument, options);
      }
export function useUserAcquiredBadgeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAcquiredBadgeListQuery, UserAcquiredBadgeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAcquiredBadgeListQuery, UserAcquiredBadgeListQueryVariables>(UserAcquiredBadgeListDocument, options);
        }
export type UserAcquiredBadgeListQueryHookResult = ReturnType<typeof useUserAcquiredBadgeListQuery>;
export type UserAcquiredBadgeListLazyQueryHookResult = ReturnType<typeof useUserAcquiredBadgeListLazyQuery>;
export type UserAcquiredBadgeListQueryResult = Apollo.QueryResult<UserAcquiredBadgeListQuery, UserAcquiredBadgeListQueryVariables>;
export const BadgeDetailDocument = gql`
    query BadgeDetail($badgeId: ID!) {
  badgeDetail(badgeId: $badgeId) {
    ...BadgeFields
  }
}
    ${BadgeFieldsFragmentDoc}`;

/**
 * __useBadgeDetailQuery__
 *
 * To run a query within a React component, call `useBadgeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBadgeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBadgeDetailQuery({
 *   variables: {
 *      badgeId: // value for 'badgeId'
 *   },
 * });
 */
export function useBadgeDetailQuery(baseOptions: Apollo.QueryHookOptions<BadgeDetailQuery, BadgeDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BadgeDetailQuery, BadgeDetailQueryVariables>(BadgeDetailDocument, options);
      }
export function useBadgeDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BadgeDetailQuery, BadgeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BadgeDetailQuery, BadgeDetailQueryVariables>(BadgeDetailDocument, options);
        }
export type BadgeDetailQueryHookResult = ReturnType<typeof useBadgeDetailQuery>;
export type BadgeDetailLazyQueryHookResult = ReturnType<typeof useBadgeDetailLazyQuery>;
export type BadgeDetailQueryResult = Apollo.QueryResult<BadgeDetailQuery, BadgeDetailQueryVariables>;
export const AddArticleDocument = gql`
    mutation AddArticle($language: String!, $article: UploadArticle!) {
  addArticle(language: $language, article: $article) {
    article {
      ...ArticleFields
    }
  }
}
    ${ArticleFieldsFragmentDoc}`;
export type AddArticleMutationFn = Apollo.MutationFunction<AddArticleMutation, AddArticleMutationVariables>;

/**
 * __useAddArticleMutation__
 *
 * To run a mutation, you first call `useAddArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addArticleMutation, { data, loading, error }] = useAddArticleMutation({
 *   variables: {
 *      language: // value for 'language'
 *      article: // value for 'article'
 *   },
 * });
 */
export function useAddArticleMutation(baseOptions?: Apollo.MutationHookOptions<AddArticleMutation, AddArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddArticleMutation, AddArticleMutationVariables>(AddArticleDocument, options);
      }
export type AddArticleMutationHookResult = ReturnType<typeof useAddArticleMutation>;
export type AddArticleMutationResult = Apollo.MutationResult<AddArticleMutation>;
export type AddArticleMutationOptions = Apollo.BaseMutationOptions<AddArticleMutation, AddArticleMutationVariables>;
export const UpdateArticleDocument = gql`
    mutation UpdateArticle($articleId: ID!, $article: UploadArticle!) {
  updateArticle(article: $article, articleId: $articleId) {
    article {
      ...ArticleFields
    }
  }
}
    ${ArticleFieldsFragmentDoc}`;
export type UpdateArticleMutationFn = Apollo.MutationFunction<UpdateArticleMutation, UpdateArticleMutationVariables>;

/**
 * __useUpdateArticleMutation__
 *
 * To run a mutation, you first call `useUpdateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticleMutation, { data, loading, error }] = useUpdateArticleMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      article: // value for 'article'
 *   },
 * });
 */
export function useUpdateArticleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticleMutation, UpdateArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticleMutation, UpdateArticleMutationVariables>(UpdateArticleDocument, options);
      }
export type UpdateArticleMutationHookResult = ReturnType<typeof useUpdateArticleMutation>;
export type UpdateArticleMutationResult = Apollo.MutationResult<UpdateArticleMutation>;
export type UpdateArticleMutationOptions = Apollo.BaseMutationOptions<UpdateArticleMutation, UpdateArticleMutationVariables>;
export const RemoveArticleDocument = gql`
    mutation RemoveArticle($articleId: ID!) {
  removeArticle(articleId: $articleId) {
    article {
      id
    }
  }
}
    `;
export type RemoveArticleMutationFn = Apollo.MutationFunction<RemoveArticleMutation, RemoveArticleMutationVariables>;

/**
 * __useRemoveArticleMutation__
 *
 * To run a mutation, you first call `useRemoveArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeArticleMutation, { data, loading, error }] = useRemoveArticleMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useRemoveArticleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveArticleMutation, RemoveArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveArticleMutation, RemoveArticleMutationVariables>(RemoveArticleDocument, options);
      }
export type RemoveArticleMutationHookResult = ReturnType<typeof useRemoveArticleMutation>;
export type RemoveArticleMutationResult = Apollo.MutationResult<RemoveArticleMutation>;
export type RemoveArticleMutationOptions = Apollo.BaseMutationOptions<RemoveArticleMutation, RemoveArticleMutationVariables>;
export const AddArticleCommentDocument = gql`
    mutation AddArticleComment($articleId: ID!, $commnet: UploadArticleComment!) {
  addArticleComment(articleId: $articleId, comment: $commnet) {
    comment {
      ...ArticleCommentFields
    }
  }
}
    ${ArticleCommentFieldsFragmentDoc}`;
export type AddArticleCommentMutationFn = Apollo.MutationFunction<AddArticleCommentMutation, AddArticleCommentMutationVariables>;

/**
 * __useAddArticleCommentMutation__
 *
 * To run a mutation, you first call `useAddArticleCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddArticleCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addArticleCommentMutation, { data, loading, error }] = useAddArticleCommentMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      commnet: // value for 'commnet'
 *   },
 * });
 */
export function useAddArticleCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddArticleCommentMutation, AddArticleCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddArticleCommentMutation, AddArticleCommentMutationVariables>(AddArticleCommentDocument, options);
      }
export type AddArticleCommentMutationHookResult = ReturnType<typeof useAddArticleCommentMutation>;
export type AddArticleCommentMutationResult = Apollo.MutationResult<AddArticleCommentMutation>;
export type AddArticleCommentMutationOptions = Apollo.BaseMutationOptions<AddArticleCommentMutation, AddArticleCommentMutationVariables>;
export const UpdateArticleCommentDocument = gql`
    mutation UpdateArticleComment($commentId: ID!, $commnet: UploadArticleComment!) {
  updateArticleComment(commentId: $commentId, comment: $commnet) {
    comment {
      ...ArticleCommentFields
    }
  }
}
    ${ArticleCommentFieldsFragmentDoc}`;
export type UpdateArticleCommentMutationFn = Apollo.MutationFunction<UpdateArticleCommentMutation, UpdateArticleCommentMutationVariables>;

/**
 * __useUpdateArticleCommentMutation__
 *
 * To run a mutation, you first call `useUpdateArticleCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticleCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticleCommentMutation, { data, loading, error }] = useUpdateArticleCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      commnet: // value for 'commnet'
 *   },
 * });
 */
export function useUpdateArticleCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticleCommentMutation, UpdateArticleCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticleCommentMutation, UpdateArticleCommentMutationVariables>(UpdateArticleCommentDocument, options);
      }
export type UpdateArticleCommentMutationHookResult = ReturnType<typeof useUpdateArticleCommentMutation>;
export type UpdateArticleCommentMutationResult = Apollo.MutationResult<UpdateArticleCommentMutation>;
export type UpdateArticleCommentMutationOptions = Apollo.BaseMutationOptions<UpdateArticleCommentMutation, UpdateArticleCommentMutationVariables>;
export const RemoveArticleCommentDocument = gql`
    mutation RemoveArticleComment($commentId: ID!) {
  removeArticleComment(commentId: $commentId) {
    comment {
      id
    }
  }
}
    `;
export type RemoveArticleCommentMutationFn = Apollo.MutationFunction<RemoveArticleCommentMutation, RemoveArticleCommentMutationVariables>;

/**
 * __useRemoveArticleCommentMutation__
 *
 * To run a mutation, you first call `useRemoveArticleCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveArticleCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeArticleCommentMutation, { data, loading, error }] = useRemoveArticleCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useRemoveArticleCommentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveArticleCommentMutation, RemoveArticleCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveArticleCommentMutation, RemoveArticleCommentMutationVariables>(RemoveArticleCommentDocument, options);
      }
export type RemoveArticleCommentMutationHookResult = ReturnType<typeof useRemoveArticleCommentMutation>;
export type RemoveArticleCommentMutationResult = Apollo.MutationResult<RemoveArticleCommentMutation>;
export type RemoveArticleCommentMutationOptions = Apollo.BaseMutationOptions<RemoveArticleCommentMutation, RemoveArticleCommentMutationVariables>;
export const AddReplyToArticleCommentDocument = gql`
    mutation AddReplyToArticleComment($commentId: ID!, $reply: UploadArticleCommentReply!) {
  addReplyToArticleComment(commentId: $commentId, reply: $reply) {
    reply {
      ...ArticleCommentReplyFields
    }
  }
}
    ${ArticleCommentReplyFieldsFragmentDoc}`;
export type AddReplyToArticleCommentMutationFn = Apollo.MutationFunction<AddReplyToArticleCommentMutation, AddReplyToArticleCommentMutationVariables>;

/**
 * __useAddReplyToArticleCommentMutation__
 *
 * To run a mutation, you first call `useAddReplyToArticleCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReplyToArticleCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReplyToArticleCommentMutation, { data, loading, error }] = useAddReplyToArticleCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      reply: // value for 'reply'
 *   },
 * });
 */
export function useAddReplyToArticleCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddReplyToArticleCommentMutation, AddReplyToArticleCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReplyToArticleCommentMutation, AddReplyToArticleCommentMutationVariables>(AddReplyToArticleCommentDocument, options);
      }
export type AddReplyToArticleCommentMutationHookResult = ReturnType<typeof useAddReplyToArticleCommentMutation>;
export type AddReplyToArticleCommentMutationResult = Apollo.MutationResult<AddReplyToArticleCommentMutation>;
export type AddReplyToArticleCommentMutationOptions = Apollo.BaseMutationOptions<AddReplyToArticleCommentMutation, AddReplyToArticleCommentMutationVariables>;
export const AddArticleToLikeDocument = gql`
    mutation AddArticleToLike($articleId: ID!) {
  addLikeToArticle(articleId: $articleId) {
    article {
      id
      isLiked
      likesCount
    }
  }
}
    `;
export type AddArticleToLikeMutationFn = Apollo.MutationFunction<AddArticleToLikeMutation, AddArticleToLikeMutationVariables>;

/**
 * __useAddArticleToLikeMutation__
 *
 * To run a mutation, you first call `useAddArticleToLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddArticleToLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addArticleToLikeMutation, { data, loading, error }] = useAddArticleToLikeMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useAddArticleToLikeMutation(baseOptions?: Apollo.MutationHookOptions<AddArticleToLikeMutation, AddArticleToLikeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddArticleToLikeMutation, AddArticleToLikeMutationVariables>(AddArticleToLikeDocument, options);
      }
export type AddArticleToLikeMutationHookResult = ReturnType<typeof useAddArticleToLikeMutation>;
export type AddArticleToLikeMutationResult = Apollo.MutationResult<AddArticleToLikeMutation>;
export type AddArticleToLikeMutationOptions = Apollo.BaseMutationOptions<AddArticleToLikeMutation, AddArticleToLikeMutationVariables>;
export const RemoveArticleToLikeDocument = gql`
    mutation RemoveArticleToLike($articleId: ID!) {
  removeLikeToArticle(articleId: $articleId) {
    article {
      id
      isLiked
      likesCount
    }
  }
}
    `;
export type RemoveArticleToLikeMutationFn = Apollo.MutationFunction<RemoveArticleToLikeMutation, RemoveArticleToLikeMutationVariables>;

/**
 * __useRemoveArticleToLikeMutation__
 *
 * To run a mutation, you first call `useRemoveArticleToLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveArticleToLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeArticleToLikeMutation, { data, loading, error }] = useRemoveArticleToLikeMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useRemoveArticleToLikeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveArticleToLikeMutation, RemoveArticleToLikeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveArticleToLikeMutation, RemoveArticleToLikeMutationVariables>(RemoveArticleToLikeDocument, options);
      }
export type RemoveArticleToLikeMutationHookResult = ReturnType<typeof useRemoveArticleToLikeMutation>;
export type RemoveArticleToLikeMutationResult = Apollo.MutationResult<RemoveArticleToLikeMutation>;
export type RemoveArticleToLikeMutationOptions = Apollo.BaseMutationOptions<RemoveArticleToLikeMutation, RemoveArticleToLikeMutationVariables>;
export const AddBookmarkToArticleDocument = gql`
    mutation AddBookmarkToArticle($articleId: ID!) {
  addBookmarkToArticle(articleId: $articleId) {
    article {
      id
      isBookmarked
    }
  }
}
    `;
export type AddBookmarkToArticleMutationFn = Apollo.MutationFunction<AddBookmarkToArticleMutation, AddBookmarkToArticleMutationVariables>;

/**
 * __useAddBookmarkToArticleMutation__
 *
 * To run a mutation, you first call `useAddBookmarkToArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBookmarkToArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBookmarkToArticleMutation, { data, loading, error }] = useAddBookmarkToArticleMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useAddBookmarkToArticleMutation(baseOptions?: Apollo.MutationHookOptions<AddBookmarkToArticleMutation, AddBookmarkToArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBookmarkToArticleMutation, AddBookmarkToArticleMutationVariables>(AddBookmarkToArticleDocument, options);
      }
export type AddBookmarkToArticleMutationHookResult = ReturnType<typeof useAddBookmarkToArticleMutation>;
export type AddBookmarkToArticleMutationResult = Apollo.MutationResult<AddBookmarkToArticleMutation>;
export type AddBookmarkToArticleMutationOptions = Apollo.BaseMutationOptions<AddBookmarkToArticleMutation, AddBookmarkToArticleMutationVariables>;
export const RemoveBookmarkFromArticleDocument = gql`
    mutation RemoveBookmarkFromArticle($articleId: ID!) {
  removeBookmarkFromArticle(articleId: $articleId) {
    article {
      id
      isBookmarked
    }
  }
}
    `;
export type RemoveBookmarkFromArticleMutationFn = Apollo.MutationFunction<RemoveBookmarkFromArticleMutation, RemoveBookmarkFromArticleMutationVariables>;

/**
 * __useRemoveBookmarkFromArticleMutation__
 *
 * To run a mutation, you first call `useRemoveBookmarkFromArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBookmarkFromArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBookmarkFromArticleMutation, { data, loading, error }] = useRemoveBookmarkFromArticleMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useRemoveBookmarkFromArticleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBookmarkFromArticleMutation, RemoveBookmarkFromArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBookmarkFromArticleMutation, RemoveBookmarkFromArticleMutationVariables>(RemoveBookmarkFromArticleDocument, options);
      }
export type RemoveBookmarkFromArticleMutationHookResult = ReturnType<typeof useRemoveBookmarkFromArticleMutation>;
export type RemoveBookmarkFromArticleMutationResult = Apollo.MutationResult<RemoveBookmarkFromArticleMutation>;
export type RemoveBookmarkFromArticleMutationOptions = Apollo.BaseMutationOptions<RemoveBookmarkFromArticleMutation, RemoveBookmarkFromArticleMutationVariables>;
export const ConfirmCommunityNotificationsDocument = gql`
    mutation ConfirmCommunityNotifications($communityNotificationIds: [ID!]!) {
  confirmCommunityNotifications(
    communityNotificationIds: $communityNotificationIds
  ) {
    communityNotifications {
      ...CommunityNotificationFields
    }
  }
}
    ${CommunityNotificationFieldsFragmentDoc}`;
export type ConfirmCommunityNotificationsMutationFn = Apollo.MutationFunction<ConfirmCommunityNotificationsMutation, ConfirmCommunityNotificationsMutationVariables>;

/**
 * __useConfirmCommunityNotificationsMutation__
 *
 * To run a mutation, you first call `useConfirmCommunityNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCommunityNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCommunityNotificationsMutation, { data, loading, error }] = useConfirmCommunityNotificationsMutation({
 *   variables: {
 *      communityNotificationIds: // value for 'communityNotificationIds'
 *   },
 * });
 */
export function useConfirmCommunityNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCommunityNotificationsMutation, ConfirmCommunityNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmCommunityNotificationsMutation, ConfirmCommunityNotificationsMutationVariables>(ConfirmCommunityNotificationsDocument, options);
      }
export type ConfirmCommunityNotificationsMutationHookResult = ReturnType<typeof useConfirmCommunityNotificationsMutation>;
export type ConfirmCommunityNotificationsMutationResult = Apollo.MutationResult<ConfirmCommunityNotificationsMutation>;
export type ConfirmCommunityNotificationsMutationOptions = Apollo.BaseMutationOptions<ConfirmCommunityNotificationsMutation, ConfirmCommunityNotificationsMutationVariables>;
export const FollowItemDocument = gql`
    mutation FollowItem($followUserId: ID, $followCompanyId: ID, $followCryptoCurrencyId: ID, $language: String!) {
  followItem(
    followUserId: $followUserId
    followCompanyId: $followCompanyId
    followCryptoCurrencyId: $followCryptoCurrencyId
    language: $language
  ) {
    item {
      id
      isFollowing
    }
  }
}
    `;
export type FollowItemMutationFn = Apollo.MutationFunction<FollowItemMutation, FollowItemMutationVariables>;

/**
 * __useFollowItemMutation__
 *
 * To run a mutation, you first call `useFollowItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followItemMutation, { data, loading, error }] = useFollowItemMutation({
 *   variables: {
 *      followUserId: // value for 'followUserId'
 *      followCompanyId: // value for 'followCompanyId'
 *      followCryptoCurrencyId: // value for 'followCryptoCurrencyId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useFollowItemMutation(baseOptions?: Apollo.MutationHookOptions<FollowItemMutation, FollowItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowItemMutation, FollowItemMutationVariables>(FollowItemDocument, options);
      }
export type FollowItemMutationHookResult = ReturnType<typeof useFollowItemMutation>;
export type FollowItemMutationResult = Apollo.MutationResult<FollowItemMutation>;
export type FollowItemMutationOptions = Apollo.BaseMutationOptions<FollowItemMutation, FollowItemMutationVariables>;
export const FollowItemsDocument = gql`
    mutation FollowItems($followCompanyIds: [ID!], $followCryptoCurrencyIds: [ID!], $language: String!) {
  followItems(
    followCompanyIds: $followCompanyIds
    followCryptoCurrencyIds: $followCryptoCurrencyIds
    language: $language
  ) {
    items {
      id
      isFollowing
    }
  }
}
    `;
export type FollowItemsMutationFn = Apollo.MutationFunction<FollowItemsMutation, FollowItemsMutationVariables>;

/**
 * __useFollowItemsMutation__
 *
 * To run a mutation, you first call `useFollowItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followItemsMutation, { data, loading, error }] = useFollowItemsMutation({
 *   variables: {
 *      followCompanyIds: // value for 'followCompanyIds'
 *      followCryptoCurrencyIds: // value for 'followCryptoCurrencyIds'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useFollowItemsMutation(baseOptions?: Apollo.MutationHookOptions<FollowItemsMutation, FollowItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowItemsMutation, FollowItemsMutationVariables>(FollowItemsDocument, options);
      }
export type FollowItemsMutationHookResult = ReturnType<typeof useFollowItemsMutation>;
export type FollowItemsMutationResult = Apollo.MutationResult<FollowItemsMutation>;
export type FollowItemsMutationOptions = Apollo.BaseMutationOptions<FollowItemsMutation, FollowItemsMutationVariables>;
export const UnfollowItemDocument = gql`
    mutation UnfollowItem($followUserId: ID, $followCompanyId: ID, $followCryptoCurrencyId: ID, $language: String!) {
  unfollowItem(
    followUserId: $followUserId
    followCompanyId: $followCompanyId
    followCryptoCurrencyId: $followCryptoCurrencyId
    language: $language
  ) {
    item {
      id
      isFollowing
    }
  }
}
    `;
export type UnfollowItemMutationFn = Apollo.MutationFunction<UnfollowItemMutation, UnfollowItemMutationVariables>;

/**
 * __useUnfollowItemMutation__
 *
 * To run a mutation, you first call `useUnfollowItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowItemMutation, { data, loading, error }] = useUnfollowItemMutation({
 *   variables: {
 *      followUserId: // value for 'followUserId'
 *      followCompanyId: // value for 'followCompanyId'
 *      followCryptoCurrencyId: // value for 'followCryptoCurrencyId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUnfollowItemMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowItemMutation, UnfollowItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowItemMutation, UnfollowItemMutationVariables>(UnfollowItemDocument, options);
      }
export type UnfollowItemMutationHookResult = ReturnType<typeof useUnfollowItemMutation>;
export type UnfollowItemMutationResult = Apollo.MutationResult<UnfollowItemMutation>;
export type UnfollowItemMutationOptions = Apollo.BaseMutationOptions<UnfollowItemMutation, UnfollowItemMutationVariables>;
export const UnfollowItemsDocument = gql`
    mutation UnfollowItems($followUserIds: [ID!], $followCompanyIds: [ID!], $followCryptoCurrencyIds: [ID!], $language: String!) {
  unfollowItems(
    followUserIds: $followUserIds
    followCompanyIds: $followCompanyIds
    followCryptoCurrencyIds: $followCryptoCurrencyIds
    language: $language
  ) {
    items {
      id
      isFollowing
    }
  }
}
    `;
export type UnfollowItemsMutationFn = Apollo.MutationFunction<UnfollowItemsMutation, UnfollowItemsMutationVariables>;

/**
 * __useUnfollowItemsMutation__
 *
 * To run a mutation, you first call `useUnfollowItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowItemsMutation, { data, loading, error }] = useUnfollowItemsMutation({
 *   variables: {
 *      followUserIds: // value for 'followUserIds'
 *      followCompanyIds: // value for 'followCompanyIds'
 *      followCryptoCurrencyIds: // value for 'followCryptoCurrencyIds'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUnfollowItemsMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowItemsMutation, UnfollowItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowItemsMutation, UnfollowItemsMutationVariables>(UnfollowItemsDocument, options);
      }
export type UnfollowItemsMutationHookResult = ReturnType<typeof useUnfollowItemsMutation>;
export type UnfollowItemsMutationResult = Apollo.MutationResult<UnfollowItemsMutation>;
export type UnfollowItemsMutationOptions = Apollo.BaseMutationOptions<UnfollowItemsMutation, UnfollowItemsMutationVariables>;
export const AddCommunityReportDocument = gql`
    mutation addCommunityReport($communityReport: CommunityReportInput!) {
  addCommunityReport(communityReport: $communityReport) {
    communityReport {
      reporterId
    }
  }
}
    `;
export type AddCommunityReportMutationFn = Apollo.MutationFunction<AddCommunityReportMutation, AddCommunityReportMutationVariables>;

/**
 * __useAddCommunityReportMutation__
 *
 * To run a mutation, you first call `useAddCommunityReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommunityReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommunityReportMutation, { data, loading, error }] = useAddCommunityReportMutation({
 *   variables: {
 *      communityReport: // value for 'communityReport'
 *   },
 * });
 */
export function useAddCommunityReportMutation(baseOptions?: Apollo.MutationHookOptions<AddCommunityReportMutation, AddCommunityReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommunityReportMutation, AddCommunityReportMutationVariables>(AddCommunityReportDocument, options);
      }
export type AddCommunityReportMutationHookResult = ReturnType<typeof useAddCommunityReportMutation>;
export type AddCommunityReportMutationResult = Apollo.MutationResult<AddCommunityReportMutation>;
export type AddCommunityReportMutationOptions = Apollo.BaseMutationOptions<AddCommunityReportMutation, AddCommunityReportMutationVariables>;
export const BlockUserDocument = gql`
    mutation BlockUser($userId: ID!) {
  blockUser(userId: $userId) {
    user {
      id
      nickname
    }
  }
}
    `;
export type BlockUserMutationFn = Apollo.MutationFunction<BlockUserMutation, BlockUserMutationVariables>;

/**
 * __useBlockUserMutation__
 *
 * To run a mutation, you first call `useBlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockUserMutation, { data, loading, error }] = useBlockUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBlockUserMutation(baseOptions?: Apollo.MutationHookOptions<BlockUserMutation, BlockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockUserMutation, BlockUserMutationVariables>(BlockUserDocument, options);
      }
export type BlockUserMutationHookResult = ReturnType<typeof useBlockUserMutation>;
export type BlockUserMutationResult = Apollo.MutationResult<BlockUserMutation>;
export type BlockUserMutationOptions = Apollo.BaseMutationOptions<BlockUserMutation, BlockUserMutationVariables>;
export const UnblockUserDocument = gql`
    mutation UnblockUser($userId: ID!) {
  unblockUser(userId: $userId) {
    user {
      id
      nickname
    }
  }
}
    `;
export type UnblockUserMutationFn = Apollo.MutationFunction<UnblockUserMutation, UnblockUserMutationVariables>;

/**
 * __useUnblockUserMutation__
 *
 * To run a mutation, you first call `useUnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockUserMutation, { data, loading, error }] = useUnblockUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnblockUserMutation(baseOptions?: Apollo.MutationHookOptions<UnblockUserMutation, UnblockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockUserMutation, UnblockUserMutationVariables>(UnblockUserDocument, options);
      }
export type UnblockUserMutationHookResult = ReturnType<typeof useUnblockUserMutation>;
export type UnblockUserMutationResult = Apollo.MutationResult<UnblockUserMutation>;
export type UnblockUserMutationOptions = Apollo.BaseMutationOptions<UnblockUserMutation, UnblockUserMutationVariables>;
export const FeedTopicsWithPortfolioTopicsDocument = gql`
    query FeedTopicsWithPortfolioTopics($communityLanguage: String) {
  feedTopics(communityLanguage: $communityLanguage) {
    ...FeedTopicFields
  }
  publicPortfolioTopics {
    ...PortfolioTopicFields
  }
}
    ${FeedTopicFieldsFragmentDoc}
${PortfolioTopicFieldsFragmentDoc}`;

/**
 * __useFeedTopicsWithPortfolioTopicsQuery__
 *
 * To run a query within a React component, call `useFeedTopicsWithPortfolioTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedTopicsWithPortfolioTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedTopicsWithPortfolioTopicsQuery({
 *   variables: {
 *      communityLanguage: // value for 'communityLanguage'
 *   },
 * });
 */
export function useFeedTopicsWithPortfolioTopicsQuery(baseOptions?: Apollo.QueryHookOptions<FeedTopicsWithPortfolioTopicsQuery, FeedTopicsWithPortfolioTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedTopicsWithPortfolioTopicsQuery, FeedTopicsWithPortfolioTopicsQueryVariables>(FeedTopicsWithPortfolioTopicsDocument, options);
      }
export function useFeedTopicsWithPortfolioTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedTopicsWithPortfolioTopicsQuery, FeedTopicsWithPortfolioTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedTopicsWithPortfolioTopicsQuery, FeedTopicsWithPortfolioTopicsQueryVariables>(FeedTopicsWithPortfolioTopicsDocument, options);
        }
export type FeedTopicsWithPortfolioTopicsQueryHookResult = ReturnType<typeof useFeedTopicsWithPortfolioTopicsQuery>;
export type FeedTopicsWithPortfolioTopicsLazyQueryHookResult = ReturnType<typeof useFeedTopicsWithPortfolioTopicsLazyQuery>;
export type FeedTopicsWithPortfolioTopicsQueryResult = Apollo.QueryResult<FeedTopicsWithPortfolioTopicsQuery, FeedTopicsWithPortfolioTopicsQueryVariables>;
export const PublicPortfolioTopicsDocument = gql`
    query PublicPortfolioTopics {
  publicPortfolioTopics {
    ...PortfolioTopicFields
  }
}
    ${PortfolioTopicFieldsFragmentDoc}`;

/**
 * __usePublicPortfolioTopicsQuery__
 *
 * To run a query within a React component, call `usePublicPortfolioTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicPortfolioTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicPortfolioTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicPortfolioTopicsQuery(baseOptions?: Apollo.QueryHookOptions<PublicPortfolioTopicsQuery, PublicPortfolioTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicPortfolioTopicsQuery, PublicPortfolioTopicsQueryVariables>(PublicPortfolioTopicsDocument, options);
      }
export function usePublicPortfolioTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicPortfolioTopicsQuery, PublicPortfolioTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicPortfolioTopicsQuery, PublicPortfolioTopicsQueryVariables>(PublicPortfolioTopicsDocument, options);
        }
export type PublicPortfolioTopicsQueryHookResult = ReturnType<typeof usePublicPortfolioTopicsQuery>;
export type PublicPortfolioTopicsLazyQueryHookResult = ReturnType<typeof usePublicPortfolioTopicsLazyQuery>;
export type PublicPortfolioTopicsQueryResult = Apollo.QueryResult<PublicPortfolioTopicsQuery, PublicPortfolioTopicsQueryVariables>;
export const TimelineFeedDocument = gql`
    query TimelineFeed($language: String!, $limit: Int!, $feedTopicId: ID, $startDate: String, $portfolioTopicId: ID, $includeInfluencerArticle: Boolean) {
  timelineFeed(
    language: $language
    limit: $limit
    feedTopicId: $feedTopicId
    startDate: $startDate
    portfolioTopicId: $portfolioTopicId
    includeInfluencerArticle: $includeInfluencerArticle
  ) {
    ...ArticleFields
  }
}
    ${ArticleFieldsFragmentDoc}`;

/**
 * __useTimelineFeedQuery__
 *
 * To run a query within a React component, call `useTimelineFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineFeedQuery({
 *   variables: {
 *      language: // value for 'language'
 *      limit: // value for 'limit'
 *      feedTopicId: // value for 'feedTopicId'
 *      startDate: // value for 'startDate'
 *      portfolioTopicId: // value for 'portfolioTopicId'
 *      includeInfluencerArticle: // value for 'includeInfluencerArticle'
 *   },
 * });
 */
export function useTimelineFeedQuery(baseOptions: Apollo.QueryHookOptions<TimelineFeedQuery, TimelineFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimelineFeedQuery, TimelineFeedQueryVariables>(TimelineFeedDocument, options);
      }
export function useTimelineFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimelineFeedQuery, TimelineFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimelineFeedQuery, TimelineFeedQueryVariables>(TimelineFeedDocument, options);
        }
export type TimelineFeedQueryHookResult = ReturnType<typeof useTimelineFeedQuery>;
export type TimelineFeedLazyQueryHookResult = ReturnType<typeof useTimelineFeedLazyQuery>;
export type TimelineFeedQueryResult = Apollo.QueryResult<TimelineFeedQuery, TimelineFeedQueryVariables>;
export const FeedFilteredByTagDocument = gql`
    query FeedFilteredByTag($language: String!, $limit: Int!, $startDate: String, $assetTagId: ID!) {
  feedFilteredByTag(
    language: $language
    limit: $limit
    startDate: $startDate
    assetTagId: $assetTagId
  ) {
    articles {
      ...ArticleFields
    }
    assetTagTitle {
      ...AssetTagTitleFields
    }
  }
}
    ${ArticleFieldsFragmentDoc}
${AssetTagTitleFieldsFragmentDoc}`;

/**
 * __useFeedFilteredByTagQuery__
 *
 * To run a query within a React component, call `useFeedFilteredByTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedFilteredByTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedFilteredByTagQuery({
 *   variables: {
 *      language: // value for 'language'
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *      assetTagId: // value for 'assetTagId'
 *   },
 * });
 */
export function useFeedFilteredByTagQuery(baseOptions: Apollo.QueryHookOptions<FeedFilteredByTagQuery, FeedFilteredByTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedFilteredByTagQuery, FeedFilteredByTagQueryVariables>(FeedFilteredByTagDocument, options);
      }
export function useFeedFilteredByTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedFilteredByTagQuery, FeedFilteredByTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedFilteredByTagQuery, FeedFilteredByTagQueryVariables>(FeedFilteredByTagDocument, options);
        }
export type FeedFilteredByTagQueryHookResult = ReturnType<typeof useFeedFilteredByTagQuery>;
export type FeedFilteredByTagLazyQueryHookResult = ReturnType<typeof useFeedFilteredByTagLazyQuery>;
export type FeedFilteredByTagQueryResult = Apollo.QueryResult<FeedFilteredByTagQuery, FeedFilteredByTagQueryVariables>;
export const ArticleDocument = gql`
    query Article($articleId: ID!) {
  article(articleId: $articleId) {
    ...ArticleFields
  }
}
    ${ArticleFieldsFragmentDoc}`;

/**
 * __useArticleQuery__
 *
 * To run a query within a React component, call `useArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useArticleQuery(baseOptions: Apollo.QueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, options);
      }
export function useArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, options);
        }
export type ArticleQueryHookResult = ReturnType<typeof useArticleQuery>;
export type ArticleLazyQueryHookResult = ReturnType<typeof useArticleLazyQuery>;
export type ArticleQueryResult = Apollo.QueryResult<ArticleQuery, ArticleQueryVariables>;
export const FavoriteArticlesInTopicDocument = gql`
    query FavoriteArticlesInTopic($feedTopicId: ID, $language: String!, $limit: Int!) {
  favoriteArticlesInTopic(
    feedTopicId: $feedTopicId
    language: $language
    limit: $limit
  ) {
    ...ArticleFields
  }
}
    ${ArticleFieldsFragmentDoc}`;

/**
 * __useFavoriteArticlesInTopicQuery__
 *
 * To run a query within a React component, call `useFavoriteArticlesInTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteArticlesInTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteArticlesInTopicQuery({
 *   variables: {
 *      feedTopicId: // value for 'feedTopicId'
 *      language: // value for 'language'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFavoriteArticlesInTopicQuery(baseOptions: Apollo.QueryHookOptions<FavoriteArticlesInTopicQuery, FavoriteArticlesInTopicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoriteArticlesInTopicQuery, FavoriteArticlesInTopicQueryVariables>(FavoriteArticlesInTopicDocument, options);
      }
export function useFavoriteArticlesInTopicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoriteArticlesInTopicQuery, FavoriteArticlesInTopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoriteArticlesInTopicQuery, FavoriteArticlesInTopicQueryVariables>(FavoriteArticlesInTopicDocument, options);
        }
export type FavoriteArticlesInTopicQueryHookResult = ReturnType<typeof useFavoriteArticlesInTopicQuery>;
export type FavoriteArticlesInTopicLazyQueryHookResult = ReturnType<typeof useFavoriteArticlesInTopicLazyQuery>;
export type FavoriteArticlesInTopicQueryResult = Apollo.QueryResult<FavoriteArticlesInTopicQuery, FavoriteArticlesInTopicQueryVariables>;
export const ArticleCommentsDocument = gql`
    query ArticleComments($articleId: ID!, $startDate: String, $limit: Int) {
  articleComments(articleId: $articleId, startDate: $startDate, limit: $limit) {
    ...ArticleCommentFields
  }
}
    ${ArticleCommentFieldsFragmentDoc}`;

/**
 * __useArticleCommentsQuery__
 *
 * To run a query within a React component, call `useArticleCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleCommentsQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      startDate: // value for 'startDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useArticleCommentsQuery(baseOptions: Apollo.QueryHookOptions<ArticleCommentsQuery, ArticleCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleCommentsQuery, ArticleCommentsQueryVariables>(ArticleCommentsDocument, options);
      }
export function useArticleCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleCommentsQuery, ArticleCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleCommentsQuery, ArticleCommentsQueryVariables>(ArticleCommentsDocument, options);
        }
export type ArticleCommentsQueryHookResult = ReturnType<typeof useArticleCommentsQuery>;
export type ArticleCommentsLazyQueryHookResult = ReturnType<typeof useArticleCommentsLazyQuery>;
export type ArticleCommentsQueryResult = Apollo.QueryResult<ArticleCommentsQuery, ArticleCommentsQueryVariables>;
export const SearchAssetTagsDocument = gql`
    query SearchAssetTags($keyword: String!, $language: String!) {
  searchAssetTags(keyword: $keyword, language: $language) {
    ...AssetTagFields
  }
}
    ${AssetTagFieldsFragmentDoc}`;

/**
 * __useSearchAssetTagsQuery__
 *
 * To run a query within a React component, call `useSearchAssetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAssetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAssetTagsQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSearchAssetTagsQuery(baseOptions: Apollo.QueryHookOptions<SearchAssetTagsQuery, SearchAssetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAssetTagsQuery, SearchAssetTagsQueryVariables>(SearchAssetTagsDocument, options);
      }
export function useSearchAssetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAssetTagsQuery, SearchAssetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAssetTagsQuery, SearchAssetTagsQueryVariables>(SearchAssetTagsDocument, options);
        }
export type SearchAssetTagsQueryHookResult = ReturnType<typeof useSearchAssetTagsQuery>;
export type SearchAssetTagsLazyQueryHookResult = ReturnType<typeof useSearchAssetTagsLazyQuery>;
export type SearchAssetTagsQueryResult = Apollo.QueryResult<SearchAssetTagsQuery, SearchAssetTagsQueryVariables>;
export const MyFollowingsDocument = gql`
    query MyFollowings($itemType: FollowingItemEnum, $language: String!, $page: Int, $limit: Int!, $sortOrderType: MyFollowingSortOrderEnum!) {
  myFollowings(
    itemType: $itemType
    language: $language
    page: $page
    limit: $limit
    sortOrderType: $sortOrderType
  ) {
    ...SearchFollowItemsFields
  }
}
    ${SearchFollowItemsFieldsFragmentDoc}`;

/**
 * __useMyFollowingsQuery__
 *
 * To run a query within a React component, call `useMyFollowingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyFollowingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyFollowingsQuery({
 *   variables: {
 *      itemType: // value for 'itemType'
 *      language: // value for 'language'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sortOrderType: // value for 'sortOrderType'
 *   },
 * });
 */
export function useMyFollowingsQuery(baseOptions: Apollo.QueryHookOptions<MyFollowingsQuery, MyFollowingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyFollowingsQuery, MyFollowingsQueryVariables>(MyFollowingsDocument, options);
      }
export function useMyFollowingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyFollowingsQuery, MyFollowingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyFollowingsQuery, MyFollowingsQueryVariables>(MyFollowingsDocument, options);
        }
export type MyFollowingsQueryHookResult = ReturnType<typeof useMyFollowingsQuery>;
export type MyFollowingsLazyQueryHookResult = ReturnType<typeof useMyFollowingsLazyQuery>;
export type MyFollowingsQueryResult = Apollo.QueryResult<MyFollowingsQuery, MyFollowingsQueryVariables>;
export const MyFollowingFeedDocument = gql`
    query MyFollowingFeed($language: String!, $limit: Int!, $startDate: String, $userFollowingId: ID) {
  myFollowingFeed(
    limit: $limit
    startDate: $startDate
    language: $language
    userFollowingId: $userFollowingId
  ) {
    ...ArticleFields
  }
}
    ${ArticleFieldsFragmentDoc}`;

/**
 * __useMyFollowingFeedQuery__
 *
 * To run a query within a React component, call `useMyFollowingFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyFollowingFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyFollowingFeedQuery({
 *   variables: {
 *      language: // value for 'language'
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *      userFollowingId: // value for 'userFollowingId'
 *   },
 * });
 */
export function useMyFollowingFeedQuery(baseOptions: Apollo.QueryHookOptions<MyFollowingFeedQuery, MyFollowingFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyFollowingFeedQuery, MyFollowingFeedQueryVariables>(MyFollowingFeedDocument, options);
      }
export function useMyFollowingFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyFollowingFeedQuery, MyFollowingFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyFollowingFeedQuery, MyFollowingFeedQueryVariables>(MyFollowingFeedDocument, options);
        }
export type MyFollowingFeedQueryHookResult = ReturnType<typeof useMyFollowingFeedQuery>;
export type MyFollowingFeedLazyQueryHookResult = ReturnType<typeof useMyFollowingFeedLazyQuery>;
export type MyFollowingFeedQueryResult = Apollo.QueryResult<MyFollowingFeedQuery, MyFollowingFeedQueryVariables>;
export const UserFollowingsDocument = gql`
    query UserFollowings($page: Int, $limit: Int!, $language: String!, $itemType: FollowingItemEnum!, $userId: ID!) {
  userFollowings(
    page: $page
    limit: $limit
    language: $language
    itemType: $itemType
    userId: $userId
  ) {
    ...SearchFollowItemsFields
  }
}
    ${SearchFollowItemsFieldsFragmentDoc}`;

/**
 * __useUserFollowingsQuery__
 *
 * To run a query within a React component, call `useUserFollowingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFollowingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFollowingsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      language: // value for 'language'
 *      itemType: // value for 'itemType'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserFollowingsQuery(baseOptions: Apollo.QueryHookOptions<UserFollowingsQuery, UserFollowingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFollowingsQuery, UserFollowingsQueryVariables>(UserFollowingsDocument, options);
      }
export function useUserFollowingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFollowingsQuery, UserFollowingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFollowingsQuery, UserFollowingsQueryVariables>(UserFollowingsDocument, options);
        }
export type UserFollowingsQueryHookResult = ReturnType<typeof useUserFollowingsQuery>;
export type UserFollowingsLazyQueryHookResult = ReturnType<typeof useUserFollowingsLazyQuery>;
export type UserFollowingsQueryResult = Apollo.QueryResult<UserFollowingsQuery, UserFollowingsQueryVariables>;
export const UserFollowersDocument = gql`
    query UserFollowers($page: Int, $limit: Int!, $language: String!, $userId: ID!) {
  userFollowers(page: $page, limit: $limit, language: $language, userId: $userId) {
    ...SearchFollowItemsFields
  }
}
    ${SearchFollowItemsFieldsFragmentDoc}`;

/**
 * __useUserFollowersQuery__
 *
 * To run a query within a React component, call `useUserFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFollowersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      language: // value for 'language'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserFollowersQuery(baseOptions: Apollo.QueryHookOptions<UserFollowersQuery, UserFollowersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFollowersQuery, UserFollowersQueryVariables>(UserFollowersDocument, options);
      }
export function useUserFollowersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFollowersQuery, UserFollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFollowersQuery, UserFollowersQueryVariables>(UserFollowersDocument, options);
        }
export type UserFollowersQueryHookResult = ReturnType<typeof useUserFollowersQuery>;
export type UserFollowersLazyQueryHookResult = ReturnType<typeof useUserFollowersLazyQuery>;
export type UserFollowersQueryResult = Apollo.QueryResult<UserFollowersQuery, UserFollowersQueryVariables>;
export const RecommendedFollowsDocument = gql`
    query RecommendedFollows($itemType: FollowingItemEnum!, $language: String!, $page: Int, $limit: Int!) {
  recommendedFollows(
    itemType: $itemType
    language: $language
    page: $page
    limit: $limit
  ) {
    ...SearchFollowItemsFields
  }
}
    ${SearchFollowItemsFieldsFragmentDoc}`;

/**
 * __useRecommendedFollowsQuery__
 *
 * To run a query within a React component, call `useRecommendedFollowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedFollowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedFollowsQuery({
 *   variables: {
 *      itemType: // value for 'itemType'
 *      language: // value for 'language'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecommendedFollowsQuery(baseOptions: Apollo.QueryHookOptions<RecommendedFollowsQuery, RecommendedFollowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedFollowsQuery, RecommendedFollowsQueryVariables>(RecommendedFollowsDocument, options);
      }
export function useRecommendedFollowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedFollowsQuery, RecommendedFollowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedFollowsQuery, RecommendedFollowsQueryVariables>(RecommendedFollowsDocument, options);
        }
export type RecommendedFollowsQueryHookResult = ReturnType<typeof useRecommendedFollowsQuery>;
export type RecommendedFollowsLazyQueryHookResult = ReturnType<typeof useRecommendedFollowsLazyQuery>;
export type RecommendedFollowsQueryResult = Apollo.QueryResult<RecommendedFollowsQuery, RecommendedFollowsQueryVariables>;
export const SearchFollowsDocument = gql`
    query SearchFollows($itemType: FollowingItemEnum!, $language: String!, $keyword: String!, $page: Int, $limit: Int!) {
  searchFollows(
    itemType: $itemType
    language: $language
    keyword: $keyword
    page: $page
    limit: $limit
  ) {
    ...SearchFollowItemsFields
  }
}
    ${SearchFollowItemsFieldsFragmentDoc}`;

/**
 * __useSearchFollowsQuery__
 *
 * To run a query within a React component, call `useSearchFollowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFollowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFollowsQuery({
 *   variables: {
 *      itemType: // value for 'itemType'
 *      language: // value for 'language'
 *      keyword: // value for 'keyword'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchFollowsQuery(baseOptions: Apollo.QueryHookOptions<SearchFollowsQuery, SearchFollowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFollowsQuery, SearchFollowsQueryVariables>(SearchFollowsDocument, options);
      }
export function useSearchFollowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFollowsQuery, SearchFollowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFollowsQuery, SearchFollowsQueryVariables>(SearchFollowsDocument, options);
        }
export type SearchFollowsQueryHookResult = ReturnType<typeof useSearchFollowsQuery>;
export type SearchFollowsLazyQueryHookResult = ReturnType<typeof useSearchFollowsLazyQuery>;
export type SearchFollowsQueryResult = Apollo.QueryResult<SearchFollowsQuery, SearchFollowsQueryVariables>;
export const SearchCommunityArticlesDocument = gql`
    query SearchCommunityArticles($keyword: String!, $language: String!, $startDate: String, $limit: Int!) {
  searchCommunityArticles(
    keyword: $keyword
    language: $language
    startDate: $startDate
    limit: $limit
  ) {
    articles {
      ...ArticleFields
    }
  }
}
    ${ArticleFieldsFragmentDoc}`;

/**
 * __useSearchCommunityArticlesQuery__
 *
 * To run a query within a React component, call `useSearchCommunityArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCommunityArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCommunityArticlesQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      language: // value for 'language'
 *      startDate: // value for 'startDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchCommunityArticlesQuery(baseOptions: Apollo.QueryHookOptions<SearchCommunityArticlesQuery, SearchCommunityArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCommunityArticlesQuery, SearchCommunityArticlesQueryVariables>(SearchCommunityArticlesDocument, options);
      }
export function useSearchCommunityArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCommunityArticlesQuery, SearchCommunityArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCommunityArticlesQuery, SearchCommunityArticlesQueryVariables>(SearchCommunityArticlesDocument, options);
        }
export type SearchCommunityArticlesQueryHookResult = ReturnType<typeof useSearchCommunityArticlesQuery>;
export type SearchCommunityArticlesLazyQueryHookResult = ReturnType<typeof useSearchCommunityArticlesLazyQuery>;
export type SearchCommunityArticlesQueryResult = Apollo.QueryResult<SearchCommunityArticlesQuery, SearchCommunityArticlesQueryVariables>;
export const SearchCommunityUsersDocument = gql`
    query SearchCommunityUsers($keyword: String!, $page: Int, $limit: Int!) {
  searchCommunityUsers(keyword: $keyword, page: $page, limit: $limit) {
    ...CommunityUserFields
  }
}
    ${CommunityUserFieldsFragmentDoc}`;

/**
 * __useSearchCommunityUsersQuery__
 *
 * To run a query within a React component, call `useSearchCommunityUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCommunityUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCommunityUsersQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchCommunityUsersQuery(baseOptions: Apollo.QueryHookOptions<SearchCommunityUsersQuery, SearchCommunityUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCommunityUsersQuery, SearchCommunityUsersQueryVariables>(SearchCommunityUsersDocument, options);
      }
export function useSearchCommunityUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCommunityUsersQuery, SearchCommunityUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCommunityUsersQuery, SearchCommunityUsersQueryVariables>(SearchCommunityUsersDocument, options);
        }
export type SearchCommunityUsersQueryHookResult = ReturnType<typeof useSearchCommunityUsersQuery>;
export type SearchCommunityUsersLazyQueryHookResult = ReturnType<typeof useSearchCommunityUsersLazyQuery>;
export type SearchCommunityUsersQueryResult = Apollo.QueryResult<SearchCommunityUsersQuery, SearchCommunityUsersQueryVariables>;
export const SearchUsersInArticleDocument = gql`
    query SearchUsersInArticle($articleId: ID!, $keyword: String!, $limit: Int!, $page: Int) {
  searchUsersInArticle(
    articleId: $articleId
    keyword: $keyword
    limit: $limit
    page: $page
  ) {
    ...CommunityUserFields
  }
}
    ${CommunityUserFieldsFragmentDoc}`;

/**
 * __useSearchUsersInArticleQuery__
 *
 * To run a query within a React component, call `useSearchUsersInArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersInArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersInArticleQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      keyword: // value for 'keyword'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSearchUsersInArticleQuery(baseOptions: Apollo.QueryHookOptions<SearchUsersInArticleQuery, SearchUsersInArticleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersInArticleQuery, SearchUsersInArticleQueryVariables>(SearchUsersInArticleDocument, options);
      }
export function useSearchUsersInArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersInArticleQuery, SearchUsersInArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersInArticleQuery, SearchUsersInArticleQueryVariables>(SearchUsersInArticleDocument, options);
        }
export type SearchUsersInArticleQueryHookResult = ReturnType<typeof useSearchUsersInArticleQuery>;
export type SearchUsersInArticleLazyQueryHookResult = ReturnType<typeof useSearchUsersInArticleLazyQuery>;
export type SearchUsersInArticleQueryResult = Apollo.QueryResult<SearchUsersInArticleQuery, SearchUsersInArticleQueryVariables>;
export const BlockedUsersDocument = gql`
    query BlockedUsers($page: Int, $limit: Int!) {
  blockedUsers(page: $page, limit: $limit) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useBlockedUsersQuery__
 *
 * To run a query within a React component, call `useBlockedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockedUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBlockedUsersQuery(baseOptions: Apollo.QueryHookOptions<BlockedUsersQuery, BlockedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockedUsersQuery, BlockedUsersQueryVariables>(BlockedUsersDocument, options);
      }
export function useBlockedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockedUsersQuery, BlockedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockedUsersQuery, BlockedUsersQueryVariables>(BlockedUsersDocument, options);
        }
export type BlockedUsersQueryHookResult = ReturnType<typeof useBlockedUsersQuery>;
export type BlockedUsersLazyQueryHookResult = ReturnType<typeof useBlockedUsersLazyQuery>;
export type BlockedUsersQueryResult = Apollo.QueryResult<BlockedUsersQuery, BlockedUsersQueryVariables>;
export const RecommendedFollowsByUserFavoritesDocument = gql`
    query RecommendedFollowsByUserFavorites($itemType: FollowingItemEnum!, $language: String!, $page: Int, $limit: Int!) {
  recommendedFollowsByUserFavorites(
    itemType: $itemType
    language: $language
    page: $page
    limit: $limit
  ) {
    ...SearchFollowItemsFields
  }
}
    ${SearchFollowItemsFieldsFragmentDoc}`;

/**
 * __useRecommendedFollowsByUserFavoritesQuery__
 *
 * To run a query within a React component, call `useRecommendedFollowsByUserFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedFollowsByUserFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedFollowsByUserFavoritesQuery({
 *   variables: {
 *      itemType: // value for 'itemType'
 *      language: // value for 'language'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecommendedFollowsByUserFavoritesQuery(baseOptions: Apollo.QueryHookOptions<RecommendedFollowsByUserFavoritesQuery, RecommendedFollowsByUserFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedFollowsByUserFavoritesQuery, RecommendedFollowsByUserFavoritesQueryVariables>(RecommendedFollowsByUserFavoritesDocument, options);
      }
export function useRecommendedFollowsByUserFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedFollowsByUserFavoritesQuery, RecommendedFollowsByUserFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedFollowsByUserFavoritesQuery, RecommendedFollowsByUserFavoritesQueryVariables>(RecommendedFollowsByUserFavoritesDocument, options);
        }
export type RecommendedFollowsByUserFavoritesQueryHookResult = ReturnType<typeof useRecommendedFollowsByUserFavoritesQuery>;
export type RecommendedFollowsByUserFavoritesLazyQueryHookResult = ReturnType<typeof useRecommendedFollowsByUserFavoritesLazyQuery>;
export type RecommendedFollowsByUserFavoritesQueryResult = Apollo.QueryResult<RecommendedFollowsByUserFavoritesQuery, RecommendedFollowsByUserFavoritesQueryVariables>;
export const GetOgTagDocument = gql`
    query GetOgTag($originalLink: String!, $refetch: Boolean) {
  getOgTag(originalLink: $originalLink, refetch: $refetch) {
    ...OgTagFields
  }
}
    ${OgTagFieldsFragmentDoc}`;

/**
 * __useGetOgTagQuery__
 *
 * To run a query within a React component, call `useGetOgTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOgTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOgTagQuery({
 *   variables: {
 *      originalLink: // value for 'originalLink'
 *      refetch: // value for 'refetch'
 *   },
 * });
 */
export function useGetOgTagQuery(baseOptions: Apollo.QueryHookOptions<GetOgTagQuery, GetOgTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOgTagQuery, GetOgTagQueryVariables>(GetOgTagDocument, options);
      }
export function useGetOgTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOgTagQuery, GetOgTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOgTagQuery, GetOgTagQueryVariables>(GetOgTagDocument, options);
        }
export type GetOgTagQueryHookResult = ReturnType<typeof useGetOgTagQuery>;
export type GetOgTagLazyQueryHookResult = ReturnType<typeof useGetOgTagLazyQuery>;
export type GetOgTagQueryResult = Apollo.QueryResult<GetOgTagQuery, GetOgTagQueryVariables>;
export const CompanyDetailByIdDocument = gql`
    query CompanyDetailById($companyId: ID!) {
  companyDetailById(companyId: $companyId) {
    ...CompanyDetailFields
  }
}
    ${CompanyDetailFieldsFragmentDoc}`;

/**
 * __useCompanyDetailByIdQuery__
 *
 * To run a query within a React component, call `useCompanyDetailByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDetailByIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyDetailByIdQuery(baseOptions: Apollo.QueryHookOptions<CompanyDetailByIdQuery, CompanyDetailByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyDetailByIdQuery, CompanyDetailByIdQueryVariables>(CompanyDetailByIdDocument, options);
      }
export function useCompanyDetailByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDetailByIdQuery, CompanyDetailByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyDetailByIdQuery, CompanyDetailByIdQueryVariables>(CompanyDetailByIdDocument, options);
        }
export type CompanyDetailByIdQueryHookResult = ReturnType<typeof useCompanyDetailByIdQuery>;
export type CompanyDetailByIdLazyQueryHookResult = ReturnType<typeof useCompanyDetailByIdLazyQuery>;
export type CompanyDetailByIdQueryResult = Apollo.QueryResult<CompanyDetailByIdQuery, CompanyDetailByIdQueryVariables>;
export const CompanyDetailByTickerDocument = gql`
    query CompanyDetailByTicker($ticker: String!, $country: String) {
  companyDetailByTicker(ticker: $ticker, country: $country) {
    ...CompanyDetailFields
  }
}
    ${CompanyDetailFieldsFragmentDoc}`;

/**
 * __useCompanyDetailByTickerQuery__
 *
 * To run a query within a React component, call `useCompanyDetailByTickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailByTickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDetailByTickerQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useCompanyDetailByTickerQuery(baseOptions: Apollo.QueryHookOptions<CompanyDetailByTickerQuery, CompanyDetailByTickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyDetailByTickerQuery, CompanyDetailByTickerQueryVariables>(CompanyDetailByTickerDocument, options);
      }
export function useCompanyDetailByTickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDetailByTickerQuery, CompanyDetailByTickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyDetailByTickerQuery, CompanyDetailByTickerQueryVariables>(CompanyDetailByTickerDocument, options);
        }
export type CompanyDetailByTickerQueryHookResult = ReturnType<typeof useCompanyDetailByTickerQuery>;
export type CompanyDetailByTickerLazyQueryHookResult = ReturnType<typeof useCompanyDetailByTickerLazyQuery>;
export type CompanyDetailByTickerQueryResult = Apollo.QueryResult<CompanyDetailByTickerQuery, CompanyDetailByTickerQueryVariables>;
export const CompanyDetailOnlyCommunityDocument = gql`
    query CompanyDetailOnlyCommunity($ticker: String!, $country: String) {
  companyDetailByTicker(ticker: $ticker, country: $country) {
    ...CompanyDetailOnlyCommunityFields
  }
}
    ${CompanyDetailOnlyCommunityFieldsFragmentDoc}`;

/**
 * __useCompanyDetailOnlyCommunityQuery__
 *
 * To run a query within a React component, call `useCompanyDetailOnlyCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailOnlyCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDetailOnlyCommunityQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useCompanyDetailOnlyCommunityQuery(baseOptions: Apollo.QueryHookOptions<CompanyDetailOnlyCommunityQuery, CompanyDetailOnlyCommunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyDetailOnlyCommunityQuery, CompanyDetailOnlyCommunityQueryVariables>(CompanyDetailOnlyCommunityDocument, options);
      }
export function useCompanyDetailOnlyCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDetailOnlyCommunityQuery, CompanyDetailOnlyCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyDetailOnlyCommunityQuery, CompanyDetailOnlyCommunityQueryVariables>(CompanyDetailOnlyCommunityDocument, options);
        }
export type CompanyDetailOnlyCommunityQueryHookResult = ReturnType<typeof useCompanyDetailOnlyCommunityQuery>;
export type CompanyDetailOnlyCommunityLazyQueryHookResult = ReturnType<typeof useCompanyDetailOnlyCommunityLazyQuery>;
export type CompanyDetailOnlyCommunityQueryResult = Apollo.QueryResult<CompanyDetailOnlyCommunityQuery, CompanyDetailOnlyCommunityQueryVariables>;
export const CompanyDetailByIdsDocument = gql`
    query CompanyDetailByIds($companyIds: [ID!]!) {
  companyDetailByIds(companyIds: $companyIds) {
    ...CompanyDetailFields
  }
}
    ${CompanyDetailFieldsFragmentDoc}`;

/**
 * __useCompanyDetailByIdsQuery__
 *
 * To run a query within a React component, call `useCompanyDetailByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDetailByIdsQuery({
 *   variables: {
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useCompanyDetailByIdsQuery(baseOptions: Apollo.QueryHookOptions<CompanyDetailByIdsQuery, CompanyDetailByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyDetailByIdsQuery, CompanyDetailByIdsQueryVariables>(CompanyDetailByIdsDocument, options);
      }
export function useCompanyDetailByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDetailByIdsQuery, CompanyDetailByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyDetailByIdsQuery, CompanyDetailByIdsQueryVariables>(CompanyDetailByIdsDocument, options);
        }
export type CompanyDetailByIdsQueryHookResult = ReturnType<typeof useCompanyDetailByIdsQuery>;
export type CompanyDetailByIdsLazyQueryHookResult = ReturnType<typeof useCompanyDetailByIdsLazyQuery>;
export type CompanyDetailByIdsQueryResult = Apollo.QueryResult<CompanyDetailByIdsQuery, CompanyDetailByIdsQueryVariables>;
export const CompanyDetailByIdsForNewsDocument = gql`
    query CompanyDetailByIdsForNews($companyIds: [ID!]!) {
  companyDetailByIds(companyIds: $companyIds) {
    ...NewsCompanyDetail
  }
}
    ${NewsCompanyDetailFragmentDoc}`;

/**
 * __useCompanyDetailByIdsForNewsQuery__
 *
 * To run a query within a React component, call `useCompanyDetailByIdsForNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailByIdsForNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDetailByIdsForNewsQuery({
 *   variables: {
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useCompanyDetailByIdsForNewsQuery(baseOptions: Apollo.QueryHookOptions<CompanyDetailByIdsForNewsQuery, CompanyDetailByIdsForNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyDetailByIdsForNewsQuery, CompanyDetailByIdsForNewsQueryVariables>(CompanyDetailByIdsForNewsDocument, options);
      }
export function useCompanyDetailByIdsForNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDetailByIdsForNewsQuery, CompanyDetailByIdsForNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyDetailByIdsForNewsQuery, CompanyDetailByIdsForNewsQueryVariables>(CompanyDetailByIdsForNewsDocument, options);
        }
export type CompanyDetailByIdsForNewsQueryHookResult = ReturnType<typeof useCompanyDetailByIdsForNewsQuery>;
export type CompanyDetailByIdsForNewsLazyQueryHookResult = ReturnType<typeof useCompanyDetailByIdsForNewsLazyQuery>;
export type CompanyDetailByIdsForNewsQueryResult = Apollo.QueryResult<CompanyDetailByIdsForNewsQuery, CompanyDetailByIdsForNewsQueryVariables>;
export const RealtimeStockPriceDocument = gql`
    subscription RealtimeStockPrice($companyIds: [ID!]!) {
  realtimeStockPrice(companyIds: $companyIds) {
    companyPrices {
      ...CompanyPriceFields
    }
  }
}
    ${CompanyPriceFieldsFragmentDoc}`;

/**
 * __useRealtimeStockPriceSubscription__
 *
 * To run a query within a React component, call `useRealtimeStockPriceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRealtimeStockPriceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealtimeStockPriceSubscription({
 *   variables: {
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useRealtimeStockPriceSubscription(baseOptions: Apollo.SubscriptionHookOptions<RealtimeStockPriceSubscription, RealtimeStockPriceSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RealtimeStockPriceSubscription, RealtimeStockPriceSubscriptionVariables>(RealtimeStockPriceDocument, options);
      }
export type RealtimeStockPriceSubscriptionHookResult = ReturnType<typeof useRealtimeStockPriceSubscription>;
export type RealtimeStockPriceSubscriptionResult = Apollo.SubscriptionResult<RealtimeStockPriceSubscription>;
export const StockPriceUpdatedDocument = gql`
    subscription StockPriceUpdated($companyId: ID!) {
  stockPriceUpdated(companyId: $companyId) {
    companyPrice {
      ...CompanyPriceFields
    }
  }
}
    ${CompanyPriceFieldsFragmentDoc}`;

/**
 * __useStockPriceUpdatedSubscription__
 *
 * To run a query within a React component, call `useStockPriceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStockPriceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockPriceUpdatedSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useStockPriceUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<StockPriceUpdatedSubscription, StockPriceUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<StockPriceUpdatedSubscription, StockPriceUpdatedSubscriptionVariables>(StockPriceUpdatedDocument, options);
      }
export type StockPriceUpdatedSubscriptionHookResult = ReturnType<typeof useStockPriceUpdatedSubscription>;
export type StockPriceUpdatedSubscriptionResult = Apollo.SubscriptionResult<StockPriceUpdatedSubscription>;
export const CryptoCurrencyExchangeDocument = gql`
    query CryptoCurrencyExchange($symbol: String!) {
  cryptoCurrencyExchange(symbol: $symbol) {
    ...CurrencyExchangeFields
  }
}
    ${CurrencyExchangeFieldsFragmentDoc}`;

/**
 * __useCryptoCurrencyExchangeQuery__
 *
 * To run a query within a React component, call `useCryptoCurrencyExchangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCryptoCurrencyExchangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCryptoCurrencyExchangeQuery({
 *   variables: {
 *      symbol: // value for 'symbol'
 *   },
 * });
 */
export function useCryptoCurrencyExchangeQuery(baseOptions: Apollo.QueryHookOptions<CryptoCurrencyExchangeQuery, CryptoCurrencyExchangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CryptoCurrencyExchangeQuery, CryptoCurrencyExchangeQueryVariables>(CryptoCurrencyExchangeDocument, options);
      }
export function useCryptoCurrencyExchangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CryptoCurrencyExchangeQuery, CryptoCurrencyExchangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CryptoCurrencyExchangeQuery, CryptoCurrencyExchangeQueryVariables>(CryptoCurrencyExchangeDocument, options);
        }
export type CryptoCurrencyExchangeQueryHookResult = ReturnType<typeof useCryptoCurrencyExchangeQuery>;
export type CryptoCurrencyExchangeLazyQueryHookResult = ReturnType<typeof useCryptoCurrencyExchangeLazyQuery>;
export type CryptoCurrencyExchangeQueryResult = Apollo.QueryResult<CryptoCurrencyExchangeQuery, CryptoCurrencyExchangeQueryVariables>;
export const CryptoCurrencyExchangesDocument = gql`
    query CryptoCurrencyExchanges($pairs: [String!]) {
  cryptoCurrencyExchanges(pairs: $pairs) {
    ...CurrencyExchangeFields
  }
}
    ${CurrencyExchangeFieldsFragmentDoc}`;

/**
 * __useCryptoCurrencyExchangesQuery__
 *
 * To run a query within a React component, call `useCryptoCurrencyExchangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCryptoCurrencyExchangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCryptoCurrencyExchangesQuery({
 *   variables: {
 *      pairs: // value for 'pairs'
 *   },
 * });
 */
export function useCryptoCurrencyExchangesQuery(baseOptions?: Apollo.QueryHookOptions<CryptoCurrencyExchangesQuery, CryptoCurrencyExchangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CryptoCurrencyExchangesQuery, CryptoCurrencyExchangesQueryVariables>(CryptoCurrencyExchangesDocument, options);
      }
export function useCryptoCurrencyExchangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CryptoCurrencyExchangesQuery, CryptoCurrencyExchangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CryptoCurrencyExchangesQuery, CryptoCurrencyExchangesQueryVariables>(CryptoCurrencyExchangesDocument, options);
        }
export type CryptoCurrencyExchangesQueryHookResult = ReturnType<typeof useCryptoCurrencyExchangesQuery>;
export type CryptoCurrencyExchangesLazyQueryHookResult = ReturnType<typeof useCryptoCurrencyExchangesLazyQuery>;
export type CryptoCurrencyExchangesQueryResult = Apollo.QueryResult<CryptoCurrencyExchangesQuery, CryptoCurrencyExchangesQueryVariables>;
export const SupportedCryptoCurrencyBasesDocument = gql`
    query SupportedCryptoCurrencyBases {
  cryptos: supportedCryptoCurrencyBases {
    ...CryptoCurrencyFields
  }
}
    ${CryptoCurrencyFieldsFragmentDoc}`;

/**
 * __useSupportedCryptoCurrencyBasesQuery__
 *
 * To run a query within a React component, call `useSupportedCryptoCurrencyBasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedCryptoCurrencyBasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportedCryptoCurrencyBasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportedCryptoCurrencyBasesQuery(baseOptions?: Apollo.QueryHookOptions<SupportedCryptoCurrencyBasesQuery, SupportedCryptoCurrencyBasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportedCryptoCurrencyBasesQuery, SupportedCryptoCurrencyBasesQueryVariables>(SupportedCryptoCurrencyBasesDocument, options);
      }
export function useSupportedCryptoCurrencyBasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportedCryptoCurrencyBasesQuery, SupportedCryptoCurrencyBasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportedCryptoCurrencyBasesQuery, SupportedCryptoCurrencyBasesQueryVariables>(SupportedCryptoCurrencyBasesDocument, options);
        }
export type SupportedCryptoCurrencyBasesQueryHookResult = ReturnType<typeof useSupportedCryptoCurrencyBasesQuery>;
export type SupportedCryptoCurrencyBasesLazyQueryHookResult = ReturnType<typeof useSupportedCryptoCurrencyBasesLazyQuery>;
export type SupportedCryptoCurrencyBasesQueryResult = Apollo.QueryResult<SupportedCryptoCurrencyBasesQuery, SupportedCryptoCurrencyBasesQueryVariables>;
export const CryptoCurrencyDetailDocument = gql`
    query CryptoCurrencyDetail($base: String!, $counter: String!) {
  cryptoCurrencyDetail(base: $base, counter: $counter) {
    ...CryptoCurrencyDetailFields
  }
}
    ${CryptoCurrencyDetailFieldsFragmentDoc}`;

/**
 * __useCryptoCurrencyDetailQuery__
 *
 * To run a query within a React component, call `useCryptoCurrencyDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCryptoCurrencyDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCryptoCurrencyDetailQuery({
 *   variables: {
 *      base: // value for 'base'
 *      counter: // value for 'counter'
 *   },
 * });
 */
export function useCryptoCurrencyDetailQuery(baseOptions: Apollo.QueryHookOptions<CryptoCurrencyDetailQuery, CryptoCurrencyDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CryptoCurrencyDetailQuery, CryptoCurrencyDetailQueryVariables>(CryptoCurrencyDetailDocument, options);
      }
export function useCryptoCurrencyDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CryptoCurrencyDetailQuery, CryptoCurrencyDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CryptoCurrencyDetailQuery, CryptoCurrencyDetailQueryVariables>(CryptoCurrencyDetailDocument, options);
        }
export type CryptoCurrencyDetailQueryHookResult = ReturnType<typeof useCryptoCurrencyDetailQuery>;
export type CryptoCurrencyDetailLazyQueryHookResult = ReturnType<typeof useCryptoCurrencyDetailLazyQuery>;
export type CryptoCurrencyDetailQueryResult = Apollo.QueryResult<CryptoCurrencyDetailQuery, CryptoCurrencyDetailQueryVariables>;
export const CryptoCurrencyDetailOnlyCommunityDocument = gql`
    query CryptoCurrencyDetailOnlyCommunity($base: String!, $counter: String!) {
  cryptoCurrencyDetail(base: $base, counter: $counter) {
    ...CryptoCurrencyDetailOnlyCommunityFields
  }
}
    ${CryptoCurrencyDetailOnlyCommunityFieldsFragmentDoc}`;

/**
 * __useCryptoCurrencyDetailOnlyCommunityQuery__
 *
 * To run a query within a React component, call `useCryptoCurrencyDetailOnlyCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCryptoCurrencyDetailOnlyCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCryptoCurrencyDetailOnlyCommunityQuery({
 *   variables: {
 *      base: // value for 'base'
 *      counter: // value for 'counter'
 *   },
 * });
 */
export function useCryptoCurrencyDetailOnlyCommunityQuery(baseOptions: Apollo.QueryHookOptions<CryptoCurrencyDetailOnlyCommunityQuery, CryptoCurrencyDetailOnlyCommunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CryptoCurrencyDetailOnlyCommunityQuery, CryptoCurrencyDetailOnlyCommunityQueryVariables>(CryptoCurrencyDetailOnlyCommunityDocument, options);
      }
export function useCryptoCurrencyDetailOnlyCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CryptoCurrencyDetailOnlyCommunityQuery, CryptoCurrencyDetailOnlyCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CryptoCurrencyDetailOnlyCommunityQuery, CryptoCurrencyDetailOnlyCommunityQueryVariables>(CryptoCurrencyDetailOnlyCommunityDocument, options);
        }
export type CryptoCurrencyDetailOnlyCommunityQueryHookResult = ReturnType<typeof useCryptoCurrencyDetailOnlyCommunityQuery>;
export type CryptoCurrencyDetailOnlyCommunityLazyQueryHookResult = ReturnType<typeof useCryptoCurrencyDetailOnlyCommunityLazyQuery>;
export type CryptoCurrencyDetailOnlyCommunityQueryResult = Apollo.QueryResult<CryptoCurrencyDetailOnlyCommunityQuery, CryptoCurrencyDetailOnlyCommunityQueryVariables>;
export const CryptoCurrencyPriceUpdatedDocument = gql`
    subscription CryptoCurrencyPriceUpdated($base: String!, $counter: String!, $dataSource: String) {
  cryptoCurrencyPriceUpdated(
    base: $base
    counter: $counter
    dataSource: $dataSource
  ) {
    cryptoCurrencyPrice {
      ...CryptoCurrencyPriceFields
    }
  }
}
    ${CryptoCurrencyPriceFieldsFragmentDoc}`;

/**
 * __useCryptoCurrencyPriceUpdatedSubscription__
 *
 * To run a query within a React component, call `useCryptoCurrencyPriceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCryptoCurrencyPriceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCryptoCurrencyPriceUpdatedSubscription({
 *   variables: {
 *      base: // value for 'base'
 *      counter: // value for 'counter'
 *      dataSource: // value for 'dataSource'
 *   },
 * });
 */
export function useCryptoCurrencyPriceUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CryptoCurrencyPriceUpdatedSubscription, CryptoCurrencyPriceUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CryptoCurrencyPriceUpdatedSubscription, CryptoCurrencyPriceUpdatedSubscriptionVariables>(CryptoCurrencyPriceUpdatedDocument, options);
      }
export type CryptoCurrencyPriceUpdatedSubscriptionHookResult = ReturnType<typeof useCryptoCurrencyPriceUpdatedSubscription>;
export type CryptoCurrencyPriceUpdatedSubscriptionResult = Apollo.SubscriptionResult<CryptoCurrencyPriceUpdatedSubscription>;
export const SupportedCurrenciesDocument = gql`
    query SupportedCurrencies {
  supportedCurrencies {
    ...CurrencyFields
  }
}
    ${CurrencyFieldsFragmentDoc}`;

/**
 * __useSupportedCurrenciesQuery__
 *
 * To run a query within a React component, call `useSupportedCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportedCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportedCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<SupportedCurrenciesQuery, SupportedCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportedCurrenciesQuery, SupportedCurrenciesQueryVariables>(SupportedCurrenciesDocument, options);
      }
export function useSupportedCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportedCurrenciesQuery, SupportedCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportedCurrenciesQuery, SupportedCurrenciesQueryVariables>(SupportedCurrenciesDocument, options);
        }
export type SupportedCurrenciesQueryHookResult = ReturnType<typeof useSupportedCurrenciesQuery>;
export type SupportedCurrenciesLazyQueryHookResult = ReturnType<typeof useSupportedCurrenciesLazyQuery>;
export type SupportedCurrenciesQueryResult = Apollo.QueryResult<SupportedCurrenciesQuery, SupportedCurrenciesQueryVariables>;
export const ThisWeekDividendStocksDocument = gql`
    query ThisWeekDividendStocks {
  thisWeekDividendStocks {
    ...DividendHistoryApi1Fields
  }
}
    ${DividendHistoryApi1FieldsFragmentDoc}`;

/**
 * __useThisWeekDividendStocksQuery__
 *
 * To run a query within a React component, call `useThisWeekDividendStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useThisWeekDividendStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThisWeekDividendStocksQuery({
 *   variables: {
 *   },
 * });
 */
export function useThisWeekDividendStocksQuery(baseOptions?: Apollo.QueryHookOptions<ThisWeekDividendStocksQuery, ThisWeekDividendStocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThisWeekDividendStocksQuery, ThisWeekDividendStocksQueryVariables>(ThisWeekDividendStocksDocument, options);
      }
export function useThisWeekDividendStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThisWeekDividendStocksQuery, ThisWeekDividendStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThisWeekDividendStocksQuery, ThisWeekDividendStocksQueryVariables>(ThisWeekDividendStocksDocument, options);
        }
export type ThisWeekDividendStocksQueryHookResult = ReturnType<typeof useThisWeekDividendStocksQuery>;
export type ThisWeekDividendStocksLazyQueryHookResult = ReturnType<typeof useThisWeekDividendStocksLazyQuery>;
export type ThisWeekDividendStocksQueryResult = Apollo.QueryResult<ThisWeekDividendStocksQuery, ThisWeekDividendStocksQueryVariables>;
export const DividendCalendarForPortfoliosDocument = gql`
    query DividendCalendarForPortfolios($portfolioSlugs: [String!]!, $currencyId: ID!, $taxRatio: Float!, $date: String!) {
  dividendCalendarForPortfolios(
    portfolioSlugs: $portfolioSlugs
    currencyId: $currencyId
    taxRatio: $taxRatio
    date: $date
  ) {
    totalDividendAmount
    dividendCalendarRecords {
      ...DividendCalendarRecordFields
    }
  }
}
    ${DividendCalendarRecordFieldsFragmentDoc}`;

/**
 * __useDividendCalendarForPortfoliosQuery__
 *
 * To run a query within a React component, call `useDividendCalendarForPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useDividendCalendarForPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDividendCalendarForPortfoliosQuery({
 *   variables: {
 *      portfolioSlugs: // value for 'portfolioSlugs'
 *      currencyId: // value for 'currencyId'
 *      taxRatio: // value for 'taxRatio'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useDividendCalendarForPortfoliosQuery(baseOptions: Apollo.QueryHookOptions<DividendCalendarForPortfoliosQuery, DividendCalendarForPortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DividendCalendarForPortfoliosQuery, DividendCalendarForPortfoliosQueryVariables>(DividendCalendarForPortfoliosDocument, options);
      }
export function useDividendCalendarForPortfoliosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DividendCalendarForPortfoliosQuery, DividendCalendarForPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DividendCalendarForPortfoliosQuery, DividendCalendarForPortfoliosQueryVariables>(DividendCalendarForPortfoliosDocument, options);
        }
export type DividendCalendarForPortfoliosQueryHookResult = ReturnType<typeof useDividendCalendarForPortfoliosQuery>;
export type DividendCalendarForPortfoliosLazyQueryHookResult = ReturnType<typeof useDividendCalendarForPortfoliosLazyQuery>;
export type DividendCalendarForPortfoliosQueryResult = Apollo.QueryResult<DividendCalendarForPortfoliosQuery, DividendCalendarForPortfoliosQueryVariables>;
export const ConnectPartnerWithUserDataDocument = gql`
    mutation ConnectPartnerWithUserData($userData: String!) {
  connectPartnerWithUserData(userData: $userData) {
    ...AuthTokenFields
  }
}
    ${AuthTokenFieldsFragmentDoc}`;
export type ConnectPartnerWithUserDataMutationFn = Apollo.MutationFunction<ConnectPartnerWithUserDataMutation, ConnectPartnerWithUserDataMutationVariables>;

/**
 * __useConnectPartnerWithUserDataMutation__
 *
 * To run a mutation, you first call `useConnectPartnerWithUserDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectPartnerWithUserDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectPartnerWithUserDataMutation, { data, loading, error }] = useConnectPartnerWithUserDataMutation({
 *   variables: {
 *      userData: // value for 'userData'
 *   },
 * });
 */
export function useConnectPartnerWithUserDataMutation(baseOptions?: Apollo.MutationHookOptions<ConnectPartnerWithUserDataMutation, ConnectPartnerWithUserDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectPartnerWithUserDataMutation, ConnectPartnerWithUserDataMutationVariables>(ConnectPartnerWithUserDataDocument, options);
      }
export type ConnectPartnerWithUserDataMutationHookResult = ReturnType<typeof useConnectPartnerWithUserDataMutation>;
export type ConnectPartnerWithUserDataMutationResult = Apollo.MutationResult<ConnectPartnerWithUserDataMutation>;
export type ConnectPartnerWithUserDataMutationOptions = Apollo.BaseMutationOptions<ConnectPartnerWithUserDataMutation, ConnectPartnerWithUserDataMutationVariables>;
export const ClosedMarketDaysDocument = gql`
    query ClosedMarketDays($country: String!, $year: String!) {
  closedMarketDays(country: $country, year: $year) {
    ...MarketCalendarFields
  }
}
    ${MarketCalendarFieldsFragmentDoc}`;

/**
 * __useClosedMarketDaysQuery__
 *
 * To run a query within a React component, call `useClosedMarketDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useClosedMarketDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClosedMarketDaysQuery({
 *   variables: {
 *      country: // value for 'country'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useClosedMarketDaysQuery(baseOptions: Apollo.QueryHookOptions<ClosedMarketDaysQuery, ClosedMarketDaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClosedMarketDaysQuery, ClosedMarketDaysQueryVariables>(ClosedMarketDaysDocument, options);
      }
export function useClosedMarketDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClosedMarketDaysQuery, ClosedMarketDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClosedMarketDaysQuery, ClosedMarketDaysQueryVariables>(ClosedMarketDaysDocument, options);
        }
export type ClosedMarketDaysQueryHookResult = ReturnType<typeof useClosedMarketDaysQuery>;
export type ClosedMarketDaysLazyQueryHookResult = ReturnType<typeof useClosedMarketDaysLazyQuery>;
export type ClosedMarketDaysQueryResult = Apollo.QueryResult<ClosedMarketDaysQuery, ClosedMarketDaysQueryVariables>;
export const ThisWeekDividendStocksInSnp500Document = gql`
    query ThisWeekDividendStocksInSnp500 {
  thisWeekDividendStocksInSnp500 {
    ...DividendHistoryFields
  }
}
    ${DividendHistoryFieldsFragmentDoc}`;

/**
 * __useThisWeekDividendStocksInSnp500Query__
 *
 * To run a query within a React component, call `useThisWeekDividendStocksInSnp500Query` and pass it any options that fit your needs.
 * When your component renders, `useThisWeekDividendStocksInSnp500Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThisWeekDividendStocksInSnp500Query({
 *   variables: {
 *   },
 * });
 */
export function useThisWeekDividendStocksInSnp500Query(baseOptions?: Apollo.QueryHookOptions<ThisWeekDividendStocksInSnp500Query, ThisWeekDividendStocksInSnp500QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThisWeekDividendStocksInSnp500Query, ThisWeekDividendStocksInSnp500QueryVariables>(ThisWeekDividendStocksInSnp500Document, options);
      }
export function useThisWeekDividendStocksInSnp500LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThisWeekDividendStocksInSnp500Query, ThisWeekDividendStocksInSnp500QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThisWeekDividendStocksInSnp500Query, ThisWeekDividendStocksInSnp500QueryVariables>(ThisWeekDividendStocksInSnp500Document, options);
        }
export type ThisWeekDividendStocksInSnp500QueryHookResult = ReturnType<typeof useThisWeekDividendStocksInSnp500Query>;
export type ThisWeekDividendStocksInSnp500LazyQueryHookResult = ReturnType<typeof useThisWeekDividendStocksInSnp500LazyQuery>;
export type ThisWeekDividendStocksInSnp500QueryResult = Apollo.QueryResult<ThisWeekDividendStocksInSnp500Query, ThisWeekDividendStocksInSnp500QueryVariables>;
export const DividendCompaniesInSnp500Document = gql`
    query DividendCompaniesInSnp500($ref: DividendHistoryBaseDateEnum!, $months: [Int!]!, $page: Int!, $per: Int!) {
  dividendCompaniesInSnp500(ref: $ref, months: $months, page: $page, per: $per) {
    ...PaginationCompaniesFields
  }
}
    ${PaginationCompaniesFieldsFragmentDoc}`;

/**
 * __useDividendCompaniesInSnp500Query__
 *
 * To run a query within a React component, call `useDividendCompaniesInSnp500Query` and pass it any options that fit your needs.
 * When your component renders, `useDividendCompaniesInSnp500Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDividendCompaniesInSnp500Query({
 *   variables: {
 *      ref: // value for 'ref'
 *      months: // value for 'months'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *   },
 * });
 */
export function useDividendCompaniesInSnp500Query(baseOptions: Apollo.QueryHookOptions<DividendCompaniesInSnp500Query, DividendCompaniesInSnp500QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DividendCompaniesInSnp500Query, DividendCompaniesInSnp500QueryVariables>(DividendCompaniesInSnp500Document, options);
      }
export function useDividendCompaniesInSnp500LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DividendCompaniesInSnp500Query, DividendCompaniesInSnp500QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DividendCompaniesInSnp500Query, DividendCompaniesInSnp500QueryVariables>(DividendCompaniesInSnp500Document, options);
        }
export type DividendCompaniesInSnp500QueryHookResult = ReturnType<typeof useDividendCompaniesInSnp500Query>;
export type DividendCompaniesInSnp500LazyQueryHookResult = ReturnType<typeof useDividendCompaniesInSnp500LazyQuery>;
export type DividendCompaniesInSnp500QueryResult = Apollo.QueryResult<DividendCompaniesInSnp500Query, DividendCompaniesInSnp500QueryVariables>;
export const MyPortfoliosFromEbestDocument = gql`
    query MyPortfoliosFromEbest($page: Int!, $per: Int!) {
  myPortfoliosFromPartner(page: $page, per: $per) {
    totalCount
    totalPages
    currentPage
    currentPageCount
    perPage
    nextPage
    portfolios {
      ...EbestUserPortfolio
    }
  }
}
    ${EbestUserPortfolioFragmentDoc}`;

/**
 * __useMyPortfoliosFromEbestQuery__
 *
 * To run a query within a React component, call `useMyPortfoliosFromEbestQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPortfoliosFromEbestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPortfoliosFromEbestQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per: // value for 'per'
 *   },
 * });
 */
export function useMyPortfoliosFromEbestQuery(baseOptions: Apollo.QueryHookOptions<MyPortfoliosFromEbestQuery, MyPortfoliosFromEbestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPortfoliosFromEbestQuery, MyPortfoliosFromEbestQueryVariables>(MyPortfoliosFromEbestDocument, options);
      }
export function useMyPortfoliosFromEbestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPortfoliosFromEbestQuery, MyPortfoliosFromEbestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPortfoliosFromEbestQuery, MyPortfoliosFromEbestQueryVariables>(MyPortfoliosFromEbestDocument, options);
        }
export type MyPortfoliosFromEbestQueryHookResult = ReturnType<typeof useMyPortfoliosFromEbestQuery>;
export type MyPortfoliosFromEbestLazyQueryHookResult = ReturnType<typeof useMyPortfoliosFromEbestLazyQuery>;
export type MyPortfoliosFromEbestQueryResult = Apollo.QueryResult<MyPortfoliosFromEbestQuery, MyPortfoliosFromEbestQueryVariables>;
export const DividendHistoriesExistingDaysForExternalChannelDocument = gql`
    query DividendHistoriesExistingDaysForExternalChannel($channelName: ExternalChannelEnum!, $date: String!, $country: String) {
  dividendHistoriesExistingDaysForExternalChannel(
    channelName: $channelName
    date: $date
    country: $country
  ) {
    ...DividendHistoriesExistingDaysForExternalChannelFields
  }
}
    ${DividendHistoriesExistingDaysForExternalChannelFieldsFragmentDoc}`;

/**
 * __useDividendHistoriesExistingDaysForExternalChannelQuery__
 *
 * To run a query within a React component, call `useDividendHistoriesExistingDaysForExternalChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useDividendHistoriesExistingDaysForExternalChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDividendHistoriesExistingDaysForExternalChannelQuery({
 *   variables: {
 *      channelName: // value for 'channelName'
 *      date: // value for 'date'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useDividendHistoriesExistingDaysForExternalChannelQuery(baseOptions: Apollo.QueryHookOptions<DividendHistoriesExistingDaysForExternalChannelQuery, DividendHistoriesExistingDaysForExternalChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DividendHistoriesExistingDaysForExternalChannelQuery, DividendHistoriesExistingDaysForExternalChannelQueryVariables>(DividendHistoriesExistingDaysForExternalChannelDocument, options);
      }
export function useDividendHistoriesExistingDaysForExternalChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DividendHistoriesExistingDaysForExternalChannelQuery, DividendHistoriesExistingDaysForExternalChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DividendHistoriesExistingDaysForExternalChannelQuery, DividendHistoriesExistingDaysForExternalChannelQueryVariables>(DividendHistoriesExistingDaysForExternalChannelDocument, options);
        }
export type DividendHistoriesExistingDaysForExternalChannelQueryHookResult = ReturnType<typeof useDividendHistoriesExistingDaysForExternalChannelQuery>;
export type DividendHistoriesExistingDaysForExternalChannelLazyQueryHookResult = ReturnType<typeof useDividendHistoriesExistingDaysForExternalChannelLazyQuery>;
export type DividendHistoriesExistingDaysForExternalChannelQueryResult = Apollo.QueryResult<DividendHistoriesExistingDaysForExternalChannelQuery, DividendHistoriesExistingDaysForExternalChannelQueryVariables>;
export const DividendCalendarForExternalChannelWithPaginationDocument = gql`
    query DividendCalendarForExternalChannelWithPagination($channelName: ExternalChannelEnum, $date: String!, $limit: Int!, $page: Int) {
  dividendCalendarForExternalChannelWithPagination(
    channelName: $channelName
    date: $date
    limit: $limit
    page: $page
  ) {
    ...DividendHistoryFields
  }
}
    ${DividendHistoryFieldsFragmentDoc}`;

/**
 * __useDividendCalendarForExternalChannelWithPaginationQuery__
 *
 * To run a query within a React component, call `useDividendCalendarForExternalChannelWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDividendCalendarForExternalChannelWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDividendCalendarForExternalChannelWithPaginationQuery({
 *   variables: {
 *      channelName: // value for 'channelName'
 *      date: // value for 'date'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDividendCalendarForExternalChannelWithPaginationQuery(baseOptions: Apollo.QueryHookOptions<DividendCalendarForExternalChannelWithPaginationQuery, DividendCalendarForExternalChannelWithPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DividendCalendarForExternalChannelWithPaginationQuery, DividendCalendarForExternalChannelWithPaginationQueryVariables>(DividendCalendarForExternalChannelWithPaginationDocument, options);
      }
export function useDividendCalendarForExternalChannelWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DividendCalendarForExternalChannelWithPaginationQuery, DividendCalendarForExternalChannelWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DividendCalendarForExternalChannelWithPaginationQuery, DividendCalendarForExternalChannelWithPaginationQueryVariables>(DividendCalendarForExternalChannelWithPaginationDocument, options);
        }
export type DividendCalendarForExternalChannelWithPaginationQueryHookResult = ReturnType<typeof useDividendCalendarForExternalChannelWithPaginationQuery>;
export type DividendCalendarForExternalChannelWithPaginationLazyQueryHookResult = ReturnType<typeof useDividendCalendarForExternalChannelWithPaginationLazyQuery>;
export type DividendCalendarForExternalChannelWithPaginationQueryResult = Apollo.QueryResult<DividendCalendarForExternalChannelWithPaginationQuery, DividendCalendarForExternalChannelWithPaginationQueryVariables>;
export const AllExchangesDocument = gql`
    query AllExchanges($pairsForFiats: [String!], $pairsForCryptos: [String!]) {
  currencyExchanges(pairs: $pairsForFiats) {
    ...CurrencyExchangeFields
  }
  cryptoCurrencyExchanges(pairs: $pairsForCryptos) {
    ...CurrencyExchangeFields
  }
}
    ${CurrencyExchangeFieldsFragmentDoc}`;

/**
 * __useAllExchangesQuery__
 *
 * To run a query within a React component, call `useAllExchangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllExchangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllExchangesQuery({
 *   variables: {
 *      pairsForFiats: // value for 'pairsForFiats'
 *      pairsForCryptos: // value for 'pairsForCryptos'
 *   },
 * });
 */
export function useAllExchangesQuery(baseOptions?: Apollo.QueryHookOptions<AllExchangesQuery, AllExchangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllExchangesQuery, AllExchangesQueryVariables>(AllExchangesDocument, options);
      }
export function useAllExchangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllExchangesQuery, AllExchangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllExchangesQuery, AllExchangesQueryVariables>(AllExchangesDocument, options);
        }
export type AllExchangesQueryHookResult = ReturnType<typeof useAllExchangesQuery>;
export type AllExchangesLazyQueryHookResult = ReturnType<typeof useAllExchangesLazyQuery>;
export type AllExchangesQueryResult = Apollo.QueryResult<AllExchangesQuery, AllExchangesQueryVariables>;
export const CurrencyExchangesDocument = gql`
    query CurrencyExchanges($pairs: [String!]) {
  currencyExchanges(pairs: $pairs) {
    ...CurrencyExchangeFields
  }
}
    ${CurrencyExchangeFieldsFragmentDoc}`;

/**
 * __useCurrencyExchangesQuery__
 *
 * To run a query within a React component, call `useCurrencyExchangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencyExchangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencyExchangesQuery({
 *   variables: {
 *      pairs: // value for 'pairs'
 *   },
 * });
 */
export function useCurrencyExchangesQuery(baseOptions?: Apollo.QueryHookOptions<CurrencyExchangesQuery, CurrencyExchangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrencyExchangesQuery, CurrencyExchangesQueryVariables>(CurrencyExchangesDocument, options);
      }
export function useCurrencyExchangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrencyExchangesQuery, CurrencyExchangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrencyExchangesQuery, CurrencyExchangesQueryVariables>(CurrencyExchangesDocument, options);
        }
export type CurrencyExchangesQueryHookResult = ReturnType<typeof useCurrencyExchangesQuery>;
export type CurrencyExchangesLazyQueryHookResult = ReturnType<typeof useCurrencyExchangesLazyQuery>;
export type CurrencyExchangesQueryResult = Apollo.QueryResult<CurrencyExchangesQuery, CurrencyExchangesQueryVariables>;
export const UpdateFavoriteItemCategoryOrdersDocument = gql`
    mutation UpdateFavoriteItemCategoryOrders($categoryOrders: [UpdateFavoriteCategoryOrder!]!) {
  updateFavoriteItemCategoryOrders(categoryOrders: $categoryOrders) {
    categories {
      ...FavoriteItemCategoryWithoutItemsFields
    }
  }
}
    ${FavoriteItemCategoryWithoutItemsFieldsFragmentDoc}`;
export type UpdateFavoriteItemCategoryOrdersMutationFn = Apollo.MutationFunction<UpdateFavoriteItemCategoryOrdersMutation, UpdateFavoriteItemCategoryOrdersMutationVariables>;

/**
 * __useUpdateFavoriteItemCategoryOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateFavoriteItemCategoryOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavoriteItemCategoryOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavoriteItemCategoryOrdersMutation, { data, loading, error }] = useUpdateFavoriteItemCategoryOrdersMutation({
 *   variables: {
 *      categoryOrders: // value for 'categoryOrders'
 *   },
 * });
 */
export function useUpdateFavoriteItemCategoryOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFavoriteItemCategoryOrdersMutation, UpdateFavoriteItemCategoryOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFavoriteItemCategoryOrdersMutation, UpdateFavoriteItemCategoryOrdersMutationVariables>(UpdateFavoriteItemCategoryOrdersDocument, options);
      }
export type UpdateFavoriteItemCategoryOrdersMutationHookResult = ReturnType<typeof useUpdateFavoriteItemCategoryOrdersMutation>;
export type UpdateFavoriteItemCategoryOrdersMutationResult = Apollo.MutationResult<UpdateFavoriteItemCategoryOrdersMutation>;
export type UpdateFavoriteItemCategoryOrdersMutationOptions = Apollo.BaseMutationOptions<UpdateFavoriteItemCategoryOrdersMutation, UpdateFavoriteItemCategoryOrdersMutationVariables>;
export const AddFavoriteItemCategoryDocument = gql`
    mutation AddFavoriteItemCategory($categoryName: String!) {
  addFavoriteItemCategory(categoryName: $categoryName) {
    category {
      ...FavoriteItemCategoryWithoutItemsFields
    }
  }
}
    ${FavoriteItemCategoryWithoutItemsFieldsFragmentDoc}`;
export type AddFavoriteItemCategoryMutationFn = Apollo.MutationFunction<AddFavoriteItemCategoryMutation, AddFavoriteItemCategoryMutationVariables>;

/**
 * __useAddFavoriteItemCategoryMutation__
 *
 * To run a mutation, you first call `useAddFavoriteItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteItemCategoryMutation, { data, loading, error }] = useAddFavoriteItemCategoryMutation({
 *   variables: {
 *      categoryName: // value for 'categoryName'
 *   },
 * });
 */
export function useAddFavoriteItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AddFavoriteItemCategoryMutation, AddFavoriteItemCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFavoriteItemCategoryMutation, AddFavoriteItemCategoryMutationVariables>(AddFavoriteItemCategoryDocument, options);
      }
export type AddFavoriteItemCategoryMutationHookResult = ReturnType<typeof useAddFavoriteItemCategoryMutation>;
export type AddFavoriteItemCategoryMutationResult = Apollo.MutationResult<AddFavoriteItemCategoryMutation>;
export type AddFavoriteItemCategoryMutationOptions = Apollo.BaseMutationOptions<AddFavoriteItemCategoryMutation, AddFavoriteItemCategoryMutationVariables>;
export const UpdateFavoriteItemCategoryDocument = gql`
    mutation UpdateFavoriteItemCategory($categoryId: ID!, $categoryName: String!) {
  updateFavoriteItemCategory(categoryId: $categoryId, categoryName: $categoryName) {
    category {
      ...FavoriteItemCategoryWithoutItemsFields
    }
  }
}
    ${FavoriteItemCategoryWithoutItemsFieldsFragmentDoc}`;
export type UpdateFavoriteItemCategoryMutationFn = Apollo.MutationFunction<UpdateFavoriteItemCategoryMutation, UpdateFavoriteItemCategoryMutationVariables>;

/**
 * __useUpdateFavoriteItemCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateFavoriteItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavoriteItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavoriteItemCategoryMutation, { data, loading, error }] = useUpdateFavoriteItemCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      categoryName: // value for 'categoryName'
 *   },
 * });
 */
export function useUpdateFavoriteItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFavoriteItemCategoryMutation, UpdateFavoriteItemCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFavoriteItemCategoryMutation, UpdateFavoriteItemCategoryMutationVariables>(UpdateFavoriteItemCategoryDocument, options);
      }
export type UpdateFavoriteItemCategoryMutationHookResult = ReturnType<typeof useUpdateFavoriteItemCategoryMutation>;
export type UpdateFavoriteItemCategoryMutationResult = Apollo.MutationResult<UpdateFavoriteItemCategoryMutation>;
export type UpdateFavoriteItemCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateFavoriteItemCategoryMutation, UpdateFavoriteItemCategoryMutationVariables>;
export const RemoveFavoriteItemCategoryDocument = gql`
    mutation RemoveFavoriteItemCategory($categoryId: ID!) {
  removeFavoriteItemCategory(categoryId: $categoryId) {
    category {
      id
    }
  }
}
    `;
export type RemoveFavoriteItemCategoryMutationFn = Apollo.MutationFunction<RemoveFavoriteItemCategoryMutation, RemoveFavoriteItemCategoryMutationVariables>;

/**
 * __useRemoveFavoriteItemCategoryMutation__
 *
 * To run a mutation, you first call `useRemoveFavoriteItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavoriteItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavoriteItemCategoryMutation, { data, loading, error }] = useRemoveFavoriteItemCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useRemoveFavoriteItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFavoriteItemCategoryMutation, RemoveFavoriteItemCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFavoriteItemCategoryMutation, RemoveFavoriteItemCategoryMutationVariables>(RemoveFavoriteItemCategoryDocument, options);
      }
export type RemoveFavoriteItemCategoryMutationHookResult = ReturnType<typeof useRemoveFavoriteItemCategoryMutation>;
export type RemoveFavoriteItemCategoryMutationResult = Apollo.MutationResult<RemoveFavoriteItemCategoryMutation>;
export type RemoveFavoriteItemCategoryMutationOptions = Apollo.BaseMutationOptions<RemoveFavoriteItemCategoryMutation, RemoveFavoriteItemCategoryMutationVariables>;
export const AddItemsToFavoriteItemCategoryDocument = gql`
    mutation AddItemsToFavoriteItemCategory($categoryId: ID!, $items: [UploadFavoriteItem!]!) {
  addItemsToFavoriteItemCategory(categoryId: $categoryId, items: $items) {
    category {
      ...FavoriteItemCategoryFields
    }
  }
}
    ${FavoriteItemCategoryFieldsFragmentDoc}`;
export type AddItemsToFavoriteItemCategoryMutationFn = Apollo.MutationFunction<AddItemsToFavoriteItemCategoryMutation, AddItemsToFavoriteItemCategoryMutationVariables>;

/**
 * __useAddItemsToFavoriteItemCategoryMutation__
 *
 * To run a mutation, you first call `useAddItemsToFavoriteItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemsToFavoriteItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemsToFavoriteItemCategoryMutation, { data, loading, error }] = useAddItemsToFavoriteItemCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useAddItemsToFavoriteItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AddItemsToFavoriteItemCategoryMutation, AddItemsToFavoriteItemCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemsToFavoriteItemCategoryMutation, AddItemsToFavoriteItemCategoryMutationVariables>(AddItemsToFavoriteItemCategoryDocument, options);
      }
export type AddItemsToFavoriteItemCategoryMutationHookResult = ReturnType<typeof useAddItemsToFavoriteItemCategoryMutation>;
export type AddItemsToFavoriteItemCategoryMutationResult = Apollo.MutationResult<AddItemsToFavoriteItemCategoryMutation>;
export type AddItemsToFavoriteItemCategoryMutationOptions = Apollo.BaseMutationOptions<AddItemsToFavoriteItemCategoryMutation, AddItemsToFavoriteItemCategoryMutationVariables>;
export const RemoveItemsToFavoriteItemCategoryDocument = gql`
    mutation RemoveItemsToFavoriteItemCategory($categoryId: String!, $items: [RemoveFavoriteItem!]!) {
  removeItemsToFavoriteItemCategory(categoryId: $categoryId, items: $items) {
    category {
      ...FavoriteItemCategoryFields
    }
  }
}
    ${FavoriteItemCategoryFieldsFragmentDoc}`;
export type RemoveItemsToFavoriteItemCategoryMutationFn = Apollo.MutationFunction<RemoveItemsToFavoriteItemCategoryMutation, RemoveItemsToFavoriteItemCategoryMutationVariables>;

/**
 * __useRemoveItemsToFavoriteItemCategoryMutation__
 *
 * To run a mutation, you first call `useRemoveItemsToFavoriteItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemsToFavoriteItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemsToFavoriteItemCategoryMutation, { data, loading, error }] = useRemoveItemsToFavoriteItemCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useRemoveItemsToFavoriteItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<RemoveItemsToFavoriteItemCategoryMutation, RemoveItemsToFavoriteItemCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveItemsToFavoriteItemCategoryMutation, RemoveItemsToFavoriteItemCategoryMutationVariables>(RemoveItemsToFavoriteItemCategoryDocument, options);
      }
export type RemoveItemsToFavoriteItemCategoryMutationHookResult = ReturnType<typeof useRemoveItemsToFavoriteItemCategoryMutation>;
export type RemoveItemsToFavoriteItemCategoryMutationResult = Apollo.MutationResult<RemoveItemsToFavoriteItemCategoryMutation>;
export type RemoveItemsToFavoriteItemCategoryMutationOptions = Apollo.BaseMutationOptions<RemoveItemsToFavoriteItemCategoryMutation, RemoveItemsToFavoriteItemCategoryMutationVariables>;
export const EnableSharingFavoriteItemCategoryDocument = gql`
    mutation EnableSharingFavoriteItemCategory($favoriteItemCategoryId: ID!) {
  enableSharingFavoriteItemCategory(
    favoriteItemCategoryId: $favoriteItemCategoryId
  ) {
    favoriteItemCategory {
      ...FavoriteItemCategoryWithoutItemsFields
    }
  }
}
    ${FavoriteItemCategoryWithoutItemsFieldsFragmentDoc}`;
export type EnableSharingFavoriteItemCategoryMutationFn = Apollo.MutationFunction<EnableSharingFavoriteItemCategoryMutation, EnableSharingFavoriteItemCategoryMutationVariables>;

/**
 * __useEnableSharingFavoriteItemCategoryMutation__
 *
 * To run a mutation, you first call `useEnableSharingFavoriteItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableSharingFavoriteItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableSharingFavoriteItemCategoryMutation, { data, loading, error }] = useEnableSharingFavoriteItemCategoryMutation({
 *   variables: {
 *      favoriteItemCategoryId: // value for 'favoriteItemCategoryId'
 *   },
 * });
 */
export function useEnableSharingFavoriteItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<EnableSharingFavoriteItemCategoryMutation, EnableSharingFavoriteItemCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableSharingFavoriteItemCategoryMutation, EnableSharingFavoriteItemCategoryMutationVariables>(EnableSharingFavoriteItemCategoryDocument, options);
      }
export type EnableSharingFavoriteItemCategoryMutationHookResult = ReturnType<typeof useEnableSharingFavoriteItemCategoryMutation>;
export type EnableSharingFavoriteItemCategoryMutationResult = Apollo.MutationResult<EnableSharingFavoriteItemCategoryMutation>;
export type EnableSharingFavoriteItemCategoryMutationOptions = Apollo.BaseMutationOptions<EnableSharingFavoriteItemCategoryMutation, EnableSharingFavoriteItemCategoryMutationVariables>;
export const DisableSharingFavoriteItemCategoryDocument = gql`
    mutation DisableSharingFavoriteItemCategory($favoriteItemCategoryId: ID!) {
  disableSharingFavoriteItemCategory(
    favoriteItemCategoryId: $favoriteItemCategoryId
  ) {
    favoriteItemCategory {
      ...FavoriteItemCategoryWithoutItemsFields
    }
  }
}
    ${FavoriteItemCategoryWithoutItemsFieldsFragmentDoc}`;
export type DisableSharingFavoriteItemCategoryMutationFn = Apollo.MutationFunction<DisableSharingFavoriteItemCategoryMutation, DisableSharingFavoriteItemCategoryMutationVariables>;

/**
 * __useDisableSharingFavoriteItemCategoryMutation__
 *
 * To run a mutation, you first call `useDisableSharingFavoriteItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableSharingFavoriteItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableSharingFavoriteItemCategoryMutation, { data, loading, error }] = useDisableSharingFavoriteItemCategoryMutation({
 *   variables: {
 *      favoriteItemCategoryId: // value for 'favoriteItemCategoryId'
 *   },
 * });
 */
export function useDisableSharingFavoriteItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DisableSharingFavoriteItemCategoryMutation, DisableSharingFavoriteItemCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableSharingFavoriteItemCategoryMutation, DisableSharingFavoriteItemCategoryMutationVariables>(DisableSharingFavoriteItemCategoryDocument, options);
      }
export type DisableSharingFavoriteItemCategoryMutationHookResult = ReturnType<typeof useDisableSharingFavoriteItemCategoryMutation>;
export type DisableSharingFavoriteItemCategoryMutationResult = Apollo.MutationResult<DisableSharingFavoriteItemCategoryMutation>;
export type DisableSharingFavoriteItemCategoryMutationOptions = Apollo.BaseMutationOptions<DisableSharingFavoriteItemCategoryMutation, DisableSharingFavoriteItemCategoryMutationVariables>;
export const FavoriteItemCategoriesDocument = gql`
    query FavoriteItemCategories {
  favorites: favoriteItemCategories {
    ...FavoriteItemCategoryWithoutItemsFields
  }
}
    ${FavoriteItemCategoryWithoutItemsFieldsFragmentDoc}`;

/**
 * __useFavoriteItemCategoriesQuery__
 *
 * To run a query within a React component, call `useFavoriteItemCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteItemCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteItemCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFavoriteItemCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<FavoriteItemCategoriesQuery, FavoriteItemCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoriteItemCategoriesQuery, FavoriteItemCategoriesQueryVariables>(FavoriteItemCategoriesDocument, options);
      }
export function useFavoriteItemCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoriteItemCategoriesQuery, FavoriteItemCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoriteItemCategoriesQuery, FavoriteItemCategoriesQueryVariables>(FavoriteItemCategoriesDocument, options);
        }
export type FavoriteItemCategoriesQueryHookResult = ReturnType<typeof useFavoriteItemCategoriesQuery>;
export type FavoriteItemCategoriesLazyQueryHookResult = ReturnType<typeof useFavoriteItemCategoriesLazyQuery>;
export type FavoriteItemCategoriesQueryResult = Apollo.QueryResult<FavoriteItemCategoriesQuery, FavoriteItemCategoriesQueryVariables>;
export const FavoriteItemCategoryDocument = gql`
    query FavoriteItemCategory($slug: [String!]!) {
  favorite: favoriteItemCategory(slug: $slug) {
    ...FavoriteItemCategoryFields
  }
}
    ${FavoriteItemCategoryFieldsFragmentDoc}`;

/**
 * __useFavoriteItemCategoryQuery__
 *
 * To run a query within a React component, call `useFavoriteItemCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteItemCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteItemCategoryQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useFavoriteItemCategoryQuery(baseOptions: Apollo.QueryHookOptions<FavoriteItemCategoryQuery, FavoriteItemCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoriteItemCategoryQuery, FavoriteItemCategoryQueryVariables>(FavoriteItemCategoryDocument, options);
      }
export function useFavoriteItemCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoriteItemCategoryQuery, FavoriteItemCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoriteItemCategoryQuery, FavoriteItemCategoryQueryVariables>(FavoriteItemCategoryDocument, options);
        }
export type FavoriteItemCategoryQueryHookResult = ReturnType<typeof useFavoriteItemCategoryQuery>;
export type FavoriteItemCategoryLazyQueryHookResult = ReturnType<typeof useFavoriteItemCategoryLazyQuery>;
export type FavoriteItemCategoryQueryResult = Apollo.QueryResult<FavoriteItemCategoryQuery, FavoriteItemCategoryQueryVariables>;
export const AddLogToInvestingDiaryDocument = gql`
    mutation AddLogToInvestingDiary($portfolioSlug: String!, $date: String!, $emotion: String, $tradeLogInput: InvestingDiaryTradeLogInput, $memoLogInput: InvestingDiaryMemoLogInput, $exchangeCurrencyLogInput: InvestingDiaryExchangeCurrencyLogInput, $depositWithdrawalLogInput: InvestingDiaryDepositWithdrawalLogInput) {
  addLogToInvestingDiary(
    portfolioSlug: $portfolioSlug
    date: $date
    emotion: $emotion
    tradeLogInput: $tradeLogInput
    memoLogInput: $memoLogInput
    exchangeCurrencyLogInput: $exchangeCurrencyLogInput
    depositWithdrawalLogInput: $depositWithdrawalLogInput
  ) {
    investingDiaryLog {
      ...TradingDiaryLogFields
    }
  }
}
    ${TradingDiaryLogFieldsFragmentDoc}`;
export type AddLogToInvestingDiaryMutationFn = Apollo.MutationFunction<AddLogToInvestingDiaryMutation, AddLogToInvestingDiaryMutationVariables>;

/**
 * __useAddLogToInvestingDiaryMutation__
 *
 * To run a mutation, you first call `useAddLogToInvestingDiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLogToInvestingDiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLogToInvestingDiaryMutation, { data, loading, error }] = useAddLogToInvestingDiaryMutation({
 *   variables: {
 *      portfolioSlug: // value for 'portfolioSlug'
 *      date: // value for 'date'
 *      emotion: // value for 'emotion'
 *      tradeLogInput: // value for 'tradeLogInput'
 *      memoLogInput: // value for 'memoLogInput'
 *      exchangeCurrencyLogInput: // value for 'exchangeCurrencyLogInput'
 *      depositWithdrawalLogInput: // value for 'depositWithdrawalLogInput'
 *   },
 * });
 */
export function useAddLogToInvestingDiaryMutation(baseOptions?: Apollo.MutationHookOptions<AddLogToInvestingDiaryMutation, AddLogToInvestingDiaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLogToInvestingDiaryMutation, AddLogToInvestingDiaryMutationVariables>(AddLogToInvestingDiaryDocument, options);
      }
export type AddLogToInvestingDiaryMutationHookResult = ReturnType<typeof useAddLogToInvestingDiaryMutation>;
export type AddLogToInvestingDiaryMutationResult = Apollo.MutationResult<AddLogToInvestingDiaryMutation>;
export type AddLogToInvestingDiaryMutationOptions = Apollo.BaseMutationOptions<AddLogToInvestingDiaryMutation, AddLogToInvestingDiaryMutationVariables>;
export const UpdateInvestingDiaryLogDocument = gql`
    mutation UpdateInvestingDiaryLog($investingDiaryLogId: ID!, $date: String!, $emotion: String, $tradeLogInput: InvestingDiaryTradeLogInput, $memoLogInput: InvestingDiaryMemoLogInput, $exchangeCurrencyLogInput: InvestingDiaryExchangeCurrencyLogInput, $depositWithdrawalLogInput: InvestingDiaryDepositWithdrawalLogInput) {
  updateInvestingDiaryLog(
    investingDiaryLogId: $investingDiaryLogId
    date: $date
    emotion: $emotion
    tradeLogInput: $tradeLogInput
    memoLogInput: $memoLogInput
    exchangeCurrencyLogInput: $exchangeCurrencyLogInput
    depositWithdrawalLogInput: $depositWithdrawalLogInput
  ) {
    investingDiaryLog {
      ...TradingDiaryLogFields
    }
  }
}
    ${TradingDiaryLogFieldsFragmentDoc}`;
export type UpdateInvestingDiaryLogMutationFn = Apollo.MutationFunction<UpdateInvestingDiaryLogMutation, UpdateInvestingDiaryLogMutationVariables>;

/**
 * __useUpdateInvestingDiaryLogMutation__
 *
 * To run a mutation, you first call `useUpdateInvestingDiaryLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvestingDiaryLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvestingDiaryLogMutation, { data, loading, error }] = useUpdateInvestingDiaryLogMutation({
 *   variables: {
 *      investingDiaryLogId: // value for 'investingDiaryLogId'
 *      date: // value for 'date'
 *      emotion: // value for 'emotion'
 *      tradeLogInput: // value for 'tradeLogInput'
 *      memoLogInput: // value for 'memoLogInput'
 *      exchangeCurrencyLogInput: // value for 'exchangeCurrencyLogInput'
 *      depositWithdrawalLogInput: // value for 'depositWithdrawalLogInput'
 *   },
 * });
 */
export function useUpdateInvestingDiaryLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvestingDiaryLogMutation, UpdateInvestingDiaryLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvestingDiaryLogMutation, UpdateInvestingDiaryLogMutationVariables>(UpdateInvestingDiaryLogDocument, options);
      }
export type UpdateInvestingDiaryLogMutationHookResult = ReturnType<typeof useUpdateInvestingDiaryLogMutation>;
export type UpdateInvestingDiaryLogMutationResult = Apollo.MutationResult<UpdateInvestingDiaryLogMutation>;
export type UpdateInvestingDiaryLogMutationOptions = Apollo.BaseMutationOptions<UpdateInvestingDiaryLogMutation, UpdateInvestingDiaryLogMutationVariables>;
export const RemoveInvestingDiaryLogDocument = gql`
    mutation RemoveInvestingDiaryLog($investingDiaryLogId: ID!) {
  removeInvestingDiaryLog(investingDiaryLogId: $investingDiaryLogId) {
    investingDiaryLog {
      ...TradingDiaryLogFields
    }
  }
}
    ${TradingDiaryLogFieldsFragmentDoc}`;
export type RemoveInvestingDiaryLogMutationFn = Apollo.MutationFunction<RemoveInvestingDiaryLogMutation, RemoveInvestingDiaryLogMutationVariables>;

/**
 * __useRemoveInvestingDiaryLogMutation__
 *
 * To run a mutation, you first call `useRemoveInvestingDiaryLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInvestingDiaryLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInvestingDiaryLogMutation, { data, loading, error }] = useRemoveInvestingDiaryLogMutation({
 *   variables: {
 *      investingDiaryLogId: // value for 'investingDiaryLogId'
 *   },
 * });
 */
export function useRemoveInvestingDiaryLogMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInvestingDiaryLogMutation, RemoveInvestingDiaryLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInvestingDiaryLogMutation, RemoveInvestingDiaryLogMutationVariables>(RemoveInvestingDiaryLogDocument, options);
      }
export type RemoveInvestingDiaryLogMutationHookResult = ReturnType<typeof useRemoveInvestingDiaryLogMutation>;
export type RemoveInvestingDiaryLogMutationResult = Apollo.MutationResult<RemoveInvestingDiaryLogMutation>;
export type RemoveInvestingDiaryLogMutationOptions = Apollo.BaseMutationOptions<RemoveInvestingDiaryLogMutation, RemoveInvestingDiaryLogMutationVariables>;
export const InvestingDiaryLogsDocument = gql`
    query InvestingDiaryLogs($portfolioSlugs: [String!], $category: String) {
  investingDiaryLogs(portfolioSlugs: $portfolioSlugs, category: $category) {
    ...TradingDiaryLogFields
  }
}
    ${TradingDiaryLogFieldsFragmentDoc}`;

/**
 * __useInvestingDiaryLogsQuery__
 *
 * To run a query within a React component, call `useInvestingDiaryLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestingDiaryLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestingDiaryLogsQuery({
 *   variables: {
 *      portfolioSlugs: // value for 'portfolioSlugs'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useInvestingDiaryLogsQuery(baseOptions?: Apollo.QueryHookOptions<InvestingDiaryLogsQuery, InvestingDiaryLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestingDiaryLogsQuery, InvestingDiaryLogsQueryVariables>(InvestingDiaryLogsDocument, options);
      }
export function useInvestingDiaryLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestingDiaryLogsQuery, InvestingDiaryLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestingDiaryLogsQuery, InvestingDiaryLogsQueryVariables>(InvestingDiaryLogsDocument, options);
        }
export type InvestingDiaryLogsQueryHookResult = ReturnType<typeof useInvestingDiaryLogsQuery>;
export type InvestingDiaryLogsLazyQueryHookResult = ReturnType<typeof useInvestingDiaryLogsLazyQuery>;
export type InvestingDiaryLogsQueryResult = Apollo.QueryResult<InvestingDiaryLogsQuery, InvestingDiaryLogsQueryVariables>;
export const EventStatusDocument = gql`
    query EventStatus {
  eventStatus {
    ...EventFields
  }
}
    ${EventFieldsFragmentDoc}`;

/**
 * __useEventStatusQuery__
 *
 * To run a query within a React component, call `useEventStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventStatusQuery(baseOptions?: Apollo.QueryHookOptions<EventStatusQuery, EventStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventStatusQuery, EventStatusQueryVariables>(EventStatusDocument, options);
      }
export function useEventStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventStatusQuery, EventStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventStatusQuery, EventStatusQueryVariables>(EventStatusDocument, options);
        }
export type EventStatusQueryHookResult = ReturnType<typeof useEventStatusQuery>;
export type EventStatusLazyQueryHookResult = ReturnType<typeof useEventStatusLazyQuery>;
export type EventStatusQueryResult = Apollo.QueryResult<EventStatusQuery, EventStatusQueryVariables>;
export const SendEmailToSubscribeMailingGroupDocument = gql`
    mutation SendEmailToSubscribeMailingGroup($locale: String!, $email: String, $mailingGroupName: String!, $serviceAgreement: Boolean!, $marketingAgreement: Boolean!) {
  sendEmailToSubscribeMailingGroup(
    locale: $locale
    email: $email
    mailingGroupName: $mailingGroupName
    serviceAgreement: $serviceAgreement
    marketingAgreement: $marketingAgreement
  ) {
    ...MailingGroupEmailVerificationFields
  }
}
    ${MailingGroupEmailVerificationFieldsFragmentDoc}`;
export type SendEmailToSubscribeMailingGroupMutationFn = Apollo.MutationFunction<SendEmailToSubscribeMailingGroupMutation, SendEmailToSubscribeMailingGroupMutationVariables>;

/**
 * __useSendEmailToSubscribeMailingGroupMutation__
 *
 * To run a mutation, you first call `useSendEmailToSubscribeMailingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailToSubscribeMailingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailToSubscribeMailingGroupMutation, { data, loading, error }] = useSendEmailToSubscribeMailingGroupMutation({
 *   variables: {
 *      locale: // value for 'locale'
 *      email: // value for 'email'
 *      mailingGroupName: // value for 'mailingGroupName'
 *      serviceAgreement: // value for 'serviceAgreement'
 *      marketingAgreement: // value for 'marketingAgreement'
 *   },
 * });
 */
export function useSendEmailToSubscribeMailingGroupMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailToSubscribeMailingGroupMutation, SendEmailToSubscribeMailingGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailToSubscribeMailingGroupMutation, SendEmailToSubscribeMailingGroupMutationVariables>(SendEmailToSubscribeMailingGroupDocument, options);
      }
export type SendEmailToSubscribeMailingGroupMutationHookResult = ReturnType<typeof useSendEmailToSubscribeMailingGroupMutation>;
export type SendEmailToSubscribeMailingGroupMutationResult = Apollo.MutationResult<SendEmailToSubscribeMailingGroupMutation>;
export type SendEmailToSubscribeMailingGroupMutationOptions = Apollo.BaseMutationOptions<SendEmailToSubscribeMailingGroupMutation, SendEmailToSubscribeMailingGroupMutationVariables>;
export const SubscribeMailingGroupDocument = gql`
    mutation SubscribeMailingGroup($verifyingEmailToken: String!) {
  subscribeMailingGroup(verifyingEmailToken: $verifyingEmailToken) {
    ...MailingGroupEmailVerificationFields
  }
}
    ${MailingGroupEmailVerificationFieldsFragmentDoc}`;
export type SubscribeMailingGroupMutationFn = Apollo.MutationFunction<SubscribeMailingGroupMutation, SubscribeMailingGroupMutationVariables>;

/**
 * __useSubscribeMailingGroupMutation__
 *
 * To run a mutation, you first call `useSubscribeMailingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeMailingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeMailingGroupMutation, { data, loading, error }] = useSubscribeMailingGroupMutation({
 *   variables: {
 *      verifyingEmailToken: // value for 'verifyingEmailToken'
 *   },
 * });
 */
export function useSubscribeMailingGroupMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeMailingGroupMutation, SubscribeMailingGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeMailingGroupMutation, SubscribeMailingGroupMutationVariables>(SubscribeMailingGroupDocument, options);
      }
export type SubscribeMailingGroupMutationHookResult = ReturnType<typeof useSubscribeMailingGroupMutation>;
export type SubscribeMailingGroupMutationResult = Apollo.MutationResult<SubscribeMailingGroupMutation>;
export type SubscribeMailingGroupMutationOptions = Apollo.BaseMutationOptions<SubscribeMailingGroupMutation, SubscribeMailingGroupMutationVariables>;
export const UnsubscribeMailingGroupDocument = gql`
    mutation UnsubscribeMailingGroup($mailingGroupId: ID!, $email: String) {
  unsubscribeMailingGroup(mailingGroupId: $mailingGroupId, email: $email) {
    ...MailingGroupEmailVerificationFields
  }
}
    ${MailingGroupEmailVerificationFieldsFragmentDoc}`;
export type UnsubscribeMailingGroupMutationFn = Apollo.MutationFunction<UnsubscribeMailingGroupMutation, UnsubscribeMailingGroupMutationVariables>;

/**
 * __useUnsubscribeMailingGroupMutation__
 *
 * To run a mutation, you first call `useUnsubscribeMailingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeMailingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeMailingGroupMutation, { data, loading, error }] = useUnsubscribeMailingGroupMutation({
 *   variables: {
 *      mailingGroupId: // value for 'mailingGroupId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUnsubscribeMailingGroupMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeMailingGroupMutation, UnsubscribeMailingGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeMailingGroupMutation, UnsubscribeMailingGroupMutationVariables>(UnsubscribeMailingGroupDocument, options);
      }
export type UnsubscribeMailingGroupMutationHookResult = ReturnType<typeof useUnsubscribeMailingGroupMutation>;
export type UnsubscribeMailingGroupMutationResult = Apollo.MutationResult<UnsubscribeMailingGroupMutation>;
export type UnsubscribeMailingGroupMutationOptions = Apollo.BaseMutationOptions<UnsubscribeMailingGroupMutation, UnsubscribeMailingGroupMutationVariables>;
export const NewsLettersDocument = gql`
    query NewsLetters {
  newsLetters {
    ...MailingGroupFields
  }
}
    ${MailingGroupFieldsFragmentDoc}`;

/**
 * __useNewsLettersQuery__
 *
 * To run a query within a React component, call `useNewsLettersQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsLettersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsLettersQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewsLettersQuery(baseOptions?: Apollo.QueryHookOptions<NewsLettersQuery, NewsLettersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsLettersQuery, NewsLettersQueryVariables>(NewsLettersDocument, options);
      }
export function useNewsLettersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsLettersQuery, NewsLettersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsLettersQuery, NewsLettersQueryVariables>(NewsLettersDocument, options);
        }
export type NewsLettersQueryHookResult = ReturnType<typeof useNewsLettersQuery>;
export type NewsLettersLazyQueryHookResult = ReturnType<typeof useNewsLettersLazyQuery>;
export type NewsLettersQueryResult = Apollo.QueryResult<NewsLettersQuery, NewsLettersQueryVariables>;
export const MailingGroupsDocument = gql`
    query MailingGroups {
  mailingGroups {
    ...MailingGroupFields
  }
}
    ${MailingGroupFieldsFragmentDoc}`;

/**
 * __useMailingGroupsQuery__
 *
 * To run a query within a React component, call `useMailingGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailingGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailingGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMailingGroupsQuery(baseOptions?: Apollo.QueryHookOptions<MailingGroupsQuery, MailingGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailingGroupsQuery, MailingGroupsQueryVariables>(MailingGroupsDocument, options);
      }
export function useMailingGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailingGroupsQuery, MailingGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailingGroupsQuery, MailingGroupsQueryVariables>(MailingGroupsDocument, options);
        }
export type MailingGroupsQueryHookResult = ReturnType<typeof useMailingGroupsQuery>;
export type MailingGroupsLazyQueryHookResult = ReturnType<typeof useMailingGroupsLazyQuery>;
export type MailingGroupsQueryResult = Apollo.QueryResult<MailingGroupsQuery, MailingGroupsQueryVariables>;
export const MailingGroupDocument = gql`
    query MailingGroup($id: ID!) {
  mailingGroup(id: $id) {
    ...MailingGroupFields
  }
}
    ${MailingGroupFieldsFragmentDoc}`;

/**
 * __useMailingGroupQuery__
 *
 * To run a query within a React component, call `useMailingGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailingGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailingGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMailingGroupQuery(baseOptions: Apollo.QueryHookOptions<MailingGroupQuery, MailingGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailingGroupQuery, MailingGroupQueryVariables>(MailingGroupDocument, options);
      }
export function useMailingGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailingGroupQuery, MailingGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailingGroupQuery, MailingGroupQueryVariables>(MailingGroupDocument, options);
        }
export type MailingGroupQueryHookResult = ReturnType<typeof useMailingGroupQuery>;
export type MailingGroupLazyQueryHookResult = ReturnType<typeof useMailingGroupLazyQuery>;
export type MailingGroupQueryResult = Apollo.QueryResult<MailingGroupQuery, MailingGroupQueryVariables>;
export const NoticesDocument = gql`
    query Notices($page: Int, $limit: Int) {
  notices(page: $page, limit: $limit) {
    ...NoticeField
  }
}
    ${NoticeFieldFragmentDoc}`;

/**
 * __useNoticesQuery__
 *
 * To run a query within a React component, call `useNoticesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoticesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoticesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useNoticesQuery(baseOptions?: Apollo.QueryHookOptions<NoticesQuery, NoticesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoticesQuery, NoticesQueryVariables>(NoticesDocument, options);
      }
export function useNoticesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoticesQuery, NoticesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoticesQuery, NoticesQueryVariables>(NoticesDocument, options);
        }
export type NoticesQueryHookResult = ReturnType<typeof useNoticesQuery>;
export type NoticesLazyQueryHookResult = ReturnType<typeof useNoticesLazyQuery>;
export type NoticesQueryResult = Apollo.QueryResult<NoticesQuery, NoticesQueryVariables>;
export const NoticeDocument = gql`
    query Notice($id: ID!) {
  notice(id: $id) {
    ...NoticeField
  }
}
    ${NoticeFieldFragmentDoc}`;

/**
 * __useNoticeQuery__
 *
 * To run a query within a React component, call `useNoticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoticeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoticeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNoticeQuery(baseOptions: Apollo.QueryHookOptions<NoticeQuery, NoticeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoticeQuery, NoticeQueryVariables>(NoticeDocument, options);
      }
export function useNoticeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoticeQuery, NoticeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoticeQuery, NoticeQueryVariables>(NoticeDocument, options);
        }
export type NoticeQueryHookResult = ReturnType<typeof useNoticeQuery>;
export type NoticeLazyQueryHookResult = ReturnType<typeof useNoticeLazyQuery>;
export type NoticeQueryResult = Apollo.QueryResult<NoticeQuery, NoticeQueryVariables>;
export const CreateSnp500DividendPortfolioDocument = gql`
    mutation CreateSnp500DividendPortfolio($monthlyDividendAmount: Float!, $currencySymbol: String!, $tickers: [String!]!) {
  createDividendPortfolioSample(
    monthlyDividendAmount: $monthlyDividendAmount
    currencySymbol: $currencySymbol
    tickers: $tickers
  ) {
    portfolio {
      ...GeneratorPortfolioFields
    }
  }
}
    ${GeneratorPortfolioFieldsFragmentDoc}`;
export type CreateSnp500DividendPortfolioMutationFn = Apollo.MutationFunction<CreateSnp500DividendPortfolioMutation, CreateSnp500DividendPortfolioMutationVariables>;

/**
 * __useCreateSnp500DividendPortfolioMutation__
 *
 * To run a mutation, you first call `useCreateSnp500DividendPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSnp500DividendPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSnp500DividendPortfolioMutation, { data, loading, error }] = useCreateSnp500DividendPortfolioMutation({
 *   variables: {
 *      monthlyDividendAmount: // value for 'monthlyDividendAmount'
 *      currencySymbol: // value for 'currencySymbol'
 *      tickers: // value for 'tickers'
 *   },
 * });
 */
export function useCreateSnp500DividendPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<CreateSnp500DividendPortfolioMutation, CreateSnp500DividendPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSnp500DividendPortfolioMutation, CreateSnp500DividendPortfolioMutationVariables>(CreateSnp500DividendPortfolioDocument, options);
      }
export type CreateSnp500DividendPortfolioMutationHookResult = ReturnType<typeof useCreateSnp500DividendPortfolioMutation>;
export type CreateSnp500DividendPortfolioMutationResult = Apollo.MutationResult<CreateSnp500DividendPortfolioMutation>;
export type CreateSnp500DividendPortfolioMutationOptions = Apollo.BaseMutationOptions<CreateSnp500DividendPortfolioMutation, CreateSnp500DividendPortfolioMutationVariables>;
export const SaveDividendPortfolioDocument = gql`
    mutation SaveDividendPortfolio($portfolioSlug: String!, $portfolioName: String!) {
  saveDividendPortfolioFromSamsung(
    portfolioSlug: $portfolioSlug
    portfolioName: $portfolioName
  ) {
    portfolio {
      ...GeneratorPortfolioFields
    }
  }
}
    ${GeneratorPortfolioFieldsFragmentDoc}`;
export type SaveDividendPortfolioMutationFn = Apollo.MutationFunction<SaveDividendPortfolioMutation, SaveDividendPortfolioMutationVariables>;

/**
 * __useSaveDividendPortfolioMutation__
 *
 * To run a mutation, you first call `useSaveDividendPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDividendPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDividendPortfolioMutation, { data, loading, error }] = useSaveDividendPortfolioMutation({
 *   variables: {
 *      portfolioSlug: // value for 'portfolioSlug'
 *      portfolioName: // value for 'portfolioName'
 *   },
 * });
 */
export function useSaveDividendPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<SaveDividendPortfolioMutation, SaveDividendPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDividendPortfolioMutation, SaveDividendPortfolioMutationVariables>(SaveDividendPortfolioDocument, options);
      }
export type SaveDividendPortfolioMutationHookResult = ReturnType<typeof useSaveDividendPortfolioMutation>;
export type SaveDividendPortfolioMutationResult = Apollo.MutationResult<SaveDividendPortfolioMutation>;
export type SaveDividendPortfolioMutationOptions = Apollo.BaseMutationOptions<SaveDividendPortfolioMutation, SaveDividendPortfolioMutationVariables>;
export const CategorizedCompaniesDocument = gql`
    query CategorizedCompanies {
  categorizedCompanies {
    ...CategorizedCompanyFields
  }
}
    ${CategorizedCompanyFieldsFragmentDoc}`;

/**
 * __useCategorizedCompaniesQuery__
 *
 * To run a query within a React component, call `useCategorizedCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorizedCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorizedCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategorizedCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<CategorizedCompaniesQuery, CategorizedCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategorizedCompaniesQuery, CategorizedCompaniesQueryVariables>(CategorizedCompaniesDocument, options);
      }
export function useCategorizedCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategorizedCompaniesQuery, CategorizedCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategorizedCompaniesQuery, CategorizedCompaniesQueryVariables>(CategorizedCompaniesDocument, options);
        }
export type CategorizedCompaniesQueryHookResult = ReturnType<typeof useCategorizedCompaniesQuery>;
export type CategorizedCompaniesLazyQueryHookResult = ReturnType<typeof useCategorizedCompaniesLazyQuery>;
export type CategorizedCompaniesQueryResult = Apollo.QueryResult<CategorizedCompaniesQuery, CategorizedCompaniesQueryVariables>;
export const DividendHistoriesInSnp500Document = gql`
    query DividendHistoriesInSnp500($companyIds: [ID!]!) {
  dividendHistoriesInSnp500(companyIds: $companyIds) {
    ...DividendHistoryFields
  }
}
    ${DividendHistoryFieldsFragmentDoc}`;

/**
 * __useDividendHistoriesInSnp500Query__
 *
 * To run a query within a React component, call `useDividendHistoriesInSnp500Query` and pass it any options that fit your needs.
 * When your component renders, `useDividendHistoriesInSnp500Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDividendHistoriesInSnp500Query({
 *   variables: {
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useDividendHistoriesInSnp500Query(baseOptions: Apollo.QueryHookOptions<DividendHistoriesInSnp500Query, DividendHistoriesInSnp500QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DividendHistoriesInSnp500Query, DividendHistoriesInSnp500QueryVariables>(DividendHistoriesInSnp500Document, options);
      }
export function useDividendHistoriesInSnp500LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DividendHistoriesInSnp500Query, DividendHistoriesInSnp500QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DividendHistoriesInSnp500Query, DividendHistoriesInSnp500QueryVariables>(DividendHistoriesInSnp500Document, options);
        }
export type DividendHistoriesInSnp500QueryHookResult = ReturnType<typeof useDividendHistoriesInSnp500Query>;
export type DividendHistoriesInSnp500LazyQueryHookResult = ReturnType<typeof useDividendHistoriesInSnp500LazyQuery>;
export type DividendHistoriesInSnp500QueryResult = Apollo.QueryResult<DividendHistoriesInSnp500Query, DividendHistoriesInSnp500QueryVariables>;
export const GetPortfolioBySlugDocument = gql`
    query getPortfolioBySlug($portfolioSlug: String!) {
  userPortfolio(portfolioSlug: $portfolioSlug) {
    id
    assets {
      ...UserAssetFields
    }
    createdAt
    currency {
      id
      decimalPoint
      symbol
      unit
    }
    depositConnectedAt
    description
    name
    slug
    updatedAt
  }
}
    ${UserAssetFieldsFragmentDoc}`;

/**
 * __useGetPortfolioBySlugQuery__
 *
 * To run a query within a React component, call `useGetPortfolioBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioBySlugQuery({
 *   variables: {
 *      portfolioSlug: // value for 'portfolioSlug'
 *   },
 * });
 */
export function useGetPortfolioBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioBySlugQuery, GetPortfolioBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioBySlugQuery, GetPortfolioBySlugQueryVariables>(GetPortfolioBySlugDocument, options);
      }
export function useGetPortfolioBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioBySlugQuery, GetPortfolioBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioBySlugQuery, GetPortfolioBySlugQueryVariables>(GetPortfolioBySlugDocument, options);
        }
export type GetPortfolioBySlugQueryHookResult = ReturnType<typeof useGetPortfolioBySlugQuery>;
export type GetPortfolioBySlugLazyQueryHookResult = ReturnType<typeof useGetPortfolioBySlugLazyQuery>;
export type GetPortfolioBySlugQueryResult = Apollo.QueryResult<GetPortfolioBySlugQuery, GetPortfolioBySlugQueryVariables>;
export const UploadPortfolioDocument = gql`
    mutation UploadPortfolio($name: String, $description: String, $baseCurrency: String, $dividendTaxRate: Float, $assets: [UploadCompanyAsset!]) {
  uploadPortfolio(
    portfolio: {name: $name, description: $description, baseCurrency: $baseCurrency, dividendTaxRate: $dividendTaxRate}
    assets: $assets
  ) {
    items {
      ...UserPortfolioItemsFields
    }
  }
}
    ${UserPortfolioItemsFieldsFragmentDoc}`;
export type UploadPortfolioMutationFn = Apollo.MutationFunction<UploadPortfolioMutation, UploadPortfolioMutationVariables>;

/**
 * __useUploadPortfolioMutation__
 *
 * To run a mutation, you first call `useUploadPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPortfolioMutation, { data, loading, error }] = useUploadPortfolioMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      baseCurrency: // value for 'baseCurrency'
 *      dividendTaxRate: // value for 'dividendTaxRate'
 *      assets: // value for 'assets'
 *   },
 * });
 */
export function useUploadPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<UploadPortfolioMutation, UploadPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadPortfolioMutation, UploadPortfolioMutationVariables>(UploadPortfolioDocument, options);
      }
export type UploadPortfolioMutationHookResult = ReturnType<typeof useUploadPortfolioMutation>;
export type UploadPortfolioMutationResult = Apollo.MutationResult<UploadPortfolioMutation>;
export type UploadPortfolioMutationOptions = Apollo.BaseMutationOptions<UploadPortfolioMutation, UploadPortfolioMutationVariables>;
export const UpdatePortfolioInformationDocument = gql`
    mutation UpdatePortfolioInformation($portfolioId: ID!, $portfolioName: String, $portfolioDescription: String, $baseCurrency: String, $dividendTaxRate: Float) {
  updatePortfolioInformation(
    portfolio: {id: $portfolioId, name: $portfolioName, description: $portfolioDescription, currency: $baseCurrency, dividendTaxRate: $dividendTaxRate}
  ) {
    portfolio {
      ...UserPortfolioFields
    }
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;
export type UpdatePortfolioInformationMutationFn = Apollo.MutationFunction<UpdatePortfolioInformationMutation, UpdatePortfolioInformationMutationVariables>;

/**
 * __useUpdatePortfolioInformationMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioInformationMutation, { data, loading, error }] = useUpdatePortfolioInformationMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      portfolioName: // value for 'portfolioName'
 *      portfolioDescription: // value for 'portfolioDescription'
 *      baseCurrency: // value for 'baseCurrency'
 *      dividendTaxRate: // value for 'dividendTaxRate'
 *   },
 * });
 */
export function useUpdatePortfolioInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioInformationMutation, UpdatePortfolioInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioInformationMutation, UpdatePortfolioInformationMutationVariables>(UpdatePortfolioInformationDocument, options);
      }
export type UpdatePortfolioInformationMutationHookResult = ReturnType<typeof useUpdatePortfolioInformationMutation>;
export type UpdatePortfolioInformationMutationResult = Apollo.MutationResult<UpdatePortfolioInformationMutation>;
export type UpdatePortfolioInformationMutationOptions = Apollo.BaseMutationOptions<UpdatePortfolioInformationMutation, UpdatePortfolioInformationMutationVariables>;
export const UpdateSwitchPortfolioDocument = gql`
    mutation UpdateSwitchPortfolio($switchPortfolioCurrencyId: ID) {
  updateSwitchPortfolio(switchPortfolioCurrencyId: $switchPortfolioCurrencyId) {
    switchPortfolio {
      ...SwitchPortfolioFields
    }
  }
}
    ${SwitchPortfolioFieldsFragmentDoc}`;
export type UpdateSwitchPortfolioMutationFn = Apollo.MutationFunction<UpdateSwitchPortfolioMutation, UpdateSwitchPortfolioMutationVariables>;

/**
 * __useUpdateSwitchPortfolioMutation__
 *
 * To run a mutation, you first call `useUpdateSwitchPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSwitchPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSwitchPortfolioMutation, { data, loading, error }] = useUpdateSwitchPortfolioMutation({
 *   variables: {
 *      switchPortfolioCurrencyId: // value for 'switchPortfolioCurrencyId'
 *   },
 * });
 */
export function useUpdateSwitchPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSwitchPortfolioMutation, UpdateSwitchPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSwitchPortfolioMutation, UpdateSwitchPortfolioMutationVariables>(UpdateSwitchPortfolioDocument, options);
      }
export type UpdateSwitchPortfolioMutationHookResult = ReturnType<typeof useUpdateSwitchPortfolioMutation>;
export type UpdateSwitchPortfolioMutationResult = Apollo.MutationResult<UpdateSwitchPortfolioMutation>;
export type UpdateSwitchPortfolioMutationOptions = Apollo.BaseMutationOptions<UpdateSwitchPortfolioMutation, UpdateSwitchPortfolioMutationVariables>;
export const UpdatePortfolioSwitchOnDocument = gql`
    mutation UpdatePortfolioSwitchOn($portfolioId: ID!, $portfolioSwitchOn: Boolean!) {
  updatePortfolioSwitchOn(
    portfolioId: $portfolioId
    portfolioSwitchOn: $portfolioSwitchOn
  ) {
    portfolio {
      id
      portfolioSwitchOn
    }
    switchPortfolio {
      ...SwitchPortfolioFields
    }
  }
}
    ${SwitchPortfolioFieldsFragmentDoc}`;
export type UpdatePortfolioSwitchOnMutationFn = Apollo.MutationFunction<UpdatePortfolioSwitchOnMutation, UpdatePortfolioSwitchOnMutationVariables>;

/**
 * __useUpdatePortfolioSwitchOnMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioSwitchOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioSwitchOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioSwitchOnMutation, { data, loading, error }] = useUpdatePortfolioSwitchOnMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      portfolioSwitchOn: // value for 'portfolioSwitchOn'
 *   },
 * });
 */
export function useUpdatePortfolioSwitchOnMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioSwitchOnMutation, UpdatePortfolioSwitchOnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioSwitchOnMutation, UpdatePortfolioSwitchOnMutationVariables>(UpdatePortfolioSwitchOnDocument, options);
      }
export type UpdatePortfolioSwitchOnMutationHookResult = ReturnType<typeof useUpdatePortfolioSwitchOnMutation>;
export type UpdatePortfolioSwitchOnMutationResult = Apollo.MutationResult<UpdatePortfolioSwitchOnMutation>;
export type UpdatePortfolioSwitchOnMutationOptions = Apollo.BaseMutationOptions<UpdatePortfolioSwitchOnMutation, UpdatePortfolioSwitchOnMutationVariables>;
export const UpdatePortfolioOrderScoresDocument = gql`
    mutation UpdatePortfolioOrderScores($portfolioOrderScores: [PortfolioOrderScoresInput!]!) {
  updatePortfolioOrderScores(portfolioOrderScores: $portfolioOrderScores) {
    portfolios {
      ...UserPortfolioItemsFields
    }
  }
}
    ${UserPortfolioItemsFieldsFragmentDoc}`;
export type UpdatePortfolioOrderScoresMutationFn = Apollo.MutationFunction<UpdatePortfolioOrderScoresMutation, UpdatePortfolioOrderScoresMutationVariables>;

/**
 * __useUpdatePortfolioOrderScoresMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioOrderScoresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioOrderScoresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioOrderScoresMutation, { data, loading, error }] = useUpdatePortfolioOrderScoresMutation({
 *   variables: {
 *      portfolioOrderScores: // value for 'portfolioOrderScores'
 *   },
 * });
 */
export function useUpdatePortfolioOrderScoresMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioOrderScoresMutation, UpdatePortfolioOrderScoresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioOrderScoresMutation, UpdatePortfolioOrderScoresMutationVariables>(UpdatePortfolioOrderScoresDocument, options);
      }
export type UpdatePortfolioOrderScoresMutationHookResult = ReturnType<typeof useUpdatePortfolioOrderScoresMutation>;
export type UpdatePortfolioOrderScoresMutationResult = Apollo.MutationResult<UpdatePortfolioOrderScoresMutation>;
export type UpdatePortfolioOrderScoresMutationOptions = Apollo.BaseMutationOptions<UpdatePortfolioOrderScoresMutation, UpdatePortfolioOrderScoresMutationVariables>;
export const RemovePortfolioDocument = gql`
    mutation RemovePortfolio($portfolioId: ID!) {
  removePortfolio(portfolioId: $portfolioId) {
    items {
      ...UserPortfolioItemsFields
    }
  }
}
    ${UserPortfolioItemsFieldsFragmentDoc}`;
export type RemovePortfolioMutationFn = Apollo.MutationFunction<RemovePortfolioMutation, RemovePortfolioMutationVariables>;

/**
 * __useRemovePortfolioMutation__
 *
 * To run a mutation, you first call `useRemovePortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePortfolioMutation, { data, loading, error }] = useRemovePortfolioMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useRemovePortfolioMutation(baseOptions?: Apollo.MutationHookOptions<RemovePortfolioMutation, RemovePortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePortfolioMutation, RemovePortfolioMutationVariables>(RemovePortfolioDocument, options);
      }
export type RemovePortfolioMutationHookResult = ReturnType<typeof useRemovePortfolioMutation>;
export type RemovePortfolioMutationResult = Apollo.MutationResult<RemovePortfolioMutation>;
export type RemovePortfolioMutationOptions = Apollo.BaseMutationOptions<RemovePortfolioMutation, RemovePortfolioMutationVariables>;
export const EnableSharingPortfolioDocument = gql`
    mutation EnableSharingPortfolio($portfolioSlug: ID!) {
  enableSharingPortfolio(portfolioSlug: $portfolioSlug) {
    linkUrl
    linkSharedAt
  }
}
    `;
export type EnableSharingPortfolioMutationFn = Apollo.MutationFunction<EnableSharingPortfolioMutation, EnableSharingPortfolioMutationVariables>;

/**
 * __useEnableSharingPortfolioMutation__
 *
 * To run a mutation, you first call `useEnableSharingPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableSharingPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableSharingPortfolioMutation, { data, loading, error }] = useEnableSharingPortfolioMutation({
 *   variables: {
 *      portfolioSlug: // value for 'portfolioSlug'
 *   },
 * });
 */
export function useEnableSharingPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<EnableSharingPortfolioMutation, EnableSharingPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableSharingPortfolioMutation, EnableSharingPortfolioMutationVariables>(EnableSharingPortfolioDocument, options);
      }
export type EnableSharingPortfolioMutationHookResult = ReturnType<typeof useEnableSharingPortfolioMutation>;
export type EnableSharingPortfolioMutationResult = Apollo.MutationResult<EnableSharingPortfolioMutation>;
export type EnableSharingPortfolioMutationOptions = Apollo.BaseMutationOptions<EnableSharingPortfolioMutation, EnableSharingPortfolioMutationVariables>;
export const DisableSharingPortfolioDocument = gql`
    mutation DisableSharingPortfolio($portfolioSlug: String!) {
  disableSharingPortfolio(portfolioSlug: $portfolioSlug) {
    linkUrl
    linkSharedAt
  }
}
    `;
export type DisableSharingPortfolioMutationFn = Apollo.MutationFunction<DisableSharingPortfolioMutation, DisableSharingPortfolioMutationVariables>;

/**
 * __useDisableSharingPortfolioMutation__
 *
 * To run a mutation, you first call `useDisableSharingPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableSharingPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableSharingPortfolioMutation, { data, loading, error }] = useDisableSharingPortfolioMutation({
 *   variables: {
 *      portfolioSlug: // value for 'portfolioSlug'
 *   },
 * });
 */
export function useDisableSharingPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<DisableSharingPortfolioMutation, DisableSharingPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableSharingPortfolioMutation, DisableSharingPortfolioMutationVariables>(DisableSharingPortfolioDocument, options);
      }
export type DisableSharingPortfolioMutationHookResult = ReturnType<typeof useDisableSharingPortfolioMutation>;
export type DisableSharingPortfolioMutationResult = Apollo.MutationResult<DisableSharingPortfolioMutation>;
export type DisableSharingPortfolioMutationOptions = Apollo.BaseMutationOptions<DisableSharingPortfolioMutation, DisableSharingPortfolioMutationVariables>;
export const PostUserPortfolioCommentDocument = gql`
    mutation PostUserPortfolioComment($portfolioSlug: String!, $comment: String!) {
  postUserPortfolioComment(portfolioSlug: $portfolioSlug, comment: $comment) {
    comment {
      ...UserPortfolioCommentFields
    }
  }
}
    ${UserPortfolioCommentFieldsFragmentDoc}`;
export type PostUserPortfolioCommentMutationFn = Apollo.MutationFunction<PostUserPortfolioCommentMutation, PostUserPortfolioCommentMutationVariables>;

/**
 * __usePostUserPortfolioCommentMutation__
 *
 * To run a mutation, you first call `usePostUserPortfolioCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostUserPortfolioCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postUserPortfolioCommentMutation, { data, loading, error }] = usePostUserPortfolioCommentMutation({
 *   variables: {
 *      portfolioSlug: // value for 'portfolioSlug'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function usePostUserPortfolioCommentMutation(baseOptions?: Apollo.MutationHookOptions<PostUserPortfolioCommentMutation, PostUserPortfolioCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostUserPortfolioCommentMutation, PostUserPortfolioCommentMutationVariables>(PostUserPortfolioCommentDocument, options);
      }
export type PostUserPortfolioCommentMutationHookResult = ReturnType<typeof usePostUserPortfolioCommentMutation>;
export type PostUserPortfolioCommentMutationResult = Apollo.MutationResult<PostUserPortfolioCommentMutation>;
export type PostUserPortfolioCommentMutationOptions = Apollo.BaseMutationOptions<PostUserPortfolioCommentMutation, PostUserPortfolioCommentMutationVariables>;
export const DeleteUserPortfolioCommentDocument = gql`
    mutation DeleteUserPortfolioComment($portfolioSlug: String!, $commentId: ID!) {
  deleteUserPortfolioComment(portfolioSlug: $portfolioSlug, commentId: $commentId) {
    comment {
      ...UserPortfolioCommentFields
    }
    portfolioComments {
      ...UserPortfolioCommentFields
    }
  }
}
    ${UserPortfolioCommentFieldsFragmentDoc}`;
export type DeleteUserPortfolioCommentMutationFn = Apollo.MutationFunction<DeleteUserPortfolioCommentMutation, DeleteUserPortfolioCommentMutationVariables>;

/**
 * __useDeleteUserPortfolioCommentMutation__
 *
 * To run a mutation, you first call `useDeleteUserPortfolioCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserPortfolioCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserPortfolioCommentMutation, { data, loading, error }] = useDeleteUserPortfolioCommentMutation({
 *   variables: {
 *      portfolioSlug: // value for 'portfolioSlug'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteUserPortfolioCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserPortfolioCommentMutation, DeleteUserPortfolioCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserPortfolioCommentMutation, DeleteUserPortfolioCommentMutationVariables>(DeleteUserPortfolioCommentDocument, options);
      }
export type DeleteUserPortfolioCommentMutationHookResult = ReturnType<typeof useDeleteUserPortfolioCommentMutation>;
export type DeleteUserPortfolioCommentMutationResult = Apollo.MutationResult<DeleteUserPortfolioCommentMutation>;
export type DeleteUserPortfolioCommentMutationOptions = Apollo.BaseMutationOptions<DeleteUserPortfolioCommentMutation, DeleteUserPortfolioCommentMutationVariables>;
export const RemoveSecuritiesAccountFromPortfolioDocument = gql`
    mutation RemoveSecuritiesAccountFromPortfolio($portfolioSlug: String!) {
  removeSecuritiesAccountFromPortfolio(portfolioSlug: $portfolioSlug) {
    portfolio {
      ...UserPortfolioFields
    }
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;
export type RemoveSecuritiesAccountFromPortfolioMutationFn = Apollo.MutationFunction<RemoveSecuritiesAccountFromPortfolioMutation, RemoveSecuritiesAccountFromPortfolioMutationVariables>;

/**
 * __useRemoveSecuritiesAccountFromPortfolioMutation__
 *
 * To run a mutation, you first call `useRemoveSecuritiesAccountFromPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSecuritiesAccountFromPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSecuritiesAccountFromPortfolioMutation, { data, loading, error }] = useRemoveSecuritiesAccountFromPortfolioMutation({
 *   variables: {
 *      portfolioSlug: // value for 'portfolioSlug'
 *   },
 * });
 */
export function useRemoveSecuritiesAccountFromPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSecuritiesAccountFromPortfolioMutation, RemoveSecuritiesAccountFromPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSecuritiesAccountFromPortfolioMutation, RemoveSecuritiesAccountFromPortfolioMutationVariables>(RemoveSecuritiesAccountFromPortfolioDocument, options);
      }
export type RemoveSecuritiesAccountFromPortfolioMutationHookResult = ReturnType<typeof useRemoveSecuritiesAccountFromPortfolioMutation>;
export type RemoveSecuritiesAccountFromPortfolioMutationResult = Apollo.MutationResult<RemoveSecuritiesAccountFromPortfolioMutation>;
export type RemoveSecuritiesAccountFromPortfolioMutationOptions = Apollo.BaseMutationOptions<RemoveSecuritiesAccountFromPortfolioMutation, RemoveSecuritiesAccountFromPortfolioMutationVariables>;
export const AddCryptoExchangeApiKeyToUserDocument = gql`
    mutation AddCryptoExchangeApiKeyToUser($cryptoExchangeId: ID!, $base64EncryptedAccessKey: String!, $base64EncryptedSecretKey: String) {
  addCryptoExchangeApiKeyToUser(
    cryptoExchangeId: $cryptoExchangeId
    base64EncryptedAccessKey: $base64EncryptedAccessKey
    base64EncryptedSecretKey: $base64EncryptedSecretKey
  ) {
    cryptoExchangeApiKey {
      ...CryptoExchangeApiKeyFields
    }
  }
}
    ${CryptoExchangeApiKeyFieldsFragmentDoc}`;
export type AddCryptoExchangeApiKeyToUserMutationFn = Apollo.MutationFunction<AddCryptoExchangeApiKeyToUserMutation, AddCryptoExchangeApiKeyToUserMutationVariables>;

/**
 * __useAddCryptoExchangeApiKeyToUserMutation__
 *
 * To run a mutation, you first call `useAddCryptoExchangeApiKeyToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCryptoExchangeApiKeyToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCryptoExchangeApiKeyToUserMutation, { data, loading, error }] = useAddCryptoExchangeApiKeyToUserMutation({
 *   variables: {
 *      cryptoExchangeId: // value for 'cryptoExchangeId'
 *      base64EncryptedAccessKey: // value for 'base64EncryptedAccessKey'
 *      base64EncryptedSecretKey: // value for 'base64EncryptedSecretKey'
 *   },
 * });
 */
export function useAddCryptoExchangeApiKeyToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddCryptoExchangeApiKeyToUserMutation, AddCryptoExchangeApiKeyToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCryptoExchangeApiKeyToUserMutation, AddCryptoExchangeApiKeyToUserMutationVariables>(AddCryptoExchangeApiKeyToUserDocument, options);
      }
export type AddCryptoExchangeApiKeyToUserMutationHookResult = ReturnType<typeof useAddCryptoExchangeApiKeyToUserMutation>;
export type AddCryptoExchangeApiKeyToUserMutationResult = Apollo.MutationResult<AddCryptoExchangeApiKeyToUserMutation>;
export type AddCryptoExchangeApiKeyToUserMutationOptions = Apollo.BaseMutationOptions<AddCryptoExchangeApiKeyToUserMutation, AddCryptoExchangeApiKeyToUserMutationVariables>;
export const RemoveCryptoExchangeApiKeyFromUserDocument = gql`
    mutation RemoveCryptoExchangeApiKeyFromUser($cryptoExchangeApiKeyId: ID!) {
  removeCryptoExchangeApiKeyFromUser(
    cryptoExchangeApiKeyId: $cryptoExchangeApiKeyId
  ) {
    cryptoExchangeApiKey {
      ...CryptoExchangeApiKeyFields
    }
    errors
  }
}
    ${CryptoExchangeApiKeyFieldsFragmentDoc}`;
export type RemoveCryptoExchangeApiKeyFromUserMutationFn = Apollo.MutationFunction<RemoveCryptoExchangeApiKeyFromUserMutation, RemoveCryptoExchangeApiKeyFromUserMutationVariables>;

/**
 * __useRemoveCryptoExchangeApiKeyFromUserMutation__
 *
 * To run a mutation, you first call `useRemoveCryptoExchangeApiKeyFromUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCryptoExchangeApiKeyFromUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCryptoExchangeApiKeyFromUserMutation, { data, loading, error }] = useRemoveCryptoExchangeApiKeyFromUserMutation({
 *   variables: {
 *      cryptoExchangeApiKeyId: // value for 'cryptoExchangeApiKeyId'
 *   },
 * });
 */
export function useRemoveCryptoExchangeApiKeyFromUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCryptoExchangeApiKeyFromUserMutation, RemoveCryptoExchangeApiKeyFromUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCryptoExchangeApiKeyFromUserMutation, RemoveCryptoExchangeApiKeyFromUserMutationVariables>(RemoveCryptoExchangeApiKeyFromUserDocument, options);
      }
export type RemoveCryptoExchangeApiKeyFromUserMutationHookResult = ReturnType<typeof useRemoveCryptoExchangeApiKeyFromUserMutation>;
export type RemoveCryptoExchangeApiKeyFromUserMutationResult = Apollo.MutationResult<RemoveCryptoExchangeApiKeyFromUserMutation>;
export type RemoveCryptoExchangeApiKeyFromUserMutationOptions = Apollo.BaseMutationOptions<RemoveCryptoExchangeApiKeyFromUserMutation, RemoveCryptoExchangeApiKeyFromUserMutationVariables>;
export const CreatePortfolioFromCryptoExchangeApiKeyDocument = gql`
    mutation CreatePortfolioFromCryptoExchangeApiKey($cryptoExchangeApiKeyId: ID!, $portfolioName: String!) {
  createPortfolioFromCryptoExchangeApiKey(
    cryptoExchangeApiKeyId: $cryptoExchangeApiKeyId
    portfolioName: $portfolioName
  ) {
    userPortfolio {
      ...UserPortfolioFields
    }
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;
export type CreatePortfolioFromCryptoExchangeApiKeyMutationFn = Apollo.MutationFunction<CreatePortfolioFromCryptoExchangeApiKeyMutation, CreatePortfolioFromCryptoExchangeApiKeyMutationVariables>;

/**
 * __useCreatePortfolioFromCryptoExchangeApiKeyMutation__
 *
 * To run a mutation, you first call `useCreatePortfolioFromCryptoExchangeApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortfolioFromCryptoExchangeApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortfolioFromCryptoExchangeApiKeyMutation, { data, loading, error }] = useCreatePortfolioFromCryptoExchangeApiKeyMutation({
 *   variables: {
 *      cryptoExchangeApiKeyId: // value for 'cryptoExchangeApiKeyId'
 *      portfolioName: // value for 'portfolioName'
 *   },
 * });
 */
export function useCreatePortfolioFromCryptoExchangeApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreatePortfolioFromCryptoExchangeApiKeyMutation, CreatePortfolioFromCryptoExchangeApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePortfolioFromCryptoExchangeApiKeyMutation, CreatePortfolioFromCryptoExchangeApiKeyMutationVariables>(CreatePortfolioFromCryptoExchangeApiKeyDocument, options);
      }
export type CreatePortfolioFromCryptoExchangeApiKeyMutationHookResult = ReturnType<typeof useCreatePortfolioFromCryptoExchangeApiKeyMutation>;
export type CreatePortfolioFromCryptoExchangeApiKeyMutationResult = Apollo.MutationResult<CreatePortfolioFromCryptoExchangeApiKeyMutation>;
export type CreatePortfolioFromCryptoExchangeApiKeyMutationOptions = Apollo.BaseMutationOptions<CreatePortfolioFromCryptoExchangeApiKeyMutation, CreatePortfolioFromCryptoExchangeApiKeyMutationVariables>;
export const UpdatePortfolioFromCryptoExchangeApiKeyDocument = gql`
    mutation UpdatePortfolioFromCryptoExchangeApiKey($userPortfolioSlug: String!) {
  updatePortfolioFromCryptoExchangeApiKey(userPortfolioSlug: $userPortfolioSlug) {
    userPortfolio {
      ...UserPortfolioFields
    }
    errors
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;
export type UpdatePortfolioFromCryptoExchangeApiKeyMutationFn = Apollo.MutationFunction<UpdatePortfolioFromCryptoExchangeApiKeyMutation, UpdatePortfolioFromCryptoExchangeApiKeyMutationVariables>;

/**
 * __useUpdatePortfolioFromCryptoExchangeApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioFromCryptoExchangeApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioFromCryptoExchangeApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioFromCryptoExchangeApiKeyMutation, { data, loading, error }] = useUpdatePortfolioFromCryptoExchangeApiKeyMutation({
 *   variables: {
 *      userPortfolioSlug: // value for 'userPortfolioSlug'
 *   },
 * });
 */
export function useUpdatePortfolioFromCryptoExchangeApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioFromCryptoExchangeApiKeyMutation, UpdatePortfolioFromCryptoExchangeApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioFromCryptoExchangeApiKeyMutation, UpdatePortfolioFromCryptoExchangeApiKeyMutationVariables>(UpdatePortfolioFromCryptoExchangeApiKeyDocument, options);
      }
export type UpdatePortfolioFromCryptoExchangeApiKeyMutationHookResult = ReturnType<typeof useUpdatePortfolioFromCryptoExchangeApiKeyMutation>;
export type UpdatePortfolioFromCryptoExchangeApiKeyMutationResult = Apollo.MutationResult<UpdatePortfolioFromCryptoExchangeApiKeyMutation>;
export type UpdatePortfolioFromCryptoExchangeApiKeyMutationOptions = Apollo.BaseMutationOptions<UpdatePortfolioFromCryptoExchangeApiKeyMutation, UpdatePortfolioFromCryptoExchangeApiKeyMutationVariables>;
export const RemoveCryptoExchangeApiKeyFromPortfolioDocument = gql`
    mutation RemoveCryptoExchangeApiKeyFromPortfolio($userPortfolioSlug: String!) {
  removeCryptoExchangeApiKeyFromPortfolio(userPortfolioSlug: $userPortfolioSlug) {
    userPortfolio {
      ...UserPortfolioFields
    }
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;
export type RemoveCryptoExchangeApiKeyFromPortfolioMutationFn = Apollo.MutationFunction<RemoveCryptoExchangeApiKeyFromPortfolioMutation, RemoveCryptoExchangeApiKeyFromPortfolioMutationVariables>;

/**
 * __useRemoveCryptoExchangeApiKeyFromPortfolioMutation__
 *
 * To run a mutation, you first call `useRemoveCryptoExchangeApiKeyFromPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCryptoExchangeApiKeyFromPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCryptoExchangeApiKeyFromPortfolioMutation, { data, loading, error }] = useRemoveCryptoExchangeApiKeyFromPortfolioMutation({
 *   variables: {
 *      userPortfolioSlug: // value for 'userPortfolioSlug'
 *   },
 * });
 */
export function useRemoveCryptoExchangeApiKeyFromPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCryptoExchangeApiKeyFromPortfolioMutation, RemoveCryptoExchangeApiKeyFromPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCryptoExchangeApiKeyFromPortfolioMutation, RemoveCryptoExchangeApiKeyFromPortfolioMutationVariables>(RemoveCryptoExchangeApiKeyFromPortfolioDocument, options);
      }
export type RemoveCryptoExchangeApiKeyFromPortfolioMutationHookResult = ReturnType<typeof useRemoveCryptoExchangeApiKeyFromPortfolioMutation>;
export type RemoveCryptoExchangeApiKeyFromPortfolioMutationResult = Apollo.MutationResult<RemoveCryptoExchangeApiKeyFromPortfolioMutation>;
export type RemoveCryptoExchangeApiKeyFromPortfolioMutationOptions = Apollo.BaseMutationOptions<RemoveCryptoExchangeApiKeyFromPortfolioMutation, RemoveCryptoExchangeApiKeyFromPortfolioMutationVariables>;
export const CreatePlaidLinkTokenDocument = gql`
    mutation CreatePlaidLinkToken {
  createPlaidLinkToken {
    linkToken
  }
}
    `;
export type CreatePlaidLinkTokenMutationFn = Apollo.MutationFunction<CreatePlaidLinkTokenMutation, CreatePlaidLinkTokenMutationVariables>;

/**
 * __useCreatePlaidLinkTokenMutation__
 *
 * To run a mutation, you first call `useCreatePlaidLinkTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaidLinkTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaidLinkTokenMutation, { data, loading, error }] = useCreatePlaidLinkTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreatePlaidLinkTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlaidLinkTokenMutation, CreatePlaidLinkTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlaidLinkTokenMutation, CreatePlaidLinkTokenMutationVariables>(CreatePlaidLinkTokenDocument, options);
      }
export type CreatePlaidLinkTokenMutationHookResult = ReturnType<typeof useCreatePlaidLinkTokenMutation>;
export type CreatePlaidLinkTokenMutationResult = Apollo.MutationResult<CreatePlaidLinkTokenMutation>;
export type CreatePlaidLinkTokenMutationOptions = Apollo.BaseMutationOptions<CreatePlaidLinkTokenMutation, CreatePlaidLinkTokenMutationVariables>;
export const CreatePortfolioFromPlaidPublicTokenDocument = gql`
    mutation CreatePortfolioFromPlaidPublicToken($portfolioName: String!, $publicToken: String!) {
  createPortfolioFromPlaidPublicToken(
    portfolioName: $portfolioName
    publicToken: $publicToken
  ) {
    userPortfolio {
      ...UserPortfolioFields
    }
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;
export type CreatePortfolioFromPlaidPublicTokenMutationFn = Apollo.MutationFunction<CreatePortfolioFromPlaidPublicTokenMutation, CreatePortfolioFromPlaidPublicTokenMutationVariables>;

/**
 * __useCreatePortfolioFromPlaidPublicTokenMutation__
 *
 * To run a mutation, you first call `useCreatePortfolioFromPlaidPublicTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortfolioFromPlaidPublicTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortfolioFromPlaidPublicTokenMutation, { data, loading, error }] = useCreatePortfolioFromPlaidPublicTokenMutation({
 *   variables: {
 *      portfolioName: // value for 'portfolioName'
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useCreatePortfolioFromPlaidPublicTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreatePortfolioFromPlaidPublicTokenMutation, CreatePortfolioFromPlaidPublicTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePortfolioFromPlaidPublicTokenMutation, CreatePortfolioFromPlaidPublicTokenMutationVariables>(CreatePortfolioFromPlaidPublicTokenDocument, options);
      }
export type CreatePortfolioFromPlaidPublicTokenMutationHookResult = ReturnType<typeof useCreatePortfolioFromPlaidPublicTokenMutation>;
export type CreatePortfolioFromPlaidPublicTokenMutationResult = Apollo.MutationResult<CreatePortfolioFromPlaidPublicTokenMutation>;
export type CreatePortfolioFromPlaidPublicTokenMutationOptions = Apollo.BaseMutationOptions<CreatePortfolioFromPlaidPublicTokenMutation, CreatePortfolioFromPlaidPublicTokenMutationVariables>;
export const UpdatePortfolioFromPlaidDocument = gql`
    mutation UpdatePortfolioFromPlaid($portfolioSlug: String!, $publicToken: String) {
  updatePortfolioFromPlaid(
    portfolioSlug: $portfolioSlug
    publicToken: $publicToken
  ) {
    userPortfolio {
      ...UserPortfolioFields
    }
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;
export type UpdatePortfolioFromPlaidMutationFn = Apollo.MutationFunction<UpdatePortfolioFromPlaidMutation, UpdatePortfolioFromPlaidMutationVariables>;

/**
 * __useUpdatePortfolioFromPlaidMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioFromPlaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioFromPlaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioFromPlaidMutation, { data, loading, error }] = useUpdatePortfolioFromPlaidMutation({
 *   variables: {
 *      portfolioSlug: // value for 'portfolioSlug'
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useUpdatePortfolioFromPlaidMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioFromPlaidMutation, UpdatePortfolioFromPlaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioFromPlaidMutation, UpdatePortfolioFromPlaidMutationVariables>(UpdatePortfolioFromPlaidDocument, options);
      }
export type UpdatePortfolioFromPlaidMutationHookResult = ReturnType<typeof useUpdatePortfolioFromPlaidMutation>;
export type UpdatePortfolioFromPlaidMutationResult = Apollo.MutationResult<UpdatePortfolioFromPlaidMutation>;
export type UpdatePortfolioFromPlaidMutationOptions = Apollo.BaseMutationOptions<UpdatePortfolioFromPlaidMutation, UpdatePortfolioFromPlaidMutationVariables>;
export const RemovePlaidConnectFromPortfolioDocument = gql`
    mutation RemovePlaidConnectFromPortfolio($portfolioSlug: String!) {
  removePlaidConnectFromPortfolio(portfolioSlug: $portfolioSlug) {
    userPortfolio {
      ...UserPortfolioFields
    }
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;
export type RemovePlaidConnectFromPortfolioMutationFn = Apollo.MutationFunction<RemovePlaidConnectFromPortfolioMutation, RemovePlaidConnectFromPortfolioMutationVariables>;

/**
 * __useRemovePlaidConnectFromPortfolioMutation__
 *
 * To run a mutation, you first call `useRemovePlaidConnectFromPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlaidConnectFromPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlaidConnectFromPortfolioMutation, { data, loading, error }] = useRemovePlaidConnectFromPortfolioMutation({
 *   variables: {
 *      portfolioSlug: // value for 'portfolioSlug'
 *   },
 * });
 */
export function useRemovePlaidConnectFromPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<RemovePlaidConnectFromPortfolioMutation, RemovePlaidConnectFromPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePlaidConnectFromPortfolioMutation, RemovePlaidConnectFromPortfolioMutationVariables>(RemovePlaidConnectFromPortfolioDocument, options);
      }
export type RemovePlaidConnectFromPortfolioMutationHookResult = ReturnType<typeof useRemovePlaidConnectFromPortfolioMutation>;
export type RemovePlaidConnectFromPortfolioMutationResult = Apollo.MutationResult<RemovePlaidConnectFromPortfolioMutation>;
export type RemovePlaidConnectFromPortfolioMutationOptions = Apollo.BaseMutationOptions<RemovePlaidConnectFromPortfolioMutation, RemovePlaidConnectFromPortfolioMutationVariables>;
export const MyPortfoliosDocument = gql`
    query MyPortfolios {
  myPortfolios {
    items {
      ...UserPortfolioItemsFields
    }
  }
}
    ${UserPortfolioItemsFieldsFragmentDoc}`;

/**
 * __useMyPortfoliosQuery__
 *
 * To run a query within a React component, call `useMyPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPortfoliosQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPortfoliosQuery(baseOptions?: Apollo.QueryHookOptions<MyPortfoliosQuery, MyPortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPortfoliosQuery, MyPortfoliosQueryVariables>(MyPortfoliosDocument, options);
      }
export function useMyPortfoliosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPortfoliosQuery, MyPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPortfoliosQuery, MyPortfoliosQueryVariables>(MyPortfoliosDocument, options);
        }
export type MyPortfoliosQueryHookResult = ReturnType<typeof useMyPortfoliosQuery>;
export type MyPortfoliosLazyQueryHookResult = ReturnType<typeof useMyPortfoliosLazyQuery>;
export type MyPortfoliosQueryResult = Apollo.QueryResult<MyPortfoliosQuery, MyPortfoliosQueryVariables>;
export const MyMetaPortfolioDocument = gql`
    query MyMetaPortfolio {
  myMetaPortfolio {
    switchPortfolio {
      ...SwitchPortfolioFields
    }
    portfolios {
      ...UserPortfolioItemsFields
    }
  }
}
    ${SwitchPortfolioFieldsFragmentDoc}
${UserPortfolioItemsFieldsFragmentDoc}`;

/**
 * __useMyMetaPortfolioQuery__
 *
 * To run a query within a React component, call `useMyMetaPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyMetaPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyMetaPortfolioQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyMetaPortfolioQuery(baseOptions?: Apollo.QueryHookOptions<MyMetaPortfolioQuery, MyMetaPortfolioQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyMetaPortfolioQuery, MyMetaPortfolioQueryVariables>(MyMetaPortfolioDocument, options);
      }
export function useMyMetaPortfolioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyMetaPortfolioQuery, MyMetaPortfolioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyMetaPortfolioQuery, MyMetaPortfolioQueryVariables>(MyMetaPortfolioDocument, options);
        }
export type MyMetaPortfolioQueryHookResult = ReturnType<typeof useMyMetaPortfolioQuery>;
export type MyMetaPortfolioLazyQueryHookResult = ReturnType<typeof useMyMetaPortfolioLazyQuery>;
export type MyMetaPortfolioQueryResult = Apollo.QueryResult<MyMetaPortfolioQuery, MyMetaPortfolioQueryVariables>;
export const MyMetaSwitchPortfolioCurrencyDocument = gql`
    query MyMetaSwitchPortfolioCurrency {
  myMetaPortfolio {
    switchPortfolio {
      currency {
        ...CurrencyFields
      }
      supportedCurrencies {
        ...CurrencyFields
      }
    }
  }
}
    ${CurrencyFieldsFragmentDoc}`;

/**
 * __useMyMetaSwitchPortfolioCurrencyQuery__
 *
 * To run a query within a React component, call `useMyMetaSwitchPortfolioCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyMetaSwitchPortfolioCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyMetaSwitchPortfolioCurrencyQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyMetaSwitchPortfolioCurrencyQuery(baseOptions?: Apollo.QueryHookOptions<MyMetaSwitchPortfolioCurrencyQuery, MyMetaSwitchPortfolioCurrencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyMetaSwitchPortfolioCurrencyQuery, MyMetaSwitchPortfolioCurrencyQueryVariables>(MyMetaSwitchPortfolioCurrencyDocument, options);
      }
export function useMyMetaSwitchPortfolioCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyMetaSwitchPortfolioCurrencyQuery, MyMetaSwitchPortfolioCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyMetaSwitchPortfolioCurrencyQuery, MyMetaSwitchPortfolioCurrencyQueryVariables>(MyMetaSwitchPortfolioCurrencyDocument, options);
        }
export type MyMetaSwitchPortfolioCurrencyQueryHookResult = ReturnType<typeof useMyMetaSwitchPortfolioCurrencyQuery>;
export type MyMetaSwitchPortfolioCurrencyLazyQueryHookResult = ReturnType<typeof useMyMetaSwitchPortfolioCurrencyLazyQuery>;
export type MyMetaSwitchPortfolioCurrencyQueryResult = Apollo.QueryResult<MyMetaSwitchPortfolioCurrencyQuery, MyMetaSwitchPortfolioCurrencyQueryVariables>;
export const UserPortfolioDocument = gql`
    query UserPortfolio($slug: String!) {
  userPortfolio(portfolioSlug: $slug) {
    ...UserPortfolioFields
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;

/**
 * __useUserPortfolioQuery__
 *
 * To run a query within a React component, call `useUserPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPortfolioQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useUserPortfolioQuery(baseOptions: Apollo.QueryHookOptions<UserPortfolioQuery, UserPortfolioQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPortfolioQuery, UserPortfolioQueryVariables>(UserPortfolioDocument, options);
      }
export function useUserPortfolioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPortfolioQuery, UserPortfolioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPortfolioQuery, UserPortfolioQueryVariables>(UserPortfolioDocument, options);
        }
export type UserPortfolioQueryHookResult = ReturnType<typeof useUserPortfolioQuery>;
export type UserPortfolioLazyQueryHookResult = ReturnType<typeof useUserPortfolioLazyQuery>;
export type UserPortfolioQueryResult = Apollo.QueryResult<UserPortfolioQuery, UserPortfolioQueryVariables>;
export const PortfolioWithCommentsDocument = gql`
    query PortfolioWithComments($slug: String!) {
  userPortfolio(portfolioSlug: $slug) {
    ...UserPortfolioFields
  }
  userPortfolioComments(portfolioSlug: $slug) {
    ...UserPortfolioCommentFields
  }
}
    ${UserPortfolioFieldsFragmentDoc}
${UserPortfolioCommentFieldsFragmentDoc}`;

/**
 * __usePortfolioWithCommentsQuery__
 *
 * To run a query within a React component, call `usePortfolioWithCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfolioWithCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfolioWithCommentsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePortfolioWithCommentsQuery(baseOptions: Apollo.QueryHookOptions<PortfolioWithCommentsQuery, PortfolioWithCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfolioWithCommentsQuery, PortfolioWithCommentsQueryVariables>(PortfolioWithCommentsDocument, options);
      }
export function usePortfolioWithCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortfolioWithCommentsQuery, PortfolioWithCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfolioWithCommentsQuery, PortfolioWithCommentsQueryVariables>(PortfolioWithCommentsDocument, options);
        }
export type PortfolioWithCommentsQueryHookResult = ReturnType<typeof usePortfolioWithCommentsQuery>;
export type PortfolioWithCommentsLazyQueryHookResult = ReturnType<typeof usePortfolioWithCommentsLazyQuery>;
export type PortfolioWithCommentsQueryResult = Apollo.QueryResult<PortfolioWithCommentsQuery, PortfolioWithCommentsQueryVariables>;
export const CombinedPortfolioWithExchangesDocument = gql`
    query CombinedPortfolioWithExchanges($slugs: [ID!]!) {
  combineUserPortfolios(portfolioSlugs: $slugs) {
    ...UserPortfolioFields
  }
}
    ${UserPortfolioFieldsFragmentDoc}`;

/**
 * __useCombinedPortfolioWithExchangesQuery__
 *
 * To run a query within a React component, call `useCombinedPortfolioWithExchangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCombinedPortfolioWithExchangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombinedPortfolioWithExchangesQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useCombinedPortfolioWithExchangesQuery(baseOptions: Apollo.QueryHookOptions<CombinedPortfolioWithExchangesQuery, CombinedPortfolioWithExchangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CombinedPortfolioWithExchangesQuery, CombinedPortfolioWithExchangesQueryVariables>(CombinedPortfolioWithExchangesDocument, options);
      }
export function useCombinedPortfolioWithExchangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CombinedPortfolioWithExchangesQuery, CombinedPortfolioWithExchangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CombinedPortfolioWithExchangesQuery, CombinedPortfolioWithExchangesQueryVariables>(CombinedPortfolioWithExchangesDocument, options);
        }
export type CombinedPortfolioWithExchangesQueryHookResult = ReturnType<typeof useCombinedPortfolioWithExchangesQuery>;
export type CombinedPortfolioWithExchangesLazyQueryHookResult = ReturnType<typeof useCombinedPortfolioWithExchangesLazyQuery>;
export type CombinedPortfolioWithExchangesQueryResult = Apollo.QueryResult<CombinedPortfolioWithExchangesQuery, CombinedPortfolioWithExchangesQueryVariables>;
export const CryptoExchangesDocument = gql`
    query CryptoExchanges($language: String!) {
  cryptoExchanges(language: $language) {
    ...CryptoExchangeFields
  }
}
    ${CryptoExchangeFieldsFragmentDoc}`;

/**
 * __useCryptoExchangesQuery__
 *
 * To run a query within a React component, call `useCryptoExchangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCryptoExchangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCryptoExchangesQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCryptoExchangesQuery(baseOptions: Apollo.QueryHookOptions<CryptoExchangesQuery, CryptoExchangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CryptoExchangesQuery, CryptoExchangesQueryVariables>(CryptoExchangesDocument, options);
      }
export function useCryptoExchangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CryptoExchangesQuery, CryptoExchangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CryptoExchangesQuery, CryptoExchangesQueryVariables>(CryptoExchangesDocument, options);
        }
export type CryptoExchangesQueryHookResult = ReturnType<typeof useCryptoExchangesQuery>;
export type CryptoExchangesLazyQueryHookResult = ReturnType<typeof useCryptoExchangesLazyQuery>;
export type CryptoExchangesQueryResult = Apollo.QueryResult<CryptoExchangesQuery, CryptoExchangesQueryVariables>;
export const CryptoExchangeApiKeysDocument = gql`
    query CryptoExchangeApiKeys($cryptoExchangeId: [ID!]) {
  cryptoExchangeApiKeys(cryptoExchangeId: $cryptoExchangeId) {
    ...CryptoExchangeApiKeyFields
  }
}
    ${CryptoExchangeApiKeyFieldsFragmentDoc}`;

/**
 * __useCryptoExchangeApiKeysQuery__
 *
 * To run a query within a React component, call `useCryptoExchangeApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useCryptoExchangeApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCryptoExchangeApiKeysQuery({
 *   variables: {
 *      cryptoExchangeId: // value for 'cryptoExchangeId'
 *   },
 * });
 */
export function useCryptoExchangeApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<CryptoExchangeApiKeysQuery, CryptoExchangeApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CryptoExchangeApiKeysQuery, CryptoExchangeApiKeysQueryVariables>(CryptoExchangeApiKeysDocument, options);
      }
export function useCryptoExchangeApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CryptoExchangeApiKeysQuery, CryptoExchangeApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CryptoExchangeApiKeysQuery, CryptoExchangeApiKeysQueryVariables>(CryptoExchangeApiKeysDocument, options);
        }
export type CryptoExchangeApiKeysQueryHookResult = ReturnType<typeof useCryptoExchangeApiKeysQuery>;
export type CryptoExchangeApiKeysLazyQueryHookResult = ReturnType<typeof useCryptoExchangeApiKeysLazyQuery>;
export type CryptoExchangeApiKeysQueryResult = Apollo.QueryResult<CryptoExchangeApiKeysQuery, CryptoExchangeApiKeysQueryVariables>;
export const MySecurityDocument = gql`
    query MySecurity {
  mySecurity {
    passwordEncryptKey
    updatedAtTimestamp
  }
}
    `;

/**
 * __useMySecurityQuery__
 *
 * To run a query within a React component, call `useMySecurityQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySecurityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySecurityQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySecurityQuery(baseOptions?: Apollo.QueryHookOptions<MySecurityQuery, MySecurityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySecurityQuery, MySecurityQueryVariables>(MySecurityDocument, options);
      }
export function useMySecurityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySecurityQuery, MySecurityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySecurityQuery, MySecurityQueryVariables>(MySecurityDocument, options);
        }
export type MySecurityQueryHookResult = ReturnType<typeof useMySecurityQuery>;
export type MySecurityLazyQueryHookResult = ReturnType<typeof useMySecurityLazyQuery>;
export type MySecurityQueryResult = Apollo.QueryResult<MySecurityQuery, MySecurityQueryVariables>;
export const ApplyProfessionalInvestorDocument = gql`
    mutation ApplyProfessionalInvestor($answers: [ProfessionalInvestorAnswersInput!]!, $professionalInvestorApplicant: ProfessionalInvestorApplicantInput!) {
  applyProfessionalInvestor(
    answers: $answers
    professionalInvestorApplicant: $professionalInvestorApplicant
  ) {
    professionalInvestorApplicant {
      ...ProfessionalInvestorApplicantFields
    }
  }
}
    ${ProfessionalInvestorApplicantFieldsFragmentDoc}`;
export type ApplyProfessionalInvestorMutationFn = Apollo.MutationFunction<ApplyProfessionalInvestorMutation, ApplyProfessionalInvestorMutationVariables>;

/**
 * __useApplyProfessionalInvestorMutation__
 *
 * To run a mutation, you first call `useApplyProfessionalInvestorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyProfessionalInvestorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyProfessionalInvestorMutation, { data, loading, error }] = useApplyProfessionalInvestorMutation({
 *   variables: {
 *      answers: // value for 'answers'
 *      professionalInvestorApplicant: // value for 'professionalInvestorApplicant'
 *   },
 * });
 */
export function useApplyProfessionalInvestorMutation(baseOptions?: Apollo.MutationHookOptions<ApplyProfessionalInvestorMutation, ApplyProfessionalInvestorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyProfessionalInvestorMutation, ApplyProfessionalInvestorMutationVariables>(ApplyProfessionalInvestorDocument, options);
      }
export type ApplyProfessionalInvestorMutationHookResult = ReturnType<typeof useApplyProfessionalInvestorMutation>;
export type ApplyProfessionalInvestorMutationResult = Apollo.MutationResult<ApplyProfessionalInvestorMutation>;
export type ApplyProfessionalInvestorMutationOptions = Apollo.BaseMutationOptions<ApplyProfessionalInvestorMutation, ApplyProfessionalInvestorMutationVariables>;
export const RequestProfessionalInvestorVerificationDocument = gql`
    mutation RequestProfessionalInvestorVerification($imageFile: Upload!) {
  requestProfessionalInvestorVerification(imageFile: $imageFile) {
    professionalInvestor {
      ...ProfessionalInvestorFields
    }
  }
}
    ${ProfessionalInvestorFieldsFragmentDoc}`;
export type RequestProfessionalInvestorVerificationMutationFn = Apollo.MutationFunction<RequestProfessionalInvestorVerificationMutation, RequestProfessionalInvestorVerificationMutationVariables>;

/**
 * __useRequestProfessionalInvestorVerificationMutation__
 *
 * To run a mutation, you first call `useRequestProfessionalInvestorVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestProfessionalInvestorVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestProfessionalInvestorVerificationMutation, { data, loading, error }] = useRequestProfessionalInvestorVerificationMutation({
 *   variables: {
 *      imageFile: // value for 'imageFile'
 *   },
 * });
 */
export function useRequestProfessionalInvestorVerificationMutation(baseOptions?: Apollo.MutationHookOptions<RequestProfessionalInvestorVerificationMutation, RequestProfessionalInvestorVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestProfessionalInvestorVerificationMutation, RequestProfessionalInvestorVerificationMutationVariables>(RequestProfessionalInvestorVerificationDocument, options);
      }
export type RequestProfessionalInvestorVerificationMutationHookResult = ReturnType<typeof useRequestProfessionalInvestorVerificationMutation>;
export type RequestProfessionalInvestorVerificationMutationResult = Apollo.MutationResult<RequestProfessionalInvestorVerificationMutation>;
export type RequestProfessionalInvestorVerificationMutationOptions = Apollo.BaseMutationOptions<RequestProfessionalInvestorVerificationMutation, RequestProfessionalInvestorVerificationMutationVariables>;
export const ProfessionalInvestorApplyStatusDocument = gql`
    query ProfessionalInvestorApplyStatus {
  professionalInvestorApplyStatus {
    appliedAt
    isUserApplied
    userId
  }
}
    `;

/**
 * __useProfessionalInvestorApplyStatusQuery__
 *
 * To run a query within a React component, call `useProfessionalInvestorApplyStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfessionalInvestorApplyStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfessionalInvestorApplyStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfessionalInvestorApplyStatusQuery(baseOptions?: Apollo.QueryHookOptions<ProfessionalInvestorApplyStatusQuery, ProfessionalInvestorApplyStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfessionalInvestorApplyStatusQuery, ProfessionalInvestorApplyStatusQueryVariables>(ProfessionalInvestorApplyStatusDocument, options);
      }
export function useProfessionalInvestorApplyStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfessionalInvestorApplyStatusQuery, ProfessionalInvestorApplyStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfessionalInvestorApplyStatusQuery, ProfessionalInvestorApplyStatusQueryVariables>(ProfessionalInvestorApplyStatusDocument, options);
        }
export type ProfessionalInvestorApplyStatusQueryHookResult = ReturnType<typeof useProfessionalInvestorApplyStatusQuery>;
export type ProfessionalInvestorApplyStatusLazyQueryHookResult = ReturnType<typeof useProfessionalInvestorApplyStatusLazyQuery>;
export type ProfessionalInvestorApplyStatusQueryResult = Apollo.QueryResult<ProfessionalInvestorApplyStatusQuery, ProfessionalInvestorApplyStatusQueryVariables>;
export const ProfessionalInvestorBadgeApplyStatusDocument = gql`
    query ProfessionalInvestorBadgeApplyStatus {
  professionalInvestorBadgeApplyStatus {
    appliedAt
    isUserApplied
    userId
  }
}
    `;

/**
 * __useProfessionalInvestorBadgeApplyStatusQuery__
 *
 * To run a query within a React component, call `useProfessionalInvestorBadgeApplyStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfessionalInvestorBadgeApplyStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfessionalInvestorBadgeApplyStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfessionalInvestorBadgeApplyStatusQuery(baseOptions?: Apollo.QueryHookOptions<ProfessionalInvestorBadgeApplyStatusQuery, ProfessionalInvestorBadgeApplyStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfessionalInvestorBadgeApplyStatusQuery, ProfessionalInvestorBadgeApplyStatusQueryVariables>(ProfessionalInvestorBadgeApplyStatusDocument, options);
      }
export function useProfessionalInvestorBadgeApplyStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfessionalInvestorBadgeApplyStatusQuery, ProfessionalInvestorBadgeApplyStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfessionalInvestorBadgeApplyStatusQuery, ProfessionalInvestorBadgeApplyStatusQueryVariables>(ProfessionalInvestorBadgeApplyStatusDocument, options);
        }
export type ProfessionalInvestorBadgeApplyStatusQueryHookResult = ReturnType<typeof useProfessionalInvestorBadgeApplyStatusQuery>;
export type ProfessionalInvestorBadgeApplyStatusLazyQueryHookResult = ReturnType<typeof useProfessionalInvestorBadgeApplyStatusLazyQuery>;
export type ProfessionalInvestorBadgeApplyStatusQueryResult = Apollo.QueryResult<ProfessionalInvestorBadgeApplyStatusQuery, ProfessionalInvestorBadgeApplyStatusQueryVariables>;
export const ProfessionalInvestorBadgeAcquisitionStatusDocument = gql`
    query ProfessionalInvestorBadgeAcquisitionStatus {
  professionalInvestorBadgeAcquisitionStatus {
    badgeAcquiredAt
    isUserAcquiredBadge
    userId
  }
}
    `;

/**
 * __useProfessionalInvestorBadgeAcquisitionStatusQuery__
 *
 * To run a query within a React component, call `useProfessionalInvestorBadgeAcquisitionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfessionalInvestorBadgeAcquisitionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfessionalInvestorBadgeAcquisitionStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfessionalInvestorBadgeAcquisitionStatusQuery(baseOptions?: Apollo.QueryHookOptions<ProfessionalInvestorBadgeAcquisitionStatusQuery, ProfessionalInvestorBadgeAcquisitionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfessionalInvestorBadgeAcquisitionStatusQuery, ProfessionalInvestorBadgeAcquisitionStatusQueryVariables>(ProfessionalInvestorBadgeAcquisitionStatusDocument, options);
      }
export function useProfessionalInvestorBadgeAcquisitionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfessionalInvestorBadgeAcquisitionStatusQuery, ProfessionalInvestorBadgeAcquisitionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfessionalInvestorBadgeAcquisitionStatusQuery, ProfessionalInvestorBadgeAcquisitionStatusQueryVariables>(ProfessionalInvestorBadgeAcquisitionStatusDocument, options);
        }
export type ProfessionalInvestorBadgeAcquisitionStatusQueryHookResult = ReturnType<typeof useProfessionalInvestorBadgeAcquisitionStatusQuery>;
export type ProfessionalInvestorBadgeAcquisitionStatusLazyQueryHookResult = ReturnType<typeof useProfessionalInvestorBadgeAcquisitionStatusLazyQuery>;
export type ProfessionalInvestorBadgeAcquisitionStatusQueryResult = Apollo.QueryResult<ProfessionalInvestorBadgeAcquisitionStatusQuery, ProfessionalInvestorBadgeAcquisitionStatusQueryVariables>;
export const MyProfileDocument = gql`
    query MyProfile {
  myProfile {
    id
    nickname
    articleCommentsCount
    articlesCount
    representativeBadge {
      ...BadgeFields
    }
  }
}
    ${BadgeFieldsFragmentDoc}`;

/**
 * __useMyProfileQuery__
 *
 * To run a query within a React component, call `useMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileQuery(baseOptions?: Apollo.QueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
      }
export function useMyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
        }
export type MyProfileQueryHookResult = ReturnType<typeof useMyProfileQuery>;
export type MyProfileLazyQueryHookResult = ReturnType<typeof useMyProfileLazyQuery>;
export type MyProfileQueryResult = Apollo.QueryResult<MyProfileQuery, MyProfileQueryVariables>;
export const ReportUnresolvedSymbolDocument = gql`
    mutation ReportUnresolvedSymbol($ticker: String!, $country: String!) {
  reportUnresolvedSymbol(company: {ticker: $ticker, country: $country}) {
    stockInfoErrorRequest {
      country
      createdAt
      detail
      errorType
      id
      ticker
      updatedAt
    }
  }
}
    `;
export type ReportUnresolvedSymbolMutationFn = Apollo.MutationFunction<ReportUnresolvedSymbolMutation, ReportUnresolvedSymbolMutationVariables>;

/**
 * __useReportUnresolvedSymbolMutation__
 *
 * To run a mutation, you first call `useReportUnresolvedSymbolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportUnresolvedSymbolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportUnresolvedSymbolMutation, { data, loading, error }] = useReportUnresolvedSymbolMutation({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useReportUnresolvedSymbolMutation(baseOptions?: Apollo.MutationHookOptions<ReportUnresolvedSymbolMutation, ReportUnresolvedSymbolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportUnresolvedSymbolMutation, ReportUnresolvedSymbolMutationVariables>(ReportUnresolvedSymbolDocument, options);
      }
export type ReportUnresolvedSymbolMutationHookResult = ReturnType<typeof useReportUnresolvedSymbolMutation>;
export type ReportUnresolvedSymbolMutationResult = Apollo.MutationResult<ReportUnresolvedSymbolMutation>;
export type ReportUnresolvedSymbolMutationOptions = Apollo.BaseMutationOptions<ReportUnresolvedSymbolMutation, ReportUnresolvedSymbolMutationVariables>;
export const SearchCompanyDocument = gql`
    query SearchCompany($keyword: String!) {
  searchCompany(keyword: $keyword) {
    ...SearchCompanyFields
  }
}
    ${SearchCompanyFieldsFragmentDoc}`;

/**
 * __useSearchCompanyQuery__
 *
 * To run a query within a React component, call `useSearchCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompanyQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useSearchCompanyQuery(baseOptions: Apollo.QueryHookOptions<SearchCompanyQuery, SearchCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCompanyQuery, SearchCompanyQueryVariables>(SearchCompanyDocument, options);
      }
export function useSearchCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCompanyQuery, SearchCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCompanyQuery, SearchCompanyQueryVariables>(SearchCompanyDocument, options);
        }
export type SearchCompanyQueryHookResult = ReturnType<typeof useSearchCompanyQuery>;
export type SearchCompanyLazyQueryHookResult = ReturnType<typeof useSearchCompanyLazyQuery>;
export type SearchCompanyQueryResult = Apollo.QueryResult<SearchCompanyQuery, SearchCompanyQueryVariables>;
export const UpdateMyCompanySectorDocument = gql`
    mutation UpdateMyCompanySector($companyId: ID!, $companySectorId: ID!) {
  updateMyCompanySector(companyId: $companyId, companySectorId: $companySectorId) {
    userCompanySector {
      ...UserCompanySectorFields
    }
  }
}
    ${UserCompanySectorFieldsFragmentDoc}`;
export type UpdateMyCompanySectorMutationFn = Apollo.MutationFunction<UpdateMyCompanySectorMutation, UpdateMyCompanySectorMutationVariables>;

/**
 * __useUpdateMyCompanySectorMutation__
 *
 * To run a mutation, you first call `useUpdateMyCompanySectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyCompanySectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyCompanySectorMutation, { data, loading, error }] = useUpdateMyCompanySectorMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      companySectorId: // value for 'companySectorId'
 *   },
 * });
 */
export function useUpdateMyCompanySectorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyCompanySectorMutation, UpdateMyCompanySectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyCompanySectorMutation, UpdateMyCompanySectorMutationVariables>(UpdateMyCompanySectorDocument, options);
      }
export type UpdateMyCompanySectorMutationHookResult = ReturnType<typeof useUpdateMyCompanySectorMutation>;
export type UpdateMyCompanySectorMutationResult = Apollo.MutationResult<UpdateMyCompanySectorMutation>;
export type UpdateMyCompanySectorMutationOptions = Apollo.BaseMutationOptions<UpdateMyCompanySectorMutation, UpdateMyCompanySectorMutationVariables>;
export const SupportedCompanySectorsDocument = gql`
    query SupportedCompanySectors {
  supportedCompanySectors {
    ...CompanySectorFields
  }
}
    ${CompanySectorFieldsFragmentDoc}`;

/**
 * __useSupportedCompanySectorsQuery__
 *
 * To run a query within a React component, call `useSupportedCompanySectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedCompanySectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportedCompanySectorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportedCompanySectorsQuery(baseOptions?: Apollo.QueryHookOptions<SupportedCompanySectorsQuery, SupportedCompanySectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportedCompanySectorsQuery, SupportedCompanySectorsQueryVariables>(SupportedCompanySectorsDocument, options);
      }
export function useSupportedCompanySectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportedCompanySectorsQuery, SupportedCompanySectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportedCompanySectorsQuery, SupportedCompanySectorsQueryVariables>(SupportedCompanySectorsDocument, options);
        }
export type SupportedCompanySectorsQueryHookResult = ReturnType<typeof useSupportedCompanySectorsQuery>;
export type SupportedCompanySectorsLazyQueryHookResult = ReturnType<typeof useSupportedCompanySectorsLazyQuery>;
export type SupportedCompanySectorsQueryResult = Apollo.QueryResult<SupportedCompanySectorsQuery, SupportedCompanySectorsQueryVariables>;
export const MyCompanySectorsDocument = gql`
    query MyCompanySectors {
  myCompanySectors {
    ...UserCompanySectorFields
  }
}
    ${UserCompanySectorFieldsFragmentDoc}`;

/**
 * __useMyCompanySectorsQuery__
 *
 * To run a query within a React component, call `useMyCompanySectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCompanySectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCompanySectorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCompanySectorsQuery(baseOptions?: Apollo.QueryHookOptions<MyCompanySectorsQuery, MyCompanySectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCompanySectorsQuery, MyCompanySectorsQueryVariables>(MyCompanySectorsDocument, options);
      }
export function useMyCompanySectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCompanySectorsQuery, MyCompanySectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCompanySectorsQuery, MyCompanySectorsQueryVariables>(MyCompanySectorsDocument, options);
        }
export type MyCompanySectorsQueryHookResult = ReturnType<typeof useMyCompanySectorsQuery>;
export type MyCompanySectorsLazyQueryHookResult = ReturnType<typeof useMyCompanySectorsLazyQuery>;
export type MyCompanySectorsQueryResult = Apollo.QueryResult<MyCompanySectorsQuery, MyCompanySectorsQueryVariables>;
export const MbtiVisitorCounterDocument = gql`
    query MbtiVisitorCounter($language: String!, $category: String!, $name: String!, $date: String!) {
  mbtiVisitorCounter(
    language: $language
    category: $category
    name: $name
    date: $date
  ) {
    ...MbtiVisitorCounterFields
  }
}
    ${MbtiVisitorCounterFieldsFragmentDoc}`;

/**
 * __useMbtiVisitorCounterQuery__
 *
 * To run a query within a React component, call `useMbtiVisitorCounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useMbtiVisitorCounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMbtiVisitorCounterQuery({
 *   variables: {
 *      language: // value for 'language'
 *      category: // value for 'category'
 *      name: // value for 'name'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useMbtiVisitorCounterQuery(baseOptions: Apollo.QueryHookOptions<MbtiVisitorCounterQuery, MbtiVisitorCounterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MbtiVisitorCounterQuery, MbtiVisitorCounterQueryVariables>(MbtiVisitorCounterDocument, options);
      }
export function useMbtiVisitorCounterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MbtiVisitorCounterQuery, MbtiVisitorCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MbtiVisitorCounterQuery, MbtiVisitorCounterQueryVariables>(MbtiVisitorCounterDocument, options);
        }
export type MbtiVisitorCounterQueryHookResult = ReturnType<typeof useMbtiVisitorCounterQuery>;
export type MbtiVisitorCounterLazyQueryHookResult = ReturnType<typeof useMbtiVisitorCounterLazyQuery>;
export type MbtiVisitorCounterQueryResult = Apollo.QueryResult<MbtiVisitorCounterQuery, MbtiVisitorCounterQueryVariables>;
export const MbtiResultCounterDocument = gql`
    query MbtiResultCounter($mbtiType: String!) {
  mbtiResultCounter(mbtiType: $mbtiType) {
    ...MbtiResultCounterFields
  }
}
    ${MbtiResultCounterFieldsFragmentDoc}`;

/**
 * __useMbtiResultCounterQuery__
 *
 * To run a query within a React component, call `useMbtiResultCounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useMbtiResultCounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMbtiResultCounterQuery({
 *   variables: {
 *      mbtiType: // value for 'mbtiType'
 *   },
 * });
 */
export function useMbtiResultCounterQuery(baseOptions: Apollo.QueryHookOptions<MbtiResultCounterQuery, MbtiResultCounterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MbtiResultCounterQuery, MbtiResultCounterQueryVariables>(MbtiResultCounterDocument, options);
      }
export function useMbtiResultCounterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MbtiResultCounterQuery, MbtiResultCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MbtiResultCounterQuery, MbtiResultCounterQueryVariables>(MbtiResultCounterDocument, options);
        }
export type MbtiResultCounterQueryHookResult = ReturnType<typeof useMbtiResultCounterQuery>;
export type MbtiResultCounterLazyQueryHookResult = ReturnType<typeof useMbtiResultCounterLazyQuery>;
export type MbtiResultCounterQueryResult = Apollo.QueryResult<MbtiResultCounterQuery, MbtiResultCounterQueryVariables>;
export const SignInDocument = gql`
    mutation SignIn($authMethod: AuthMethod!, $accessToken: String, $refreshToken: String, $idToken: String, $authorizationCode: String) {
  signIn(
    authMethod: $authMethod
    accessToken: $accessToken
    refreshToken: $refreshToken
    idToken: $idToken
    authorizationCode: $authorizationCode
    authClient: WEB
  ) {
    ...AuthTokenFields
  }
}
    ${AuthTokenFieldsFragmentDoc}`;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      authMethod: // value for 'authMethod'
 *      accessToken: // value for 'accessToken'
 *      refreshToken: // value for 'refreshToken'
 *      idToken: // value for 'idToken'
 *      authorizationCode: // value for 'authorizationCode'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const UpdateMyProfileDocument = gql`
    mutation UpdateMyProfile($profile: UpdateUserProfile!) {
  updateMyProfile(profile: $profile) {
    user {
      ...UserProfileFields
    }
  }
}
    ${UserProfileFieldsFragmentDoc}`;
export type UpdateMyProfileMutationFn = Apollo.MutationFunction<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>;

/**
 * __useUpdateMyProfileMutation__
 *
 * To run a mutation, you first call `useUpdateMyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyProfileMutation, { data, loading, error }] = useUpdateMyProfileMutation({
 *   variables: {
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useUpdateMyProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>(UpdateMyProfileDocument, options);
      }
export type UpdateMyProfileMutationHookResult = ReturnType<typeof useUpdateMyProfileMutation>;
export type UpdateMyProfileMutationResult = Apollo.MutationResult<UpdateMyProfileMutation>;
export type UpdateMyProfileMutationOptions = Apollo.BaseMutationOptions<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>;
export const RequestTerminateUserMembershipDocument = gql`
    mutation RequestTerminateUserMembership($reason: String!) {
  requestTerminateUserMembership(reason: $reason) {
    id
    reason
  }
}
    `;
export type RequestTerminateUserMembershipMutationFn = Apollo.MutationFunction<RequestTerminateUserMembershipMutation, RequestTerminateUserMembershipMutationVariables>;

/**
 * __useRequestTerminateUserMembershipMutation__
 *
 * To run a mutation, you first call `useRequestTerminateUserMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTerminateUserMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTerminateUserMembershipMutation, { data, loading, error }] = useRequestTerminateUserMembershipMutation({
 *   variables: {
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRequestTerminateUserMembershipMutation(baseOptions?: Apollo.MutationHookOptions<RequestTerminateUserMembershipMutation, RequestTerminateUserMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestTerminateUserMembershipMutation, RequestTerminateUserMembershipMutationVariables>(RequestTerminateUserMembershipDocument, options);
      }
export type RequestTerminateUserMembershipMutationHookResult = ReturnType<typeof useRequestTerminateUserMembershipMutation>;
export type RequestTerminateUserMembershipMutationResult = Apollo.MutationResult<RequestTerminateUserMembershipMutation>;
export type RequestTerminateUserMembershipMutationOptions = Apollo.BaseMutationOptions<RequestTerminateUserMembershipMutation, RequestTerminateUserMembershipMutationVariables>;
export const UpdateUserSurveyDocument = gql`
    mutation UpdateUserSurvey($surveyCategory: String!, $surveyResult: String!) {
  updateUserSurvey(surveyCategory: $surveyCategory, surveyResult: $surveyResult) {
    ...UserSurveyFields
  }
}
    ${UserSurveyFieldsFragmentDoc}`;
export type UpdateUserSurveyMutationFn = Apollo.MutationFunction<UpdateUserSurveyMutation, UpdateUserSurveyMutationVariables>;

/**
 * __useUpdateUserSurveyMutation__
 *
 * To run a mutation, you first call `useUpdateUserSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSurveyMutation, { data, loading, error }] = useUpdateUserSurveyMutation({
 *   variables: {
 *      surveyCategory: // value for 'surveyCategory'
 *      surveyResult: // value for 'surveyResult'
 *   },
 * });
 */
export function useUpdateUserSurveyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSurveyMutation, UpdateUserSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSurveyMutation, UpdateUserSurveyMutationVariables>(UpdateUserSurveyDocument, options);
      }
export type UpdateUserSurveyMutationHookResult = ReturnType<typeof useUpdateUserSurveyMutation>;
export type UpdateUserSurveyMutationResult = Apollo.MutationResult<UpdateUserSurveyMutation>;
export type UpdateUserSurveyMutationOptions = Apollo.BaseMutationOptions<UpdateUserSurveyMutation, UpdateUserSurveyMutationVariables>;
export const ConfirmTokenToVerifyEmailDocument = gql`
    mutation ConfirmTokenToVerifyEmail($token: String!) {
  confirmTokenToVerifyEmail(token: $token) {
    emailVerifiedAt
  }
}
    `;
export type ConfirmTokenToVerifyEmailMutationFn = Apollo.MutationFunction<ConfirmTokenToVerifyEmailMutation, ConfirmTokenToVerifyEmailMutationVariables>;

/**
 * __useConfirmTokenToVerifyEmailMutation__
 *
 * To run a mutation, you first call `useConfirmTokenToVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTokenToVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmTokenToVerifyEmailMutation, { data, loading, error }] = useConfirmTokenToVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useConfirmTokenToVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmTokenToVerifyEmailMutation, ConfirmTokenToVerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmTokenToVerifyEmailMutation, ConfirmTokenToVerifyEmailMutationVariables>(ConfirmTokenToVerifyEmailDocument, options);
      }
export type ConfirmTokenToVerifyEmailMutationHookResult = ReturnType<typeof useConfirmTokenToVerifyEmailMutation>;
export type ConfirmTokenToVerifyEmailMutationResult = Apollo.MutationResult<ConfirmTokenToVerifyEmailMutation>;
export type ConfirmTokenToVerifyEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmTokenToVerifyEmailMutation, ConfirmTokenToVerifyEmailMutationVariables>;
export const DenyTokenToVerifyEmailDocument = gql`
    mutation DenyTokenToVerifyEmail($token: String!) {
  denyTokenToVerifyEmail(token: $token) {
    emailVerifiedAt
  }
}
    `;
export type DenyTokenToVerifyEmailMutationFn = Apollo.MutationFunction<DenyTokenToVerifyEmailMutation, DenyTokenToVerifyEmailMutationVariables>;

/**
 * __useDenyTokenToVerifyEmailMutation__
 *
 * To run a mutation, you first call `useDenyTokenToVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyTokenToVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyTokenToVerifyEmailMutation, { data, loading, error }] = useDenyTokenToVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useDenyTokenToVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<DenyTokenToVerifyEmailMutation, DenyTokenToVerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyTokenToVerifyEmailMutation, DenyTokenToVerifyEmailMutationVariables>(DenyTokenToVerifyEmailDocument, options);
      }
export type DenyTokenToVerifyEmailMutationHookResult = ReturnType<typeof useDenyTokenToVerifyEmailMutation>;
export type DenyTokenToVerifyEmailMutationResult = Apollo.MutationResult<DenyTokenToVerifyEmailMutation>;
export type DenyTokenToVerifyEmailMutationOptions = Apollo.BaseMutationOptions<DenyTokenToVerifyEmailMutation, DenyTokenToVerifyEmailMutationVariables>;
export const SendEmailToVerifyEmailDocument = gql`
    mutation SendEmailToVerifyEmail($email: String!, $locale: String) {
  sendEmailToVerifyEmail(email: $email, locale: $locale) {
    email
  }
}
    `;
export type SendEmailToVerifyEmailMutationFn = Apollo.MutationFunction<SendEmailToVerifyEmailMutation, SendEmailToVerifyEmailMutationVariables>;

/**
 * __useSendEmailToVerifyEmailMutation__
 *
 * To run a mutation, you first call `useSendEmailToVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailToVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailToVerifyEmailMutation, { data, loading, error }] = useSendEmailToVerifyEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useSendEmailToVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailToVerifyEmailMutation, SendEmailToVerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailToVerifyEmailMutation, SendEmailToVerifyEmailMutationVariables>(SendEmailToVerifyEmailDocument, options);
      }
export type SendEmailToVerifyEmailMutationHookResult = ReturnType<typeof useSendEmailToVerifyEmailMutation>;
export type SendEmailToVerifyEmailMutationResult = Apollo.MutationResult<SendEmailToVerifyEmailMutation>;
export type SendEmailToVerifyEmailMutationOptions = Apollo.BaseMutationOptions<SendEmailToVerifyEmailMutation, SendEmailToVerifyEmailMutationVariables>;
export const UpdateSignInSessionDocument = gql`
    mutation UpdateSignInSession($deviceRegistrationToken: String, $appVersion: String, $language: String, $communityLanguage: String) {
  updateSignInSession(
    deviceRegistrationToken: $deviceRegistrationToken
    appVersion: $appVersion
    language: $language
    communityLanguage: $communityLanguage
  ) {
    ...AuthTokenFields
  }
}
    ${AuthTokenFieldsFragmentDoc}`;
export type UpdateSignInSessionMutationFn = Apollo.MutationFunction<UpdateSignInSessionMutation, UpdateSignInSessionMutationVariables>;

/**
 * __useUpdateSignInSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSignInSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignInSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignInSessionMutation, { data, loading, error }] = useUpdateSignInSessionMutation({
 *   variables: {
 *      deviceRegistrationToken: // value for 'deviceRegistrationToken'
 *      appVersion: // value for 'appVersion'
 *      language: // value for 'language'
 *      communityLanguage: // value for 'communityLanguage'
 *   },
 * });
 */
export function useUpdateSignInSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSignInSessionMutation, UpdateSignInSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSignInSessionMutation, UpdateSignInSessionMutationVariables>(UpdateSignInSessionDocument, options);
      }
export type UpdateSignInSessionMutationHookResult = ReturnType<typeof useUpdateSignInSessionMutation>;
export type UpdateSignInSessionMutationResult = Apollo.MutationResult<UpdateSignInSessionMutation>;
export type UpdateSignInSessionMutationOptions = Apollo.BaseMutationOptions<UpdateSignInSessionMutation, UpdateSignInSessionMutationVariables>;
export const RequestUserPhoneVerificationToKrTelecomDocument = gql`
    mutation RequestUserPhoneVerificationToKrTelecom($name: String!, $birthDate: String!, $genderNumber: String!, $telecomType: String!, $phoneNumber: String!) {
  requestUserPhoneVerificationToKrTelecom(
    name: $name
    birthDate: $birthDate
    genderNumber: $genderNumber
    telecomType: $telecomType
    phoneNumber: $phoneNumber
  ) {
    userPhoneVerificationKr {
      ...UserPhoneVerificationKrFields
    }
  }
}
    ${UserPhoneVerificationKrFieldsFragmentDoc}`;
export type RequestUserPhoneVerificationToKrTelecomMutationFn = Apollo.MutationFunction<RequestUserPhoneVerificationToKrTelecomMutation, RequestUserPhoneVerificationToKrTelecomMutationVariables>;

/**
 * __useRequestUserPhoneVerificationToKrTelecomMutation__
 *
 * To run a mutation, you first call `useRequestUserPhoneVerificationToKrTelecomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUserPhoneVerificationToKrTelecomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUserPhoneVerificationToKrTelecomMutation, { data, loading, error }] = useRequestUserPhoneVerificationToKrTelecomMutation({
 *   variables: {
 *      name: // value for 'name'
 *      birthDate: // value for 'birthDate'
 *      genderNumber: // value for 'genderNumber'
 *      telecomType: // value for 'telecomType'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useRequestUserPhoneVerificationToKrTelecomMutation(baseOptions?: Apollo.MutationHookOptions<RequestUserPhoneVerificationToKrTelecomMutation, RequestUserPhoneVerificationToKrTelecomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestUserPhoneVerificationToKrTelecomMutation, RequestUserPhoneVerificationToKrTelecomMutationVariables>(RequestUserPhoneVerificationToKrTelecomDocument, options);
      }
export type RequestUserPhoneVerificationToKrTelecomMutationHookResult = ReturnType<typeof useRequestUserPhoneVerificationToKrTelecomMutation>;
export type RequestUserPhoneVerificationToKrTelecomMutationResult = Apollo.MutationResult<RequestUserPhoneVerificationToKrTelecomMutation>;
export type RequestUserPhoneVerificationToKrTelecomMutationOptions = Apollo.BaseMutationOptions<RequestUserPhoneVerificationToKrTelecomMutation, RequestUserPhoneVerificationToKrTelecomMutationVariables>;
export const VerifyUserPhoneVerificationFromKrTelecomDocument = gql`
    mutation VerifyUserPhoneVerificationFromKrTelecom($clientRequestNumber: String!, $authNumber: String!) {
  verifyUserPhoneVerificationFromKrTelecom(
    clientRequestNumber: $clientRequestNumber
    authNumber: $authNumber
  ) {
    userPhoneVerificationKr {
      ...UserPhoneVerificationKrFields
    }
  }
}
    ${UserPhoneVerificationKrFieldsFragmentDoc}`;
export type VerifyUserPhoneVerificationFromKrTelecomMutationFn = Apollo.MutationFunction<VerifyUserPhoneVerificationFromKrTelecomMutation, VerifyUserPhoneVerificationFromKrTelecomMutationVariables>;

/**
 * __useVerifyUserPhoneVerificationFromKrTelecomMutation__
 *
 * To run a mutation, you first call `useVerifyUserPhoneVerificationFromKrTelecomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserPhoneVerificationFromKrTelecomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserPhoneVerificationFromKrTelecomMutation, { data, loading, error }] = useVerifyUserPhoneVerificationFromKrTelecomMutation({
 *   variables: {
 *      clientRequestNumber: // value for 'clientRequestNumber'
 *      authNumber: // value for 'authNumber'
 *   },
 * });
 */
export function useVerifyUserPhoneVerificationFromKrTelecomMutation(baseOptions?: Apollo.MutationHookOptions<VerifyUserPhoneVerificationFromKrTelecomMutation, VerifyUserPhoneVerificationFromKrTelecomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyUserPhoneVerificationFromKrTelecomMutation, VerifyUserPhoneVerificationFromKrTelecomMutationVariables>(VerifyUserPhoneVerificationFromKrTelecomDocument, options);
      }
export type VerifyUserPhoneVerificationFromKrTelecomMutationHookResult = ReturnType<typeof useVerifyUserPhoneVerificationFromKrTelecomMutation>;
export type VerifyUserPhoneVerificationFromKrTelecomMutationResult = Apollo.MutationResult<VerifyUserPhoneVerificationFromKrTelecomMutation>;
export type VerifyUserPhoneVerificationFromKrTelecomMutationOptions = Apollo.BaseMutationOptions<VerifyUserPhoneVerificationFromKrTelecomMutation, VerifyUserPhoneVerificationFromKrTelecomMutationVariables>;
export const MyProfileWithServeyAndVerificationDocument = gql`
    query MyProfileWithServeyAndVerification {
  myProfile {
    ...MyProfileFields
  }
  userSurvey {
    ...UserSurveyFields
  }
  userVerification {
    ...UserVerificationFields
  }
}
    ${MyProfileFieldsFragmentDoc}
${UserSurveyFieldsFragmentDoc}
${UserVerificationFieldsFragmentDoc}`;

/**
 * __useMyProfileWithServeyAndVerificationQuery__
 *
 * To run a query within a React component, call `useMyProfileWithServeyAndVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileWithServeyAndVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileWithServeyAndVerificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileWithServeyAndVerificationQuery(baseOptions?: Apollo.QueryHookOptions<MyProfileWithServeyAndVerificationQuery, MyProfileWithServeyAndVerificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileWithServeyAndVerificationQuery, MyProfileWithServeyAndVerificationQueryVariables>(MyProfileWithServeyAndVerificationDocument, options);
      }
export function useMyProfileWithServeyAndVerificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileWithServeyAndVerificationQuery, MyProfileWithServeyAndVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileWithServeyAndVerificationQuery, MyProfileWithServeyAndVerificationQueryVariables>(MyProfileWithServeyAndVerificationDocument, options);
        }
export type MyProfileWithServeyAndVerificationQueryHookResult = ReturnType<typeof useMyProfileWithServeyAndVerificationQuery>;
export type MyProfileWithServeyAndVerificationLazyQueryHookResult = ReturnType<typeof useMyProfileWithServeyAndVerificationLazyQuery>;
export type MyProfileWithServeyAndVerificationQueryResult = Apollo.QueryResult<MyProfileWithServeyAndVerificationQuery, MyProfileWithServeyAndVerificationQueryVariables>;
export const UserProfileDocument = gql`
    query UserProfile($userId: ID!) {
  userProfile(userId: $userId) {
    ...UserProfileFields
  }
}
    ${UserProfileFieldsFragmentDoc}`;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions: Apollo.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const UserProfileOnlyCommunityDocument = gql`
    query UserProfileOnlyCommunity($userId: ID!) {
  userProfile(userId: $userId) {
    ...UserProfileOnlyCommunityFields
  }
}
    ${UserProfileOnlyCommunityFieldsFragmentDoc}`;

/**
 * __useUserProfileOnlyCommunityQuery__
 *
 * To run a query within a React component, call `useUserProfileOnlyCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileOnlyCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileOnlyCommunityQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProfileOnlyCommunityQuery(baseOptions: Apollo.QueryHookOptions<UserProfileOnlyCommunityQuery, UserProfileOnlyCommunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileOnlyCommunityQuery, UserProfileOnlyCommunityQueryVariables>(UserProfileOnlyCommunityDocument, options);
      }
export function useUserProfileOnlyCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileOnlyCommunityQuery, UserProfileOnlyCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileOnlyCommunityQuery, UserProfileOnlyCommunityQueryVariables>(UserProfileOnlyCommunityDocument, options);
        }
export type UserProfileOnlyCommunityQueryHookResult = ReturnType<typeof useUserProfileOnlyCommunityQuery>;
export type UserProfileOnlyCommunityLazyQueryHookResult = ReturnType<typeof useUserProfileOnlyCommunityLazyQuery>;
export type UserProfileOnlyCommunityQueryResult = Apollo.QueryResult<UserProfileOnlyCommunityQuery, UserProfileOnlyCommunityQueryVariables>;
export const UserVerificationDocument = gql`
    query UserVerification {
  userVerification {
    ...UserVerificationFields
  }
}
    ${UserVerificationFieldsFragmentDoc}`;

/**
 * __useUserVerificationQuery__
 *
 * To run a query within a React component, call `useUserVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserVerificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserVerificationQuery(baseOptions?: Apollo.QueryHookOptions<UserVerificationQuery, UserVerificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserVerificationQuery, UserVerificationQueryVariables>(UserVerificationDocument, options);
      }
export function useUserVerificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserVerificationQuery, UserVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserVerificationQuery, UserVerificationQueryVariables>(UserVerificationDocument, options);
        }
export type UserVerificationQueryHookResult = ReturnType<typeof useUserVerificationQuery>;
export type UserVerificationLazyQueryHookResult = ReturnType<typeof useUserVerificationLazyQuery>;
export type UserVerificationQueryResult = Apollo.QueryResult<UserVerificationQuery, UserVerificationQueryVariables>;
export const MyCommunityNotificationsWithLanguageDocument = gql`
    query MyCommunityNotificationsWithLanguage($language: String!) {
  myCommunityNotifications: myCommunityNotificationsWithLanguage(
    language: $language
  ) {
    ...CommunityNotificationStatusFields
  }
}
    ${CommunityNotificationStatusFieldsFragmentDoc}`;

/**
 * __useMyCommunityNotificationsWithLanguageQuery__
 *
 * To run a query within a React component, call `useMyCommunityNotificationsWithLanguageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCommunityNotificationsWithLanguageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCommunityNotificationsWithLanguageQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useMyCommunityNotificationsWithLanguageQuery(baseOptions: Apollo.QueryHookOptions<MyCommunityNotificationsWithLanguageQuery, MyCommunityNotificationsWithLanguageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCommunityNotificationsWithLanguageQuery, MyCommunityNotificationsWithLanguageQueryVariables>(MyCommunityNotificationsWithLanguageDocument, options);
      }
export function useMyCommunityNotificationsWithLanguageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCommunityNotificationsWithLanguageQuery, MyCommunityNotificationsWithLanguageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCommunityNotificationsWithLanguageQuery, MyCommunityNotificationsWithLanguageQueryVariables>(MyCommunityNotificationsWithLanguageDocument, options);
        }
export type MyCommunityNotificationsWithLanguageQueryHookResult = ReturnType<typeof useMyCommunityNotificationsWithLanguageQuery>;
export type MyCommunityNotificationsWithLanguageLazyQueryHookResult = ReturnType<typeof useMyCommunityNotificationsWithLanguageLazyQuery>;
export type MyCommunityNotificationsWithLanguageQueryResult = Apollo.QueryResult<MyCommunityNotificationsWithLanguageQuery, MyCommunityNotificationsWithLanguageQueryVariables>;
export const MyInvestingKeywordsDocument = gql`
    query MyInvestingKeywords($language: String!) {
  myInvestingKeywords(language: $language) {
    ...InvestingKeywordWithIsSelectedFields
  }
}
    ${InvestingKeywordWithIsSelectedFieldsFragmentDoc}`;

/**
 * __useMyInvestingKeywordsQuery__
 *
 * To run a query within a React component, call `useMyInvestingKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyInvestingKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyInvestingKeywordsQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useMyInvestingKeywordsQuery(baseOptions: Apollo.QueryHookOptions<MyInvestingKeywordsQuery, MyInvestingKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyInvestingKeywordsQuery, MyInvestingKeywordsQueryVariables>(MyInvestingKeywordsDocument, options);
      }
export function useMyInvestingKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyInvestingKeywordsQuery, MyInvestingKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyInvestingKeywordsQuery, MyInvestingKeywordsQueryVariables>(MyInvestingKeywordsDocument, options);
        }
export type MyInvestingKeywordsQueryHookResult = ReturnType<typeof useMyInvestingKeywordsQuery>;
export type MyInvestingKeywordsLazyQueryHookResult = ReturnType<typeof useMyInvestingKeywordsLazyQuery>;
export type MyInvestingKeywordsQueryResult = Apollo.QueryResult<MyInvestingKeywordsQuery, MyInvestingKeywordsQueryVariables>;
export const UserArticlesDocument = gql`
    query UserArticles($userId: ID, $language: String!, $limit: Int!, $startDate: String) {
  userArticles(
    userId: $userId
    language: $language
    limit: $limit
    startDate: $startDate
  ) {
    ...ArticleFields
  }
}
    ${ArticleFieldsFragmentDoc}`;

/**
 * __useUserArticlesQuery__
 *
 * To run a query within a React component, call `useUserArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserArticlesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      language: // value for 'language'
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useUserArticlesQuery(baseOptions: Apollo.QueryHookOptions<UserArticlesQuery, UserArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserArticlesQuery, UserArticlesQueryVariables>(UserArticlesDocument, options);
      }
export function useUserArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserArticlesQuery, UserArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserArticlesQuery, UserArticlesQueryVariables>(UserArticlesDocument, options);
        }
export type UserArticlesQueryHookResult = ReturnType<typeof useUserArticlesQuery>;
export type UserArticlesLazyQueryHookResult = ReturnType<typeof useUserArticlesLazyQuery>;
export type UserArticlesQueryResult = Apollo.QueryResult<UserArticlesQuery, UserArticlesQueryVariables>;
export const MyArticlesDocument = gql`
    query MyArticles($limit: Int!, $startDate: String) {
  myArticles(limit: $limit, startDate: $startDate) {
    ...ArticleFields
  }
}
    ${ArticleFieldsFragmentDoc}`;

/**
 * __useMyArticlesQuery__
 *
 * To run a query within a React component, call `useMyArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyArticlesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useMyArticlesQuery(baseOptions: Apollo.QueryHookOptions<MyArticlesQuery, MyArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyArticlesQuery, MyArticlesQueryVariables>(MyArticlesDocument, options);
      }
export function useMyArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyArticlesQuery, MyArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyArticlesQuery, MyArticlesQueryVariables>(MyArticlesDocument, options);
        }
export type MyArticlesQueryHookResult = ReturnType<typeof useMyArticlesQuery>;
export type MyArticlesLazyQueryHookResult = ReturnType<typeof useMyArticlesLazyQuery>;
export type MyArticlesQueryResult = Apollo.QueryResult<MyArticlesQuery, MyArticlesQueryVariables>;
export const MyCommentedArticlesDocument = gql`
    query MyCommentedArticles($limit: Int!, $startDate: String) {
  myCommentedArticles(limit: $limit, startDate: $startDate) {
    ...ArticleFields
  }
}
    ${ArticleFieldsFragmentDoc}`;

/**
 * __useMyCommentedArticlesQuery__
 *
 * To run a query within a React component, call `useMyCommentedArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCommentedArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCommentedArticlesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useMyCommentedArticlesQuery(baseOptions: Apollo.QueryHookOptions<MyCommentedArticlesQuery, MyCommentedArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCommentedArticlesQuery, MyCommentedArticlesQueryVariables>(MyCommentedArticlesDocument, options);
      }
export function useMyCommentedArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCommentedArticlesQuery, MyCommentedArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCommentedArticlesQuery, MyCommentedArticlesQueryVariables>(MyCommentedArticlesDocument, options);
        }
export type MyCommentedArticlesQueryHookResult = ReturnType<typeof useMyCommentedArticlesQuery>;
export type MyCommentedArticlesLazyQueryHookResult = ReturnType<typeof useMyCommentedArticlesLazyQuery>;
export type MyCommentedArticlesQueryResult = Apollo.QueryResult<MyCommentedArticlesQuery, MyCommentedArticlesQueryVariables>;
export const MyBookmarkedArticlesDocument = gql`
    query MyBookmarkedArticles($limit: Int!, $startDate: String) {
  myBookmarkedArticles(limit: $limit, startDate: $startDate) {
    ...ArticleFields
  }
}
    ${ArticleFieldsFragmentDoc}`;

/**
 * __useMyBookmarkedArticlesQuery__
 *
 * To run a query within a React component, call `useMyBookmarkedArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBookmarkedArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBookmarkedArticlesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useMyBookmarkedArticlesQuery(baseOptions: Apollo.QueryHookOptions<MyBookmarkedArticlesQuery, MyBookmarkedArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyBookmarkedArticlesQuery, MyBookmarkedArticlesQueryVariables>(MyBookmarkedArticlesDocument, options);
      }
export function useMyBookmarkedArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyBookmarkedArticlesQuery, MyBookmarkedArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyBookmarkedArticlesQuery, MyBookmarkedArticlesQueryVariables>(MyBookmarkedArticlesDocument, options);
        }
export type MyBookmarkedArticlesQueryHookResult = ReturnType<typeof useMyBookmarkedArticlesQuery>;
export type MyBookmarkedArticlesLazyQueryHookResult = ReturnType<typeof useMyBookmarkedArticlesLazyQuery>;
export type MyBookmarkedArticlesQueryResult = Apollo.QueryResult<MyBookmarkedArticlesQuery, MyBookmarkedArticlesQueryVariables>;
export const MyPublicFavoriteItemCategoriesDocument = gql`
    query MyPublicFavoriteItemCategories {
  myPublicFavorites: myPublicFavoriteItemCategories {
    publicFavoritesCount: myPublicFavoriteItemCategoriesCount
    favoritesCount: totalUserFavoriteItemCategoriesCount
    favorites: myPublicFavoriteItemCategories {
      ...FavoriteItemCategoryWithoutItemsFields
    }
  }
}
    ${FavoriteItemCategoryWithoutItemsFieldsFragmentDoc}`;

/**
 * __useMyPublicFavoriteItemCategoriesQuery__
 *
 * To run a query within a React component, call `useMyPublicFavoriteItemCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPublicFavoriteItemCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPublicFavoriteItemCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPublicFavoriteItemCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<MyPublicFavoriteItemCategoriesQuery, MyPublicFavoriteItemCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPublicFavoriteItemCategoriesQuery, MyPublicFavoriteItemCategoriesQueryVariables>(MyPublicFavoriteItemCategoriesDocument, options);
      }
export function useMyPublicFavoriteItemCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPublicFavoriteItemCategoriesQuery, MyPublicFavoriteItemCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPublicFavoriteItemCategoriesQuery, MyPublicFavoriteItemCategoriesQueryVariables>(MyPublicFavoriteItemCategoriesDocument, options);
        }
export type MyPublicFavoriteItemCategoriesQueryHookResult = ReturnType<typeof useMyPublicFavoriteItemCategoriesQuery>;
export type MyPublicFavoriteItemCategoriesLazyQueryHookResult = ReturnType<typeof useMyPublicFavoriteItemCategoriesLazyQuery>;
export type MyPublicFavoriteItemCategoriesQueryResult = Apollo.QueryResult<MyPublicFavoriteItemCategoriesQuery, MyPublicFavoriteItemCategoriesQueryVariables>;
export const UserPublicPortfoliosDocument = gql`
    query UserPublicPortfolios($userId: ID!, $limit: Int!, $page: Int!) {
  portfolios: userPublicPortfolios(userId: $userId, limit: $limit, page: $page) {
    ...UserPortfolioItemsFields
  }
}
    ${UserPortfolioItemsFieldsFragmentDoc}`;

/**
 * __useUserPublicPortfoliosQuery__
 *
 * To run a query within a React component, call `useUserPublicPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPublicPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPublicPortfoliosQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useUserPublicPortfoliosQuery(baseOptions: Apollo.QueryHookOptions<UserPublicPortfoliosQuery, UserPublicPortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPublicPortfoliosQuery, UserPublicPortfoliosQueryVariables>(UserPublicPortfoliosDocument, options);
      }
export function useUserPublicPortfoliosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPublicPortfoliosQuery, UserPublicPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPublicPortfoliosQuery, UserPublicPortfoliosQueryVariables>(UserPublicPortfoliosDocument, options);
        }
export type UserPublicPortfoliosQueryHookResult = ReturnType<typeof useUserPublicPortfoliosQuery>;
export type UserPublicPortfoliosLazyQueryHookResult = ReturnType<typeof useUserPublicPortfoliosLazyQuery>;
export type UserPublicPortfoliosQueryResult = Apollo.QueryResult<UserPublicPortfoliosQuery, UserPublicPortfoliosQueryVariables>;
export const MyPublicPortfoliosDocument = gql`
    query MyPublicPortfolios($limit: Int!, $page: Int!) {
  myPublicPortfolios(limit: $limit, page: $page) {
    portfolios: myPublicPortfolios {
      ...UserPortfolioItemsFields
    }
    myPublicPortfoliosCount
    totalUserPortfoliosCount
  }
}
    ${UserPortfolioItemsFieldsFragmentDoc}`;

/**
 * __useMyPublicPortfoliosQuery__
 *
 * To run a query within a React component, call `useMyPublicPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPublicPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPublicPortfoliosQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useMyPublicPortfoliosQuery(baseOptions: Apollo.QueryHookOptions<MyPublicPortfoliosQuery, MyPublicPortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPublicPortfoliosQuery, MyPublicPortfoliosQueryVariables>(MyPublicPortfoliosDocument, options);
      }
export function useMyPublicPortfoliosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPublicPortfoliosQuery, MyPublicPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPublicPortfoliosQuery, MyPublicPortfoliosQueryVariables>(MyPublicPortfoliosDocument, options);
        }
export type MyPublicPortfoliosQueryHookResult = ReturnType<typeof useMyPublicPortfoliosQuery>;
export type MyPublicPortfoliosLazyQueryHookResult = ReturnType<typeof useMyPublicPortfoliosLazyQuery>;
export type MyPublicPortfoliosQueryResult = Apollo.QueryResult<MyPublicPortfoliosQuery, MyPublicPortfoliosQueryVariables>;
export const UserPublicFavoriteItemCategoriesDocument = gql`
    query UserPublicFavoriteItemCategories($userId: ID!) {
  favorites: userPublicFavoriteItemCategories(userId: $userId) {
    ...FavoriteItemCategoryWithoutItemsFields
  }
}
    ${FavoriteItemCategoryWithoutItemsFieldsFragmentDoc}`;

/**
 * __useUserPublicFavoriteItemCategoriesQuery__
 *
 * To run a query within a React component, call `useUserPublicFavoriteItemCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPublicFavoriteItemCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPublicFavoriteItemCategoriesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserPublicFavoriteItemCategoriesQuery(baseOptions: Apollo.QueryHookOptions<UserPublicFavoriteItemCategoriesQuery, UserPublicFavoriteItemCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPublicFavoriteItemCategoriesQuery, UserPublicFavoriteItemCategoriesQueryVariables>(UserPublicFavoriteItemCategoriesDocument, options);
      }
export function useUserPublicFavoriteItemCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPublicFavoriteItemCategoriesQuery, UserPublicFavoriteItemCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPublicFavoriteItemCategoriesQuery, UserPublicFavoriteItemCategoriesQueryVariables>(UserPublicFavoriteItemCategoriesDocument, options);
        }
export type UserPublicFavoriteItemCategoriesQueryHookResult = ReturnType<typeof useUserPublicFavoriteItemCategoriesQuery>;
export type UserPublicFavoriteItemCategoriesLazyQueryHookResult = ReturnType<typeof useUserPublicFavoriteItemCategoriesLazyQuery>;
export type UserPublicFavoriteItemCategoriesQueryResult = Apollo.QueryResult<UserPublicFavoriteItemCategoriesQuery, UserPublicFavoriteItemCategoriesQueryVariables>;
export const PublicFavoriteItemsDocument = gql`
    query PublicFavoriteItems($favoriteItemCategoryId: ID!, $limit: Int!, $page: Int!) {
  publicFavoriteItems(
    favoriteItemCategoryId: $favoriteItemCategoryId
    limit: $limit
    page: $page
  ) {
    ...FavoriteItemFields
  }
}
    ${FavoriteItemFieldsFragmentDoc}`;

/**
 * __usePublicFavoriteItemsQuery__
 *
 * To run a query within a React component, call `usePublicFavoriteItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicFavoriteItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicFavoriteItemsQuery({
 *   variables: {
 *      favoriteItemCategoryId: // value for 'favoriteItemCategoryId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePublicFavoriteItemsQuery(baseOptions: Apollo.QueryHookOptions<PublicFavoriteItemsQuery, PublicFavoriteItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicFavoriteItemsQuery, PublicFavoriteItemsQueryVariables>(PublicFavoriteItemsDocument, options);
      }
export function usePublicFavoriteItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicFavoriteItemsQuery, PublicFavoriteItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicFavoriteItemsQuery, PublicFavoriteItemsQueryVariables>(PublicFavoriteItemsDocument, options);
        }
export type PublicFavoriteItemsQueryHookResult = ReturnType<typeof usePublicFavoriteItemsQuery>;
export type PublicFavoriteItemsLazyQueryHookResult = ReturnType<typeof usePublicFavoriteItemsLazyQuery>;
export type PublicFavoriteItemsQueryResult = Apollo.QueryResult<PublicFavoriteItemsQuery, PublicFavoriteItemsQueryVariables>;
export const namedOperations = {
  Query: {
    InvestingInsightTags: 'InvestingInsightTags',
    InvestingInsights: 'InvestingInsights',
    InvestingInsight: 'InvestingInsight',
    Ads: 'Ads',
    MyAds: 'MyAds',
    UserAgreementStatus: 'UserAgreementStatus',
    LatestAgreements: 'LatestAgreements',
    MyBackTestingProjects: 'MyBackTestingProjects',
    BackTestingProject: 'BackTestingProject',
    UserBadgeList: 'UserBadgeList',
    UserAcquiredBadgeList: 'UserAcquiredBadgeList',
    BadgeDetail: 'BadgeDetail',
    FeedTopicsWithPortfolioTopics: 'FeedTopicsWithPortfolioTopics',
    PublicPortfolioTopics: 'PublicPortfolioTopics',
    TimelineFeed: 'TimelineFeed',
    FeedFilteredByTag: 'FeedFilteredByTag',
    Article: 'Article',
    FavoriteArticlesInTopic: 'FavoriteArticlesInTopic',
    ArticleComments: 'ArticleComments',
    SearchAssetTags: 'SearchAssetTags',
    MyFollowings: 'MyFollowings',
    MyFollowingFeed: 'MyFollowingFeed',
    UserFollowings: 'UserFollowings',
    UserFollowers: 'UserFollowers',
    RecommendedFollows: 'RecommendedFollows',
    SearchFollows: 'SearchFollows',
    SearchCommunityArticles: 'SearchCommunityArticles',
    SearchCommunityUsers: 'SearchCommunityUsers',
    SearchUsersInArticle: 'SearchUsersInArticle',
    BlockedUsers: 'BlockedUsers',
    RecommendedFollowsByUserFavorites: 'RecommendedFollowsByUserFavorites',
    GetOgTag: 'GetOgTag',
    CompanyDetailById: 'CompanyDetailById',
    CompanyDetailByTicker: 'CompanyDetailByTicker',
    CompanyDetailOnlyCommunity: 'CompanyDetailOnlyCommunity',
    CompanyDetailByIds: 'CompanyDetailByIds',
    CompanyDetailByIdsForNews: 'CompanyDetailByIdsForNews',
    CryptoCurrencyExchange: 'CryptoCurrencyExchange',
    CryptoCurrencyExchanges: 'CryptoCurrencyExchanges',
    SupportedCryptoCurrencyBases: 'SupportedCryptoCurrencyBases',
    CryptoCurrencyDetail: 'CryptoCurrencyDetail',
    CryptoCurrencyDetailOnlyCommunity: 'CryptoCurrencyDetailOnlyCommunity',
    SupportedCurrencies: 'SupportedCurrencies',
    ThisWeekDividendStocks: 'ThisWeekDividendStocks',
    DividendCalendarForPortfolios: 'DividendCalendarForPortfolios',
    ClosedMarketDays: 'ClosedMarketDays',
    ThisWeekDividendStocksInSnp500: 'ThisWeekDividendStocksInSnp500',
    DividendCompaniesInSnp500: 'DividendCompaniesInSnp500',
    MyPortfoliosFromEbest: 'MyPortfoliosFromEbest',
    DividendHistoriesExistingDaysForExternalChannel: 'DividendHistoriesExistingDaysForExternalChannel',
    DividendCalendarForExternalChannelWithPagination: 'DividendCalendarForExternalChannelWithPagination',
    AllExchanges: 'AllExchanges',
    CurrencyExchanges: 'CurrencyExchanges',
    FavoriteItemCategories: 'FavoriteItemCategories',
    FavoriteItemCategory: 'FavoriteItemCategory',
    InvestingDiaryLogs: 'InvestingDiaryLogs',
    EventStatus: 'EventStatus',
    NewsLetters: 'NewsLetters',
    MailingGroups: 'MailingGroups',
    MailingGroup: 'MailingGroup',
    Notices: 'Notices',
    Notice: 'Notice',
    CategorizedCompanies: 'CategorizedCompanies',
    DividendHistoriesInSnp500: 'DividendHistoriesInSnp500',
    getPortfolioBySlug: 'getPortfolioBySlug',
    MyPortfolios: 'MyPortfolios',
    MyMetaPortfolio: 'MyMetaPortfolio',
    MyMetaSwitchPortfolioCurrency: 'MyMetaSwitchPortfolioCurrency',
    UserPortfolio: 'UserPortfolio',
    PortfolioWithComments: 'PortfolioWithComments',
    CombinedPortfolioWithExchanges: 'CombinedPortfolioWithExchanges',
    CryptoExchanges: 'CryptoExchanges',
    CryptoExchangeApiKeys: 'CryptoExchangeApiKeys',
    MySecurity: 'MySecurity',
    ProfessionalInvestorApplyStatus: 'ProfessionalInvestorApplyStatus',
    ProfessionalInvestorBadgeApplyStatus: 'ProfessionalInvestorBadgeApplyStatus',
    ProfessionalInvestorBadgeAcquisitionStatus: 'ProfessionalInvestorBadgeAcquisitionStatus',
    MyProfile: 'MyProfile',
    SearchCompany: 'SearchCompany',
    SupportedCompanySectors: 'SupportedCompanySectors',
    MyCompanySectors: 'MyCompanySectors',
    MbtiVisitorCounter: 'MbtiVisitorCounter',
    MbtiResultCounter: 'MbtiResultCounter',
    MyProfileWithServeyAndVerification: 'MyProfileWithServeyAndVerification',
    UserProfile: 'UserProfile',
    UserProfileOnlyCommunity: 'UserProfileOnlyCommunity',
    UserVerification: 'UserVerification',
    MyCommunityNotificationsWithLanguage: 'MyCommunityNotificationsWithLanguage',
    MyInvestingKeywords: 'MyInvestingKeywords',
    UserArticles: 'UserArticles',
    MyArticles: 'MyArticles',
    MyCommentedArticles: 'MyCommentedArticles',
    MyBookmarkedArticles: 'MyBookmarkedArticles',
    MyPublicFavoriteItemCategories: 'MyPublicFavoriteItemCategories',
    UserPublicPortfolios: 'UserPublicPortfolios',
    MyPublicPortfolios: 'MyPublicPortfolios',
    UserPublicFavoriteItemCategories: 'UserPublicFavoriteItemCategories',
    PublicFavoriteItems: 'PublicFavoriteItems'
  },
  Mutation: {
    ClickInvestingInsight: 'ClickInvestingInsight',
    ClickAd: 'ClickAd',
    DoNotShowAd: 'DoNotShowAd',
    UpdateUserAgreements: 'UpdateUserAgreements',
    AddCurrencyAssetsToPortfolio: 'AddCurrencyAssetsToPortfolio',
    AddCompanyAssetsToPortfolio: 'AddCompanyAssetsToPortfolio',
    AddEtcAssetsToPortfolio: 'AddEtcAssetsToPortfolio',
    AddCryptoCurrencyAssetsToPortfolio: 'AddCryptoCurrencyAssetsToPortfolio',
    RemovePortfolioAssets: 'RemovePortfolioAssets',
    UpdatePortfolioAsset: 'UpdatePortfolioAsset',
    AddBackTestingProjectResult: 'AddBackTestingProjectResult',
    UpdateBackTestingProjectResult: 'UpdateBackTestingProjectResult',
    RemoveBackTestingProjectResult: 'RemoveBackTestingProjectResult',
    UpdateMyRepresentativeBadge: 'UpdateMyRepresentativeBadge',
    RemoveMyRepresentativeBadge: 'RemoveMyRepresentativeBadge',
    AcquireBadge: 'AcquireBadge',
    AddArticle: 'AddArticle',
    UpdateArticle: 'UpdateArticle',
    RemoveArticle: 'RemoveArticle',
    AddArticleComment: 'AddArticleComment',
    UpdateArticleComment: 'UpdateArticleComment',
    RemoveArticleComment: 'RemoveArticleComment',
    AddReplyToArticleComment: 'AddReplyToArticleComment',
    AddArticleToLike: 'AddArticleToLike',
    RemoveArticleToLike: 'RemoveArticleToLike',
    AddBookmarkToArticle: 'AddBookmarkToArticle',
    RemoveBookmarkFromArticle: 'RemoveBookmarkFromArticle',
    ConfirmCommunityNotifications: 'ConfirmCommunityNotifications',
    FollowItem: 'FollowItem',
    FollowItems: 'FollowItems',
    UnfollowItem: 'UnfollowItem',
    UnfollowItems: 'UnfollowItems',
    addCommunityReport: 'addCommunityReport',
    BlockUser: 'BlockUser',
    UnblockUser: 'UnblockUser',
    ConnectPartnerWithUserData: 'ConnectPartnerWithUserData',
    UpdateFavoriteItemCategoryOrders: 'UpdateFavoriteItemCategoryOrders',
    AddFavoriteItemCategory: 'AddFavoriteItemCategory',
    UpdateFavoriteItemCategory: 'UpdateFavoriteItemCategory',
    RemoveFavoriteItemCategory: 'RemoveFavoriteItemCategory',
    AddItemsToFavoriteItemCategory: 'AddItemsToFavoriteItemCategory',
    RemoveItemsToFavoriteItemCategory: 'RemoveItemsToFavoriteItemCategory',
    EnableSharingFavoriteItemCategory: 'EnableSharingFavoriteItemCategory',
    DisableSharingFavoriteItemCategory: 'DisableSharingFavoriteItemCategory',
    AddLogToInvestingDiary: 'AddLogToInvestingDiary',
    UpdateInvestingDiaryLog: 'UpdateInvestingDiaryLog',
    RemoveInvestingDiaryLog: 'RemoveInvestingDiaryLog',
    SendEmailToSubscribeMailingGroup: 'SendEmailToSubscribeMailingGroup',
    SubscribeMailingGroup: 'SubscribeMailingGroup',
    UnsubscribeMailingGroup: 'UnsubscribeMailingGroup',
    CreateSnp500DividendPortfolio: 'CreateSnp500DividendPortfolio',
    SaveDividendPortfolio: 'SaveDividendPortfolio',
    UploadPortfolio: 'UploadPortfolio',
    UpdatePortfolioInformation: 'UpdatePortfolioInformation',
    UpdateSwitchPortfolio: 'UpdateSwitchPortfolio',
    UpdatePortfolioSwitchOn: 'UpdatePortfolioSwitchOn',
    UpdatePortfolioOrderScores: 'UpdatePortfolioOrderScores',
    RemovePortfolio: 'RemovePortfolio',
    EnableSharingPortfolio: 'EnableSharingPortfolio',
    DisableSharingPortfolio: 'DisableSharingPortfolio',
    PostUserPortfolioComment: 'PostUserPortfolioComment',
    DeleteUserPortfolioComment: 'DeleteUserPortfolioComment',
    RemoveSecuritiesAccountFromPortfolio: 'RemoveSecuritiesAccountFromPortfolio',
    AddCryptoExchangeApiKeyToUser: 'AddCryptoExchangeApiKeyToUser',
    RemoveCryptoExchangeApiKeyFromUser: 'RemoveCryptoExchangeApiKeyFromUser',
    CreatePortfolioFromCryptoExchangeApiKey: 'CreatePortfolioFromCryptoExchangeApiKey',
    UpdatePortfolioFromCryptoExchangeApiKey: 'UpdatePortfolioFromCryptoExchangeApiKey',
    RemoveCryptoExchangeApiKeyFromPortfolio: 'RemoveCryptoExchangeApiKeyFromPortfolio',
    CreatePlaidLinkToken: 'CreatePlaidLinkToken',
    CreatePortfolioFromPlaidPublicToken: 'CreatePortfolioFromPlaidPublicToken',
    UpdatePortfolioFromPlaid: 'UpdatePortfolioFromPlaid',
    RemovePlaidConnectFromPortfolio: 'RemovePlaidConnectFromPortfolio',
    ApplyProfessionalInvestor: 'ApplyProfessionalInvestor',
    RequestProfessionalInvestorVerification: 'RequestProfessionalInvestorVerification',
    ReportUnresolvedSymbol: 'ReportUnresolvedSymbol',
    UpdateMyCompanySector: 'UpdateMyCompanySector',
    SignIn: 'SignIn',
    UpdateMyProfile: 'UpdateMyProfile',
    RequestTerminateUserMembership: 'RequestTerminateUserMembership',
    UpdateUserSurvey: 'UpdateUserSurvey',
    ConfirmTokenToVerifyEmail: 'ConfirmTokenToVerifyEmail',
    DenyTokenToVerifyEmail: 'DenyTokenToVerifyEmail',
    SendEmailToVerifyEmail: 'SendEmailToVerifyEmail',
    UpdateSignInSession: 'UpdateSignInSession',
    RequestUserPhoneVerificationToKrTelecom: 'RequestUserPhoneVerificationToKrTelecom',
    VerifyUserPhoneVerificationFromKrTelecom: 'VerifyUserPhoneVerificationFromKrTelecom'
  },
  Subscription: {
    RealtimeStockPrice: 'RealtimeStockPrice',
    StockPriceUpdated: 'StockPriceUpdated',
    CryptoCurrencyPriceUpdated: 'CryptoCurrencyPriceUpdated'
  },
  Fragment: {
    InvestingInsightTagFields: 'InvestingInsightTagFields',
    InvestingInsightFields: 'InvestingInsightFields',
    AdFields: 'AdFields',
    AdContentFields: 'AdContentFields',
    UserAgreementStatusFields: 'UserAgreementStatusFields',
    UserAgreementItemFields: 'UserAgreementItemFields',
    AgreementFields: 'AgreementFields',
    UserAgreementFields: 'UserAgreementFields',
    LatestAgreementsFields: 'LatestAgreementsFields',
    EtcAssetFields: 'EtcAssetFields',
    EtcCompanyAssetFields: 'EtcCompanyAssetFields',
    UserAssetFields: 'UserAssetFields',
    BackTestingStockFields: 'BackTestingStockFields',
    BackTestingPortfolioStockFields: 'BackTestingPortfolioStockFields',
    BackTestingCryptoFields: 'BackTestingCryptoFields',
    BackTestingPortfolioCryptoFields: 'BackTestingPortfolioCryptoFields',
    BackTestingPortfolioFields: 'BackTestingPortfolioFields',
    BackTestingProjectFields: 'BackTestingProjectFields',
    BadgeFields: 'BadgeFields',
    AssetTagFields: 'AssetTagFields',
    AssetTagTitleFields: 'AssetTagTitleFields',
    CounterCurrencyFields: 'CounterCurrencyFields',
    ArticleFields: 'ArticleFields',
    ArticleContentFields: 'ArticleContentFields',
    ArticleContentAssetFields: 'ArticleContentAssetFields',
    ArticleContentBackTestingProjectFields: 'ArticleContentBackTestingProjectFields',
    ArticleContentPortfolioFields: 'ArticleContentPortfolioFields',
    ArticleContentTextFields: 'ArticleContentTextFields',
    ArticleContentImageFields: 'ArticleContentImageFields',
    ArticleContentOgTagFields: 'ArticleContentOgTagFields',
    ArticleContentAssetContentFields: 'ArticleContentAssetContentFields',
    ArticleContentPortfolioContentFields: 'ArticleContentPortfolioContentFields',
    ArticleContentImageContentFields: 'ArticleContentImageContentFields',
    ArticleContentSubTextComponentFields: 'ArticleContentSubTextComponentFields',
    ArticleContentTextSubTextComponentCryptoFields: 'ArticleContentTextSubTextComponentCryptoFields',
    ArticleContentTextSubTextComponentStockFields: 'ArticleContentTextSubTextComponentStockFields',
    ArticleContentTextSubTextComponentTextFields: 'ArticleContentTextSubTextComponentTextFields',
    ArticleContentTextSubTextComponentUserFields: 'ArticleContentTextSubTextComponentUserFields',
    ArticleCommentFields: 'ArticleCommentFields',
    ArticleCommentContentFields: 'ArticleCommentContentFields',
    ArticleCommentReplyFields: 'ArticleCommentReplyFields',
    FeedTopicFields: 'FeedTopicFields',
    PortfolioTopicFields: 'PortfolioTopicFields',
    CommunityNotificationUserFields: 'CommunityNotificationUserFields',
    CommunityUserFields: 'CommunityUserFields',
    SearchFollowItemsFields: 'SearchFollowItemsFields',
    SearchFollowItemFields: 'SearchFollowItemFields',
    FollowItemFields: 'FollowItemFields',
    FollowCompanyFields: 'FollowCompanyFields',
    FollowCryptoCurrencyFields: 'FollowCryptoCurrencyFields',
    FollowUserFields: 'FollowUserFields',
    OgTagFields: 'OgTagFields',
    CompanyFields: 'CompanyFields',
    CompanyDetailFields: 'CompanyDetailFields',
    CompanyDetailOnlyCommunityFields: 'CompanyDetailOnlyCommunityFields',
    CompanyPriceFields: 'CompanyPriceFields',
    NewsCompanyDetail: 'NewsCompanyDetail',
    StockPriceFields: 'StockPriceFields',
    CryptoCurrencyFields: 'CryptoCurrencyFields',
    CryptoCurrencyAssetFields: 'CryptoCurrencyAssetFields',
    CryptoCurrencyDetailFields: 'CryptoCurrencyDetailFields',
    CryptoCurrencyDetailOnlyCommunityFields: 'CryptoCurrencyDetailOnlyCommunityFields',
    CryptoCurrencyPriceFields: 'CryptoCurrencyPriceFields',
    CurrencyFields: 'CurrencyFields',
    DividendHistoryApi1Fields: 'DividendHistoryApi1Fields',
    DividendHistoryFields: 'DividendHistoryFields',
    DividendCalendarRecordFields: 'DividendCalendarRecordFields',
    MarketCalendarFields: 'MarketCalendarFields',
    PaginationCompaniesFields: 'PaginationCompaniesFields',
    EbestUserPortfolio: 'EbestUserPortfolio',
    DividendHistoriesExistingDaysForExternalChannelFields: 'DividendHistoriesExistingDaysForExternalChannelFields',
    CurrencyExchangeFields: 'CurrencyExchangeFields',
    FavoriteItemFields: 'FavoriteItemFields',
    FavoriteItemCategoryWithoutItemsFields: 'FavoriteItemCategoryWithoutItemsFields',
    FavoriteItemCategoryFields: 'FavoriteItemCategoryFields',
    TradingDiaryLogFields: 'TradingDiaryLogFields',
    EventFields: 'EventFields',
    MailingGroupEmailVerificationFields: 'MailingGroupEmailVerificationFields',
    MailingGroupFields: 'MailingGroupFields',
    LanguageStringFields: 'LanguageStringFields',
    SubscribedUserFields: 'SubscribedUserFields',
    NoticeField: 'NoticeField',
    GeneratorPortfolioFields: 'GeneratorPortfolioFields',
    CategorizedCompanyFields: 'CategorizedCompanyFields',
    UserPortfolioFields: 'UserPortfolioFields',
    UserPortfolioItemsFields: 'UserPortfolioItemsFields',
    CommonUserPortfolioItemsFields: 'CommonUserPortfolioItemsFields',
    SwitchPortfolioFields: 'SwitchPortfolioFields',
    UserPortfolioCommentFields: 'UserPortfolioCommentFields',
    CryptoExchangeFields: 'CryptoExchangeFields',
    CryptoExchangeApiKeyFields: 'CryptoExchangeApiKeyFields',
    ProfessionalInvestorApplicantFields: 'ProfessionalInvestorApplicantFields',
    ProfessionalInvestorFields: 'ProfessionalInvestorFields',
    SearchCompanyFields: 'SearchCompanyFields',
    UserCompanySectorFields: 'UserCompanySectorFields',
    CompanySectorFields: 'CompanySectorFields',
    MbtiVisitorCounterFields: 'MbtiVisitorCounterFields',
    MbtiResultCounterFields: 'MbtiResultCounterFields',
    AuthTokenFields: 'AuthTokenFields',
    UserPortfolioUserFields: 'UserPortfolioUserFields',
    UserAccountFields: 'UserAccountFields',
    UserFields: 'UserFields',
    MyProfileFields: 'MyProfileFields',
    UserSurveyFields: 'UserSurveyFields',
    InvestingKeywordFields: 'InvestingKeywordFields',
    InvestingKeywordWithIsSelectedFields: 'InvestingKeywordWithIsSelectedFields',
    UserProfileFields: 'UserProfileFields',
    UserProfileOnlyCommunityFields: 'UserProfileOnlyCommunityFields',
    CommunityNotificationStatusFields: 'CommunityNotificationStatusFields',
    CommunityNotificationFields: 'CommunityNotificationFields',
    CommunityNotificationContentFields: 'CommunityNotificationContentFields',
    UserVerificationFields: 'UserVerificationFields',
    UserPhoneVerificationKrFields: 'UserPhoneVerificationKrFields'
  }
}